webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cepURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var apiURL = 'https://api.savoycontrole.com.br/api/v1';
var cepURL = 'https://viacep.com.br/ws';

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  "data-v-86009418",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(726)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(981),
  /* scopeId */
  "data-v-0356ce58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  "data-v-f4a76b96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_Login__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Public_PublicPagamentoAvaliacao__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Public_PublicPagamentoAvaliacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Public_PublicPagamentoAvaliacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Imoveis_ImoveisRoot__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Imoveis_ImoveisRoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Imoveis_ImoveisRoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Imoveis_ImoveisLista__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Imoveis_ImoveisLista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Imoveis_ImoveisLista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Imoveis_ImoveisMapa__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Imoveis_ImoveisMapa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Imoveis_ImoveisMapa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Imoveis_ImoveisAdicionar__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Imoveis_ImoveisAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Imoveis_ImoveisAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Imoveis_ImoveisDetalhes__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Imoveis_ImoveisDetalhes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Imoveis_ImoveisDetalhes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Imoveis_Detalhes_DetalhesResumo__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Imoveis_Detalhes_DetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Imoveis_Detalhes_DetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imoveis_Detalhes_DetalhesInfo__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imoveis_Detalhes_DetalhesInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Imoveis_Detalhes_DetalhesInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Imoveis_Detalhes_DetalhesObservacoes__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Imoveis_Detalhes_DetalhesObservacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Imoveis_Detalhes_DetalhesObservacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Imoveis_Detalhes_DetalhesAnexos__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Imoveis_Detalhes_DetalhesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Imoveis_Detalhes_DetalhesAnexos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Imoveis_Detalhes_DetalhesFotos__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Imoveis_Detalhes_DetalhesFotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Imoveis_Detalhes_DetalhesFotos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Imoveis_Detalhes_DetalhesEndereco__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Imoveis_Detalhes_DetalhesEndereco___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Imoveis_Detalhes_DetalhesEndereco__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Imoveis_Detalhes_DetalhesRegistro__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Imoveis_Detalhes_DetalhesRegistro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Imoveis_Detalhes_DetalhesRegistro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Imoveis_Detalhes_DetalhesArea__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Imoveis_Detalhes_DetalhesArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Imoveis_Detalhes_DetalhesArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Imoveis_Detalhes_DetalhesTaxas__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Imoveis_Detalhes_DetalhesTaxas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Imoveis_Detalhes_DetalhesTaxas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Imoveis_Detalhes_DetalhesValor__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Imoveis_Detalhes_DetalhesValor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Imoveis_Detalhes_DetalhesValor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Imoveis_Detalhes_DetalhesStatus__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Imoveis_Detalhes_DetalhesStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Imoveis_Detalhes_DetalhesStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Imoveis_Pagamentos_PagamentosMain__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Imoveis_Pagamentos_PagamentosMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Imoveis_Pagamentos_PagamentosMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Vistoria_VistoriaAdicionar__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Vistoria_VistoriaAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Vistoria_VistoriaAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Vistoria_VistoriaEditar__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Vistoria_VistoriaEditar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Vistoria_VistoriaEditar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Tarefas_TarefasLista__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Tarefas_TarefasLista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Tarefas_TarefasLista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Tarefas_TarefasAdicionar__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Tarefas_TarefasAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Tarefas_TarefasAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Tarefas_TarefasEditar__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Tarefas_TarefasEditar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Tarefas_TarefasEditar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Relatorios_RelatoriosRoot__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Relatorios_RelatoriosRoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Relatorios_RelatoriosRoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Relatorios_RelatoriosHistorico__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Relatorios_RelatoriosHistorico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Relatorios_RelatoriosHistorico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Relatorios_RelatoriosComparativos__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Relatorios_RelatoriosComparativos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Relatorios_RelatoriosComparativos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Relatorios_RelatoriosPagamentos__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Relatorios_RelatoriosPagamentos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Relatorios_RelatoriosPagamentos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Usuarios_UsuariosMain__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Usuarios_UsuariosMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Usuarios_UsuariosMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Usuarios_UsuariosLista__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Usuarios_UsuariosLista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Usuarios_UsuariosLista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Usuarios_UsuariosAdicionar__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Usuarios_UsuariosAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Usuarios_UsuariosAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Usuarios_UsuariosEditar__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Usuarios_UsuariosEditar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Usuarios_UsuariosEditar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Usuarios_UsuariosConfiguracoes__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Usuarios_UsuariosConfiguracoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Usuarios_UsuariosConfiguracoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Roles_RolesLista__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Roles_RolesLista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Roles_RolesLista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Roles_RolesAdicionar__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Roles_RolesAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Roles_RolesAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Roles_RolesEditar__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Roles_RolesEditar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Roles_RolesEditar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Login_Logout__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Login_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Login_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Utils_Forbidden__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Utils_Forbidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Utils_Forbidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_access__ = __webpack_require__(168);




var _this = this;












































__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var isMobileViewport = function isMobileViewport() {
  return typeof window !== 'undefined' && window.innerWidth < 960;
};

var getCurrentUser = function getCurrentUser() {
  if (!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth || typeof __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.user !== 'function') return null;
  return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.user();
};

var hasGeneralAccess = function hasGeneralAccess(permissionKey) {
  var user = getCurrentUser();
  if (!user) return false;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["a" /* shouldUseCustomPermissions */])(user)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["b" /* hasGeneralAccess */])(user, permissionKey);
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["c" /* hasCustomPermissionsPayload */])(user)) return false;

  if (permissionKey === 'administracao_usuarios') {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check(['Administrador', 'Patrimônio']);
  }

  if (permissionKey === 'administracao_niveis_acesso') {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check(['Administrador']);
  }

  if (permissionKey === 'visualizar_relatorios') {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check(['Administrador']);
  }

  return false;
};

var hasGranularAccess = function hasGranularAccess(category) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'view';

  var user = getCurrentUser();
  if (!user) return false;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["a" /* shouldUseCustomPermissions */])(user)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["d" /* hasGranularPermission */])(user, category, action);
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["c" /* hasCustomPermissionsPayload */])(user)) return false;

  if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check(['Administrador', 'Diretoria', 'Patrimônio'])) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check('Operacional')) {
    if (category === 'valor') return false;
    if (action === 'view') return true;
    return false;
  }

  return false;
};

var blockReportsRoute = function blockReportsRoute(to, from, next) {
  if (isMobileViewport()) {
    next({ name: 'ImoveisRoot' });
    return;
  }
  next();
};

var normalizeGeneralAccess = function normalizeGeneralAccess(permissions) {
  return {
    usuarios: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["e" /* hasGeneralAccessFromPermissions */])(permissions, 'administracao_usuarios'),
    niveis_acesso: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["e" /* hasGeneralAccessFromPermissions */])(permissions, 'administracao_niveis_acesso'),
    relatorios: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["e" /* hasGeneralAccessFromPermissions */])(permissions, 'visualizar_relatorios')
  };
};

var fetchCurrentUser = function fetchCurrentUser() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth || typeof __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.fetch !== 'function') {
      resolve(false);
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.fetch({
      success: function success() {
        return resolve(true);
      },
      error: function error() {
        return resolve(false);
      }
    });
  });
};

var sessionSyncPromise = null;

var isPublicRoute = function isPublicRoute(to) {
  return to.matched.some(function (route) {
    return route.meta && route.meta.public === true;
  });
};

var syncCurrentUserOnNavigation = function syncCurrentUserOnNavigation(to) {
  if (!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth || isPublicRoute(to)) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(false);
  }

  var hasToken = typeof __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.token === 'function' && !!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.token();
  if (!hasToken) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(false);
  }

  if (!sessionSyncPromise) {
    sessionSyncPromise = fetchCurrentUser().then(function (synced) {
      if (!synced) {
        console.warn('[auth-sync] failed to refresh user payload on navigation', { to: to.fullPath });
      }
      return synced;
    }).finally(function () {
      sessionSyncPromise = null;
    });
  }

  return sessionSyncPromise;
};

var guardLog = function guardLog(type, payload) {
  var logMethod = type === 'deny' ? console.warn : console.info;
  logMethod('[auth-guard] ' + type, payload);
};

var ROUTE_GRANULAR_REQUIREMENTS = {
  ImoveisRoot: { category: 'info', action: 'view' },
  ImoveisLista: { category: 'info', action: 'view' },
  ImoveisMapa: { category: 'info', action: 'view' },
  ImoveisAdicionar: { category: 'info', action: 'add' },
  ImoveisDetalhes: { category: 'info', action: 'view' },
  ImoveisDetalhesResumo: { category: 'info', action: 'view' },
  ImoveisDetalhesInfo: { category: 'info', action: 'view' },
  ImoveisDetalhesObservacoes: { category: 'observacoes', action: 'view' },
  ImoveisDetalhesAnexos: { category: 'anexos', action: 'view' },
  ImoveisDetalhesFotos: { category: 'fotos', action: 'view' },
  ImoveisDetalhesEndereco: { category: 'endereco', action: 'view' },
  ImoveisDetalhesRegistro: { category: 'registro', action: 'view' },
  ImoveisDetalhesArea: { category: 'area', action: 'view' },
  ImoveisDetalhesTaxas: { category: 'taxas', action: 'view' },
  ImoveisDetalhesValor: { category: 'valor', action: 'view' },
  ImoveisDetalhesStatus: { category: 'status', action: 'view' },
  ImoveisDetalhesPagamentos: { category: 'pagamentos', action: 'view' },
  VistoriaAdicionar: { category: 'vistoria', action: 'add' },
  VistoriaEditar: { category: 'vistoria', action: 'edit' },
  TarefasLista: { category: 'tarefas', action: 'view' },
  TarefasAdicionar: { category: 'tarefas', action: 'add' },
  TarefasEditar: { category: 'tarefas', action: 'edit' }
};

var resolveGranularRequirement = function resolveGranularRequirement(to) {
  if (!to) return null;
  if (to.name && ROUTE_GRANULAR_REQUIREMENTS[to.name]) return ROUTE_GRANULAR_REQUIREMENTS[to.name];

  if (typeof to.path === 'string' && to.path.startsWith('/imoveis')) {
    return { category: 'info', action: 'view' };
  }

  return null;
};

var resolveGeneralAccessRequirement = function resolveGeneralAccessRequirement(to) {
  var generalAccessRoute = to.matched.find(function (route) {
    return route.meta && route.meta.generalAccess;
  });
  if (generalAccessRoute) return generalAccessRoute.meta.generalAccess;

  if (to.path === '/usuarios') return 'administracao_usuarios';
  if (to.path.startsWith('/usuarios/') && to.path !== '/usuarios/configuracoes') return 'administracao_usuarios';
  if (to.path === '/roles' || to.path.startsWith('/roles/')) return 'administracao_niveis_acesso';
  if (to.path === '/relatorios' || to.path.startsWith('/relatorios/')) return 'visualizar_relatorios';

  return null;
};

var shouldRedirectToHomeOnDenied = function shouldRedirectToHomeOnDenied(to) {
  if (!to || typeof to.path !== 'string') return false;
  if (to.path === '/usuarios') return true;
  if (to.path.startsWith('/usuarios/') && to.path !== '/usuarios/configuracoes') return true;
  if (to.path === '/roles' || to.path.startsWith('/roles/')) return true;
  if (to.path === '/relatorios' || to.path.startsWith('/relatorios/')) return true;
  return false;
};

var redirectDenied = function redirectDenied(to, next) {
  if (shouldRedirectToHomeOnDenied(to)) {
    next({ path: '/' });
    return;
  }
  next({ name: 'Forbidden' });
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  mode: 'hash',
  routes: [{
    path: '/imoveis/aprovar_pagamento/:token',
    name: 'PublicAprovarPagamento',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Public_PublicPagamentoAvaliacao___default.a,
    meta: {
      public: true,
      paymentAction: 'aprovar'
    }
  }, {
    path: '/imoveis/rejeitar_pagamento/:token',
    name: 'PublicRejeitarPagamento',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Public_PublicPagamentoAvaliacao___default.a,
    meta: {
      public: true,
      paymentAction: 'rejeitar'
    }
  }, {
    path: '/403',
    name: 'Forbidden',
    component: __WEBPACK_IMPORTED_MODULE_43__components_Utils_Forbidden___default.a
  }, {
    path: '/404',
    redirect: '/'
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login_Login___default.a,
    meta: {
      auth: false
    }
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_7__App___default.a,
    meta: {
      auth: true
    },
    children: [{
      path: '/logout',
      name: 'Logout',
      component: __WEBPACK_IMPORTED_MODULE_42__components_Login_Logout___default.a
    }, {
      path: '/usuarios',
      name: 'Usuarios',
      component: __WEBPACK_IMPORTED_MODULE_34__components_Usuarios_UsuariosMain___default.a,
      children: [{
        path: '/usuarios',
        name: 'UsuariosLista',
        component: __WEBPACK_IMPORTED_MODULE_35__components_Usuarios_UsuariosLista___default.a,
        meta: {
          generalAccess: 'administracao_usuarios'
        }
      }, {
        path: '/usuarios/adicionar',
        name: 'UsuariosAdicionar',
        component: __WEBPACK_IMPORTED_MODULE_36__components_Usuarios_UsuariosAdicionar___default.a,
        meta: {
          generalAccess: 'administracao_usuarios'
        }
      }, {
        path: '/usuarios/editar/:id',
        name: 'UsuariosEditar',
        component: __WEBPACK_IMPORTED_MODULE_37__components_Usuarios_UsuariosEditar___default.a,
        meta: {
          generalAccess: 'administracao_usuarios'
        }
      }, {
        path: '/usuarios/configuracoes',
        name: 'UsuariosConfiguracoes',
        component: __WEBPACK_IMPORTED_MODULE_38__components_Usuarios_UsuariosConfiguracoes___default.a
      }]
    }, {
      path: '/roles',
      name: 'RolesLista',
      component: __WEBPACK_IMPORTED_MODULE_39__components_Roles_RolesLista___default.a,
      meta: {
        generalAccess: 'administracao_niveis_acesso'
      }
    }, {
      path: '/roles/adicionar',
      name: 'RolesAdicionar',
      component: __WEBPACK_IMPORTED_MODULE_40__components_Roles_RolesAdicionar___default.a,
      meta: {
        generalAccess: 'administracao_niveis_acesso'
      }
    }, {
      path: '/roles/editar/:id',
      name: 'RolesEditar',
      component: __WEBPACK_IMPORTED_MODULE_41__components_Roles_RolesEditar___default.a,
      meta: {
        generalAccess: 'administracao_niveis_acesso'
      }
    }, {
      path: '/',
      redirect: '/imoveis'
    }, {
      path: '/imoveis',
      name: 'ImoveisRoot',
      component: __WEBPACK_IMPORTED_MODULE_8__components_Imoveis_ImoveisRoot___default.a
    }, {
      path: '/imoveis/lista',
      name: 'ImoveisLista',
      component: __WEBPACK_IMPORTED_MODULE_9__components_Imoveis_ImoveisLista___default.a
    }, {
      path: '/imoveis/mapa',
      name: 'ImoveisMapa',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Imoveis_ImoveisMapa___default.a,
      meta: {
        touchless: true
      }
    }, {
      path: '/imoveis/adicionar',
      name: 'ImoveisAdicionar',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Imoveis_ImoveisAdicionar___default.a
    }, {
      path: '/imoveis/detalhes/:id',
      name: 'ImoveisDetalhes',
      component: __WEBPACK_IMPORTED_MODULE_12__components_Imoveis_ImoveisDetalhes___default.a,
      children: [{
        path: '/imoveis/detalhes/:id',
        name: 'ImoveisDetalhesResumo',
        component: __WEBPACK_IMPORTED_MODULE_13__components_Imoveis_Detalhes_DetalhesResumo___default.a
      }, {
        path: '/imoveis/info/:id',
        name: 'ImoveisDetalhesInfo',
        component: __WEBPACK_IMPORTED_MODULE_14__components_Imoveis_Detalhes_DetalhesInfo___default.a
      }, {
        path: '/imoveis/observacoes/:tipo/:id',
        name: 'ImoveisDetalhesObservacoes',
        component: __WEBPACK_IMPORTED_MODULE_15__components_Imoveis_Detalhes_DetalhesObservacoes___default.a
      }, {
        path: '/imoveis/anexos/:tipo/:id',
        name: 'ImoveisDetalhesAnexos',
        component: __WEBPACK_IMPORTED_MODULE_16__components_Imoveis_Detalhes_DetalhesAnexos___default.a
      }, {
        path: '/imoveis/fotos/:tipo/:id',
        name: 'ImoveisDetalhesFotos',
        component: __WEBPACK_IMPORTED_MODULE_17__components_Imoveis_Detalhes_DetalhesFotos___default.a
      }, {
        path: '/imoveis/endereco/:id',
        name: 'ImoveisDetalhesEndereco',
        component: __WEBPACK_IMPORTED_MODULE_18__components_Imoveis_Detalhes_DetalhesEndereco___default.a,
        meta: {
          tipo: 'endereco'
        }
      }, {
        path: '/imoveis/registro/:id',
        name: 'ImoveisDetalhesRegistro',
        component: __WEBPACK_IMPORTED_MODULE_19__components_Imoveis_Detalhes_DetalhesRegistro___default.a,
        meta: {
          tipo: 'registro'
        }
      }, {
        path: '/imoveis/area/:id',
        name: 'ImoveisDetalhesArea',
        component: __WEBPACK_IMPORTED_MODULE_20__components_Imoveis_Detalhes_DetalhesArea___default.a,
        meta: {
          tipo: 'area'
        }
      }, {
        path: '/imoveis/taxas/:id',
        name: 'ImoveisDetalhesTaxas',
        component: __WEBPACK_IMPORTED_MODULE_21__components_Imoveis_Detalhes_DetalhesTaxas___default.a,
        meta: {
          tipo: 'taxas'
        }
      }, {
        path: '/imoveis/valor/:id',
        name: 'ImoveisDetalhesValor',
        component: __WEBPACK_IMPORTED_MODULE_22__components_Imoveis_Detalhes_DetalhesValor___default.a,
        meta: {
          tipo: 'valor'
        }
      }, {
        path: '/imoveis/status/:id',
        name: 'ImoveisDetalhesStatus',
        component: __WEBPACK_IMPORTED_MODULE_23__components_Imoveis_Detalhes_DetalhesStatus___default.a,
        meta: {
          tipo: 'status'
        }
      }, {
        path: '/imoveis/pagamentos/:id',
        name: 'ImoveisDetalhesPagamentos',
        component: __WEBPACK_IMPORTED_MODULE_24__components_Imoveis_Pagamentos_PagamentosMain___default.a,
        meta: {
          tipo: 'pagamentos'
        }
      }, {
        path: '/vistoria/adicionar/:id',
        name: 'VistoriaAdicionar',
        component: __WEBPACK_IMPORTED_MODULE_25__components_Vistoria_VistoriaAdicionar___default.a,
        meta: {
          auth: ['Administrador', 'Patrimônio']
        }
      }, {
        path: '/vistoria/editar/:id',
        name: 'VistoriaEditar',
        component: __WEBPACK_IMPORTED_MODULE_26__components_Vistoria_VistoriaEditar___default.a,
        meta: {
          auth: ['Administrador', 'Patrimônio']
        }
      }, {
        path: '/tarefas/:id',
        name: 'TarefasLista',
        component: __WEBPACK_IMPORTED_MODULE_27__components_Tarefas_TarefasLista___default.a,
        meta: {
          auth: ['Administrador', 'Patrimônio']
        }
      }, {
        path: '/tarefas/adicionar/:id',
        name: 'TarefasAdicionar',
        component: __WEBPACK_IMPORTED_MODULE_28__components_Tarefas_TarefasAdicionar___default.a,
        meta: {
          auth: ['Administrador', 'Patrimônio']
        }
      }, {
        path: '/tarefas/editar/:id/:tarefa',
        name: 'TarefasEditar',
        component: __WEBPACK_IMPORTED_MODULE_29__components_Tarefas_TarefasEditar___default.a,
        meta: {
          auth: ['Administrador', 'Patrimônio']
        }
      }]
    }, {
      path: '/relatorios',
      name: 'RelatoriosRoot',
      component: __WEBPACK_IMPORTED_MODULE_30__components_Relatorios_RelatoriosRoot___default.a,
      beforeEnter: blockReportsRoute,
      meta: {
        generalAccess: 'visualizar_relatorios'
      },
      children: [{
        path: '/relatorios/historico/data',
        name: 'RelatoriosHistoricoData',
        component: __WEBPACK_IMPORTED_MODULE_31__components_Relatorios_RelatoriosHistorico___default.a
      }, {
        path: '/relatorios/historico/usuario',
        name: 'RelatoriosHistoricoUsuario',
        component: __WEBPACK_IMPORTED_MODULE_31__components_Relatorios_RelatoriosHistorico___default.a
      }, {
        path: '/relatorios/comparativos',
        name: 'RelatoriosComparativos',
        component: __WEBPACK_IMPORTED_MODULE_32__components_Relatorios_RelatoriosComparativos___default.a
      }, {
        path: '/relatorios/pagamentos',
        name: 'RelatoriosPagamentos',
        component: __WEBPACK_IMPORTED_MODULE_33__components_Relatorios_RelatoriosPagamentos___default.a
      }]
    }]
  }]
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var publicRoute, granularRequirement, requiredPermission, isProtectedRoute, didSyncUser, hasToken, user, invalidUserPayload, category, action, canAccess, rawPermissions, normalizedPermissions, normalizedGeneralAccess, hasAccess;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            publicRoute = isPublicRoute(to);
            granularRequirement = publicRoute ? null : resolveGranularRequirement(to);
            requiredPermission = publicRoute ? null : resolveGeneralAccessRequirement(to);
            isProtectedRoute = !!granularRequirement || !!requiredPermission;
            _context.next = 6;
            return syncCurrentUserOnNavigation(to);

          case 6:
            didSyncUser = _context.sent;

            if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth) {
              _context.next = 10;
              break;
            }

            next();
            return _context.abrupt('return');

          case 10:
            hasToken = typeof __WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.token === 'function' && !!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.token();

            if (hasToken) {
              _context.next = 14;
              break;
            }

            next();
            return _context.abrupt('return');

          case 14:
            user = getCurrentUser();

            if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].auth.check()) {
              _context.next = 18;
              break;
            }

            next();
            return _context.abrupt('return');

          case 18:
            invalidUserPayload = !user || !user.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["f" /* isCustomPermissionsPayloadInvalid */])(user);

            if (!(isProtectedRoute && (!didSyncUser || invalidUserPayload))) {
              _context.next = 23;
              break;
            }

            guardLog('deny', {
              to: to.fullPath,
              userId: user && user.id,
              reason: !didSyncUser ? 'user_payload_refresh_failed' : 'invalid_custom_permissions_payload'
            });
            redirectDenied(to, next);
            return _context.abrupt('return');

          case 23:
            if (!granularRequirement) {
              _context.next = 31;
              break;
            }

            category = granularRequirement.category;
            action = granularRequirement.action || 'view';
            canAccess = hasGranularAccess(category, action);

            if (canAccess) {
              _context.next = 31;
              break;
            }

            guardLog('deny', {
              to: to.fullPath,
              userId: user && user.id,
              reason: 'missing_granular_permission:' + category + '.' + action
            });
            redirectDenied(to, next);
            return _context.abrupt('return');

          case 31:
            if (requiredPermission) {
              _context.next = 34;
              break;
            }

            next();
            return _context.abrupt('return');

          case 34:
            rawPermissions = user ? user.custom_permissions : null;
            normalizedPermissions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_access__["g" /* normalizePermissions */])(rawPermissions);
            normalizedGeneralAccess = normalizeGeneralAccess(normalizedPermissions);
            hasAccess = hasGeneralAccess(requiredPermission);

            if (!hasAccess) {
              _context.next = 42;
              break;
            }

            guardLog('allow', {
              to: to.fullPath,
              userId: user && user.id,
              requiredPermission: requiredPermission,
              normalizedGeneralAccess: normalizedGeneralAccess
            });
            next();
            return _context.abrupt('return');

          case 42:

            guardLog('deny', {
              to: to.fullPath,
              userId: user && user.id,
              rawPermissions: rawPermissions,
              normalizedPermissions: normalizedPermissions,
              normalizedGeneralAccess: normalizedGeneralAccess,
              reason: 'missing_required_permission:' + requiredPermission
            });

            redirectDenied(to, next);

          case 44:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].router);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var hasBlobConstructor = typeof Blob !== 'undefined' && function () {
    try {
        return Boolean(new Blob());
    } catch (e) {
        return false;
    }
}();

var hasArrayBufferViewSupport = hasBlobConstructor && typeof Uint8Array !== 'undefined' && function () {
    try {
        return new Blob([new Uint8Array(100)]).size === 100;
    } catch (e) {
        return false;
    }
}();

var hasToBlobSupport = typeof HTMLCanvasElement !== "undefined" ? HTMLCanvasElement.prototype.toBlob : false;

var hasBlobSupport = hasToBlobSupport || typeof Uint8Array !== 'undefined' && typeof ArrayBuffer !== 'undefined' && typeof atob !== 'undefined';

var hasReaderSupport = typeof FileReader !== 'undefined' || typeof URL !== 'undefined';

var ImageTools = function () {
    function ImageTools() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ImageTools);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ImageTools, null, [{
        key: 'resize',
        value: function resize(file, maxDimensions, callback) {
            if (typeof maxDimensions === 'function') {
                callback = maxDimensions;
                maxDimensions = {
                    width: 640,
                    height: 480
                };
            }

            var maxWidth = maxDimensions.width;
            var maxHeight = maxDimensions.height;

            if (!ImageTools.isSupported() || !file.type.match(/image.*/)) {
                callback(file, false);
                return false;
            }

            if (file.type.match(/image\/gif/)) {
                callback(file, false);

                return false;
            }

            var image = document.createElement('img');

            image.onload = function (imgEvt) {
                var width = image.width;
                var height = image.height;
                var isTooLarge = false;

                if (width >= height && width > maxDimensions.width) {
                    height *= maxDimensions.width / width;
                    width = maxDimensions.width;
                    isTooLarge = true;
                } else if (height > maxDimensions.height) {
                    width *= maxDimensions.height / height;
                    height = maxDimensions.height;
                    isTooLarge = true;
                }

                if (!isTooLarge) {
                    callback(file, false);
                    return;
                }

                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                var ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, width, height);

                if (hasToBlobSupport) {
                    canvas.toBlob(function (blob) {
                        callback(blob, true);
                    }, file.type);
                } else {
                    var blob = ImageTools._toBlob(canvas, file.type);
                    callback(blob, true);
                }
            };
            ImageTools._loadImage(image, file);

            return true;
        }
    }, {
        key: '_toBlob',
        value: function _toBlob(canvas, type) {
            var dataURI = canvas.toDataURL(type);
            var dataURIParts = dataURI.split(',');
            var byteString = void 0;
            if (dataURIParts[0].indexOf('base64') >= 0) {
                byteString = atob(dataURIParts[1]);
            } else {
                byteString = decodeURIComponent(dataURIParts[1]);
            }
            var arrayBuffer = new ArrayBuffer(byteString.length);
            var intArray = new Uint8Array(arrayBuffer);

            for (var i = 0; i < byteString.length; i += 1) {
                intArray[i] = byteString.charCodeAt(i);
            }

            var mimeString = dataURIParts[0].split(':')[1].split(';')[0];
            var blob = null;

            if (hasBlobConstructor) {
                blob = new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], { type: mimeString });
            } else {
                var bb = new BlobBuilder();
                bb.append(arrayBuffer);
                blob = bb.getBlob(mimeString);
            }

            return blob;
        }
    }, {
        key: '_loadImage',
        value: function _loadImage(image, file, callback) {
            if (typeof URL === 'undefined') {
                var reader = new FileReader();
                reader.onload = function (evt) {
                    image.src = evt.target.result;
                    if (callback) {
                        callback();
                    }
                };
                reader.readAsDataURL(file);
            } else {
                if (file.hasOwnProperty('localURL')) {
                    image.src = file.localURL;
                } else {
                    image.src = URL.createObjectURL(file);
                }
                if (callback) {
                    callback();
                }
            }
        }
    }, {
        key: 'isSupported',
        value: function isSupported() {
            return typeof HTMLCanvasElement !== 'undefined' && hasBlobSupport && hasReaderSupport;
        }
    }]);

    return ImageTools;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageTools);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAssignedUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAssignedUserName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var ID_PATHS = ['user_id', 'userId', 'user.id', 'user.data.id', 'usuario_id', 'usuarioId', 'usuario.id', 'usuario.data.id', 'responsavel_id', 'responsavelId', 'responsavel.id', 'responsavel.data.id', 'assigned_user_id', 'assignedUserId', 'assigned_user.id', 'assigned_user.data.id', 'assignedUser.id', 'assignedUser.data.id'];

var NAME_PATHS = ['user_name', 'userName', 'user.name', 'user.data.name', 'usuario_name', 'usuarioName', 'usuario.nome', 'usuario.name', 'usuario.data.nome', 'usuario.data.name', 'responsavel_name', 'responsavelName', 'responsavel.nome', 'responsavel.name', 'responsavel.data.nome', 'responsavel.data.name', 'assigned_user_name', 'assignedUserName', 'assigned_user.name', 'assigned_user.data.name', 'assignedUser.name', 'assignedUser.data.name'];

var RELATION_KEYS = ['user', 'usuario', 'responsavel', 'assigned_user', 'assignedUser'];

var isDefinedValue = function isDefinedValue(value) {
  return value !== null && typeof value !== 'undefined' && value !== '';
};

var resolveRelationValue = function resolveRelationValue(item, relationKey, field) {
  var relation = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, relationKey);
  if (!isDefinedValue(relation)) {
    return null;
  }

  if (field === 'id' && typeof relation === 'number' || field === 'id' && typeof relation === 'string') {
    return relation;
  }

  if ((typeof relation === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(relation)) !== 'object') {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find([__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(relation, field), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(relation, 'data.' + field)], isDefinedValue) || null;
};

var getAssignedUserId = function getAssignedUserId(item) {
  if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) !== 'object') return null;

  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ID_PATHS.map(function (path) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, path);
  })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(RELATION_KEYS.map(function (key) {
    return resolveRelationValue(item, key, 'id');
  }))), isDefinedValue) || null;
};

var getAssignedUserName = function getAssignedUserName(item) {
  if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) !== 'object') return '';

  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(NAME_PATHS.map(function (path) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, path);
  })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(RELATION_KEYS.map(function (key) {
    return resolveRelationValue(item, key, 'name');
  })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(RELATION_KEYS.map(function (key) {
    return resolveRelationValue(item, key, 'nome');
  }))), function (value) {
    return typeof value === 'string' && value.trim().length > 0;
  }) || '';
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeMoney;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatBRLCurrency;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatBRDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function normalizeMoney(value) {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return value;

  var rawValue = String(value).replace(/[^0-9,.-]/g, '');
  if (!rawValue) return 0;

  var normalized = rawValue.indexOf(',') !== -1 ? rawValue.replace(/\./g, '').replace(',', '.') : rawValue;

  var parsed = parseFloat(normalized);
  return isNaN(parsed) ? 0 : parsed;
}

function formatBRLCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(normalizeMoney(value));
}

function formatBRDate(value) {
  if (!value) return '--';

  if (typeof value === 'string') {
    var match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) return match[3] + '/' + match[2] + '/' + match[1];
  }

  var parsed = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, [__WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601, 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY'], true);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '--';
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeSavoyNetItem */
/* harmony export (immutable) */ __webpack_exports__["d"] = splitSavoyNetValues;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeSavoyNetList;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseSavoyNetFromApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildSavoyNetUrl;
var SAVOY_NET_URL_PREFIX_REGEX = /^https?:\/\/savoynet\.com\.br\/?/i;

function normalizeSavoyNetItem(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim().replace(SAVOY_NET_URL_PREFIX_REGEX, '').trim();
}

function splitSavoyNetValues(value) {
  if (value === null || value === undefined) {
    return [];
  }

  return String(value).split(/[\n,;]+/g);
}

function normalizeSavoyNetList(value) {
  var source = Array.isArray(value) ? value : splitSavoyNetValues(value);
  var normalized = [];
  var seen = {};

  source.forEach(function (item) {
    var normalizedItem = normalizeSavoyNetItem(item);

    if (!normalizedItem || seen[normalizedItem]) {
      return;
    }

    seen[normalizedItem] = true;
    normalized.push(normalizedItem);
  });

  return normalized;
}

function parseSavoyNetFromApi(value) {
  if (Array.isArray(value)) {
    return normalizeSavoyNetList(value);
  }

  var normalized = normalizeSavoyNetItem(value);
  return normalized ? [normalized] : [];
}

function buildSavoyNetUrl(numero) {
  var normalized = normalizeSavoyNetItem(numero);
  return normalized ? 'https://www.savoynet.com.br/Dados_contrato.aspx?contrato=' + normalized : '';
}

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  "data-v-3561f683",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasCustomPermissionsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shouldUseCustomPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCustomPermissionsPayloadInvalid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return normalizePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasGeneralAccessFromPermissions; });
/* unused harmony export hasExplicitGeneralAccessFromPermissions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasGeneralAccess; });
/* unused harmony export hasExplicitGeneralAccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasGranularPermission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);



var GENERAL_ACCESS_MAP = {
  administracao_usuarios: ['usuarios', 'users', 'user'],
  administracao_niveis_acesso: ['niveis_acesso', 'niveis', 'roles', 'custom_roles', 'access_levels'],
  visualizar_relatorios: ['relatorios', 'relatorio', 'reports', 'report']
};

var GENERAL_ACCESS_ACTION_MAP = {
  administracao_usuarios: 'view',
  administracao_niveis_acesso: 'view',
  visualizar_relatorios: 'view'
};

var TRUE_STRING_VALUES = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(['1', 'true', 'yes', 'sim']);
var FALSE_STRING_VALUES = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(['0', 'false', 'no', 'nao', 'não', 'null', 'undefined', '']);

var toPermissionFlag = function toPermissionFlag(value) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
    return !!value;
  }
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    if (TRUE_STRING_VALUES.has(normalized)) return true;
    if (FALSE_STRING_VALUES.has(normalized)) return false;
  }
  return !!value;
};

var normalizePermissionValue = function normalizePermissionValue(value) {
  if (Array.isArray(value)) {
    return value.map(normalizePermissionValue);
  }

  if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).reduce(function (acc, key) {
      acc[key] = normalizePermissionValue(value[key]);
      return acc;
    }, {});
  }

  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    if (TRUE_STRING_VALUES.has(normalized)) return true;
    if (FALSE_STRING_VALUES.has(normalized)) return false;
  }

  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }

  return value;
};

var hasCustomPermissionsPayload = function hasCustomPermissionsPayload(user) {
  if (!user || (typeof user === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(user)) !== 'object') return false;
  return Object.prototype.hasOwnProperty.call(user, 'custom_permissions');
};

var shouldUseCustomPermissions = function shouldUseCustomPermissions(user) {
  if (!hasCustomPermissionsPayload(user)) return false;
  return typeof user.custom_permissions !== 'undefined';
};

var isCustomPermissionsPayloadInvalid = function isCustomPermissionsPayloadInvalid(user) {
  return !shouldUseCustomPermissions(user);
};

var normalizePermissions = function normalizePermissions(permissions) {
  if (!permissions) return {};
  if (typeof permissions === 'string') {
    try {
      var parsedPermissions = JSON.parse(permissions);
      if (!parsedPermissions || (typeof parsedPermissions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(parsedPermissions)) !== 'object') return {};
      return normalizePermissionValue(parsedPermissions);
    } catch (e) {
      return {};
    }
  }
  if ((typeof permissions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(permissions)) === 'object') return normalizePermissionValue(permissions);
  return {};
};

var hasActionInCategory = function hasActionInCategory(permissions, category, action) {
  var categoryPermissions = permissions[category];
  if (categoryPermissions === true) return true;
  if (!categoryPermissions || (typeof categoryPermissions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(categoryPermissions)) !== 'object') return false;

  if (action === 'view') {
    var viewAliases = ['view', 'viewAny', 'visualizar'];
    var hasViewAlias = viewAliases.some(function (alias) {
      return typeof categoryPermissions[alias] !== 'undefined';
    });

    if (hasViewAlias) {
      return viewAliases.some(function (alias) {
        return typeof categoryPermissions[alias] !== 'undefined' && toPermissionFlag(categoryPermissions[alias]);
      });
    }
  }

  if (typeof categoryPermissions[action] !== 'undefined') {
    return toPermissionFlag(categoryPermissions[action]);
  }

  return toPermissionFlag(categoryPermissions.view);
};

var hasGeneralAccessFromPermissions = function hasGeneralAccessFromPermissions(permissions, permissionKey) {
  if (!permissions || (typeof permissions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(permissions)) !== 'object') return false;

  var generalAccess = permissions.acessos_gerais;
  if (generalAccess && (typeof generalAccess === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(generalAccess)) === 'object' && typeof generalAccess[permissionKey] !== 'undefined') {
    return toPermissionFlag(generalAccess[permissionKey]);
  }

  if (typeof permissions[permissionKey] !== 'undefined') {
    return toPermissionFlag(permissions[permissionKey]);
  }

  var mappedCategories = GENERAL_ACCESS_MAP[permissionKey] || [];
  var expectedAction = GENERAL_ACCESS_ACTION_MAP[permissionKey] || 'view';

  if (mappedCategories.some(function (category) {
    return hasActionInCategory(permissions, category, expectedAction);
  })) {
    return true;
  }

  return mappedCategories.some(function (category) {
    var flatActionKey = category + '.' + expectedAction;
    if (typeof permissions[flatActionKey] !== 'undefined') return toPermissionFlag(permissions[flatActionKey]);

    if (expectedAction === 'view') {
      var flatViewAnyKey = category + '.viewAny';
      if (typeof permissions[flatViewAnyKey] !== 'undefined') return toPermissionFlag(permissions[flatViewAnyKey]);

      var flatBooleanKey = category + '.visualizar';
      if (typeof permissions[flatBooleanKey] !== 'undefined') return toPermissionFlag(permissions[flatBooleanKey]);
    }

    return false;
  });
};

var hasExplicitGeneralAccessFromPermissions = function hasExplicitGeneralAccessFromPermissions(permissions, permissionKey) {
  if (!permissions || (typeof permissions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(permissions)) !== 'object') return false;

  var generalAccess = permissions.acessos_gerais;
  if (generalAccess && (typeof generalAccess === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(generalAccess)) === 'object' && typeof generalAccess[permissionKey] !== 'undefined') {
    return toPermissionFlag(generalAccess[permissionKey]);
  }

  if (typeof permissions[permissionKey] !== 'undefined') {
    return toPermissionFlag(permissions[permissionKey]);
  }

  return false;
};

var hasGeneralAccess = function hasGeneralAccess(user, permissionKey) {
  if (!user) return false;
  var permissions = normalizePermissions(user.custom_permissions);
  return hasGeneralAccessFromPermissions(permissions, permissionKey);
};

var hasExplicitGeneralAccess = function hasExplicitGeneralAccess(user, permissionKey) {
  if (!user) return false;
  var permissions = normalizePermissions(user.custom_permissions);
  return hasExplicitGeneralAccessFromPermissions(permissions, permissionKey);
};

var hasGranularPermission = function hasGranularPermission(user, category, action) {
  if (!user) return false;
  var permissions = normalizePermissions(user.custom_permissions);
  return hasActionInCategory(permissions, category, action);
};

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moneyOptions = {
  'symbol': '',
  'thousand': '.',
  'decimal': ',',
  'precision': 2
};

/* harmony default export */ __webpack_exports__["a"] = (moneyOptions);

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  "data-v-8ecb6356",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  "data-v-6fa3eadb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-20fc8c51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__websanova_vue_auth__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(4);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      if (req.url.indexOf(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* apiURL */]) !== -1) {
        this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
      }
    },
    response: function response(res) {
      return res.data.access_token;
    }
  },
  http: __webpack_require__(416),
  router: __webpack_require__(417),
  loginData: {
    url: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* apiURL */] + '/clients/mobile/login'
  },
  fetchData: {
    url: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* apiURL */] + '/userinfo'
  },
  refreshData: {
    enabled: false
  },
  logoutData: {
    url: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* apiURL */] + '/logout',
    makeRequest: true,
    redirect: false
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserRestrictionFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return primeUserRestrictions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var toBoolean = function toBoolean(value) {
  if (typeof value === 'string') {
    return ['1', 'true', 'sim', 'yes'].includes(value.trim().toLowerCase());
  }

  return value === true || value === 1;
};

var getDirectRestrictionFlag = function getDirectRestrictionFlag(user, flag) {
  var camelFlag = flag.replace(/_([a-z])/g, function (_, char) {
    return char.toUpperCase();
  });
  var candidates = [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'data.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'data.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_role.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_role.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_role.data.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_role.data.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'customRole.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'customRole.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'customRole.data.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'customRole.data.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'role.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'role.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'role.data.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'role.data.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_permissions.acessos_gerais.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_permissions.acessos_gerais.' + camelFlag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_permissions.acessosGerais.' + flag), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(user, 'custom_permissions.acessosGerais.' + camelFlag)];

  var definedValue = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(candidates, function (value) {
    return typeof value !== 'undefined' && value !== null;
  });
  if (typeof definedValue === 'undefined') {
    return null;
  }

  return toBoolean(definedValue);
};

var getUserRestrictionFlag = function getUserRestrictionFlag(user, flag) {
  if (!user) return false;

  var directValue = getDirectRestrictionFlag(user, flag);
  if (directValue !== null) {
    return directValue;
  }
  return false;
};

var primeUserRestrictions = function primeUserRestrictions() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
};

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_users__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_constants__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_utils__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_anexos__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_fotos__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_imoveis__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_relatorios__ = __webpack_require__(514);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    users: __WEBPACK_IMPORTED_MODULE_2__modules_users__["a" /* default */],
    constants: __WEBPACK_IMPORTED_MODULE_3__modules_constants__["a" /* default */],
    utils: __WEBPACK_IMPORTED_MODULE_4__modules_utils__["a" /* default */],
    anexos: __WEBPACK_IMPORTED_MODULE_5__modules_anexos__["a" /* default */],
    fotos: __WEBPACK_IMPORTED_MODULE_6__modules_fotos__["a" /* default */],
    imoveis: __WEBPACK_IMPORTED_MODULE_7__modules_imoveis__["a" /* default */],
    relatorios: __WEBPACK_IMPORTED_MODULE_8__modules_relatorios__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),n=" *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; display: flex; justify-content: space-between; align-items: center; } .title-v-img[data-v-5928e1c7] { font-family: 'Avenir', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .close-v-img[data-v-5928e1c7] { width: 80px; font-family: 'Avenir', Helvetica, Arial, sans-serif; line-height: 50px; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .close-v-img[data-v-5928e1c7] { margin-right: 10px; color: #E5E6EB; font-size: 30px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; text-align: right; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: 'Avenir', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ";t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(document.createTextNode(n)),e.appendChild(t)}}();var ImgScreen={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():n("div",{staticClass:"fullscreen-v-img",on:{click:function(t){if(t.target!==t.currentTarget)return null;e.close()}}},[n("div",{staticClass:"header-v-img"},[n("span",{staticClass:"count-v-img"},[e.images.length>1?n("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),n("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex])+" ")]),n("span",{staticClass:"close-v-img",on:{click:e.close}},[e._v("×")])]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"prev-v-img",on:{click:e.prev}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"next-v-img",on:{click:e.next}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),n("div",{staticClass:"content-v-img"},[n("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)])},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function(){return{images:[],titles:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null,handlers:{}}},watch:{closed:function(e){e&&this.handlers.closed&&this.handlers.closed(),!e&&this.handlers.opened&&this.handlers.opened()}},methods:{fireChangeEvent:function(){this.handlers.changed&&this.handlers.changed(this.currentImageIndex)},close:function(){this.closed||(document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0)},next:function(){this.closed||(this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0,this.fireChangeEvent())},prev:function(){this.closed||(this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1,this.fireChangeEvent())},showUI:function(){var e=this;this.closed||(clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1},3500))}},created:function(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev()}),window.addEventListener("scroll",function(){e.close()}),window.addEventListener("mousemove",function(){e.showUI()})}},babelHelpers={},asyncGenerator=function(){function e(e){this.value=e}function t(t){function n(a,r){try{var o=t[a](r),s=o.value;s instanceof e?Promise.resolve(s.value).then(function(e){n("next",e)},function(e){n("throw",e)}):i(o.done?"return":"normal",o.value)}catch(e){i("throw",e)}}function i(e,t){switch(e){case"return":a.resolve({value:t,done:!0});break;case"throw":a.reject(t);break;default:a.resolve({value:t,done:!1})}(a=a.next)?n(a.key,a.arg):r=null}var a,r;this._invoke=function(e,t){return new Promise(function(i,o){var s={key:e,arg:t,resolve:i,reject:o,next:null};r?r=r.next=s:(a=r=s,n(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)},install=function(e,t){var n=e.extend(ImgScreen),i={altAsTitle:!1};t=Object.assign(i,t),e.directive("img",{bind:function(i,a){var r="pointer",o=i.src,s=a.arg||null,c=void 0,l={};t.altAsTitle&&(c=i.alt),void 0!==a.value&&(r=a.value.cursor||r,o=a.value.src||o,s=a.value.group||s,c=a.value.title||c,l.opened=a.value.opened,l.closed=a.value.closed,l.changed=a.value.changed),i.setAttribute("data-vue-img-group",s||""),i.setAttribute("data-vue-img-src",o),i.setAttribute("data-vue-img-title",c||""),o||console.error("v-img element missing src parameter."),i.style.cursor=r;var d=window.vueImg;if(!d){var u=document.createElement("div");u.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(u),d=window.vueImg=(new n).$mount("#imageScreen")}i.addEventListener("click",function(){document.querySelector("body").classList.add("body-fs-v-img");var t=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+s+'"]')));0===t.length?(e.set(d,"images",[o]),e.set(d,"titles",[c])):(e.set(d,"images",t.map(function(e){return e.dataset.vueImgSrc})),e.set(d,"titles",t.map(function(e){return e.dataset.vueImgTitle})),e.set(d,"currentImageIndex",t.indexOf(i))),e.set(d,"handlers",l),e.set(d,"closed",!1)})}})};/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);





if (typeof window !== 'undefined') {
  var slick = __webpack_require__(915);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.create();
  },

  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
  },

  methods: {
    create: function create() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },

    destroy: function destroy() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
    },

    reSlick: function reSlick() {
      this.destroy();
      this.create();
    },

    next: function next() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickNext');
    },

    prev: function prev() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPrev');
    },

    pause: function pause() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPause');
    },

    play: function play() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPlay');
    },

    goTo: function goTo(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },

    currentSlide: function currentSlide() {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickCurrentSlide');
    },

    add: function add(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },

    remove: function remove(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },

    filter: function filter(filterData) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickFilter', filterData);
    },

    unfilter: function unfilter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickUnfilter');
    },

    getOption: function getOption(option) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGetOption', option);
    },

    setOption: function setOption(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },

    setPosition: function setPosition() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('setPosition');
    },

    onAfterChange: function onAfterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },

    onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },

    onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },

    onDestroy: function onDestroy(event, slick) {
      this.$emit('destroy', event, slick);
    },

    onEdge: function onEdge(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },

    onInit: function onInit(event, slick) {
      this.$emit('init', event, slick);
    },

    onReInit: function onReInit(event, slick) {
      this.$emit('reInit', event, slick);
    },

    onSetPosition: function onSetPosition(event, slick) {
      this.$emit('setPosition', event, slick);
    },

    onSwipe: function onSwipe(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },

    onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },

    onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    }
  }

});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Utils_Loading__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Utils_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Utils_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Template_TemplateLeftNav__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Template_TemplateLeftNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Template_TemplateLeftNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Utils_Snackbar__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Utils_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Utils_Snackbar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_Utils_Loading___default.a,
    TemplateLeftNav: __WEBPACK_IMPORTED_MODULE_1__components_Template_TemplateLeftNav___default.a,
    Snackbar: __WEBPACK_IMPORTED_MODULE_2__components_Utils_Snackbar___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('constants/loadConstants');
    this.$store.dispatch('imoveis/loadListaFiltros');
    if (this.$auth.check()) {
      this.$auth.fetch();
    }
  },
  data: function data() {
    return {
      transitionName: '',
      isMobile: false,
      leftNavOpen: false
    };
  },

  computed: {
    snackbar: function snackbar() {
      return this.$store.getters['utils/snackbar'];
    }
  },
  mounted: function mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },

  watch: {
    '$route': function $route(to, from) {
      if (this.isMobile && this.isRelatoriosRoute(to.name)) {
        this.$router.replace({ name: 'ImoveisRoot' });
        return;
      }

      var toDepth = to.path.split('/').length;
      var fromDepth = from.path.split('/').length;
      this.transitionName = toDepth < fromDepth ? 'fade-transition' : 'slide-x-transition';

      if (this.isMobile) {
        this.leftNavOpen = false;
      }

      this.$store.dispatch('utils/hideLoading');
      this.$store.dispatch('utils/emptySnackbar');
    }
  },
  methods: {
    isRelatoriosRoute: function isRelatoriosRoute(routeName) {
      return typeof routeName === 'string' && routeName.indexOf('Relatorios') === 0;
    },
    enforceMobileRouteRestrictions: function enforceMobileRouteRestrictions() {
      if (this.isMobile && this.isRelatoriosRoute(this.$route.name)) {
        this.$router.replace({ name: 'ImoveisRoot' });
      }
    },
    updateViewport: function updateViewport() {
      var mobile = window.innerWidth < 960;

      if (mobile !== this.isMobile) {
        this.isMobile = mobile;
        this.leftNavOpen = false;
      } else if (!mobile) {
        this.leftNavOpen = false;
      }

      this.enforceMobileRouteRestrictions();
    },
    toggleLeftNav: function toggleLeftNav() {
      this.leftNavOpen = !this.leftNavOpen;
    },
    onLeftNavUpdate: function onLeftNavUpdate(value) {
      this.leftNavOpen = !!value;
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Utils_FileInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IrParaOTopo: __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default.a,
    FileInput: __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput___default.a,
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      componentVoltar: this.$route.params.tipo === 'geral' ? 'ImoveisDetalhesResumo' : 'ImoveisDetalhes' + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.upperFirst(this.$route.params.tipo),
      dialog: false,
      dialogEditar: false,
      dialogApagar: false,
      imovelId: this.$route.params.id,
      inputKey: Math.random(),
      form: {
        fields: {
          tipo: this.$route.params.tipo,
          legenda: '',
          anexo: null,
          anexoFilename: ''
        }
      },
      formEditar: {
        fields: {
          legenda: ''
        }
      },
      itemEditar: {},
      itemApagar: {}
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    anexos: function anexos() {
      return this.$store.getters['imoveis/anexos'](this.$route.params.tipo);
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    onFilePicked: function onFilePicked(event) {
      this.form.fields.anexo = event;
    },
    descartar: function descartar() {
      this.dialog = false;
      this.dialogEditar = false;
      this.dialogApagar = false;
      this.form.fields.legenda = '';
      this.form.fields.anexo = null;
      this.form.fields.anexoFilename = '';
      this.formEditar.fields.legenda = '';
      this.inputKey = Math.random();
      this.errors.clear();
    },
    beforeEditar: function beforeEditar(item) {
      document.querySelectorAll('.menu__content').forEach(function (a) {
        a.style.display = 'none';
      });
      this.formEditar.fields.legenda = item.legenda;
      this.itemEditar = item;
    },
    beforeApagar: function beforeApagar(item) {
      document.querySelectorAll('.menu__content').forEach(function (a) {
        a.style.display = 'none';
      });
      this.itemApagar = item;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('adicionar').then(function (result) {
        if (result) {
          var formData = new FormData();

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.form.fields).forEach(function (key) {
            formData.append(key, _this2.form.fields[key]);
          });

          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/anexos/' + _this2.imovelId, formData).then(function () {
            _this2.$store.dispatch('imoveis/loadImovel', { id: _this2.imovelId }).finally(function () {
              _this2.descartar();
              _this2.$store.dispatch('utils/hideLoading');
            });
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitEditar: function onSubmitEditar() {
      var _this3 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('editar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/anexos/' + _this3.itemEditar.id, _this3.formEditar.fields).then(function (response) {
            _this3.$store.dispatch('imoveis/updateAnexo', { item: _this3.itemEditar, legenda: _this3.formEditar.fields.legenda });
            _this3.descartar();
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitApagar: function onSubmitApagar() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/anexos/' + this.itemApagar.id).then(function (response) {
        _this4.$store.dispatch('imoveis/deleteAnexo', _this4.itemApagar);
        _this4.descartar();
        _this4.$store.dispatch('utils/hideLoading');
      }, function () {
        _this4.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this4.$store.dispatch('utils/hideLoading');
      });
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos___default.a
  },
  data: function data() {
    return {
      form: {
        fields: {
          area_terreno: '',
          area_construida: '',
          area_util: '',
          calcada: false,
          muro: false,
          desenho: []
        }
      },
      map: {
        center: {
          lat: null,
          lng: null
        }
      },
      polygon: {
        paths: [],
        edited: false,
        area: 0,
        distanciaPontos: 0.0001,
        options: {
          strokeWeight: 0,
          fillColor: '',
          draggable: true
        }
      }
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewArea: function canViewArea() {
      return this.$hasGranularPermission('area', 'view');
    },
    canEditArea: function canEditArea() {
      return this.$hasGranularPermission('area', 'edit');
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty));
    },
    polygonOptions: function polygonOptions() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.polygon.options, {
        draggable: this.canEditArea
      });
    }
  },
  watch: {
    imovel: function imovel() {
      if (this.imovel.hasOwnProperty('area')) {
        this.form.fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.imovel.area.data);
      }
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(this.imovel, 'endereco.data.latitude') && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(this.imovel, 'endereco.data.longitude')) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(this.imovel, 'area.data.desenho') && this.imovel.area.data.desenho !== null && this.imovel.area.data.desenho.length > 1) {
          this.map.center.lat = this.imovel.area.data.desenho[0].lat;
          this.map.center.lng = this.imovel.area.data.desenho[0].lng;

          this.polygon.paths = this.imovel.area.data.desenho;
          this.polygon.edited = true;
        } else {
          this.map.center.lat = this.imovel.endereco.data.latitude;
          this.map.center.lng = this.imovel.endereco.data.longitude;

          this.polygon.paths.push({ lat: this.map.center.lat, lng: this.map.center.lng });
          this.polygon.paths.push({ lat: this.map.center.lat, lng: this.map.center.lng + this.polygon.distanciaPontos });
          this.polygon.paths.push({ lat: this.map.center.lat + this.polygon.distanciaPontos, lng: this.map.center.lng + this.polygon.distanciaPontos });
          this.polygon.paths.push({ lat: this.map.center.lat + this.polygon.distanciaPontos, lng: this.map.center.lng });
        }
      }
    },
    'polygon.paths': function polygonPaths() {
      if (this.polygon.edited) {
        this.form.fields.desenho = this.polygon.paths;
      }
    },
    'polygon.edited': function polygonEdited(value) {
      if (value) {
        this.polygon.options.fillColor = '#F37021';
      } else {
        this.polygon.options.fillColor = 'grey';
      }
    },
    'form.fields.area_terreno': function formFieldsArea_terreno(value) {
      this.form.fields.area_terreno = this.formatArea(value);
    },
    'form.fields.area_construida': function formFieldsArea_construida(value) {
      this.form.fields.area_construida = this.formatArea(value);
    },
    'form.fields.area_util': function formFieldsArea_util(value) {
      this.form.fields.area_util = this.formatArea(value);
    }
  },
  methods: {
    updateEdited: function updateEdited(resultPaths) {
      if (!this.canEditArea) return;
      var newPolygonPaths = [];
      this.$refs.polygon.$polygonObject.getPath().forEach(function (path) {
        newPolygonPaths.push({ lat: path.lat(), lng: path.lng() });
      });
      this.calculateArea();
      this.polygon.paths = newPolygonPaths;
      this.polygon.edited = true;
    },
    calculateArea: function calculateArea() {
      if (google && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(google, 'maps.geometry.spherical')) {
        this.polygon.area = google.maps.geometry.spherical.computeArea(this.$refs.polygon.$polygonObject.getPath());
      }
    },
    handleClickForDelete: function handleClickForDelete($event) {
      if (!this.canEditArea) return;
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject.getPaths().getAt($event.path).removeAt($event.vertex);
      }
    },
    formatArea: function formatArea(area) {
      if (area === null) {
        return '';
      }

      var value = area;
      var newValue = String(value).replace(/\./g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');

      return newValue;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.canEditArea) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        var fieldsToSubmit = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.form.fields);
        fieldsToSubmit.area_terreno = fieldsToSubmit.area_terreno ? parseInt(fieldsToSubmit.area_terreno.replace(/\./g, '')) : null;
        fieldsToSubmit.area_construida = fieldsToSubmit.area_construida ? parseInt(fieldsToSubmit.area_construida.replace(/\./g, '')) : null;
        fieldsToSubmit.area_util = fieldsToSubmit.area_util ? parseInt(fieldsToSubmit.area_util.replace(/\./g, '')) : null;
        fieldsToSubmit.desenho = fieldsToSubmit.desenho !== null && fieldsToSubmit.desenho.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fieldsToSubmit.desenho) : null;

        if (result) {
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* apiURL */] + '/imoveis/' + _this2.$route.params.id, { area: fieldsToSubmit }).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default.a
  },
  data: function data() {
    return {
      coordsUsuario: {
        lat: this.$store.getters['utils/coords'].latitude,
        lng: this.$store.getters['utils/coords'].longitude
      },
      form: {
        fields: {
          cep: '',
          tipo: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: '',
          loteamento: false,
          loteamento_nome: '',
          loteamento_lote: '',
          loteamento_quadra: '',
          coordenadas_manual: false,
          latitude_manual: '',
          longitude_manual: ''
        }
      }
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    enderecoTipo: function enderecoTipo() {
      return this.$store.getters['constants/enderecoTipo'];
    },
    enderecoUF: function enderecoUF() {
      return this.$store.getters['constants/enderecoUF'];
    },
    canViewEndereco: function canViewEndereco() {
      return this.$hasGranularPermission('endereco', 'view');
    },
    canEditEndereco: function canEditEndereco() {
      return this.$hasGranularPermission('endereco', 'edit');
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    },
    coords: function coords() {
      if (this.imovel.hasOwnProperty('endereco') && this.imovel.endereco.data.latitude !== null && this.imovel.endereco.data.longitude !== null) {
        return {
          lat: this.imovel.endereco ? this.imovel.endereco.data.latitude : null,
          lng: this.imovel.endereco ? this.imovel.endereco.data.longitude : null
        };
      } else {
        return this.coordsUsuario;
      }
    }
  },
  watch: {
    imovel: function imovel() {
      if (this.imovel.hasOwnProperty('endereco')) {
        this.form.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.imovel.endereco.data);

        this.$set(this.form.fields, 'latitude_manual', this.imovel.endereco.data.latitude);
        this.$set(this.form.fields, 'longitude_manual', this.imovel.endereco.data.longitude);
      }
    }
  },
  methods: {
    buscarCEP: function buscarCEP() {
      var _this2 = this;

      if (!this.canEditEndereco) return;
      if (this.form.fields.cep.length !== 9) {
        return;
      }

      this.$store.dispatch('utils/showLoading');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* cepURL */] + '/' + this.form.fields.cep + '/json').then(function (response) {
        if (response.data.erro) {
          _this2.$store.dispatch('utils/showSnackbar', {
            text: 'CEP não encontrado. Preencha o endereço manualmente'
          });
        } else {
          _this2.form.fields.tipo = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.first(response.data.logradouro.split(' '));
          _this2.form.fields.logradouro = response.data.logradouro.substr(response.data.logradouro.indexOf(' ') + 1);
          _this2.form.fields.bairro = response.data.bairro;
          _this2.form.fields.cidade = response.data.localidade;
          _this2.form.fields.uf = response.data.uf;
        }
        _this2.$store.dispatch('utils/hideLoading');
      }, function () {
        _this2.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this2.$store.dispatch('utils/hideLoading');
      });
    },
    updateManualCoords: function updateManualCoords(event) {
      if (!this.canEditEndereco) return;
      this.$set(this.form.fields, 'latitude_manual', event.latLng.lat());
      this.$set(this.form.fields, 'longitude_manual', event.latLng.lng());
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (!this.canEditEndereco) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis/' + _this3.$route.params.id, { endereco: _this3.form.fields }).then(function (response) {
            _this3.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this3.$store.dispatch('utils/hideLoading');
          }, function (error) {
            var errorText = '';
            if (error.response.data.message === 'COORDS NOT FOUND') {
              errorText = 'Endereço não localizado. Preencha as coordenadas manualmente.';
            } else {
              errorText = 'Servidor indisponível. Tente novamente mais tarde.';
            }
            _this3.$store.dispatch('utils/showSnackbar', {
              text: errorText
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fab: false,
      dialogSubstituirVistoria: false
    };
  },
  mounted: function mounted() {
    this.$primeUserRestrictions();
  },

  props: ['status'],
  computed: {
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    showVistoriaButton: function showVistoriaButton() {
      return !this.isLimitadoTarefas && this.$hasGranularPermission('vistoria', 'add');
    },
    showTarefasButton: function showTarefasButton() {
      return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add');
    }
  },
  methods: {
    substituirVistoria: function substituirVistoria(event) {
      var imovel = this.$store.getters['imoveis/detalhes'];

      if (imovel.hasOwnProperty('vistoria')) {
        this.fab = false;
        this.dialogSubstituirVistoria = true;
      } else {
        this.$router.push({ name: 'VistoriaAdicionar', params: { id: this.$route.params.id } });
      }
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Utils_FileInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IrParaOTopo: __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default.a,
    FileInput: __WEBPACK_IMPORTED_MODULE_5__Utils_FileInput___default.a,
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      dialog: false,
      dialogEditar: false,
      dialogApagar: false,
      imovelId: this.$route.params.id,
      inputKey: Math.random(),
      form: {
        fields: {
          tipo: this.$route.params.tipo,
          legenda: '',
          foto: null,
          fotoFilename: ''
        }
      },
      formEditar: {
        fields: {
          legenda: ''
        }
      },
      itemEditar: {},
      itemApagar: {}
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    fotos: function fotos() {
      return this.$store.getters['imoveis/fotos'](this.$route.params.tipo);
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    onFilePicked: function onFilePicked(event) {
      this.form.fields.foto = event;
    },
    descartar: function descartar() {
      this.dialog = false;
      this.dialogEditar = false;
      this.dialogApagar = false;
      this.form.fields.legenda = '';
      this.form.fields.foto = null;
      this.form.fields.fotoFilename = '';
      this.formEditar.fields.legenda = '';
      this.inputKey = Math.random();
      this.errors.clear();
    },
    beforeEditar: function beforeEditar(item) {
      document.querySelectorAll('.menu__content').forEach(function (a) {
        a.style.display = 'none';
      });
      this.formEditar.fields.legenda = item.legenda;
      this.itemEditar = item;
    },
    beforeApagar: function beforeApagar(item) {
      document.querySelectorAll('.menu__content').forEach(function (a) {
        a.style.display = 'none';
      });
      this.itemApagar = item;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('adicionar').then(function (result) {
        if (result) {
          var fieldsFormatados = {
            id: _this2.imovelId,
            tipo: _this2.form.fields.tipo,
            legenda: _this2.form.fields.legenda,
            foto: _this2.form.fields.foto,
            fotoFilename: _this2.form.fields.fotoFilename
          };

          _this2.$store.dispatch('fotos/adicionarFoto', { fields: fieldsFormatados }).then(function (response) {
            if (response === false) {
              _this2.$store.dispatch('utils/hideLoading');
              return;
            }

            _this2.$store.dispatch('imoveis/loadImovel', { id: _this2.imovelId }).finally(function () {
              _this2.descartar();
              _this2.$store.dispatch('utils/hideLoading');
            });
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitEditar: function onSubmitEditar() {
      var _this3 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('editar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/fotos/' + _this3.itemEditar.id, _this3.formEditar.fields).then(function (response) {
            _this3.$store.dispatch('imoveis/updateFoto', { item: _this3.itemEditar, legenda: _this3.formEditar.fields.legenda });
            _this3.descartar();
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitApagar: function onSubmitApagar() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/fotos/' + this.itemApagar.id).then(function (response) {
        _this4.$store.dispatch('imoveis/deleteFoto', _this4.itemApagar);
        _this4.descartar();
        _this4.$store.dispatch('utils/hideLoading');
      }, function () {
        _this4.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this4.$store.dispatch('utils/hideLoading');
      });
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_savoynet__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      dialogExcluir: false,
      savoynetInput: '',
      form: {
        fields: {
          apelido: '',
          proprietarioSelect: '',
          proprietario: '',
          tipoSelect: '',
          tipo: '',
          savoynet: []
        }
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('imoveis/loadProprietarios');
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewInfo: function canViewInfo() {
      return this.$hasGranularPermission('info', 'view');
    },
    canEditInfo: function canEditInfo() {
      return this.$hasGranularPermission('info', 'edit');
    },
    canDeleteInfo: function canDeleteInfo() {
      return this.$hasGranularPermission('info', 'delete');
    },
    canViewFotos: function canViewFotos() {
      return this.$hasGranularPermission('fotos', 'view');
    },
    imovelTipoSugestoes: function imovelTipoSugestoes() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.$store.getters['constants/imovelTipo'], this.getImovelTipoItemValue)));
    },
    tipos: function tipos() {
      var tipos = this.imovelTipoSugestoes.slice(0);
      tipos.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true });
      return tipos;
    },
    proprietarios: function proprietarios() {
      var proprietarios = this.$store.getters['imoveis/proprietarios'].slice(0);

      proprietarios.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true });

      return proprietarios;
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    }
  },
  watch: {
    imovel: function imovel() {
      this.form.fields.apelido = this.imovel.apelido;
      this.form.fields.proprietarioSelect = this.imovel.proprietario;
      this.form.fields.proprietario = this.imovel.proprietario;
      this.setTipoFromValue(this.imovel.tipo);
      this.form.fields.savoynet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["a" /* parseSavoyNetFromApi */])(this.imovel.savoynet);
      this.savoynetInput = '';
    },
    'form.fields.proprietarioSelect': function formFieldsProprietarioSelect(value) {
      if (value === 'Preencher manualmente') {
        this.form.fields.proprietario = '';
      } else {
        this.form.fields.proprietario = value;
      }
    },
    'form.fields.tipoSelect': function formFieldsTipoSelect(value, oldValue) {
      if (value === 'Preencher manualmente') {
        if (oldValue && oldValue !== 'Preencher manualmente') {
          this.form.fields.tipo = '';
        }
      } else {
        this.form.fields.tipo = value;
      }
    }
  },
  methods: {
    getImovelTipoItemValue: function getImovelTipoItemValue(item) {
      if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
        return (item.text || item.value || '').trim();
      }

      return String(item || '').trim();
    },
    normalizeTipo: function normalizeTipo(value) {
      return String(value || '').trim().replace(/\s+/g, ' ');
    },
    setTipoFromValue: function setTipoFromValue(value) {
      var tipo = this.normalizeTipo(value);
      this.form.fields.tipo = tipo;

      if (!tipo) {
        this.form.fields.tipoSelect = '';
        return;
      }

      if (this.imovelTipoSugestoes.indexOf(tipo) !== -1) {
        this.form.fields.tipoSelect = tipo;
        return;
      }

      this.form.fields.tipoSelect = 'Preencher manualmente';
    },
    addSavoyNetValues: function addSavoyNetValues(values) {
      if (!this.canEditInfo) return;
      this.form.fields.savoynet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["c" /* normalizeSavoyNetList */])(this.form.fields.savoynet.concat(values));
    },
    commitSavoyNetInput: function commitSavoyNetInput() {
      if (!this.canEditInfo) return;
      if (!this.savoynetInput) {
        return;
      }

      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(this.savoynetInput));
      this.savoynetInput = '';
    },
    onSavoyNetInput: function onSavoyNetInput(value) {
      if (!this.canEditInfo) return;
      if (!/[,\n;]/.test(value)) {
        return;
      }

      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(value));
      this.savoynetInput = '';
    },
    onSavoyNetKeydown: function onSavoyNetKeydown(event) {
      if (!this.canEditInfo) return;
      if (event.key !== 'Enter' && event.key !== ',' && event.key !== ';') {
        return;
      }

      event.preventDefault();
      this.commitSavoyNetInput();
    },
    onSavoyNetPaste: function onSavoyNetPaste(event) {
      if (!this.canEditInfo) return;
      var clipboardData = event.clipboardData || window.clipboardData;
      var pastedText = clipboardData ? clipboardData.getData('text') : '';

      if (!pastedText) {
        return;
      }

      event.preventDefault();
      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(pastedText));
      this.savoynetInput = '';
    },
    removeSavoyNet: function removeSavoyNet(index) {
      if (!this.canEditInfo) return;
      this.form.fields.savoynet.splice(index, 1);
    },
    openDialogExcluir: function openDialogExcluir() {
      if (!this.canDeleteInfo) return;
      this.dialogExcluir = true;
    },
    excluirImovel: function excluirImovel() {
      var _this2 = this;

      if (!this.canDeleteInfo) return;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis/' + this.$route.params.id).then(function (response) {
        _this2.$store.dispatch('utils/showSnackbar', {
          persistent: true,
          type: 'success',
          text: 'Imóvel excluído com sucesso.'
        });
        _this2.$store.dispatch('utils/hideLoading');
        _this2.$router.push({ name: 'ImoveisLista' });
      }, function () {
        _this2.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this2.$store.dispatch('utils/hideLoading');
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (!this.canEditInfo) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this3.commitSavoyNetInput();

          var payload = {
            apelido: _this3.form.fields.apelido,
            proprietario: _this3.form.fields.proprietario,
            tipo: _this3.normalizeTipo(_this3.form.fields.tipo),
            savoynet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["c" /* normalizeSavoyNetList */])(_this3.form.fields.savoynet)
          };

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis/' + _this3.$route.params.id, payload).then(function (response) {
            _this3.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IrParaOTopo: __WEBPACK_IMPORTED_MODULE_4__Utils_IrParaOTopo___default.a,
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      componentVoltar: this.$route.params.tipo === 'geral' ? 'ImoveisDetalhesResumo' : 'ImoveisDetalhes' + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.upperFirst(this.$route.params.tipo),
      componentTitulo: this.$route.params.tipo === 'geral' ? 'Anotação' : 'Observação',
      componentTituloPlural: this.$route.params.tipo === 'geral' ? 'Anotações' : 'Observações',
      dialog: false,
      dialogEditar: false,
      dialogApagar: false,
      imovelId: this.$route.params.id,
      form: {
        fields: {
          tipo: this.$route.params.tipo,
          conteudo: ''
        }
      },
      formEditar: {
        fields: {
          conteudo: ''
        }
      },
      itemEditar: {},
      itemApagar: {}
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    observacoes: function observacoes() {
      return this.$store.getters['imoveis/observacoes'](this.$route.params.tipo);
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    descartar: function descartar() {
      this.dialog = false;
      this.dialogEditar = false;
      this.dialogApagar = false;
      this.form.fields.conteudo = '';
      this.formEditar.fields.conteudo = '';
      this.errors.clear();
    },
    beforeEditar: function beforeEditar(item) {
      this.formEditar.fields.conteudo = item.conteudo;
      this.itemEditar = item;
    },
    beforeApagar: function beforeApagar(item) {
      this.itemApagar = item;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('adicionar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/observacoes/' + _this2.imovelId, _this2.form.fields).then(function (response) {
            _this2.$store.dispatch('imoveis/loadImovel', { id: _this2.imovelId }).finally(function () {
              _this2.descartar();
              _this2.$store.dispatch('utils/hideLoading');
            });
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitEditar: function onSubmitEditar() {
      var _this3 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('editar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/observacoes/' + _this3.itemEditar.id, _this3.formEditar.fields).then(function (response) {
            _this3.$store.dispatch('imoveis/updateObservacao', { item: _this3.itemEditar, conteudo: _this3.formEditar.fields.conteudo });
            _this3.descartar();
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitApagar: function onSubmitApagar() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/observacoes/' + this.itemApagar.id).then(function (response) {
        _this4.$store.dispatch('imoveis/deleteObservacao', _this4.itemApagar);
        _this4.descartar();
        _this4.$store.dispatch('utils/hideLoading');
      }, function () {
        _this4.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this4.$store.dispatch('utils/hideLoading');
      });
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default.a
  },
  data: function data() {
    return {
      form: {
        fields: {
          matricula: '',
          transcricao: '',
          cartorio: ''
        }
      }
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewRegistro: function canViewRegistro() {
      return this.$hasGranularPermission('registro', 'view');
    },
    canEditRegistro: function canEditRegistro() {
      return this.$hasGranularPermission('registro', 'edit');
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    }
  },
  watch: {
    imovel: function imovel() {
      if (this.imovel.hasOwnProperty('registro')) {
        this.form.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.imovel.registro.data);
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.canEditRegistro) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis/' + _this2.$route.params.id, { registro: _this2.form.fields }).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vistoria_VistoriaSituacao__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vistoria_VistoriaSituacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Vistoria_VistoriaSituacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Vistoria_VistoriaRealizar__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Vistoria_VistoriaRealizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Vistoria_VistoriaRealizar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tarefas_TarefasSituacao__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tarefas_TarefasSituacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tarefas_TarefasSituacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tarefas_TarefasRealizar__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tarefas_TarefasRealizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tarefas_TarefasRealizar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_IrParaOTopo__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_IrParaOTopo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Utils_IrParaOTopo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_FileIcon__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_FileIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Utils_FileIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetalhesFAB__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetalhesFAB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DetalhesFAB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_slick__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_html2pdf_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_html2pdf_js__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_2__Headers_HeadersDetalhesResumo___default.a,
    VistoriaSituacao: __WEBPACK_IMPORTED_MODULE_3__Vistoria_VistoriaSituacao___default.a,
    VistoriaRealizar: __WEBPACK_IMPORTED_MODULE_4__Vistoria_VistoriaRealizar___default.a,
    TarefasSituacao: __WEBPACK_IMPORTED_MODULE_5__Tarefas_TarefasSituacao___default.a,
    TarefasRealizar: __WEBPACK_IMPORTED_MODULE_6__Tarefas_TarefasRealizar___default.a,
    IrParaOTopo: __WEBPACK_IMPORTED_MODULE_7__Utils_IrParaOTopo___default.a,
    FileIcon: __WEBPACK_IMPORTED_MODULE_8__Utils_FileIcon___default.a,
    DetalhesFAB: __WEBPACK_IMPORTED_MODULE_9__DetalhesFAB___default.a,
    jquery: __WEBPACK_IMPORTED_MODULE_12_jquery___default.a,
    Slick: __WEBPACK_IMPORTED_MODULE_14_vue_slick___default.a
  },
  data: function data() {
    return {
      unsubscribe: null,
      colors: {
        undefined: 'grey',
        Vago: '#EDC109',
        Compromissado: '#EA5DDF',
        Locado: '#4FBF46',
        Comodato: '#006AB6',
        Invadido: '#ED1B09'
      },
      slickOptions: {
        infinite: true,
        variableWidth: true,
        centerMode: false,
        arrows: false
      },
      dialogSubstituirVistoria: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$primeUserRestrictions();
    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'imoveis/SET_FILTROS') {
        _this.$router.push('/');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    currentUserId: function currentUserId() {
      var user = this.currentUser || {};
      return user.id || null;
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    tarefas: function tarefas() {
      var _this2 = this;

      var tarefas = this.$store.getters['imoveis/tarefasPendentes'];
      if (!this.isLimitadoTarefas) {
        return tarefas;
      }

      return tarefas.filter(function (item) {
        return _this2.isTaskAssignedToCurrentUser(item);
      });
    },
    showVistoriaColumn: function showVistoriaColumn() {
      return this.showVistoriaEmptyState || this.canShowVistoriaCard;
    },
    showVistoriaEmptyState: function showVistoriaEmptyState() {
      return this.$hasGranularPermission('vistoria', 'view') && !this.isLimitadoTarefas && this.vistoria.length < 1;
    },
    canShowVistoriaCard: function canShowVistoriaCard() {
      return this.$hasGranularPermission('vistoria', 'view') && this.vistoria.length !== 0;
    },
    canCompleteVistoria: function canCompleteVistoria() {
      return this.normalizeId(this.vistoriaUserId()) === this.normalizeId(this.currentUserId) && !this.vistoria.realizada && this.vistoria.situacao !== 'em dia';
    },
    canAddVistoria: function canAddVistoria() {
      return !this.isLimitadoTarefas && this.$hasGranularPermission('vistoria', 'add');
    },
    canAddTask: function canAddTask() {
      return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add');
    },
    vistoria: function vistoria() {
      if (this.imovel.hasOwnProperty('vistoria')) {
        if (!this.isLimitadoTarefas) {
          return this.imovel.vistoria.data;
        }

        return this.isVistoriaAssignedToCurrentUser(this.imovel.vistoria.data) ? this.imovel.vistoria.data : [];
      }
      return [];
    },
    endereco: function endereco() {
      var endereco = {
        'Logradouro': __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter([this.imovel.endereco.data.tipo + ' ' + this.imovel.endereco.data.logradouro, this.imovel.endereco.data.numero, this.imovel.endereco.data.complemento]).join(', '),
        'Bairro': this.imovel.endereco.data.bairro,
        'CEP': this.imovel.endereco.data.cep ? 'CEP: ' + this.imovel.endereco.data.cep : null,
        'Cidade': __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter([this.imovel.endereco.data.cidade, this.imovel.endereco.data.uf]).join(' - '),
        'observacoes': this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'endereco' }) : [],
        'anexos': this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'endereco' }) : []
      };

      return endereco;
    },
    coords: function coords() {
      return {
        lat: this.imovel.endereco ? this.imovel.endereco.data.latitude : null,
        lng: this.imovel.endereco ? this.imovel.endereco.data.longitude : null
      };
    },
    loteamento: function loteamento() {
      if (!this.imovel.endereco.data.loteamento) {
        return false;
      }
      var loteamento = {
        'Nome': this.imovel.endereco.data.loteamento_nome,
        'Lote': this.imovel.endereco.data.loteamento_lote ? 'Lote ' + this.imovel.endereco.data.loteamento_lote : null,
        'Quadra': this.imovel.endereco.data.loteamento_quadra ? 'Quadra ' + this.imovel.endereco.data.loteamento_quadra : null
      };
      loteamento = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omitBy(loteamento, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty);

      return loteamento;
    },
    registro: function registro() {
      var registro = {
        'Matrícula': this.imovel.registro.data.matricula,
        'Transcrição': this.imovel.registro.data.transcricao,
        'Cartório': this.imovel.registro.data.cartorio
      };
      registro = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omitBy(registro, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty);

      registro['observacoes'] = this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'registro' }) : [];
      registro['anexos'] = this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'registro' }) : [];

      return registro;
    },
    area: function area() {
      return {
        'Área do terreno': this.imovel.area.data.area_terreno > 0 ? String(this.imovel.area.data.area_terreno).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + '  m\xB2' : '',
        'Área construída': this.imovel.area.data.area_construida > 0 ? String(this.imovel.area.data.area_construida).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + '  m\xB2' : '',
        'Área útil': this.imovel.area.data.area_util > 0 ? String(this.imovel.area.data.area_util).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + '  m\xB2' : '',
        'Calçada': this.imovel.area.data.calcada ? 'Com' : 'Sem',
        'Muro': this.imovel.area.data.muro ? 'Com' : 'Sem',
        'observacoes': this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'area' }) : [],
        'anexos': this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'area' }) : []
      };
    },
    taxas: function taxas() {
      if (this.imovel.hasOwnProperty('taxas')) {
        return {
          'lista': this.imovel.taxas.data,
          'observacoes': this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'taxas' }) : [],
          'anexos': this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'taxas' }) : []
        };
      } else {
        return {
          'lista': []
        };
      }
    },
    valor: function valor() {
      return {
        'Valor (est.)': this.imovel.valor.data.estimativa_valor > 0 ? __WEBPACK_IMPORTED_MODULE_11_currency_formatter___default.a.format(this.imovel.valor.data.estimativa_valor, { code: 'BRL' }) : '',
        'Data da estimativa': this.imovel.valor.data.estimativa_data.length > 0 ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.valor.data.estimativa_data).format('DD/MM/YYYY') : '',
        'Valor m²/região': this.imovel.valor.data.regiao_valor > 0 ? __WEBPACK_IMPORTED_MODULE_11_currency_formatter___default.a.format(this.imovel.valor.data.regiao_valor, { code: 'BRL' }) : '',
        'observacoes': this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'valor' }) : [],
        'anexos': this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'valor' }) : []
      };
    },
    status: function status() {
      var result = {
        'status': this.imovel.status ? this.imovel.status.data.status : '',
        'observacoes': this.imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'status' }) : [],
        'anexos': this.imovel.anexos ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'status' }) : []
      };

      if (result.status === 'Vago') {
        result['Placa'] = this.imovel.status.data.vago_com_placa ? 'Com placa' : 'Sem placa';
        result['Nível de segurança'] = this.imovel.status.data.vago_seguranca;
        result['Observações de segurança'] = this.imovel.status.data.vago_seguranca_observacoes;
      }

      if (result.status === 'Compromissado') {
        result['Comprador'] = this.imovel.status.data.compromissado_comprador;
        result['Data do compromisso'] = this.imovel.status.data.compromissado_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.compromissado_data).format('DD/MM/YYYY') : '';

        if (this.imovel.status.data.compromissado_condicao) {
          result['divider-3'] = true;
          result['Condição'] = this.imovel.status.data.compromissado_condicao;
          if (this.imovel.status.data.compromissado_condicao === 'Inadimplente') {
            result['Data da inadimplência'] = this.imovel.status.data.compromissado_inadimplente_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.compromissado_inadimplente_data).format('DD/MM/YYYY') : '';
          }
          if (this.imovel.status.data.compromissado_condicao === 'Inadimplente ajuizado') {
            result['Cliente/caso'] = this.imovel.status.data.compromissado_ajuizado_cliente;
            result['Processo/execução'] = this.imovel.status.data.compromissado_ajuizado_processo;
          }
        }
      }

      if (result.status === 'Locado') {
        if (this.$auth.check('Administrador')) {
          result['Índice'] = this.imovel.status.data.locado_indice ? this.imovel.status.data.locado_indice : 'Faltam dados';
        }

        if (this.imovel.status.data.locado_locador || this.imovel.status.data.locado_locatario || this.imovel.status.data.locado_valor || this.imovel.status.data.locado_valor_data || this.imovel.status.data.locado_inicio_data || this.imovel.status.data.locado_fim_data) {
          result['divider-1'] = true;
          result['Locador'] = this.imovel.status.data.locado_locador;
          result['Locatário'] = this.imovel.status.data.locado_locatario;
          result['Valor do aluguel'] = this.imovel.status.data.locado_valor > 0 ? __WEBPACK_IMPORTED_MODULE_11_currency_formatter___default.a.format(this.imovel.status.data.locado_valor, { code: 'BRL' }) : '';
          result['Data do valor do aluguel'] = this.imovel.status.data.locado_valor_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.locado_valor_data).format('DD/MM/YYYY') : '';
          result['Data do contrato início'] = this.imovel.status.data.locado_inicio_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.locado_inicio_data).format('DD/MM/YYYY') : '';
          result['Data do contrato fim'] = this.imovel.status.data.locado_fim_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.locado_fim_data).format('DD/MM/YYYY') : '';
        }

        if (this.imovel.status.data.locado_acao_renovatoria) {
          result['divider-2'] = true;
          result['Ação renovatória'] = this.imovel.status.data.locado_acao_renovatoria_numero;
          result[' Cliente/caso'] = this.imovel.status.data.locado_acao_renovatoria_cliente;
        }

        if (this.imovel.status.data.locado_condicao) {
          result['divider-3'] = true;
          result['Condição'] = this.imovel.status.data.locado_condicao;
          if (this.imovel.status.data.locado_condicao === 'Inadimplente') {
            result['Data da inadimplência'] = this.imovel.status.data.locado_inadimplente_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.locado_inadimplente_data).format('DD/MM/YYYY') : '';
          }
          if (this.imovel.status.data.locado_condicao === 'Inadimplente ajuizado') {
            result['Cliente/caso'] = this.imovel.status.data.locado_ajuizado_cliente;
            result['Processo/execução'] = this.imovel.status.data.locado_ajuizado_processo;
          }
        }
      }

      if (result.status === 'Comodato') {
        result['Nome'] = this.imovel.status.data.comodato_nome;
        result['RG'] = this.imovel.status.data.comodato_rg;
        result['CPF'] = this.imovel.status.data.comodato_cpf;
        result['Telefone'] = this.imovel.status.data.comodato_telefone && this.imovel.status.data.comodato_telefone.length > 0 ? this.imovel.status.data.comodato_telefone : '';
      }

      if (result.status === 'Invadido') {
        if (this.imovel.status.data.invadido_data) {
          result['Data estimada da invasão'] = this.imovel.status.data.invadido_data ? __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.imovel.status.data.invadido_data).format('DD/MM/YYYY') : '';
          result['divider-1'] = true;
        }

        result['Nome'] = this.imovel.status.data.invadido_nome;
        result['RG'] = this.imovel.status.data.invadido_rg;
        result['CPF'] = this.imovel.status.data.invadido_cpf;
        result['Telefone'] = this.imovel.status.data.invadido_telefone && this.imovel.status.data.invadido_telefone.length > 0 ? this.imovel.status.data.invadido_telefone : '';

        if (this.imovel.status.data.invadido_condicao) {
          result['divider-3'] = true;
          result['Condição'] = this.imovel.status.data.invadido_condicao;
          if (this.imovel.status.data.invadido_condicao === 'Ocupado ajuizado') {
            result['Cliente/caso'] = this.imovel.status.data.invadido_ajuizado_cliente;
            result['Processo/execução'] = this.imovel.status.data.invadido_ajuizado_processo;
          }
        }
      }

      return result;
    },
    anotacoes: function anotacoes() {
      if (this.imovel.hasOwnProperty('observacoes')) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.observacoes.data, { tipo: 'geral' });
      } else {
        return [];
      }
    },
    anexos: function anexos() {
      if (this.imovel.hasOwnProperty('anexos')) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.anexos.data, { tipo: 'geral' });
      } else {
        return [];
      }
    },
    fotos: function fotos() {
      if (this.imovel.hasOwnProperty('fotos')) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.fotos.data, function (item) {
          return item.tipo !== 'ilustrativa';
        });
      } else {
        return [];
      }
    },
    ilustrativas: function ilustrativas() {
      if (this.imovel.hasOwnProperty('fotos')) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.imovel.fotos.data, { tipo: 'ilustrativa' });
      } else {
        return [];
      }
    }
  },
  methods: {
    normalizeId: function normalizeId(value) {
      if (value === null || typeof value === 'undefined' || value === '') return null;
      return String(value);
    },
    vistoriaUserId: function vistoriaUserId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__["a" /* getAssignedUserId */])(this.vistoria);
    },
    vistoriaUserName: function vistoriaUserName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__["b" /* getAssignedUserName */])(this.vistoria);
    },
    isVistoriaAssignedToCurrentUser: function isVistoriaAssignedToCurrentUser(item) {
      return this.normalizeId(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__["a" /* getAssignedUserId */])(item)) === this.normalizeId(this.currentUserId);
    },
    taskUserId: function taskUserId(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__["a" /* getAssignedUserId */])(item);
    },
    taskUserName: function taskUserName(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assignedUser__["b" /* getAssignedUserName */])(item);
    },
    isTaskAssignedToCurrentUser: function isTaskAssignedToCurrentUser(item) {
      return this.normalizeId(this.taskUserId(item)) === this.normalizeId(this.currentUserId);
    },
    download: function download() {
      var _this3 = this;

      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_15_html2pdf_js___default()(document.getElementById('save-as-pdf'), {
        margin: 2,
        filename: this.imovel.apelido + ' - ' + __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('DD.MM.YYYY') + '.pdf',
        pagebreak: {
          avoid: 'p'
        },
        image: {
          type: 'jpeg',
          quality: 1
        },
        html2canvas: {
          dpi: 144,
          scale: 2,
          windowWidth: 2
        },
        jsPDF: {
          format: 'a4',
          orientation: 'p'
        }
      }).then(function () {
        _this3.$store.dispatch('utils/hideLoading');
      });
    },
    substituirVistoria: function substituirVistoria(event) {
      if (this.imovel.hasOwnProperty('vistoria')) {
        this.dialogSubstituirVistoria = true;
      } else {
        this.$router.push({ name: 'VistoriaAdicionar', params: { id: this.$route.params.id } });
      }
    },
    getIcon: function getIcon() {
      var fillColor = this.colors.undefined;
      if (this.imovel.status !== undefined) {
        fillColor = this.colors[this.imovel.status.data.status];
      }

      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: fillColor,
        fillOpacity: 1,
        strokeColor: '#FFFFFF',
        strokeWeight: 1,
        scale: 1
      };
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_awesome_mask__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__moneyOptions__ = __webpack_require__(176);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_7__ButtonsObservacoesAnexos___default.a
  },
  directives: {
    'money': __WEBPACK_IMPORTED_MODULE_9_awesome_mask___default.a
  },
  data: function data() {
    return {
      compromissadoDataMenu: false,
      compromissadoInadimplenteDataMenu: false,
      locadoValorDataMenu: false,
      locadoInicioDataMenu: false,
      locadoFimDataMenu: false,
      locadoInadimplenteDataMenu: false,
      invadidoDataMenu: false,
      listaStatus: ['Vago', 'Compromissado', 'Locado', 'Comodato', 'Invadido'],
      listaSeguranca: ['Seguro', 'Média segurança', 'Inseguro'],
      form: {
        fields: {
          status: null,
          vago_com_placa: false,
          vago_seguranca: null,
          vago_seguranca_observacoes: null,
          compromissado_condicao: null,
          compromissado_comprador: null,
          compromissado_data: null,
          compromissado_data_formatada: null,
          compromissado_inadimplente_data: null,
          compromissado_inadimplente_data_formatada: null,
          compromissado_ajuizado_cliente: null,
          compromissado_ajuizado_processo: null,
          locado_condicao: null,
          locado_locador: null,
          locado_locatario: null,
          locado_valor: null,
          locado_valor_data: null,
          locado_valor_data_formatada: null,
          locado_inicio_data: null,
          locado_inicio_data_formatada: null,
          locado_fim_data: null,
          locado_fim_data_formatada: null,
          locado_acao_renovatoria: null,
          locado_acao_renovatoria_numero: null,
          locado_acao_renovatoria_cliente: null,
          locado_inadimplente_data: null,
          locado_inadimplente_data_formatada: null,
          locado_ajuizado_cliente: null,
          locado_ajuizado_processo: null,
          comodato_nome: null,
          comodato_rg: null,
          comodato_cpf: null,
          comodato_telefone: [{ numero: '' }],
          invadido_condicao: null,
          invadido_nome: null,
          invadido_rg: null,
          invadido_cpf: null,
          invadido_telefone: [{ numero: '' }],
          invadido_data: null,
          invadido_data_formatada: null,
          invadido_ajuizado_cliente: null,
          invadido_ajuizado_processo: null
        }
      }
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewStatus: function canViewStatus() {
      return this.$hasGranularPermission('status', 'view');
    },
    canEditStatus: function canEditStatus() {
      return this.$hasGranularPermission('status', 'edit');
    },
    listaCondicao: function listaCondicao() {
      var listaCondicao = [];

      switch (this.form.fields.status) {
        case 'Compromissado':
          listaCondicao = ['Em dia', 'Quitado sem escritura', 'Com escritura definitiva', 'Inadimplente', 'Inadimplente ajuizado'];
          break;
        case 'Locado':
          listaCondicao = ['Em dia', 'Inadimplente', 'Inadimplente ajuizado'];
          break;
        case 'Invadido':
          listaCondicao = ['Ocupado irregularmente', 'Ocupado ajuizado'];
          break;
      }

      return listaCondicao;
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty));
    }
  },
  watch: {
    imovel: function imovel() {
      if (this.imovel.hasOwnProperty('status')) {
        var imovelStatus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.imovel.status.data);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(imovelStatus).forEach(function (key) {
          return imovelStatus[key] == null && delete imovelStatus[key];
        });

        if (imovelStatus.locado_valor) {
          imovelStatus.locado_valor = __WEBPACK_IMPORTED_MODULE_10_currency_formatter___default.a.format(imovelStatus.locado_valor, __WEBPACK_IMPORTED_MODULE_11__moneyOptions__["a" /* default */]);
        }

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(imovelStatus).forEach(function (key) {
          if (/.*_data$/.test(key)) {
            imovelStatus[key] = __WEBPACK_IMPORTED_MODULE_8_moment___default()(imovelStatus[key]).format('YYYY-MM-DD');
            imovelStatus[key + '_formatada'] = __WEBPACK_IMPORTED_MODULE_8_moment___default()(imovelStatus[key]).format('DD/MM/YYYY');
          }
          if (/.*_telefone$/.test(key)) {
            if (imovelStatus[key].length < 1) {
              imovelStatus[key] = [{ numero: '' }];
            }
          }
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.form.fields, imovelStatus);
      }
    }
  },
  methods: {
    appendIcon: function appendIcon(index) {
      if (!this.canEditStatus) return null;
      if (index === 0) {
        return 'add_circle';
      } else {
        return 'remove_circle_outline';
      }
    },
    adicionarRemoverTelefone: function adicionarRemoverTelefone(index, fields) {
      if (!this.canEditStatus) return;
      if (index === 0) {
        fields.push({ numero: '' });
      } else {
        fields.splice(index, 1);
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.canEditStatus) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var formattedFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.form.fields);

          formattedFields.locado_valor = __WEBPACK_IMPORTED_MODULE_10_currency_formatter___default.a.unformat(formattedFields.locado_valor, __WEBPACK_IMPORTED_MODULE_11__moneyOptions__["a" /* default */]);

          var comodatoTelefone = formattedFields.comodato_telefone.filter(function (telefone) {
            return telefone.numero.length > 0;
          });
          var invadidoTelefone = formattedFields.invadido_telefone.filter(function (telefone) {
            return telefone.numero.length > 0;
          });
          formattedFields.comodato_telefone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(comodatoTelefone);
          formattedFields.invadido_telefone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invadidoTelefone);

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* apiURL */] + '/imoveis/' + _this2.$route.params.id, { status: formattedFields }).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ButtonsObservacoesAnexos__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_4__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_5__ButtonsObservacoesAnexos___default.a
  },
  data: function data() {
    return {
      dialog: false,
      dialogEditar: false,
      dialogApagar: false,
      imovelId: this.$route.params.id,
      form: {
        fields: {
          selecionarTaxa: 'IPTU',
          taxa: 'IPTU',
          numero: '',
          situacao: '',
          ajuizado_cliente: '',
          ajuizado_processo: ''
        }
      },
      formEditar: {
        fields: {
          numero: '',
          situacao: '',
          ajuizado_cliente: '',
          ajuizado_processo: ''
        }
      },
      itemEditar: {},
      itemApagar: {}
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewTaxas: function canViewTaxas() {
      return this.$hasGranularPermission('taxas', 'view');
    },
    canEditTaxas: function canEditTaxas() {
      return this.$hasGranularPermission('taxas', 'edit');
    },
    taxas: function taxas() {
      return this.$store.getters['imoveis/taxas'];
    },
    taxaSituacao: function taxaSituacao() {
      return this.$store.getters['constants/taxaSituacao'];
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  watch: {
    'form.fields.selecionarTaxa': function formFieldsSelecionarTaxa(value) {
      if (value === 'IPTU') {
        this.form.fields.taxa = 'IPTU';
      } else {
        this.form.fields.taxa = '';
      }
    }
  },
  methods: {
    descartar: function descartar() {
      this.dialog = false;
      this.dialogEditar = false;
      this.dialogApagar = false;
      this.form.fields.selecionarTaxa = 'IPTU';
      this.form.fields.taxa = '';
      this.form.fields.numero = '';
      this.form.fields.situacao = '';
      this.form.fields.ajuizado_cliente = '';
      this.form.fields.ajuizado_processo = '';
      this.formEditar.fields.numero = '';
      this.formEditar.fields.situacao = '';
      this.formEditar.fields.ajuizado_cliente = '';
      this.formEditar.fields.ajuizado_processo = '';
      this.errors.clear();
    },
    beforeEditar: function beforeEditar(item) {
      if (!this.canEditTaxas) return;
      this.formEditar.fields.numero = item.numero;
      this.formEditar.fields.situacao = item.situacao;
      this.formEditar.fields.ajuizado_cliente = item.ajuizado_cliente;
      this.formEditar.fields.ajuizado_processo = item.ajuizado_processo;
      this.itemEditar = item;
    },
    beforeApagar: function beforeApagar(item) {
      this.itemApagar = item;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('adicionar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/taxas/' + _this2.imovelId, _this2.form.fields).then(function (response) {
            _this2.$store.dispatch('imoveis/insertTaxa', response.data.data);
            _this2.descartar();
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitEditar: function onSubmitEditar() {
      var _this3 = this;

      if (!this.canEditTaxas) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll('editar').then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/taxas/' + _this3.itemEditar.id, _this3.formEditar.fields).then(function (response) {
            _this3.$store.dispatch('imoveis/updateTaxa', { item: _this3.itemEditar, data: response.data.data });
            _this3.descartar();
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    },
    onSubmitApagar: function onSubmitApagar() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/taxas/' + this.itemApagar.id).then(function (response) {
        _this4.$store.dispatch('imoveis/deleteTaxa', _this4.itemApagar);
        _this4.descartar();
        _this4.$store.dispatch('utils/hideLoading');
      }, function () {
        _this4.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this4.$store.dispatch('utils/hideLoading');
      });
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_awesome_mask__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__moneyOptions__ = __webpack_require__(176);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Headers_HeadersDetalhesResumo___default.a,
    ButtonsObservacoesAnexos: __WEBPACK_IMPORTED_MODULE_6__ButtonsObservacoesAnexos___default.a
  },
  directives: {
    'money': __WEBPACK_IMPORTED_MODULE_8_awesome_mask___default.a
  },
  data: function data() {
    return {
      dataMenu: false,
      form: {
        fields: {
          estimativa_valor: null,
          estimativa_data: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD'),
          estimativa_data_formatada: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('DD/MM/YYYY'),
          regiao_valor: null
        }
      }
    };
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewValor: function canViewValor() {
      return this.$hasGranularPermission('valor', 'view');
    },
    canEditValor: function canEditValor() {
      return this.$hasGranularPermission('valor', 'edit');
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    }
  },
  watch: {
    imovel: function imovel() {
      if (this.imovel.hasOwnProperty('valor')) {
        this.form.fields.estimativa_valor = __WEBPACK_IMPORTED_MODULE_9_currency_formatter___default.a.format(this.imovel.valor.data.estimativa_valor, __WEBPACK_IMPORTED_MODULE_10__moneyOptions__["a" /* default */]);
        this.form.fields.estimativa_data = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.imovel.valor.data.estimativa_data).format('YYYY-MM-DD');
        this.form.fields.estimativa_data_formatada = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.imovel.valor.data.estimativa_data).format('DD/MM/YYYY');
        this.form.fields.regiao_valor = __WEBPACK_IMPORTED_MODULE_9_currency_formatter___default.a.format(this.imovel.valor.data.regiao_valor, __WEBPACK_IMPORTED_MODULE_10__moneyOptions__["a" /* default */]);
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (!this.canEditValor) return;
      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var formattedFields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.form.fields);
          formattedFields.estimativa_valor = __WEBPACK_IMPORTED_MODULE_9_currency_formatter___default.a.unformat(formattedFields.estimativa_valor, __WEBPACK_IMPORTED_MODULE_10__moneyOptions__["a" /* default */]);
          formattedFields.regiao_valor = __WEBPACK_IMPORTED_MODULE_9_currency_formatter___default.a.unformat(formattedFields.regiao_valor, __WEBPACK_IMPORTED_MODULE_10__moneyOptions__["a" /* default */]);

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis/' + _this2.$route.params.id, { valor: formattedFields }).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_savoynet__ = __webpack_require__(80);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['apelido', 'proprietario', 'tipo', 'savoynet'],
  computed: {
    savoyNetItems: function savoyNetItems() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_savoynet__["a" /* parseSavoyNetFromApi */])(this.savoynet).map(function (numero) {
        return {
          numero: numero,
          url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_savoynet__["b" /* buildSavoyNetUrl */])(numero)
        };
      });
    }
  },
  methods: {
    setRightNav: function setRightNav() {
      this.$store.dispatch('template/setRightNav', true);
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    setLeftNav: function setLeftNav() {
      this.$store.dispatch('template/setLeftNav', true);
    },
    setRightNav: function setRightNav() {
      this.$store.dispatch('template/setRightNav', true);
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_savoynet__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersAdicionar__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Headers_HeadersAdicionar__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersAdicionar: __WEBPACK_IMPORTED_MODULE_6__Headers_HeadersAdicionar___default.a
  },
  data: function data() {
    return {
      savoynetInput: '',
      form: {
        fields: {
          apelido: '',
          proprietarioSelect: '',
          proprietario: '',
          tipoSelect: '',
          tipo: '',
          savoynet: []
        }
      }
    };
  },
  mounted: function mounted() {
    if (!this.$hasGranularPermission('info', 'add')) {
      this.$router.push({ name: 'ImoveisLista' });
    }
    this.$store.dispatch('imoveis/loadProprietarios');
  },

  computed: {
    imovelTipoSugestoes: function imovelTipoSugestoes() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.$store.getters['constants/imovelTipo'], this.getImovelTipoItemValue)));
    },
    tipos: function tipos() {
      var tipos = this.imovelTipoSugestoes.slice(0);
      tipos.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true });
      return tipos;
    },
    proprietarios: function proprietarios() {
      var proprietarios = this.$store.getters['imoveis/proprietarios'].slice(0);

      proprietarios.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true });

      return proprietarios;
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    }
  },
  watch: {
    'form.fields.proprietarioSelect': function formFieldsProprietarioSelect(value) {
      if (value === 'Preencher manualmente') {
        this.form.fields.proprietario = '';
      } else {
        this.form.fields.proprietario = value;
      }
    },
    'form.fields.tipoSelect': function formFieldsTipoSelect(value) {
      if (value === 'Preencher manualmente') {
        this.form.fields.tipo = '';
      } else {
        this.form.fields.tipo = value;
      }
    }
  },
  methods: {
    getImovelTipoItemValue: function getImovelTipoItemValue(item) {
      if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
        return (item.text || item.value || '').trim();
      }

      return String(item || '').trim();
    },
    normalizeTipo: function normalizeTipo(value) {
      return String(value || '').trim().replace(/\s+/g, ' ');
    },
    addSavoyNetValues: function addSavoyNetValues(values) {
      this.form.fields.savoynet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["c" /* normalizeSavoyNetList */])(this.form.fields.savoynet.concat(values));
    },
    commitSavoyNetInput: function commitSavoyNetInput() {
      if (!this.savoynetInput) {
        return;
      }

      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(this.savoynetInput));
      this.savoynetInput = '';
    },
    onSavoyNetInput: function onSavoyNetInput(value) {
      if (!/[,\n;]/.test(value)) {
        return;
      }

      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(value));
      this.savoynetInput = '';
    },
    onSavoyNetKeydown: function onSavoyNetKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ',' && event.key !== ';') {
        return;
      }

      event.preventDefault();
      this.commitSavoyNetInput();
    },
    onSavoyNetPaste: function onSavoyNetPaste(event) {
      var clipboardData = event.clipboardData || window.clipboardData;
      var pastedText = clipboardData ? clipboardData.getData('text') : '';

      if (!pastedText) {
        return;
      }

      event.preventDefault();
      this.addSavoyNetValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["d" /* splitSavoyNetValues */])(pastedText));
      this.savoynetInput = '';
    },
    removeSavoyNet: function removeSavoyNet(index) {
      this.form.fields.savoynet.splice(index, 1);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.commitSavoyNetInput();

          var payload = {
            apelido: _this2.form.fields.apelido,
            proprietario: _this2.form.fields.proprietario,
            tipo: _this2.normalizeTipo(_this2.form.fields.tipo),
            savoynet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_savoynet__["c" /* normalizeSavoyNetList */])(_this2.form.fields.savoynet)
          };

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/imoveis', payload).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.loadImovel();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.loadImovel();
    next();
  },

  methods: {
    loadImovel: function loadImovel() {
      this.$store.dispatch('imoveis/loadImovel', { id: this.$route.params.id });
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_ListaImovel__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_ListaImovel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Lista_ListaImovel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_currency_formatter__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ListaImovel: __WEBPACK_IMPORTED_MODULE_2__Lista_ListaImovel___default.a
  },
  computed: {
    imoveis: function imoveis() {
      return this.$store.getters['imoveis/lista'];
    },
    paginacao: function paginacao() {
      return this.$store.getters['imoveis/listaPaginacao'];
    },
    filtros: function filtros() {
      return this.$store.getters['imoveis/filtros'];
    },
    imoveisDownload: function imoveisDownload() {
      return this.$store.getters['imoveis/listaDownload'];
    },
    coords: function coords() {
      return this.$store.getters['utils/coords'];
    },
    tabs: function tabs() {
      var tabs = [];
      if (this.isMobile) {
        tabs.push({ title: 'Distância', id: 'distancia' });
      }
      if (this.$hasGranularPermission('vistoria', 'view')) {
        tabs.push({ title: 'Vistoria', id: 'vistoria' });
      }
      if (this.$hasGranularPermission('tarefas', 'view')) {
        tabs.push({ title: 'Tarefas', id: 'tarefas' });
      }
      if (tabs.length === 0) {
        tabs.push({ title: 'Lista', id: 'geral' });
      }
      return tabs;
    }
  },
  data: function data() {
    return {
      unsubscribe: null,
      tabAtiva: '',
      fabSave: false,
      isMobile: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);

    if (this.tabs.length > 0) {
      this.tabAtiva = this.tabs[0].id;
    }
    this.clearImoveis();
    this.loadImoveis();

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'imoveis/SET_FILTROS') {
        _this.clearImoveis();
        _this.loadImoveis();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
    this.unsubscribe();
  },

  methods: {
    updateViewport: function updateViewport() {
      var isMobile = window.innerWidth < 960;
      if (isMobile === this.isMobile) {
        return;
      }

      this.isMobile = isMobile;

      if (this.tabs.length < 1) {
        return;
      }

      var firstTabId = this.tabs[0].id;
      var hasCurrentTab = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.some(this.tabs, { id: this.tabAtiva });

      if (!hasCurrentTab || this.isMobile && this.tabAtiva !== firstTabId) {
        var hadActiveTab = !!this.tabAtiva;
        this.tabAtiva = firstTabId;
        if (hadActiveTab) {
          this.clearImoveis();
          this.loadImoveis();
        }
      }
    },
    normalizeTabId: function normalizeTabId(tabId) {
      if (typeof tabId !== 'string') {
        return tabId;
      }

      return tabId.charAt(0) === '#' ? tabId.slice(1) : tabId;
    },
    setTabPayloadParams: function setTabPayloadParams(payload) {
      if (this.tabAtiva === 'distancia') {
        payload.parametro = 'distancia';
        payload.latitude = this.coords.latitude;
        payload.longitude = this.coords.longitude;
        return;
      }

      payload.parametro = this.tabAtiva;
    },
    downloadLista: function downloadLista(tipo) {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      var filtrosFormatados = {};
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filtros).length > 0) {
        if (this.filtros.hasOwnProperty('proprietario')) {
          filtrosFormatados['Proprietário'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.proprietario).join(', ');
        }
        if (this.filtros.hasOwnProperty('tipo')) {
          filtrosFormatados['Tipo'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.tipo).join(', ');
        }
        if (this.filtros.hasOwnProperty('uf')) {
          filtrosFormatados['Estado'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.uf).join(', ');
        }
        if (this.filtros.hasOwnProperty('cidade')) {
          filtrosFormatados['Cidade'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.cidade).join(', ');
        }
        if (this.filtros.hasOwnProperty('bairro')) {
          filtrosFormatados['Bairro'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.bairro).join(', ');
        }
        if (this.filtros.hasOwnProperty('com_loteamento')) {
          filtrosFormatados['Em Loteamento'] = this.filtros.com_loteamento ? 'Sim' : 'Não';
        }
        if (this.filtros.hasOwnProperty('loteamento')) {
          filtrosFormatados['Loteamento'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.loteamento).join(', ');
        }
        if (this.filtros.hasOwnProperty('lote')) {
          filtrosFormatados['Lote'] = this.filtros.lote;
        }
        if (this.filtros.hasOwnProperty('quadra')) {
          filtrosFormatados['Quadra'] = this.filtros.quadra;
        }
        if (this.filtros.hasOwnProperty('status')) {
          filtrosFormatados['Status'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.status).join(', ');
        }
        if (this.filtros.hasOwnProperty('vago_com_placa')) {
          filtrosFormatados['Vago - Com Placa'] = this.filtros.vago_com_placa ? 'Sim' : 'Não';
        }
        if (this.filtros.hasOwnProperty('vago_seguranca')) {
          filtrosFormatados['Vago - Segurança'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.vago_seguranca).join(', ');
        }
        if (this.filtros.hasOwnProperty('compromissado_condicao')) {
          filtrosFormatados['Compromissado - Condição'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.compromissado_condicao).join(', ');
        }
        if (this.filtros.hasOwnProperty('locado_condicao')) {
          filtrosFormatados['Locado - Condição'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.locado_condicao).join(', ');
        }
        if (this.filtros.hasOwnProperty('locado_acao_renovatoria')) {
          filtrosFormatados['Locado - Com Ação Renovatória'] = this.filtros.locado_acao_renovatoria ? 'Sim' : 'Não';
        }
        if (this.filtros.hasOwnProperty('locado_indice')) {
          filtrosFormatados['Locado - Com Placa'] = this.filtros.locado_indice ? 'Satisfatório' : 'Insatisfatório';
        }
        if (this.filtros.hasOwnProperty('locado_valor_minimo') || this.filtros.hasOwnProperty('locado_valor_maximo')) {
          filtrosFormatados['Locado - Valor'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([this.filtros.locado_valor_minimo, this.filtros.locado_valor_maximo]).join(' - ');
        }
        if (this.filtros.hasOwnProperty('invadido_condicao')) {
          filtrosFormatados['Invadido - Condição'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.invadido_condicao).join(', ');
        }
        if (this.filtros.hasOwnProperty('area_terreno_minima') || this.filtros.hasOwnProperty('area_terreno_maxima')) {
          filtrosFormatados['Área do Terreno'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([this.filtros.area_terreno_minima, this.filtros.area_terreno_maxima]).join(' - ');
        }
        if (this.filtros.hasOwnProperty('area_construida_minima') || this.filtros.hasOwnProperty('area_construida_maxima')) {
          filtrosFormatados['Área Construída'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([this.filtros.area_construida_minima, this.filtros.area_construida_maxima]).join(' - ');
        }
        if (this.filtros.hasOwnProperty('area_util_minima') || this.filtros.hasOwnProperty('area_util_maxima')) {
          filtrosFormatados['Área Útil'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([this.filtros.area_util_minima, this.filtros.area_util_maxima]).join(' - ');
        }
        if (this.filtros.hasOwnProperty('com_calcada')) {
          filtrosFormatados['Com Calçada'] = this.filtros.com_calcada ? 'Sim' : 'Não';
        }
        if (this.filtros.hasOwnProperty('com_muro')) {
          filtrosFormatados['Com Muro'] = this.filtros.com_muro ? 'Sim' : 'Não';
        }
        if (this.filtros.hasOwnProperty('iptu_condicao')) {
          filtrosFormatados['IPTU'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.iptu_condicao).join(', ');
        }
        if (this.filtros.hasOwnProperty('estimativa_valor_minimo') || this.filtros.hasOwnProperty('estimativa_valor_maximo')) {
          filtrosFormatados['Estimativa do Valor'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([this.filtros.estimativa_valor_minimo, this.filtros.estimativa_valor_maximo]).join(' - ');
        }
        if (this.filtros.hasOwnProperty('vistoria')) {
          filtrosFormatados['Vistoria'] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.filtros.vistoria).join(', ');
        }
        if (this.filtros.hasOwnProperty('tarefas_pendentes')) {
          filtrosFormatados['Com Tarefas Pendentes'] = this.filtros.tarefas_pendentes ? 'Sim' : 'Não';
        }
      }

      this.loadImoveisDownload().then(function () {
        if (tipo === 'pdf') {
          var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__();
          var pdfName = 'Lista de Im\xF3veis - ' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('DD.MM.YYYY');
          var totalPagesExp = '{total_pages_count_string}';
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

          var marginTop = 20;
          var marginBottom = 25;
          var marginLeft = 9;
          var marginRight = 9;

          var fontSize = 7;
          var fontColor = 40;

          var currentDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('DD/MM/YYYY [às] HH:mm:ss');

          var currentHeight = marginTop;

          doc.setFontSize(fontSize);
          doc.setTextColor(fontColor);
          doc.setFont('helvetica', 'normal');

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filtrosFormatados).length > 0) {
            doc.setFontStyle('bold');
            doc.setFontSize(fontSize * 2);
            var filtrosTitulo = 'Filtros Aplicados';
            doc.text(filtrosTitulo, marginLeft, currentHeight);
            currentHeight += doc.getTextDimensions(filtrosTitulo).h;
            currentHeight += 2;
            doc.setFontStyle('normal');
            doc.setFontSize(fontSize);
          }
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(filtrosFormatados, function (filtro, index) {
            doc.setFontStyle('bold');
            var indexWidth = doc.getTextDimensions(index).w;
            doc.text(index + ':', marginLeft, currentHeight);

            doc.setFontStyle('normal');
            var filtrosSplit = doc.splitTextToSize(filtro, pageWidth - indexWidth);
            var filtrosHeight = doc.getTextDimensions(filtro).h;
            doc.text(filtrosSplit, indexWidth + marginLeft + 2, currentHeight);

            currentHeight += filtrosHeight;
            currentHeight += 2;
          });

          var imoveisFormatados = [];
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_this2.imoveisDownload, function (imovel) {
            var apelido = imovel.apelido ? imovel.apelido : '-';
            var proprietario = imovel.proprietario ? imovel.proprietario : '-';
            var tipo = imovel.tipo ? imovel.tipo : '-';
            var cidade = imovel.endereco ? _this2.formatarCidade(imovel.endereco.data) : '-';
            var endereco = imovel.endereco ? _this2.formatarEndereco(imovel.endereco.data) : '-';
            var status = imovel.status ? imovel.status.data.status : '-';

            var condicao = '-';
            if (imovel.status) {
              if (imovel.status.data.status === 'Compromissado' && imovel.status.data.compromissado_condicao) {
                condicao = imovel.status.data.compromissado_condicao;
              }
              if (imovel.status.data.status === 'Locado' && imovel.status.data.locado_condicao) {
                condicao = imovel.status.data.locado_condicao;
              }
              if (imovel.status.data.status === 'Invadido' && imovel.status.data.invadido_condicao) {
                condicao = imovel.status.data.invadido_condicao;
              }
            }

            imoveisFormatados.push([apelido, proprietario, tipo, cidade, endereco, status, condicao]);
          });

          doc.autoTable({
            startY: currentHeight + 2,
            head: [['Apelido', 'Proprietário', 'Tipo', 'Cidade', 'Endereço', 'Status', 'Condição']],
            body: imoveisFormatados,
            margin: {
              top: marginTop,
              bottom: marginBottom,
              left: marginLeft,
              right: marginRight
            },
            styles: {
              valign: 'middle',
              halign: 'center',
              fontSize: fontSize,
              cellPadding: 3,
              minCellWidth: 27
            },
            columnStyles: {
              4: {
                minCellWidth: 30
              }
            },
            didDrawPage: function didDrawPage(data) {
              var str = 'Página ' + doc.internal.getNumberOfPages();
              if (typeof doc.putTotalPages === 'function') {
                str = str + ' de ' + totalPagesExp;
              }

              doc.text(str + ' - Total de imóveis: ' + imoveisFormatados.length, marginLeft, pageHeight - 10);
              doc.text(currentDate, pageWidth - data.settings.margin.right, pageHeight - 10, { align: 'right' });
            }
          });

          if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
          }

          doc.save(pdfName + '.pdf');
        }

        if (tipo === 'excel') {
          var header = [['Apelido', 'Proprietário', 'Tipo', 'Cidade', 'Endereço', 'Status', 'Condição', 'Loteamento', 'Loteamento (Nome)', 'Loteamento (Lote)', 'Loteamento (Quadra)', 'Registro (Matrícula)', 'Registro (Transcrição)', 'Registro (Cartório)', 'Área do Terreno (m²)', 'Área Construída (m²)', 'Área Útil (m²)', 'Com Calçada', 'Com Muro', 'Estimativa do valor (R$)', 'Data da Estimativa', 'Valor do m² da região (R$)', 'IPTU (Número)', 'IPTU (Situação)', 'IPTU (Observações)', 'Registro / Documentos (Observações)']];
          var _imoveisFormatados = [];

          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_this2.imoveisDownload, function (imovel) {
            var apelido = imovel.apelido ? imovel.apelido : '-';
            var proprietario = imovel.proprietario ? imovel.proprietario : '-';
            var tipo = imovel.tipo ? imovel.tipo : '-';
            var cidade = imovel.endereco ? _this2.formatarCidade(imovel.endereco.data, ' - ') : '-';
            var endereco = imovel.endereco ? _this2.formatarEndereco(imovel.endereco.data, ' - ') : '-';
            var status = imovel.status ? imovel.status.data.status : '-';

            var condicao = '-';
            if (imovel.status) {
              if (imovel.status.data.status === 'Compromissado' && imovel.status.data.compromissado_condicao) {
                condicao = imovel.status.data.compromissado_condicao;
              }
              if (imovel.status.data.status === 'Locado' && imovel.status.data.locado_condicao) {
                condicao = imovel.status.data.locado_condicao;
              }
              if (imovel.status.data.status === 'Invadido' && imovel.status.data.invadido_condicao) {
                condicao = imovel.status.data.invadido_condicao;
              }
            }

            var loteamento = '-';
            var loteamento_nome = '-';
            var loteamento_lote = '-';
            var loteamento_quadra = '-';
            if (imovel.endereco) {
              loteamento = imovel.endereco.data.loteamento ? 'Sim' : 'Não';
              loteamento_nome = imovel.endereco.data.loteamento_nome ? imovel.endereco.data.loteamento_nome : '-';
              loteamento_lote = imovel.endereco.data.loteamento_lote ? imovel.endereco.data.loteamento_lote : '-';
              loteamento_quadra = imovel.endereco.data.loteamento_quadra ? imovel.endereco.data.loteamento_quadra : '-';
            }

            var registro_matricula = '-';
            var registro_transcricao = '-';
            var registro_cartorio = '-';
            if (imovel.registro) {
              registro_matricula = imovel.registro.data.matricula ? imovel.registro.data.matricula : '-';
              registro_transcricao = imovel.registro.data.transcricao ? imovel.registro.data.transcricao : '-';
              registro_cartorio = imovel.registro.data.cartorio ? imovel.registro.data.cartorio : '-';
            }

            var area_terreno = '-';
            var area_construida = '-';
            var area_util = '-';
            var com_calcada = '-';
            var com_muro = '';
            if (imovel.area) {
              area_terreno = imovel.area.data.area_terreno ? imovel.area.data.area_terreno : '-';
              area_construida = imovel.area.data.area_construida ? imovel.area.data.area_construida : '-';
              area_util = imovel.area.data.area_util ? imovel.area.data.area_util : '-';
              com_calcada = imovel.area.data.calcada ? 'Sim' : 'Não';
              com_muro = imovel.area.data.muro ? 'Sim' : 'Não';
            }

            var estimativa_valor = '-';
            var estimativa_data = '-';
            var regiao_valor = '-';
            if (imovel.valor) {
              estimativa_valor = imovel.valor.data.estimativa_valor ? __WEBPACK_IMPORTED_MODULE_8_currency_formatter___default.a.format(imovel.valor.data.estimativa_valor, { code: 'BRL' }) : '-';
              estimativa_data = imovel.valor.data.estimativa_data ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(imovel.valor.data.estimativa_data).format('DD/MM/YYYY') : '-';
              regiao_valor = imovel.valor.data.regiao_valor ? __WEBPACK_IMPORTED_MODULE_8_currency_formatter___default.a.format(imovel.valor.data.regiao_valor, { code: 'BRL' }) : '-';
            }

            var iptu_numero = '-';
            var iptu_situacao = '-';
            var iptu_observacoes = '-';
            var iptu = imovel.taxas ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(imovel.taxas.data, function (o) {
              return o.taxa === 'IPTU';
            }) : null;
            if (iptu) {
              iptu_numero = iptu.numero;
              iptu_situacao = iptu.situacao;
              var taxas_observacoes = imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(imovel.observacoes.data, function (o) {
                return o.tipo === 'taxas';
              }) : null;
              if (taxas_observacoes) {
                iptu_observacoes = taxas_observacoes.conteudo;
              }
            }

            var registro_observacoes = '-';
            var observacoes_tipo_registro = imovel.observacoes ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(imovel.observacoes.data, function (o) {
              return o.tipo === 'registro';
            }) : null;
            if (observacoes_tipo_registro) {
              registro_observacoes = observacoes_tipo_registro.conteudo;
            }

            _imoveisFormatados.push([apelido, proprietario, tipo, cidade, endereco, status, condicao, loteamento, loteamento_nome, loteamento_lote, loteamento_quadra, registro_matricula, registro_transcricao, registro_cartorio, area_terreno, area_construida, area_util, com_calcada, com_muro, estimativa_valor, estimativa_data, regiao_valor, iptu_numero, iptu_situacao, iptu_observacoes, registro_observacoes]);
          });

          __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
            var sheetName = 'Lista de Imóveis';
            workbook.sheet(0).name(sheetName);

            var initialRow = 2;
            var currentRow = initialRow;

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filtrosFormatados).length > 0) {
              workbook.sheet(sheetName).cell('B' + currentRow).value('Filtros Aplicados');
              workbook.sheet(sheetName).row(currentRow).style({
                fontFamily: 'Verdana',
                fontSize: 14,
                bold: true
              });
              currentRow += 2;

              __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(filtrosFormatados, function (filtro, index) {
                workbook.sheet(sheetName).cell('B' + currentRow).value(index + ': ' + filtro);
                workbook.sheet(sheetName).cell('B' + currentRow).style({
                  fontFamily: 'Verdana',
                  fontSize: 12
                });

                currentRow++;
              });

              currentRow += 3;

              workbook.sheet(sheetName).cell('B' + currentRow).value('Lista de Imóveis');
              workbook.sheet(sheetName).row(currentRow).style({
                fontFamily: 'Verdana',
                fontSize: 14,
                bold: true
              });
              currentRow += 2;
            }

            var headerRow = currentRow;
            var contentRow = headerRow + 1;
            var tableRange = 'B' + headerRow + ':AA' + (headerRow + _imoveisFormatados.length);

            workbook.sheet(sheetName).cell('B' + headerRow).value(header);
            workbook.sheet(sheetName).cell('B' + contentRow).value(_imoveisFormatados);

            workbook.sheet(sheetName).column('A').width(5);
            workbook.sheet(sheetName).column('B').width(60);
            workbook.sheet(sheetName).column('C').width(40);
            workbook.sheet(sheetName).column('D').width(20);
            workbook.sheet(sheetName).column('E').width(30);
            workbook.sheet(sheetName).column('F').width(60);
            workbook.sheet(sheetName).column('G').width(30);
            workbook.sheet(sheetName).column('H').width(30);
            workbook.sheet(sheetName).column('I').width(30);
            workbook.sheet(sheetName).column('J').width(30);
            workbook.sheet(sheetName).column('K').width(30);
            workbook.sheet(sheetName).column('L').width(30);
            workbook.sheet(sheetName).column('M').width(45);
            workbook.sheet(sheetName).column('N').width(45);
            workbook.sheet(sheetName).column('O').width(45);
            workbook.sheet(sheetName).column('P').width(45);
            workbook.sheet(sheetName).column('Q').width(45);
            workbook.sheet(sheetName).column('R').width(45);
            workbook.sheet(sheetName).column('S').width(30);
            workbook.sheet(sheetName).column('T').width(30);
            workbook.sheet(sheetName).column('U').width(50);
            workbook.sheet(sheetName).column('V').width(30);
            workbook.sheet(sheetName).column('W').width(50);
            workbook.sheet(sheetName).column('X').width(30);
            workbook.sheet(sheetName).column('Y').width(30);
            workbook.sheet(sheetName).column('Z').width(100);
            workbook.sheet(sheetName).column('AA').width(100);

            workbook.sheet(sheetName).range(tableRange).style({
              fontFamily: 'Verdana',
              fontSize: 12,
              horizontalAlignment: 'left',
              verticalAlignment: 'center',
              textDirection: 'left-to-right',
              border: true,
              wrapText: true
            });

            workbook.sheet(sheetName).row(headerRow).style({
              bold: true
            });

            return workbook.outputAsync().then(function (blob) {
              var fileName = 'Lista de Im\xF3veis - ' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('DD.MM.YYYY') + '.xlsx';
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }
            });
          });
        }

        _this2.$store.dispatch('utils/hideLoading');
      }, function () {
        _this2.$store.dispatch('utils/hideLoading');
      });
    },
    changeTab: function changeTab(parametro) {
      var tabId = this.normalizeTabId(parametro);

      if (tabId === this.tabAtiva) {
        return;
      }

      this.clearImoveis();
      this.tabAtiva = tabId;
      this.loadImoveis();
    },
    openRightNav: function openRightNav() {
      this.$store.dispatch('template/setRightNav', true);
    },
    limparFiltros: function limparFiltros() {
      this.$store.dispatch('imoveis/clearFiltros');
    },
    clearImoveis: function clearImoveis() {
      this.$store.dispatch('imoveis/clearLista');
    },
    loadImoveis: function loadImoveis(page) {
      var payload = {};

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.filtros)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, this.filtros);
      }

      this.setTabPayloadParams(payload);

      if (page) {
        payload.page = page;
      }

      this.$store.dispatch('imoveis/loadLista', payload);
    },
    loadImoveisDownload: function loadImoveisDownload() {
      var payload = {};

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.filtros)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, this.filtros);
      }

      this.setTabPayloadParams(payload);

      return this.$store.dispatch('imoveis/loadListaDownload', payload);
    },
    formatarEndereco: function formatarEndereco(endereco) {
      var separador = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n';

      var logradouro = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([endereco.tipo + ' ' + endereco.logradouro, endereco.numero, endereco.complemento]).join(separador);

      return logradouro;
    },
    formatarCidade: function formatarCidade(endereco) {
      var separador = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n';

      var cidade = '-';
      if (endereco.cidade || endereco.uf) {
        cidade = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter([endereco.cidade, endereco.uf]).join(separador);
      }

      return cidade;
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Headers_HeadersMapa__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Headers_HeadersMapa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Headers_HeadersMapa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mapa_MapaInfoWindow__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mapa_MapaInfoWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Mapa_MapaInfoWindow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersMapa: __WEBPACK_IMPORTED_MODULE_1__Headers_HeadersMapa___default.a,
    MapaInfoWindow: __WEBPACK_IMPORTED_MODULE_2__Mapa_MapaInfoWindow___default.a
  },
  data: function data() {
    return {
      unsubscribe: null,

      currentLocationIcon: {
        url: 'static/current_location_marker.png',
        scaledSize: new google.maps.Size(16, 16)
      },
      zoomPosition: google.maps.ControlPosition.RIGHT_TOP,

      infoWindowOpened: false,
      infoWindowMarker: null,
      infoWindowImovel: null,
      mapBounds: {},
      currentZoom: 14,
      colors: {
        undefined: 'grey',
        Vago: '#EDC109',
        Compromissado: '#EA5DDF',
        Locado: '#4FBF46',
        Comodato: '#006AB6',
        Invadido: '#ED1B09'
      },
      legenda: false,
      center: {
        lat: this.$store.getters['utils/coords'].latitude,
        lng: this.$store.getters['utils/coords'].longitude
      }
    };
  },

  computed: {
    imoveis: {
      get: function get() {
        return this.$store.getters['imoveis/lista'];
      },
      set: function set() {}
    },
    coords: function coords() {
      return this.$store.getters['utils/coords'];
    },
    filtros: function filtros() {
      return this.$store.getters['imoveis/filtros'];
    },
    isRetrievingCoords: function isRetrievingCoords() {
      return this.$store.getters['utils/isRetrievingCoords'];
    }
  },
  watch: {
    isRetrievingCoords: function isRetrievingCoords() {
      this.center.lat = this.coords.latitude;
      this.center.lng = this.coords.longitude;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.clearImoveis();
    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'imoveis/SET_FILTROS') {
        _this.clearImoveis();
        _this.loadImoveis();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },

  methods: {
    getIcon: function getIcon(imovel) {
      var fillColor = this.colors.undefined;
      if (imovel.status !== undefined) {
        fillColor = this.colors[imovel.status.data.status];
      }

      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: fillColor,
        fillOpacity: 1,
        strokeColor: '#FFFFFF',
        strokeWeight: 1,
        scale: 1
      };
    },
    openRightNav: function openRightNav() {
      this.$store.dispatch('template/setRightNav', true);
    },
    clickMarker: function clickMarker(item) {
      this.infoWindowMarker = this.$refs['marker' + item.id][0].$markerObject;
      this.infoWindowImovel = item;
      this.infoWindowOpened = true;
    },
    updateBounds: function updateBounds(event) {
      this.$store.dispatch('template/setLeftNav', false);
      if (this.isRetrievingCoords) {
        return;
      }
      this.mapBounds = event;
    },
    updateZoom: function updateZoom(event) {
      this.currentZoom = event;
    },
    clearImoveis: function clearImoveis() {
      this.$store.dispatch('imoveis/clearLista');
    },
    idleLoadImoveis: function idleLoadImoveis() {
      this.loadImoveis();
    },
    loadImoveis: function loadImoveis() {
      if (this.isRetrievingCoords) {
        return;
      }

      if (this.currentZoom < 10) {
        return;
      }

      var payload = {};

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.filtros)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, this.filtros);
      }

      payload.loading = false;
      payload.parametro = 'coords';
      payload.sw_lat = this.mapBounds.getSouthWest().lat();
      payload.sw_lng = this.mapBounds.getSouthWest().lng();
      payload.ne_lat = this.mapBounds.getNorthEast().lat();
      payload.ne_lng = this.mapBounds.getNorthEast().lng();
      payload.center_lat = this.mapBounds.getCenter().lat();
      payload.center_lng = this.mapBounds.getCenter().lng();
      payload.zoom = this.currentZoom;

      this.$store.dispatch('imoveis/loadLista', payload);
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.$auth.user().visualizacao === 'mapa') {
      this.$router.push({ name: 'ImoveisMapa' });
    } else {
      this.$router.push({ name: 'ImoveisLista' });
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListaVistoriaSituacao__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListaVistoriaSituacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ListaVistoriaSituacao__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['imovel', 'flat', 'exibirStatus'],
  components: {
    ListaVistoriaSituacao: __WEBPACK_IMPORTED_MODULE_2__ListaVistoriaSituacao___default.a
  },
  computed: {
    fallbackTitulo: function fallbackTitulo() {
      return this.imovel && this.imovel.id ? 'Im\xF3vel #' + this.imovel.id : 'Imóvel';
    },
    statusName: function statusName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.imovel, 'status.data.status');
    },
    statusColor: function statusColor() {
      return this.colors[this.statusName] || this.colors.undefined;
    },
    formattedEndereco: function formattedEndereco() {
      var endereco = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.imovel, 'endereco.data');
      if (!endereco) return '';
      return this.formatarEndereco(endereco);
    },
    tarefasPendentesCount: function tarefasPendentesCount() {
      return this.countTarefasPendentes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.imovel, 'tarefas.data', []));
    },
    vistoriaSituacao: function vistoriaSituacao() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.imovel, 'vistoria.data.situacao', '');
    }
  },
  data: function data() {
    return {
      colors: {
        undefined: 'grey',
        Vago: '#EDC109',
        Compromissado: '#EA5DDF',
        Locado: '#4FBF46',
        Comodato: '#006AB6',
        Invadido: '#ED1B09'
      }
    };
  },

  methods: {
    formatarEndereco: function formatarEndereco(endereco) {
      if (!endereco || (typeof endereco === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(endereco)) !== 'object') return '';
      var logradouro = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter([endereco.tipo + ' ' + endereco.logradouro, endereco.numero, endereco.complemento]).join(', ');
      var cidade = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter([logradouro, endereco.cidade, endereco.uf]).join(' - ');

      return cidade;
    },
    countTarefasPendentes: function countTarefasPendentes(tarefas) {
      if (!Array.isArray(tarefas)) return 0;
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(tarefas, { realizada: false }).length;
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['situacao'],
  computed: {
    situacaoClass: function situacaoClass() {
      switch (this.situacao) {
        case 'realizada':
          return 'primary';
        case 'atrasada':
          return 'vermelho';
        case 'próxima':
          return 'amarelo';
        case 'em dia':
          return 'verde';
      }
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snazzy_info_window_dist_snazzy_info_window_min_css__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_snazzy_info_window_dist_snazzy_info_window_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_snazzy_info_window_dist_snazzy_info_window_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_ListaVistoriaSituacao__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_ListaVistoriaSituacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Lista_ListaVistoriaSituacao__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['marker', 'imovel'],
  components: {
    ListaVistoriaSituacao: __WEBPACK_IMPORTED_MODULE_2__Lista_ListaVistoriaSituacao___default.a
  },
  data: function data() {
    return {
      infoWindowContentApelido: '',
      infoWindowContentProprietario: '',
      infoWindowContentEndereco: '',
      infoWindowContentFoto: '',
      infoWindowContentVistoria: '',
      infoWindowContentTarefasPendentes: ''
    };
  },
  mounted: function mounted() {
    this.infoWindowContentApelido = this.imovel.apelido;
    this.infoWindowContentProprietario = this.imovel.proprietario ? this.imovel.proprietario : '';
    this.infoWindowContentEndereco = this.formatarEndereco(this.imovel.endereco.data);
    this.infoWindowContentFoto = this.imovel.fotos ? this.formatarFotos(this.imovel.fotos.data) : '';
    this.infoWindowContentVistoria = this.imovel.vistoria ? this.imovel.vistoria.data.situacao : '';
    this.infoWindowContentTarefasPendentes = this.imovel.tarefas ? this.countTarefasPendentes(this.imovel.tarefas.data) : '';

    var SnazzyInfoWindow = __webpack_require__(916);
    var info = new SnazzyInfoWindow({
      marker: this.marker,
      content: this.$refs['info-window'],
      placement: 'bottom',
      closeWhenOthersOpen: true,
      panOnOpen: true,
      showCloseButton: false,
      border: false,
      borderRadius: '12px',
      padding: '0px',
      callbacks: {
        afterOpen: function afterOpen() {
          if (document.getElementsByClassName('si-float-wrapper').length > 0) {
            document.getElementsByClassName('mapa_botoes')[0].style.opacity = 0;
          }
        },
        afterClose: function afterClose() {
          if (document.getElementsByClassName('si-float-wrapper').length === 0) {
            document.getElementsByClassName('mapa_botoes')[0].style.opacity = 1;
          }
        }
      }
    });

    info.open();
  },

  methods: {
    formatarEndereco: function formatarEndereco(endereco) {
      var logradouro = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter([endereco.tipo + ' ' + endereco.logradouro, endereco.numero, endereco.complemento]).join(', ');
      var cidade = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter([logradouro, endereco.cidade, endereco.uf]).join(' - ');

      return cidade;
    },
    formatarFotos: function formatarFotos(fotos) {
      var ilustrativa = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(fotos, function (item) {
        return item.tipo === 'ilustrativa';
      });

      if (ilustrativa.length > 0) {
        return ilustrativa[0].foto;
      } else {
        return '';
      }
    },
    countTarefasPendentes: function countTarefasPendentes(tarefas) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(tarefas, { realizada: false }).length;
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_formatters__ = __webpack_require__(79);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['visible', 'imovelId'],
  data: function data() {
    return {
      users: [],
      form: {
        descricao: '',
        valor: '',
        data_vencimento: '',
        aprovador_id: null
      },
      file: null,
      fileName: '',
      loading: false,
      openedAt: 0
    };
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      var fieldsInvalid = this.fields ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) : false;
      var hasEmptyFields = !this.form.descricao || !this.form.valor || !this.form.data_vencimento || !this.form.aprovador_id;
      return fieldsInvalid || hasEmptyFields || !this.file || this.loading;
    },
    valorPreview: function valorPreview() {
      return this.form.valor ? this.formatCurrency(this.form.valor) : 'R$ 0,00';
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.openedAt = Date.now();
        this.loadUsers();
        this.resetForm();
      }
    }
  },
  methods: {
    isBlockedUser: function isBlockedUser(user) {
      if (!user) return true;
      var blocked = user.bloqueado;
      return blocked === true || blocked === 1 || blocked === '1';
    },
    normalizeApprovers: function normalizeApprovers(users) {
      var _this2 = this;

      if (!Array.isArray(users)) return [];

      return users.filter(function (user) {
        return !_this2.isBlockedUser(user);
      }).sort(function (a, b) {
        var nameA = String(a && a.name || '');
        var nameB = String(b && b.name || '');
        return nameA.localeCompare(nameB, 'pt-BR');
      });
    },
    loadUsers: function loadUsers() {
      var _this3 = this;

      var endpoints = ['/pagamentos/aprovadores', '/users', '/usuarios'];

      var requestApprovers = function requestApprovers() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (index >= endpoints.length) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('approvers_not_available'));
        }

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + __WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + endpoints[index]).then(function (response) {
          return response && response.data ? response.data.data : [];
        }).catch(function (error) {
          var status = error && error.response ? error.response.status : null;
          var canFallback = index < endpoints.length - 1 && (status === 404 || status === 405);
          if (canFallback) {
            return requestApprovers(index + 1);
          }
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
      };

      requestApprovers().then(function (users) {
        _this3.users = _this3.normalizeApprovers(users);

        if (_this3.users.length < 1) {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'info',
            text: 'Nenhum usuário ativo disponível para aprovador.'
          });
        }
      }).catch(function (error) {
        _this3.users = [];
        var status = error && error.response ? error.response.status : null;
        var text = status === 403 ? 'Sem permissão para carregar aprovadores.' : 'Não foi possível carregar a lista de aprovadores.';

        _this3.$store.dispatch('utils/showSnackbar', {
          type: 'error',
          text: text
        });
      });
    },
    onValorInput: function onValorInput(value) {
      this.form.valor = this.formatCurrencyInput(value);
    },
    formatCurrencyInput: function formatCurrencyInput(value) {
      var digits = String(value || '').replace(/\D/g, '');
      if (!digits) return '';
      var amount = parseInt(digits, 10) / 100;

      return amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    normalizeMoney: __WEBPACK_IMPORTED_MODULE_4__utils_formatters__["a" /* normalizeMoney */],
    formatCurrency: __WEBPACK_IMPORTED_MODULE_4__utils_formatters__["b" /* formatBRLCurrency */],
    formatDate: __WEBPACK_IMPORTED_MODULE_4__utils_formatters__["c" /* formatBRDate */],
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
      this.fileName = files[0].name;
    },
    resetFile: function resetFile() {
      this.file = null;
      this.fileName = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    resetForm: function resetForm() {
      var _this4 = this;

      this.form = {
        descricao: '',
        valor: '',
        data_vencimento: '',
        aprovador_id: null
      };
      this.file = null;
      this.fileName = '';
      this.loading = false;
      if (this.$validator) {
        this.$validator.pause();
        this.$nextTick(function () {
          _this4.$validator.errors.clear();
          _this4.$validator.resume();
        });
      }
    },
    onDialogInput: function onDialogInput(value) {
      if (value === false && !this.loading) {
        if (Date.now() - this.openedAt < 200) return;
        this.close();
      }
    },
    close: function close() {
      this.$emit('close');
    },
    save: function save() {
      var _this5 = this;

      if (this.loading) return;

      this.$store.dispatch('utils/showLoading');
      this.loading = true;

      this.$validator.validateAll().then(function (result) {
        if (result && _this5.file) {
          var formData = new FormData();
          formData.append('imovel_id', _this5.imovelId);
          formData.append('documento', _this5.file);

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.form).forEach(function (key) {
            var value = _this5.form[key];
            if (key === 'valor') {
              value = _this5.normalizeMoney(value).toFixed(2);
            }
            formData.append(key, value);
          });

          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/pagamentos', formData).then(function () {
            _this5.loading = false;
            _this5.$store.dispatch('utils/hideLoading');
            _this5.$store.dispatch('utils/showSnackbar', {
              type: 'success',
              text: 'Solicitação de pagamento enviada!'
            });
            _this5.$emit('saved');
            _this5.close();
          }).catch(function (error) {
            _this5.loading = false;
            _this5.$store.dispatch('utils/hideLoading');
            var text = 'Erro ao enviar solicitação.';
            if (error.response && error.response.data && error.response.data.errors) {
              var errors = error.response.data.errors;
              text = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
                return errors[key][0];
              }).join(' | ');
            } else if (error.response && error.response.data && error.response.data.error) {
              text = error.response.data.error;
            }
            _this5.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: text
            });
          });
        } else {
          _this5.loading = false;
          _this5.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formatters__ = __webpack_require__(79);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['visible', 'pagamento'],
  data: function data() {
    return {
      loading: false,
      colors: {
        pendente: '#EDC109',
        autorizado: '#006AB6',
        rejeitado: '#ED1B09',
        pago: '#4FBF46'
      },
      statusLabels: {
        pendente: 'Pendente',
        autorizado: 'Autorizado',
        rejeitado: 'Rejeitado',
        pago: 'Pago'
      }
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.loading = false;
      }
    }
  },
  methods: {
    formatCurrency: __WEBPACK_IMPORTED_MODULE_2__utils_formatters__["b" /* formatBRLCurrency */],
    formatDate: __WEBPACK_IMPORTED_MODULE_2__utils_formatters__["c" /* formatBRDate */],
    getStatusColor: function getStatusColor(status) {
      return this.colors[status] || '#9E9E9E';
    },
    formatStatus: function formatStatus(status) {
      return this.statusLabels[status] || 'Não definido';
    },
    onDialogInput: function onDialogInput(value) {
      if (value === false && !this.loading) this.close();
    },
    close: function close() {
      this.$emit('close');
    },
    confirmar: function confirmar(tipo) {
      var _this = this;

      if (this.loading) return;

      this.loading = true;
      this.$store.dispatch('utils/showLoading');

      var data = {
        acao_aprovacao: tipo
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/pagamentos/' + this.pagamento.id, data).then(function () {
        _this.loading = false;
        _this.$store.dispatch('utils/hideLoading');
        _this.$emit('saved');
        _this.close();
        _this.$store.dispatch('utils/showSnackbar', {
          type: 'success',
          text: 'Pagamento ' + (tipo === 'autorizar' ? 'autorizado' : 'rejeitado') + ' com sucesso!'
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.$store.dispatch('utils/hideLoading');
        var text = 'Erro ao processar ação.';
        if (error.response && error.response.data && error.response.data.error) {
          text = error.response.data.error;
        }
        _this.$store.dispatch('utils/showSnackbar', {
          type: 'error',
          text: text
        });
      });
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formatters__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PagamentosAdicionar__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PagamentosAdicionar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PagamentosAdicionar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PagamentosAprovar__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PagamentosAprovar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PagamentosAprovar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PagamentosPagar__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PagamentosPagar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PagamentosPagar__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['imovelId'],
  components: { PagamentosAdicionar: __WEBPACK_IMPORTED_MODULE_3__PagamentosAdicionar___default.a, PagamentosAprovar: __WEBPACK_IMPORTED_MODULE_4__PagamentosAprovar___default.a, PagamentosPagar: __WEBPACK_IMPORTED_MODULE_5__PagamentosPagar___default.a },
  data: function data() {
    return {
      pagamentos: [],
      dialogAdicionar: false,
      dialogAprovar: false,
      dialogPagar: false,
      selectedPagamento: null,
      colors: {
        pendente: '#EDC109',
        autorizado: '#006AB6',
        rejeitado: '#ED1B09',
        pago: '#4FBF46'
      },
      statusLabels: {
        pendente: 'Pendente',
        autorizado: 'Autorizado',
        rejeitado: 'Rejeitado',
        pago: 'Pago'
      }
    };
  },
  mounted: function mounted() {
    this.loadPagamentos();
  },

  computed: {
    totalSolicitado: function totalSolicitado() {
      return this.pagamentos.reduce(function (total, item) {
        return total + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["a" /* normalizeMoney */])(item.valor);
      }, 0);
    },
    totalPago: function totalPago() {
      return this.pagamentos.filter(function (item) {
        return item.status === 'pago';
      }).reduce(function (total, item) {
        return total + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["a" /* normalizeMoney */])(item.valor);
      }, 0);
    }
  },
  methods: {
    loadPagamentos: function loadPagamentos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/pagamentos?imovel_id=' + this.imovelId).then(function (response) {
        _this.pagamentos = response.data.data;
      }).catch(function () {
        _this.pagamentos = [];
      });
    },

    formatCurrency: __WEBPACK_IMPORTED_MODULE_2__utils_formatters__["b" /* formatBRLCurrency */],
    formatDate: __WEBPACK_IMPORTED_MODULE_2__utils_formatters__["c" /* formatBRDate */],
    formatStatus: function formatStatus(status) {
      return this.statusLabels[status] || 'Não definido';
    },
    getStatusColor: function getStatusColor(status) {
      return this.colors[status] || 'grey';
    },
    normalizeId: function normalizeId(value) {
      if (value === null || value === undefined || value === '') return null;
      return String(value).trim();
    },
    normalizeEmail: function normalizeEmail(value) {
      if (!value) return null;
      return String(value).trim().toLowerCase();
    },
    isCurrentUser: function isCurrentUser(targetId, targetUser) {
      var user = this.$auth.user();
      if (!user) return false;

      var currentId = this.normalizeId(user.id);
      var currentEmail = this.normalizeEmail(user.email);
      var directId = this.normalizeId(targetId);
      var relationId = this.normalizeId(targetUser && targetUser.id);
      var relationEmail = this.normalizeEmail(targetUser && targetUser.email);

      var idMatch = !!currentId && (directId && currentId === directId || relationId && currentId === relationId);
      var emailMatch = !!currentEmail && !!relationEmail && currentEmail === relationEmail;

      return idMatch || emailMatch;
    },
    podeAprovar: function podeAprovar(item) {
      var isAdmin = this.$auth.check('Administrador');
      return this.isCurrentUser(item.aprovador_id, item.aprovador) || isAdmin;
    },
    canApproveAction: function canApproveAction(item) {
      if (!this.$hasGranularPermission('pagamentos', 'edit')) return false;

      return this.isCurrentUser(item.aprovador_id, item.aprovador);
    },
    canRegisterPaymentAction: function canRegisterPaymentAction(item) {
      if (!this.$hasGranularPermission('pagamentos', 'edit')) return false;
      if (item.status !== 'autorizado') return false;
      return this.isCurrentUser(item.solicitante_id, item.solicitante);
    },
    canDeleteAction: function canDeleteAction(item) {
      if (!this.$hasGranularPermission('pagamentos', 'delete')) return false;
      var isOwner = this.isCurrentUser(item.solicitante_id, item.solicitante);
      return item.status !== 'pago' && (this.podeAprovar(item) || isOwner);
    },
    hasMenuActions: function hasMenuActions(item) {
      var canEvaluate = item.status === 'pendente' && this.canApproveAction(item);
      var canRegister = this.canRegisterPaymentAction(item);
      var canDelete = this.canDeleteAction(item);

      return canEvaluate || canRegister || canDelete;
    },
    openDialogAprovar: function openDialogAprovar(item) {
      this.selectedPagamento = item;
      this.dialogAprovar = true;
    },
    openDialogAdicionar: function openDialogAdicionar() {
      var _this2 = this;

      setTimeout(function () {
        _this2.dialogAdicionar = true;
      }, 0);
    },
    openDialogPagar: function openDialogPagar(item) {
      this.selectedPagamento = item;
      this.dialogPagar = true;
    },
    excluirPagamento: function excluirPagamento(item) {
      var _this3 = this;

      if (confirm('Tem certeza que deseja excluir esta solicitação?')) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/pagamentos/' + item.id).then(function () {
          _this3.loadPagamentos();
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'success',
            text: 'Solicitação excluída com sucesso!'
          });
        }).catch(function () {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Erro ao excluir solicitação.'
          });
        });
      }
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Headers_HeadersDetalhesResumo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PagamentosLista__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PagamentosLista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PagamentosLista__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_0__Headers_HeadersDetalhesResumo___default.a,
    PagamentosLista: __WEBPACK_IMPORTED_MODULE_1__PagamentosLista___default.a
  },
  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    canViewPagamentos: function canViewPagamentos() {
      return this.$hasGranularPermission('pagamentos', 'view');
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formatters__ = __webpack_require__(79);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['visible', 'pagamento'],
  data: function data() {
    return {
      data_pagamento: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      file: null,
      fileName: '',
      loading: false
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.resetFile();
        this.data_pagamento = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
        this.loading = false;
      }
    }
  },
  methods: {
    formatCurrency: __WEBPACK_IMPORTED_MODULE_3__utils_formatters__["b" /* formatBRLCurrency */],
    formatDate: __WEBPACK_IMPORTED_MODULE_3__utils_formatters__["c" /* formatBRDate */],
    onFileChange: function onFileChange(e) {
      var files = e.target.files;
      if (files[0]) {
        this.file = files[0];
        this.fileName = files[0].name;
      }
    },
    resetFile: function resetFile() {
      this.file = null;
      this.fileName = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    onDialogInput: function onDialogInput(value) {
      if (value === false && !this.loading) this.close();
    },
    close: function close() {
      this.$emit('close');
    },
    save: function save() {
      var _this = this;

      if (this.loading) return;

      if (this.file && this.data_pagamento) {
        this.loading = true;
        this.$store.dispatch('utils/showLoading');

        var formData = new FormData();
        formData.append('acao_pagamento', true);
        formData.append('data_pagamento', this.data_pagamento);
        formData.append('comprovante', this.file);

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/pagamentos/' + this.pagamento.id, formData).then(function () {
          _this.loading = false;
          _this.$store.dispatch('utils/hideLoading');
          _this.$emit('saved');
          _this.close();
          _this.$store.dispatch('utils/showSnackbar', {
            type: 'success',
            text: 'Pagamento registrado com sucesso!'
          });
        }).catch(function (error) {
          _this.loading = false;
          _this.$store.dispatch('utils/hideLoading');
          var text = 'Erro ao registrar pagamento.';
          if (error.response && error.response.data && error.response.data.error) {
            text = error.response.data.error;
          }
          _this.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: text
          });
        });
      }
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Utils_Loading__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Utils_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Utils_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Utils_Snackbar__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Utils_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Utils_Snackbar__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_Utils_Loading___default.a,
    Snackbar: __WEBPACK_IMPORTED_MODULE_6__components_Utils_Snackbar___default.a
  },
  data: function data() {
    return {
      dialogRecuperarSenha: false,
      form: {
        fields: {
          email: '',
          password: ''
        }
      }
    };
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty));
    },
    snackbar: function snackbar() {
      return this.$store.getters['utils/snackbar'];
    }
  },
  methods: {
    onSubmitRecuperarSenha: function onSubmitRecuperarSenha() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiURL */] + '/password-forgot', { email: this.form.fields.email }).then(function (response) {
        _this2.$store.dispatch('utils/showSnackbar', {
          text: 'E-mail enviado com sucesso.',
          type: 'success'
        });
        _this2.dialogRecuperarSenha = false;
        _this2.$store.dispatch('utils/hideLoading');
      }, function () {
        _this2.$store.dispatch('utils/showSnackbar', {
          text: 'E-mail não encontrado.',
          type: 'error'
        });
        _this2.$store.dispatch('utils/hideLoading');
      });
    },
    onSubmit: function onSubmit() {
      this.$store.dispatch('utils/showLoading');
      this.$auth.login({
        data: {
          email: this.form.fields.email,
          password: this.form.fields.password
        },
        success: function success() {
          var _this3 = this;

          this.$store.dispatch('utils/hideLoading');

          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].cordova.on('deviceready', function () {
            window.plugins.OneSignal.setSubscription(true);
            window.plugins.OneSignal.sendTag('user_id', _this3.$auth.user().id);
          });
        },
        error: function error(_error) {
          var errorText = '';
          var errorType = 'error';
          if (_error.response.status === 401) {
            errorText = 'E-mail ou senha inválidos. Tente novamente.';
          } else if (_error.response.status === 409) {
            errorText = 'Seu usuário encontra-se inativo. Solicite a um administrador para ativa-lo.';
            errorType = 'info';
          } else {
            errorText = 'Servidor indisponível. Tente novamente mais tarde.';
          }

          this.$store.dispatch('utils/showSnackbar', {
            text: errorText,
            type: errorType
          });
          this.$store.dispatch('utils/hideLoading');
        },
        rememberMe: true,
        fetchUser: true
      });
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$auth.logout({
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.on('deviceready', function () {
          window.plugins.OneSignal.setSubscription(false);
        });
        this.$router.push({ name: 'Login' });
      }
    });
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      status: 'loading',
      responseTitle: '',
      responseMessage: '',
      pagamento: null
    };
  },

  computed: {
    token: function token() {
      return this.$route.params.token || '';
    },
    actionType: function actionType() {
      return this.$route.meta.paymentAction || 'aprovar';
    },
    isApproveAction: function isApproveAction() {
      return this.actionType === 'aprovar';
    },
    actionLabel: function actionLabel() {
      return this.isApproveAction ? 'Aprovação de pagamento' : 'Rejeição de pagamento';
    },
    pageHeading: function pageHeading() {
      return this.isApproveAction ? 'Confirmando aprovação' : 'Confirmando rejeição';
    },
    pageSubheading: function pageSubheading() {
      return this.isApproveAction ? 'Estamos registrando a autorização enviada pelo WhatsApp.' : 'Estamos registrando a rejeição enviada pelo WhatsApp.';
    },
    loadingTitle: function loadingTitle() {
      return this.isApproveAction ? 'Aprovando pagamento' : 'Rejeitando pagamento';
    },
    loadingMessage: function loadingMessage() {
      return 'Aguarde enquanto validamos este link e concluímos a ação.';
    },
    hasPagamentoDetails: function hasPagamentoDetails() {
      return !!(this.pagamento && (this.pagamento.id || this.pagamento.status || this.pagamento.descricao || this.pagamento.imovel || this.pagamento.solicitante));
    },
    maskedToken: function maskedToken() {
      if (this.token.length <= 10) return this.token;
      return this.token.slice(0, 6) + '...' + this.token.slice(-4);
    }
  },
  watch: {
    '$route': function $route() {
      this.executeAction();
    }
  },
  mounted: function mounted() {
    this.executeAction();
  },

  methods: {
    executeAction: function executeAction() {
      var _this = this;

      if (!this.token) {
        this.setError({
          title: 'Link inválido',
          message: 'O token de avaliação não foi informado.'
        });
        return;
      }

      this.status = 'loading';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.buildEndpoint()).then(function (response) {
        var payload = response && response.data ? response.data : {};

        if (payload.success === false) {
          _this.setError(payload);
          return;
        }

        _this.status = 'success';
        _this.responseTitle = payload.title || 'Avaliação registrada';
        _this.responseMessage = payload.message || _this.defaultSuccessMessage();
        _this.pagamento = _this.normalizePagamento(payload.pagamento);
      }).catch(function (error) {
        var payload = error && error.response && error.response.data ? error.response.data : {};
        _this.setError(payload);
      });
    },
    buildEndpoint: function buildEndpoint() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + '/public/pagamentos/' + this.actionType + '/' + encodeURIComponent(this.token);
    },
    defaultSuccessMessage: function defaultSuccessMessage() {
      return this.isApproveAction ? 'O pagamento foi aprovado com sucesso.' : 'O pagamento foi rejeitado com sucesso.';
    },
    normalizePagamento: function normalizePagamento(pagamento) {
      if (!pagamento) return null;

      return {
        id: pagamento.id,
        status: pagamento.status,
        descricao: pagamento.descricao,
        imovel: pagamento.imovel,
        solicitante: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(pagamento.solicitante) === 'object' && pagamento.solicitante !== null ? pagamento.solicitante.name : pagamento.solicitante
      };
    },
    setError: function setError(payload) {
      this.status = 'error';
      this.pagamento = this.normalizePagamento(payload.pagamento);
      this.responseTitle = payload.title || 'Não foi possível concluir a avaliação';
      this.responseMessage = payload.message || payload.error || 'Esse link é inválido, expirou ou esta avaliação já foi processada.';
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Charts_Pie_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2pdf_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2pdf_js__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PieChart: __WEBPACK_IMPORTED_MODULE_5__Charts_Pie_js__["a" /* default */] },
  data: function data() {
    return {
      unsubscribe: null,
      dataLoaded: false,
      dataChart: {
        status: null,
        substatus: {},
        proprietario: null,
        tipo: null,
        iptu: null,
        vistoria: null,
        tarefas: null
      },
      legendChart: {
        status: null,
        compromissado: null,
        locado: null,
        invadido: null,
        proprietario: null,
        tipo: null,
        iptu: null,
        vistoria: null,
        tarefas: null
      },
      substatusSelecionado: null,
      data: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD/MM/YYYY [às] HH:mm:ss'),
      gerandoPdf: false,
      totalCidades: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.clearComparativo();
              _this.loadComparativo();

              _this.unsubscribe = _this.$store.subscribe(function (mutation, state) {
                if (mutation.type === 'imoveis/SET_FILTROS') {
                  _this.clearComparativo();
                  _this.loadComparativo();
                }
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },

  computed: {
    comparativo: function comparativo() {
      return this.$store.getters['relatorios/comparativo'];
    },
    filtros: function filtros() {
      return this.$store.getters['imoveis/filtros'];
    }
  },
  watch: {
    comparativo: function comparativo() {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.comparativo).length > 0) {
        this.dataChart.status = this.buildChartData(this.comparativo.status);

        if (this.comparativo.substatus['Compromissado']) {
          this.dataChart.substatus['Compromissado'] = this.buildChartData(this.comparativo.substatus['Compromissado']);
        }

        if (this.comparativo.substatus['Locado']) {
          this.dataChart.substatus['Locado'] = this.buildChartData(this.comparativo.substatus['Locado']);
        }

        if (this.comparativo.substatus['Invadido']) {
          this.dataChart.substatus['Invadido'] = this.buildChartData(this.comparativo.substatus['Invadido']);
        }

        this.substatusSelecionado = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.dataChart.substatus)[0];

        this.dataChart.proprietario = this.buildChartData(this.comparativo.proprietario);

        this.dataChart.tipo = this.buildChartData(this.comparativo.tipo);

        this.dataChart.iptu = this.buildChartData(this.comparativo.iptu);

        this.dataChart.vistoria = this.buildChartData(this.comparativo.vistoria);

        this.dataChart.tarefas = this.buildChartData(this.comparativo.tarefas);

        var sum = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.reduce(this.comparativo.cidade, function (acc, n) {
          return acc + n;
        });
        this.totalCidades = sum;

        this.dataLoaded = true;
      }
    },
    filtros: function filtros() {
      this.dataLoaded = false;
    }
  },
  methods: {
    buildChartData: function buildChartData(source) {
      var safeSource = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(source) ? source : {};
      var labels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(safeSource);
      var values = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(safeSource, 'total');
      var apiColors = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(safeSource, 'color');
      var backgroundColor = this.getDistinctColors(apiColors, labels.length);

      return {
        labels: labels,
        datasets: [{
          backgroundColor: backgroundColor,
          data: values
        }]
      };
    },
    getDistinctColors: function getDistinctColors(apiColors, size) {
      var palette = ['#F37021', '#1E88E5', '#43A047', '#E53935', '#8E24AA', '#FB8C00', '#00ACC1', '#7CB342', '#6D4C41', '#3949AB', '#D81B60', '#5E35B1', '#039BE5', '#00897B', '#C0CA33', '#546E7A', '#EF6C00', '#C62828', '#2E7D32', '#1565C0'];
      var used = {};
      var colors = [];

      for (var i = 0; i < size; i++) {
        var color = apiColors[i] ? apiColors[i].trim() : '';
        if (this.isValidColor(color) && !used[color.toLowerCase()]) {
          colors.push(color);
          used[color.toLowerCase()] = true;
          continue;
        }

        var fallbackColor = null;
        for (var p = 0; p < palette.length; p++) {
          var paletteColor = palette[p];
          if (!used[paletteColor.toLowerCase()]) {
            fallbackColor = paletteColor;
            break;
          }
        }

        if (!fallbackColor) {
          var seed = i;
          do {
            var hue = seed * 137.508 % 360;
            fallbackColor = 'hsl(' + Math.round(hue) + ', 65%, 50%)';
            seed++;
          } while (used[fallbackColor.toLowerCase()]);
        }

        colors.push(fallbackColor);
        used[fallbackColor.toLowerCase()] = true;
      }

      return colors;
    },
    isValidColor: function isValidColor(value) {
      return !!value && typeof value === 'string' && value.trim().length > 0;
    },
    printGraph: function printGraph(element, name) {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');
      this.gerandoPdf = true;

      setTimeout(function () {
        _this2.data = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD/MM/YYYY [às] HH:mm:ss');
        __WEBPACK_IMPORTED_MODULE_7_html2pdf_js___default()(document.getElementById(element), {
          margin: 2,
          filename: 'Relat\xF3rio - ' + name + ' - ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD.MM.YYYY') + '.pdf',
          image: {
            type: 'jpeg',
            quality: 1
          },
          html2canvas: {
            dpi: 300,
            windowWidth: 10
          }
        }).then(function () {
          _this2.$store.dispatch('utils/hideLoading');
          _this2.gerandoPdf = false;
        });
      }, 500);
    },
    setLegend: function setLegend(html, legend) {
      this.legendChart[legend] = html;
    },
    clearComparativo: function clearComparativo() {
      this.$store.dispatch('relatorios/clearComparativo');
    },
    loadComparativo: function loadComparativo() {
      var payload = {};

      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.filtros)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, this.filtros);
      }

      this.$store.dispatch('relatorios/loadComparativo', payload);
    },
    changeSubstatusSelecionado: function changeSubstatusSelecionado(substatus) {
      this.substatusSelecionado = substatus;
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_daterange_picker__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_daterange_picker_dist_vuetify_daterange_picker_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_daterange_picker_dist_vuetify_daterange_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_daterange_picker_dist_vuetify_daterange_picker_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DateRange: __WEBPACK_IMPORTED_MODULE_4_vuetify_daterange_picker___default.a },
  data: function data() {
    return {
      unsubscribe: null,
      dateRangeOptions: {
        minDate: '2018-01-01',
        startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day').subtract('1', 'months').format('YYYY-MM-DD'),
        endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day').format('YYYY-MM-DD'),
        format: 'DD/MM/YYYY'
      },
      dateMenu: false,
      periodoSelecionado: 'recentes',
      dataInicial: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day').subtract('1', 'months').format('YYYY-MM-DD'),
      dataFinal: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day').format('YYYY-MM-DD'),
      userSelecionado: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('users/loadUsers');

    if (this.por === 'data') {
      this.clearHistorico();
      this.loadHistorico();
    }

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'imoveis/SET_FILTROS') {
        _this.clearHistorico();
        _this.loadHistorico();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },

  computed: {
    por: function por() {
      return this.$route.name === 'RelatoriosHistoricoData' ? 'data' : 'usuário';
    },
    users: function users() {
      return this.$store.getters['users/users'];
    },
    historico: function historico() {
      var historicoFormatado = {};
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(this.$store.getters['relatorios/historico'], function (item, key) {
        var dataFormatada = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(item, function (imovel) {
          return 'imovel' + imovel.tags;
        });
        historicoFormatado[key] = dataFormatada;
      });
      return historicoFormatado;
    },
    paginacao: function paginacao() {
      return this.$store.getters['relatorios/historicoPaginacao'];
    },
    filtros: function filtros() {
      return this.$store.getters['imoveis/filtros'];
    }
  },
  methods: {
    formatType: function formatType(type) {
      var typeName = type.split('\\').pop();
      var fixTypeNames = {
        'Imovel': 'Imóvel',
        'Area': 'Área',
        'Endereco': 'Endereço',
        'Observacao': 'Observação'
      };

      if (fixTypeNames.hasOwnProperty(typeName)) {
        return fixTypeNames[typeName];
      } else {
        return typeName;
      }
    },
    formatEndereco: function formatEndereco(endereco) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter([endereco['tipo'] + ' ' + endereco['logradouro'], endereco['numero'], endereco['complemento']]).join(', ');
    },
    formatData: function formatData(data) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY');
    },
    formatHora: function formatHora(hora) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(hora).format('H:mm');
    },
    formatColunaName: function formatColunaName(coluna) {
      var fixColunaNames = {
        'titulo': 'Título',
        'conteudo': 'Conteúdo',
        'area_terreno': 'Área do terreno',
        'area_construida': 'Área construída',
        'area_util': 'Área útil',
        'calcada': 'Calçada',
        'numero': 'Número',
        'cep': 'CEP',
        'uf': 'UF',
        'loteamento': 'Loteamento',
        'loteamento_nome': 'Nome do loteamento',
        'loteamento_lote': 'Número no loteamento',
        'loteamento_quadra': 'Quadra no loteamento',
        'coordenadas_manual': 'Coordenadas manuais',
        'proprietario': 'Proprietário',
        'matricula': 'Matrícula',
        'transcricao': 'Transcrição',
        'cartorio': 'Cartório',
        'vago_com_placa': 'Vago - Com placa',
        'vago_seguranca': 'Vago - Segurança',
        'vago_seguranca_observacoes': 'Vago - Segurança (observações)',
        'compromissado_condicao': 'Compromissado - Condição',
        'compromissado_comprador': 'Compromissado - Comprador',
        'compromissado_data': 'Compromissado - Data do compromisso',
        'compromissado_inadimplente_data': 'Compromissado - Data da inadimplência',
        'compromissado_ajuizado_cliente': 'Compromissado - Nº do cliente/caso',
        'compromissado_ajuizado_processo': 'Compromissado - Nº do processo/execução',
        'locado_condicao': 'Locado - Condição',
        'locado_locador': 'Locado - Nome do locador',
        'locado_locatario': 'Locado - Nome do locatário',
        'locado_valor': 'Locado - Valor do aluguel',
        'locado_valor_data': 'Locado - Data do valor do aluguel',
        'locado_inicio_data': 'Locado - Data do início do contrato',
        'locado_fim_data': 'Locado - Data do fim do contrato',
        'locado_acao_renovatoria': 'Locado - Ação renovatória',
        'locado_acao_renovatoria_numero': 'Locado - Ação renovatória- Nº da ação',
        'locado_acao_renovatoria_cliente': 'Locado - Ação renovatória - Nº do cliente/caso',
        'locado_inadimplente_data': 'Locado - Data da inadimplência',
        'locado_ajuizado_cliente': 'Locado - Nº do cliente/caso',
        'locado_ajuizado_processo': 'Locado - Nº do processo/execução',
        'comodato_nome': 'Comodato - Nome',
        'comodato_rg': 'Comodato - RG',
        'comodato_cpf': 'Comodato - CPF',
        'comodato_telefone': 'Comodato - Telefone',
        'invadido_condicao': 'Invadido - Condição',
        'invadido_nome': 'Invadido - Nome',
        'invadido_rg': 'Invadido - RG',
        'invadido_cpf': 'Invadido - CPF',
        'invadido_telefone': 'Invadido - Telefone',
        'invadido_data': 'Invadido - Data estimada da invasão',
        'invadido_ajuizado_cliente': 'Invadido - Nº do cliente/caso',
        'invadido_ajuizado_processo': 'Invadido - Nº do processo/execução',
        'situacao': 'Situação',
        'ajuizado_cliente': 'Nº do cliente/caso',
        'ajuizado_processo': 'Nº do processo/execução',
        'estimativa_valor': 'Estimativa do valor do imóvel',
        'estimativa_data': 'Data da estimativa do valor do imóvel',
        'regiao_valor': 'Valor do m² da região',
        'observacoes': 'Observações',
        'recorrencia': 'Recorrente',
        'recorrencia_cada': 'Recorrência a cada',
        'recorrencia_periodo': 'Recorrência período',
        'realizada': 'Realizada',
        'realizada_em': 'Realizada em'
      };

      if (fixColunaNames.hasOwnProperty(coluna)) {
        return fixColunaNames[coluna];
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(coluna));
      }
    },
    formatValue: function formatValue(value, coluna) {
      var data = ['compromissado_data', 'compromissado_inadimplente_data', 'locado_valor_data', 'locado_inicio_data', 'locado_fim_data', 'locado_inadimplente_data', 'invadido_data', 'estimativa_data', 'realizada_em', 'data'];

      var valor = ['locado_valor', 'estimativa_valor', 'regiao_valor'];

      var area = ['area_terreno', 'area_construida', 'area_util'];

      var boolean = ['calcada', 'muro', 'loteamento', 'coordenadas_manual', 'vago_com_placa', 'locado_acao_renovatoria', 'realizada', 'recorrencia', 'postergarda'];

      var telefone = ['comodato_telefone', 'invadido_telefone'];

      if (value === null) {
        return null;
      }

      if (data.indexOf(coluna) > -1) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/YYYY');
      }

      if (valor.indexOf(coluna) > -1) {
        return __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(value, { code: 'BRL' });
      }

      if (area.indexOf(coluna) > -1) {
        return value + 'm²';
      }

      if (boolean.indexOf(coluna) > -1) {
        if (value) {
          return 'Sim';
        } else {
          return 'Não';
        }
      }

      if (telefone.indexOf(coluna) > -1) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(JSON.parse(value), 'numero').join(', ');
      }

      if (coluna === 'tipo') {
        return this.formatType(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(value)));
      }

      if (coluna === 'recorrencia_periodo') {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(value));
      }

      if (value === true) {
        return 'Sim';
      }

      if (value === false) {
        return 'Não';
      }

      return value;
    },
    clearHistorico: function clearHistorico() {
      this.$store.dispatch('relatorios/clearHistorico');
    },
    loadHistorico: function loadHistorico(page) {
      var payload = {};

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.filtros)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, this.filtros);
      }

      payload.periodo = this.periodoSelecionado;

      if (this.periodoSelecionado === 'custom') {
        payload.data_inicial = this.dataInicial;
        payload.data_final = this.dataFinal;
      }

      if (this.por === 'usuário') {
        payload.user_id = this.userSelecionado;
      }

      if (page) {
        payload.page = page;
      }

      this.$store.dispatch('relatorios/loadHistorico', payload);
    },
    onDateRangeChange: function onDateRangeChange(data) {
      this.dataInicial = data[0];
      this.dataFinal = data[1];

      if (this.periodoSelecionado === 'custom') {
        this.clearHistorico();
        this.loadHistorico();
      }
    },
    changePeriodo: function changePeriodo(periodo) {
      this.periodoSelecionado = periodo;

      this.clearHistorico();
      this.loadHistorico();
    },
    changePeriodoCustom: function changePeriodoCustom() {
      this.periodoSelecionado = 'custom';
      this.clearHistorico();
      this.loadHistorico();
      this.dateMenu = false;
    },
    changeUserSelecionado: function changeUserSelecionado(id) {
      this.userSelecionado = id;
    }
  },
  watch: {
    por: function por() {
      this.clearHistorico();
      this.loadHistorico();
    },
    users: function users() {
      this.userSelecionado = this.users[0].id;
    },
    userSelecionado: function userSelecionado() {
      if (this.por === 'usuário') {
        this.clearHistorico();
        this.loadHistorico();
      }
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__ = __webpack_require__(509);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      periodo: 'mes',
      status: [],
      selectedImovelId: null,
      imoveisLoading: false,
      imoveis: [],
      dateMenu: false,
      dataInicial: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD'),
      dataFinal: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD'),
      periodoItems: [{ text: 'Mais recentes', value: 'recentes' }, { text: 'Dia', value: 'dia' }, { text: 'Semana', value: 'semana' }, { text: 'Mês', value: 'mes' }, { text: 'Semestre', value: 'semestre' }, { text: 'Ano', value: 'ano' }, { text: 'Período customizado', value: 'custom' }],
      statusItems: ['pendente', 'autorizado', 'rejeitado', 'pago']
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.syncImovelFromRoute();
    this.loadPagamentos();
    this.$nextTick(function () {
      window.setTimeout(function () {
        _this.loadImoveis();
      }, 0);
    });
  },

  watch: {
    periodo: function periodo() {
      this.loadPagamentos();
    },
    status: function status() {
      this.loadPagamentos();
    },

    '$route.query.imovel_id': function $routeQueryImovel_id(value) {
      var normalizedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(value);
      if (normalizedValue === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(this.selectedImovelId)) return;
      this.selectedImovelId = normalizedValue;
      this.loadPagamentos(normalizedValue);
    }
  },
  computed: {
    filtros: function filtros() {
      return this.$store.getters['imoveis/filtros'];
    },
    imovelItems: function imovelItems() {
      var items = this.imoveis.map(function (item) {
        return {
          text: item.apelido || 'Im\xF3vel #' + item.id,
          value: String(item.id)
        };
      });

      return [{ text: 'Todos os imóveis', value: null }].concat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(items, ['text'], ['asc']));
    },
    relatorio: function relatorio() {
      return this.$store.getters['relatorios/pagamentos'];
    },
    resumo: function resumo() {
      return this.relatorio.resumo || {};
    },
    itens: function itens() {
      return this.relatorio.itens || [];
    },
    statusRows: function statusRows() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.relatorio.por_status || {}, function (row, key) {
        return {
          status: _this2.formatStatus(key),
          total: row.total || 0,
          valor_total: row.valor_total || 0
        };
      });
    },
    isCustomDateRangeValid: function isCustomDateRangeValid() {
      if (!this.dataInicial || !this.dataFinal) return false;
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dataInicial).isSameOrBefore(this.dataFinal, 'day');
    },
    periodoTitulo: function periodoTitulo() {
      var periodoAplicado = this.relatorio.periodo_aplicado || {};
      if (periodoAplicado.periodo === 'custom' || periodoAplicado.data_inicial && periodoAplicado.data_final) {
        return this.formatDate(periodoAplicado.data_inicial) + ' at\xE9 ' + this.formatDate(periodoAplicado.data_final);
      }
      var label = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.periodoItems, { value: periodoAplicado.periodo || this.periodo });
      return label ? label.text : '-';
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      if (!value) return '-';
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/YYYY');
    },
    formatCurrency: function formatCurrency(value) {
      return __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(value || 0, { code: 'BRL' });
    },
    formatStatus: function formatStatus(status) {
      if (!status) return '-';
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(status));
    },
    onCustomDateInput: function onCustomDateInput() {
      if (!this.isCustomDateRangeValid || this.periodo !== 'custom') return;
      this.loadPagamentos();
    },
    applyCustomDateRange: function applyCustomDateRange() {
      if (!this.isCustomDateRangeValid) return;
      this.dateMenu = false;
      if (this.periodo === 'custom') {
        this.loadPagamentos();
      }
    },
    imovelFilter: function imovelFilter(item, queryText, itemText) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["b" /* includesNormalizedText */])(itemText, queryText);
    },
    normalizeSelectedImovel: function normalizeSelectedImovel(value) {
      var normalizedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(value);

      if (normalizedValue && this.hasImovelOption(normalizedValue)) {
        return normalizedValue;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(value)) {
        if (value.hasOwnProperty('value')) {
          var normalizedFromValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(value.value);
          if (normalizedFromValue && this.hasImovelOption(normalizedFromValue)) {
            return normalizedFromValue;
          }
        }
        if (value.hasOwnProperty('id')) {
          var normalizedFromId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(value.id);
          if (normalizedFromId && this.hasImovelOption(normalizedFromId)) {
            return normalizedFromId;
          }
        }
      }

      var normalizedText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["c" /* normalizeSearchText */])(value);
      if (!normalizedText) return null;

      var selectedItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.imoveis, function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["c" /* normalizeSearchText */])(item.apelido || 'Im\xF3vel #' + item.id) === normalizedText;
      });
      return selectedItem ? String(selectedItem.id) : null;
    },
    applyImovelSelection: function applyImovelSelection(value) {
      var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var normalizedValue = this.normalizeSelectedImovel(value);
      var currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(this.selectedImovelId);
      var hasChanged = normalizedValue !== currentValue;

      if (hasChanged) {
        this.selectedImovelId = normalizedValue;
      }

      this.syncImovelQuery(normalizedValue);

      if (hasChanged || forceReload) {
        this.loadPagamentos(normalizedValue);
      }
    },
    onImovelInput: function onImovelInput(value) {
      this.applyImovelSelection(value, true);
    },
    hasImovelOption: function hasImovelOption(value) {
      if (value === null) return true;
      return this.imovelItems.some(function (item) {
        return item.value === String(value);
      });
    },
    syncImovelFromRoute: function syncImovelFromRoute() {
      this.selectedImovelId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(this.$route.query.imovel_id);
    },
    syncImovelQuery: function syncImovelQuery(value) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      var normalizedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["a" /* normalizeImovelFilterValue */])(value);

      if (normalizedValue) {
        query.imovel_id = normalizedValue;
      } else {
        delete query.imovel_id;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(query, this.$route.query)) return;

      this.$router.replace({ query: query }).catch(function () {});
    },
    loadImoveis: function loadImoveis() {
      var _this3 = this;

      this.imoveisLoading = true;
      this.$store.dispatch('imoveis/loadListaSelect', {}).then(function (items) {
        _this3.imoveis = items;
        if (_this3.selectedImovelId !== null && !_this3.hasImovelOption(_this3.selectedImovelId)) {
          _this3.applyImovelSelection(null, true);
        }
        _this3.imoveisLoading = false;
      }).catch(function () {
        _this3.imoveis = [];
        _this3.imoveisLoading = false;
      });
    },
    buildPayload: function buildPayload(imovelIdOverride) {
      var resolvedImovelId = typeof imovelIdOverride === 'undefined' ? this.selectedImovelId : imovelIdOverride;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_relatoriosPagamentos__["d" /* buildRelatorioPagamentosPayload */])({
        periodo: this.periodo,
        filtros: this.filtros,
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal,
        status: this.status,
        imovelId: resolvedImovelId
      });
    },
    loadPagamentos: function loadPagamentos(imovelIdOverride) {
      this.$store.dispatch('relatorios/loadPagamentos', this.buildPayload(imovelIdOverride));
    },
    download: function download(tipo) {
      var _this4 = this;

      if (this.itens.length < 1) return;

      if (tipo === 'pdf') {
        var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__();
        var headers = [['ID', 'Data ref.', 'Vencimento', 'Pagamento', 'Status', 'Descrição', 'Imóvel', 'Valor']];
        var rows = this.itens.map(function (item) {
          return [item.id, _this4.formatDate(item.data_referencia), _this4.formatDate(item.data_vencimento), _this4.formatDate(item.data_pagamento), _this4.formatStatus(item.status), item.descricao || '-', item.imovel ? item.imovel.apelido : '-', _this4.formatCurrency(item.valor)];
        });

        doc.text('Relatório de Pagamentos', 14, 15);
        doc.autoTable({
          head: headers,
          body: rows,
          margin: { top: 22 },
          theme: 'grid',
          styles: { fontSize: 8 }
        });
        doc.save('Relatorio de Pagamentos - ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD.MM.YYYY') + '.pdf');
      }

      if (tipo === 'excel') {
        var header = [['ID', 'Data ref.', 'Vencimento', 'Pagamento', 'Status', 'Descrição', 'Imóvel', 'Solicitante', 'Aprovador', 'Valor']];
        var _rows = this.itens.map(function (item) {
          return [item.id, _this4.formatDate(item.data_referencia), _this4.formatDate(item.data_vencimento), _this4.formatDate(item.data_pagamento), _this4.formatStatus(item.status), item.descricao || '-', item.imovel ? item.imovel.apelido : '-', item.solicitante ? item.solicitante.name : '-', item.aprovador ? item.aprovador.name : '-', _this4.formatCurrency(item.valor)];
        });

        __WEBPACK_IMPORTED_MODULE_6_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
          var sheetName = 'Relatório de Pagamentos';
          workbook.sheet(0).name(sheetName);
          workbook.sheet(sheetName).cell('A1').value(header);
          workbook.sheet(sheetName).cell('A2').value(_rows);
          workbook.sheet(sheetName).range('A1:J' + (_rows.length + 1)).style({
            fontFamily: 'Verdana',
            fontSize: 11,
            border: true,
            wrapText: true
          });
          workbook.sheet(sheetName).row(1).style({ bold: true });
          workbook.sheet(sheetName).column('A').width(10);
          workbook.sheet(sheetName).column('B').width(18);
          workbook.sheet(sheetName).column('C').width(18);
          workbook.sheet(sheetName).column('D').width(18);
          workbook.sheet(sheetName).column('E').width(18);
          workbook.sheet(sheetName).column('F').width(60);
          workbook.sheet(sheetName).column('G').width(35);
          workbook.sheet(sheetName).column('H').width(30);
          workbook.sheet(sheetName).column('I').width(30);
          workbook.sheet(sheetName).column('J').width(20);

          return workbook.outputAsync().then(function (blob) {
            var fileName = 'Relatorio de Pagamentos - ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD.MM.YYYY') + '.xlsx';
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              document.body.appendChild(a);
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            }
          });
        });
      }
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  updated: function updated() {
    this.redirectFromRoot();
  },
  created: function created() {
    this.redirectFromRoot();
  },
  data: function data() {
    return {
      tabAtiva: '',
      tabs: [{ title: 'Histórico por data', to: { name: 'RelatoriosHistoricoData' } }, { title: 'Histórico por usuário', to: { name: 'RelatoriosHistoricoUsuario' } }, { title: 'Comparativos', to: { name: 'RelatoriosComparativos' } }, { title: 'Pagamentos', to: { name: 'RelatoriosPagamentos' } }]
    };
  },

  methods: {
    redirectFromRoot: function redirectFromRoot() {
      if (this.$route.name === 'RelatoriosRoot') {
        this.$router.push({ name: 'RelatoriosHistoricoData' });
      }
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      categories: [{ id: 'info', name: 'Info' }, { id: 'endereco', name: 'Endereço' }, { id: 'registro', name: 'Registros / Documentos' }, { id: 'area', name: 'Área' }, { id: 'taxas', name: 'IPTU / Impostos / Taxas' }, { id: 'valor', name: 'Valor' }, { id: 'status', name: 'Status' }, { id: 'tarefas', name: 'Tarefas' }, { id: 'vistoria', name: 'Vistoria' }, { id: 'pagamentos', name: 'Pagamentos' }, { id: 'fotos', name: 'Fotos' }, { id: 'anexos', name: 'Anexos' }, { id: 'observacoes', name: 'Observações' }],
      actions: [{ id: 'view', name: 'Visualizar' }, { id: 'add', name: 'Adicionar' }, { id: 'edit', name: 'Editar' }, { id: 'delete', name: 'Apagar' }],
      form: {
        fields: {
          name: '',
          limitado_tarefas: false,
          limitado_proprietario: false,
          limitado_proprietario_lista: [],
          permissions: {}
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$set(this.form.fields.permissions, 'acessos_gerais', {
      administracao_usuarios: false,
      administracao_niveis_acesso: false,
      visualizar_relatorios: false
    });

    this.categories.forEach(function (cat) {
      _this.$set(_this.form.fields.permissions, cat.id, {
        view: false,
        add: false,
        edit: false,
        delete: false
      });
    });
  },
  mounted: function mounted() {
    this.$store.dispatch('imoveis/loadProprietarios');
  },

  computed: {
    proprietarios: function proprietarios() {
      return this.$store.getters['imoveis/proprietarios'];
    },
    isFormInvalid: function isFormInvalid() {
      return !this.form.fields.name || this.errors.any();
    }
  },
  methods: {
    toggleAllAction: function toggleAllAction(actionId) {
      var _this2 = this;

      var anyUnchecked = this.categories.some(function (cat) {
        return !_this2.form.fields.permissions[cat.id][actionId];
      });
      this.categories.forEach(function (cat) {
        _this2.form.fields.permissions[cat.id][actionId] = anyUnchecked;
      });
    },
    toggleAllCategory: function toggleAllCategory(catId) {
      var _this3 = this;

      var anyUnchecked = this.actions.some(function (act) {
        return !_this3.form.fields.permissions[catId][act.id];
      });
      this.actions.forEach(function (act) {
        _this3.form.fields.permissions[catId][act.id] = anyUnchecked;
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var data = {
            name: _this4.form.fields.name,
            limitado_tarefas: _this4.form.fields.limitado_tarefas,
            limitado_proprietario: _this4.form.fields.limitado_proprietario,
            proprietarios: _this4.form.fields.limitado_proprietario ? _this4.form.fields.limitado_proprietario_lista : [],
            permissions: _this4.form.fields.permissions
          };

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/roles', data).then(function (response) {
            _this4.$store.dispatch('utils/showSnackbar', {
              persistent: true,
              type: 'success',
              text: 'O n\xEDvel de acesso ' + response.data.data.name + ' foi criado com sucesso!'
            });
            _this4.$store.dispatch('utils/hideLoading');
            _this4.$router.push({ name: 'RolesLista' });
          }, function (error) {
            var isForbidden = error && error.response && error.response.status === 403;
            _this4.$store.dispatch('utils/showSnackbar', {
              text: isForbidden ? 'Sem permissão para criar níveis de acesso.' : 'Erro ao salvar nível de acesso. Verifique os dados.'
            });
            _this4.$store.dispatch('utils/hideLoading');
            if (isForbidden) {
              _this4.$router.push('/');
            }
          });
        } else {
          _this4.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this4.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialogApagar: false,
      categories: [{ id: 'info', name: 'Info' }, { id: 'endereco', name: 'Endereço' }, { id: 'registro', name: 'Registros / Documentos' }, { id: 'area', name: 'Área' }, { id: 'taxas', name: 'IPTU / Impostos / Taxas' }, { id: 'valor', name: 'Valor' }, { id: 'status', name: 'Status' }, { id: 'tarefas', name: 'Tarefas' }, { id: 'vistoria', name: 'Vistoria' }, { id: 'pagamentos', name: 'Pagamentos' }, { id: 'fotos', name: 'Fotos' }, { id: 'anexos', name: 'Anexos' }, { id: 'observacoes', name: 'Observações' }],
      actions: [{ id: 'view', name: 'Visualizar' }, { id: 'add', name: 'Adicionar' }, { id: 'edit', name: 'Editar' }, { id: 'delete', name: 'Apagar' }],
      form: {
        fields: {
          name: '',
          limitado_tarefas: false,
          limitado_proprietario: false,
          limitado_proprietario_lista: [],
          permissions: {}
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$set(this.form.fields.permissions, 'acessos_gerais', {
      administracao_usuarios: false,
      administracao_niveis_acesso: false,
      visualizar_relatorios: false
    });

    this.categories.forEach(function (cat) {
      _this.$set(_this.form.fields.permissions, cat.id, {
        view: false,
        add: false,
        edit: false,
        delete: false
      });
    });
  },
  mounted: function mounted() {
    this.$store.dispatch('imoveis/loadProprietarios');
    this.loadRole();
  },

  computed: {
    proprietarios: function proprietarios() {
      return this.$store.getters['imoveis/proprietarios'];
    },
    isFormInvalid: function isFormInvalid() {
      return !this.form.fields.name || this.errors.any();
    }
  },
  methods: {
    loadRole: function loadRole() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/roles/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;
        _this2.form.fields.name = data.name;
        _this2.form.fields.limitado_tarefas = data.limitado_tarefas;
        _this2.form.fields.limitado_proprietario = data.limitado_proprietario;
        _this2.form.fields.limitado_proprietario_lista = data.proprietarios || [];

        if (data.permissions) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.permissions).forEach(function (catId) {
            if (_this2.form.fields.permissions[catId]) {
              _this2.form.fields.permissions[catId] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.form.fields.permissions[catId], data.permissions[catId]);
            }
          });
        }

        _this2.$store.dispatch('utils/hideLoading');
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        if (isForbidden) {
          _this2.$store.dispatch('utils/showSnackbar', {
            text: 'Sem permissão para visualizar níveis de acesso.'
          });
          _this2.$store.dispatch('utils/hideLoading');
          _this2.$router.push('/');
          return;
        }
        _this2.$store.dispatch('utils/hideLoading');
        _this2.$router.push({ name: 'RolesLista' });
      });
    },
    toggleAllAction: function toggleAllAction(actionId) {
      var _this3 = this;

      var anyUnchecked = this.categories.some(function (cat) {
        return !_this3.form.fields.permissions[cat.id][actionId];
      });
      this.categories.forEach(function (cat) {
        _this3.form.fields.permissions[cat.id][actionId] = anyUnchecked;
      });
    },
    toggleAllCategory: function toggleAllCategory(catId) {
      var _this4 = this;

      var anyUnchecked = this.actions.some(function (act) {
        return !_this4.form.fields.permissions[catId][act.id];
      });
      this.actions.forEach(function (act) {
        _this4.form.fields.permissions[catId][act.id] = anyUnchecked;
      });
    },
    openDialogApagar: function openDialogApagar() {
      this.dialogApagar = true;
    },
    apagarRole: function apagarRole() {
      var _this5 = this;

      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/roles/' + this.$route.params.id).then(function () {
        _this5.$store.dispatch('utils/showSnackbar', {
          type: 'success',
          text: 'Nível de acesso apagado com sucesso.'
        });
        _this5.$store.dispatch('utils/hideLoading');
        _this5.$router.push({ name: 'RolesLista' });
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        _this5.$store.dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para apagar níveis de acesso.' : 'Erro ao apagar nível de acesso.'
        });
        _this5.$store.dispatch('utils/hideLoading');
        if (isForbidden) {
          _this5.$router.push('/');
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this6 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var data = {
            name: _this6.form.fields.name,
            limitado_tarefas: _this6.form.fields.limitado_tarefas,
            limitado_proprietario: _this6.form.fields.limitado_proprietario,
            proprietarios: _this6.form.fields.limitado_proprietario ? _this6.form.fields.limitado_proprietario_lista : [],
            permissions: _this6.form.fields.permissions
          };

          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/roles/' + _this6.$route.params.id, data).then(function (response) {
            _this6.$store.dispatch('utils/showSnackbar', {
              persistent: true,
              type: 'success',
              text: 'O n\xEDvel de acesso ' + response.data.data.name + ' foi alterado com sucesso!'
            });
            _this6.$store.dispatch('utils/hideLoading');
            _this6.$router.push({ name: 'RolesLista' });
          }, function (error) {
            var isForbidden = error && error.response && error.response.status === 403;
            _this6.$store.dispatch('utils/showSnackbar', {
              text: isForbidden ? 'Sem permissão para editar níveis de acesso.' : 'Erro ao salvar nível de acesso.'
            });
            _this6.$store.dispatch('utils/hideLoading');
            if (isForbidden) {
              _this6.$router.push('/');
            }
          });
        } else {
          _this6.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this6.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      roles: []
    };
  },
  mounted: function mounted() {
    this.loadRoles();
  },

  methods: {
    loadRoles: function loadRoles() {
      var _this = this;

      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/roles').then(function (response) {
        _this.roles = response.data.data;
        _this.$store.dispatch('utils/hideLoading');
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        _this.$store.dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar níveis de acesso.' : 'Erro ao carregar níveis de acesso.'
        });
        _this.$store.dispatch('utils/hideLoading');
        if (isForbidden) {
          _this.$router.push('/');
        }
      });
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      imovelId: this.$route.params.id,
      dialogTarefasTipos: false,
      dialogUsuarios: false,
      menuData: false,
      datasPermitidas: function datasPermitidas(date) {
        var today = new Date();
        return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
      },
      tipoTarefaPersonalizada: '',
      form: {
        fields: {
          tipo: '',
          data: '',
          data_formatada: '',
          user_id: '',
          user_name: ''
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$primeUserRestrictions().then(function () {
      if (_this.isLimitadoTarefas) {
        _this.$store.dispatch('utils/showSnackbar', {
          text: 'Usuários limitados por tarefas/vistorias não podem adicionar tarefas.'
        });
        _this.$router.replace({ name: 'TarefasLista', params: { id: _this.imovelId } });
        return;
      }

      _this.$store.dispatch('users/loadAssignableUsers');
    });
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    tarefaTipo: function tarefaTipo() {
      return this.$store.getters['constants/tarefaTipo'];
    },
    users: function users() {
      return this.$store.getters['users/users'];
    },
    isFormInvalid: function isFormInvalid() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this2.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  watch: {
    tipoTarefaPersonalizada: function tipoTarefaPersonalizada(value) {
      if (value.length > 0) {
        this.form.fields.tipo = value;
      }
    },
    'form.fields.tipo': function formFieldsTipo(value) {
      if (value !== this.tipoTarefaPersonalizada) {
        this.tipoTarefaPersonalizada = '';
      }
    },
    'form.fields.user_id': function formFieldsUser_id(value) {
      this.form.fields.user_name = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.users, { id: value }).name;
    }
  },
  methods: {
    selectTarefa: function selectTarefa(item) {
      this.form.fields.tipo = item;
      this.dialogTarefasTipos = false;
    },
    selectUser: function selectUser(userId) {
      this.form.fields.user_id = userId;
      this.dialogUsuarios = false;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (this.isLimitadoTarefas) {
        return;
      }

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/tarefas/' + _this3.imovelId, _this3.form.fields).then(function (response) {
            _this3.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: _this3.imovelId } });
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      tarefaId: this.$route.params.tarefa,
      dialogTarefasTipos: false,
      dialogUsuarios: false,
      menuData: false,
      datasPermitidas: function datasPermitidas(date) {
        var today = new Date();
        return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
      },
      tipoTarefaPersonalizada: '',
      form: {
        fields: {
          tipo: '',
          data: '',
          data_formatada: '',
          user_id: '',
          user_name: ''
        }
      }
    };
  },
  mounted: function mounted() {
    this.$primeUserRestrictions();
    this.$store.dispatch('users/loadAssignableUsers');
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    currentUserId: function currentUserId() {
      var user = this.currentUser || {};
      return user.id || null;
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    tarefa: function tarefa() {
      return this.$store.getters['imoveis/tarefaById'](this.tarefaId);
    },
    tarefaTipo: function tarefaTipo() {
      return this.$store.getters['constants/tarefaTipo'];
    },
    users: function users() {
      return this.$store.getters['users/users'];
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  watch: {
    tarefa: {
      handler: function handler() {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.tarefa)) {
          return;
        }

        if (this.isLimitadoTarefas && !this.canEditCurrentTask()) {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Você só pode editar tarefas atribuídas a você.'
          });
          this.$router.replace({ name: 'TarefasLista', params: { id: this.$route.params.id } });
          return;
        }

        this.form.fields.tipo = this.tarefa.tipo;
        this.form.fields.data = this.tarefa.data;
        this.form.fields.data_formatada = this.tarefa.data_formatada;
        this.form.fields.user_id = this.taskUserId();
        this.form.fields.user_name = this.taskUserName();
        if (this.tarefaTipo.indexOf(this.tarefa.tipo) < 0) {
          this.tipoTarefaPersonalizada = this.tarefa.tipo;
        }
      },

      immediate: true
    },
    tipoTarefaPersonalizada: function tipoTarefaPersonalizada(value) {
      if (value.length > 0) {
        this.form.fields.tipo = value;
      }
    },
    'form.fields.tipo': function formFieldsTipo(value) {
      if (value !== this.tipoTarefaPersonalizada) {
        this.tipoTarefaPersonalizada = '';
      }
    },
    'form.fields.user_id': function formFieldsUser_id(value) {
      var user = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.users, { id: value });
      this.form.fields.user_name = user ? user.name : this.form.fields.user_name;
    }
  },
  methods: {
    normalizeId: function normalizeId(value) {
      if (value === null || typeof value === 'undefined' || value === '') return null;
      return String(value);
    },
    taskUserId: function taskUserId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__["a" /* getAssignedUserId */])(this.tarefa);
    },
    taskUserName: function taskUserName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__["b" /* getAssignedUserName */])(this.tarefa);
    },
    canEditCurrentTask: function canEditCurrentTask() {
      return this.normalizeId(this.taskUserId()) === this.normalizeId(this.currentUserId);
    },
    selectTarefa: function selectTarefa(item) {
      this.form.fields.tipo = item;
      this.dialogTarefasTipos = false;
    },
    selectUser: function selectUser(userId) {
      this.form.fields.user_id = userId;
      this.dialogUsuarios = false;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.isLimitadoTarefas && !this.canEditCurrentTask()) {
        return;
      }

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/tarefas/' + _this2.tarefaId, _this2.form.fields).then(function (response) {
            _this2.$router.push({ name: 'TarefasLista', params: { id: _this2.$route.params.id } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assignedUser__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TarefasRealizar__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TarefasRealizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TarefasRealizar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TarefasSituacao__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TarefasSituacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TarefasSituacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_IrParaOTopo__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_IrParaOTopo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Utils_IrParaOTopo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Imoveis_Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Imoveis_Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Imoveis_Headers_HeadersDetalhesResumo__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IrParaOTopo: __WEBPACK_IMPORTED_MODULE_5__Utils_IrParaOTopo___default.a,
    TarefasRealizar: __WEBPACK_IMPORTED_MODULE_3__TarefasRealizar___default.a,
    TarefasSituacao: __WEBPACK_IMPORTED_MODULE_4__TarefasSituacao___default.a,
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_6__Imoveis_Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      dialogApagar: false,
      imovelId: this.$route.params.id,
      itemApagar: {}
    };
  },
  mounted: function mounted() {
    this.$primeUserRestrictions();
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    currentUserId: function currentUserId() {
      var user = this.currentUser || {};
      return user.id || null;
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    tarefas: function tarefas() {
      var _this = this;

      var tarefas = this.$store.getters['imoveis/tarefas'];
      if (!this.isLimitadoTarefas) {
        return tarefas;
      }

      return tarefas.filter(function (item) {
        return _this.isTaskAssignedToCurrentUser(item);
      });
    },
    canAddTask: function canAddTask() {
      return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add');
    }
  },
  methods: {
    normalizeId: function normalizeId(value) {
      if (value === null || typeof value === 'undefined' || value === '') return null;
      return String(value);
    },
    taskUserId: function taskUserId(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assignedUser__["a" /* getAssignedUserId */])(item);
    },
    taskUserName: function taskUserName(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assignedUser__["b" /* getAssignedUserName */])(item);
    },
    isTaskAssignedToCurrentUser: function isTaskAssignedToCurrentUser(item) {
      return this.normalizeId(this.taskUserId(item)) === this.normalizeId(this.currentUserId);
    },
    canCompleteTask: function canCompleteTask(item) {
      return this.isTaskAssignedToCurrentUser(item) && !item.realizada;
    },
    canEditTask: function canEditTask(item) {
      if (!this.$hasGranularPermission('tarefas', 'edit')) {
        return false;
      }

      if (!this.isLimitadoTarefas) {
        return true;
      }

      return this.isTaskAssignedToCurrentUser(item);
    },
    descartar: function descartar() {
      this.dialogApagar = false;
    },
    beforeApagar: function beforeApagar(item) {
      this.itemApagar = item;
    },
    onSubmitApagar: function onSubmitApagar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/tarefas/' + this.itemApagar.id).then(function (response) {
        _this2.$store.dispatch('imoveis/deleteTarefa', _this2.itemApagar);
        _this2.descartar();
        _this2.$store.dispatch('utils/hideLoading');
      }, function () {
        _this2.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this2.$store.dispatch('utils/hideLoading');
      });
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tarefaId', 'imovelId'],
  data: function data() {
    return {
      dialog: false,
      inputKey: Math.random(),
      form: {
        fields: {
          tipo: 'geral',
          conteudo: ''
        }
      }
    };
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    descartar: function descartar() {
      this.dialog = false;
      this.form.fields.conteudo = '';
      this.inputKey = Math.random();
      this.errors.clear();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/observacoes/' + _this2.imovelId, _this2.form.fields).then(function () {
            try {
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/tarefas/realizar/' + _this2.tarefaId).then(function (response) {
                _this2.$store.dispatch('imoveis/loadImovel', { id: _this2.imovelId }).finally(function () {
                  _this2.descartar();
                });
              }).catch(function (error) {
                console.error('Erro ao finalizar tarefa', error);
                _this2.$store.dispatch('utils/showSnackbar', {
                  text: 'Servidor indisponível. Tente novamente mais tarde.'
                });
              }).then(function () {
                _this2.$store.dispatch('utils/hideLoading');
              });
            } catch (error) {
              console.error('Erro ao concluir fluxo de realizacao de tarefa', error);
              _this2.$store.dispatch('utils/hideLoading');
            }
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'realizada', 'tipo'],
  computed: {
    situacao: {
      get: function get() {
        if (this.realizada) {
          return 'Tarefa Realizada';
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()().isAfter(this.data, 'day')) {
            return 'Tarefa Atrasada';
          } else {
            return 'Tarefa Agendada';
          }
        }
      },
      set: function set() {}
    },
    situacaoClass: {
      get: function get() {
        if (this.realizada) {
          this.situacao = 'Tarefa Realizada';
          return 'primary';
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()().isAfter(this.data, 'day')) {
            this.situacao = 'Tarefa Atrasada';
            return 'grey';
          } else {
            this.situacao = 'Tarefa Agendada';
            return 'grey';
          }
        }
      },
      set: function set() {}
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








function initialForm() {
  return {
    texto: '',
    proprietario: [],
    tipo: [],
    uf: [],
    cidade: [],
    bairro: [],
    com_loteamento: '',
    loteamento: [],
    lote: '',
    quadra: '',
    status: [],
    vago_com_placa: '',
    vago_seguranca: [],
    compromissado_condicao: [],
    locado_condicao: [],
    locado_acao_renovatoria: '',
    locado_indice: '',
    locado_valor_minimo: '',
    locado_valor_maximo: '',
    invadido_condicao: [],
    area_terreno_minima: '',
    area_terreno_maxima: '',
    area_construida_minima: '',
    area_construida_maxima: '',
    area_util_minima: '',
    area_util_maxima: '',
    com_calcada: '',
    com_muro: '',
    iptu_condicao: [],
    estimativa_valor_minimo: '',
    estimativa_valor_maximo: '',
    vistoria: [],
    tarefas_pendentes: ''
  };
}

function normalizeProprietarioValue(item) {
  if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(item)) === 'object') {
    if (typeof item.value !== 'undefined' && item.value !== null && item.value !== '') return String(item.value);
    if (typeof item.text !== 'undefined' && item.text !== null && item.text !== '') return String(item.text);
    if (typeof item.nome !== 'undefined' && item.nome !== null && item.nome !== '') return String(item.nome);
    if (typeof item.name !== 'undefined' && item.name !== null && item.name !== '') return String(item.name);
    if (typeof item.id !== 'undefined' && item.id !== null && item.id !== '') return String(item.id);
  }

  if (item === null || typeof item === 'undefined' || item === '') return null;
  return String(item);
}

function dedupeProprietarios(items) {
  return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy(items, normalizeProprietarioValue);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      preventClickOutside: false,
      filtroAlterado: false,
      opcoes: {
        lote: false,
        status: false,
        area: false,
        valor: false
      },
      form: initialForm()
    };
  },

  computed: {
    currentUser: function currentUser() {
      if (!this.$auth || typeof this.$auth.user !== 'function') return null;
      return this.$auth.user();
    },
    drawerState: function drawerState() {
      if (this.mobile) {
        return this.drawer;
      }
      return true;
    },
    countFiltros: function countFiltros() {
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.form, initialForm())) {
        return 1;
      } else {
        return 0;
      }
    },
    canShowProprietarioFilter: function canShowProprietarioFilter() {
      return this.$hasGranularPermission('info', 'view');
    },
    isLimitadoProprietario: function isLimitadoProprietario() {
      return this.$hasUserRestrictionFlag('limitado_proprietario');
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    allowedRoleProprietarios: function allowedRoleProprietarios() {
      var user = this.currentUser || {};
      var directOwners = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(user, 'proprietarios', []);
      var customRoleOwners = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(user, 'custom_role.proprietarios', []);

      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flatten([__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(directOwners) ? directOwners : [], __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(customRoleOwners) ? customRoleOwners : []]).map(normalizeProprietarioValue));
    },
    proprietarioItems: function proprietarioItems() {
      var storeItems = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.$store.getters, 'imoveis/listaFiltros.proprietario', []);
      var allItems = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(storeItems) ? storeItems : [];

      if (this.isLimitadoProprietario) {
        var allowedOwners = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.allowedRoleProprietarios);

        if (allowedOwners.size < 1) {
          return [];
        }

        var filteredItems = allItems.filter(function (item) {
          return allowedOwners.has(normalizeProprietarioValue(item));
        });
        if (filteredItems.length > 0) {
          return dedupeProprietarios(filteredItems);
        }

        return dedupeProprietarios(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(allowedOwners));
      }

      if (this.isLimitadoTarefas) {
        return dedupeProprietarios(allItems);
      }

      return dedupeProprietarios(allItems);
    },
    lista: function lista() {
      return {
        proprietario: this.proprietarioItems,
        tipo: this.$store.getters['imoveis/listaFiltros']['tipo'],
        uf: this.$store.getters['imoveis/listaFiltros']['uf'],
        cidade: [],
        bairro: [],
        com_loteamento: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
        loteamento: this.$store.getters['imoveis/listaFiltros']['loteamento'],
        vago_com_placa: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
        locado_acao_renovatoria: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
        locado_indice: [{ text: 'Indiferente', value: '' }, { text: 'Satisfatório', value: 1 }, { text: 'Insatisfatório', value: 0 }],
        com_calcada: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
        com_muro: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
        iptu_condicao: ['Quitado / em dia', 'Pendente', 'Pendente ajuizado'],
        vistoria: ['Sem vistoria', 'Em dia', 'Próxima', 'Atrasada', 'Vistoria realizada'],
        tarefas_pendentes: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }]
      };
    }
  },
  watch: {
    'form.com_loteamento': function formCom_loteamento(value) {
      if (value !== 1) {
        this.form.loteamento = [];
      }
    },
    'form.uf': function formUf(value) {
      var _this = this;

      var novaLista = [];
      var cidades = [];
      value.forEach(function (itemUf) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.lista.uf[itemUf]).forEach(function (itemCidade) {
          novaLista[itemCidade] = _this.lista.uf[itemUf][itemCidade];
          cidades.push(itemCidade);
        });
      });
      this.form.cidade = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.intersection(cidades, this.form.cidade);
      this.lista.cidade = novaLista;
    },
    'form.cidade': function formCidade(value) {
      var _this2 = this;

      var novaLista = [];
      value.forEach(function (itemCidade) {
        novaLista.push(_this2.lista.cidade[itemCidade]);
      });
      this.lista.bairro = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flatten(novaLista).sort());
      this.form.bairro = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.intersection(this.lista.bairro, this.form.bairro);
    },
    proprietarioItems: function proprietarioItems(items) {
      var allowedValues = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.compact(items.map(normalizeProprietarioValue)));
      this.form.proprietario = this.form.proprietario.filter(function (item) {
        return allowedValues.has(normalizeProprietarioValue(item));
      });
    },
    'form.area_terreno_minima': function formArea_terreno_minima(value) {
      this.form.area_terreno_minima = this.formatArea(value);
    },
    'form.area_terreno_maxima': function formArea_terreno_maxima(value) {
      this.form.area_terreno_maxima = this.formatArea(value);
    },
    'form.area_construida_minima': function formArea_construida_minima(value) {
      this.form.area_construida_minima = this.formatArea(value);
    },
    'form.area_construida_maxima': function formArea_construida_maxima(value) {
      this.form.area_construida_maxima = this.formatArea(value);
    },
    'form.area_util_minima': function formArea_util_minima(value) {
      this.form.area_util_minima = this.formatArea(value);
    },
    'form.area_util_maxima': function formArea_util_maxima(value) {
      this.form.area_util_maxima = this.formatArea(value);
    },
    'form': {
      handler: function handler() {
        if (this.filtroAlterado === false) {
          this.marcarFiltroAlterado;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'imoveis/CLEAR_FILTROS') {
        _this3.limparFiltros();
      }
    });
  },

  methods: {
    onDrawerInput: function onDrawerInput(value) {
      if (this.mobile) {
        this.$emit('update:drawer', value);
      }
    },
    formatArea: function formatArea(area) {
      if (area === null) {
        return '';
      }

      var value = area;
      var newValue = String(value).replace(/\./g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');

      return newValue;
    },
    resetarFilhos: function resetarFilhos(campo) {
      var _this4 = this;

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.indexOf(this.form.status, campo) < 0) {
        var status = campo.toLowerCase();
        var filhos = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pickBy(this.form, function (value, key) {
          return key.startsWith(status);
        });
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(filhos, function (value, key) {
          _this4.form[key] = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(_this4.form[key]) ? [] : '';
        });
      }
    },
    marcarStatus: function marcarStatus(event, status) {
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(event) && event !== null && event !== '' || __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(event) && !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(event) && !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.includes(this.form.status, status)) {
        this.form.status.push(status);
      }
    },
    limparFiltros: function limparFiltros() {
      this.form = initialForm();
      this.$store.dispatch('imoveis/setFiltros', {});
      this.filtroAlterado = false;
    },
    marcarFiltroAlterado: function marcarFiltroAlterado() {
      this.filtroAlterado = true;
    },
    setFiltros: function setFiltros() {
      var payload = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omitBy(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omitBy(this.form, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNull), function (item) {
        return item.length === 0;
      });

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_terreno_minima')) {
        payload.area_terreno_minima = parseInt(payload.area_terreno_minima.replace(/\./g, ''));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_terreno_maxima')) {
        payload.area_terreno_maxima = parseInt(payload.area_terreno_maxima.replace(/\./g, ''));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_construida_minima')) {
        payload.area_construida_minima = parseInt(payload.area_construida_minima.replace(/\./g, ''));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_construida_maxima')) {
        payload.area_construida_maxima = parseInt(payload.area_construida_maxima.replace(/\./g, ''));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_util_minima')) {
        payload.area_util_minima = parseInt(payload.area_util_minima.replace(/\./g, ''));
      }

      if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(payload, 'area_util_maxima')) {
        payload.area_util_maxima = parseInt(payload.area_util_maxima.replace(/\./g, ''));
      }

      this.$store.dispatch('imoveis/setFiltros', payload);
      this.filtroAlterado = false;

      if (this.mobile) {
        this.$emit('update:drawer', false);
      }
    },
    openedSelect: function openedSelect() {
      this.preventClickOutside = true;
    },
    closedSelect: function closedSelect() {
      var _this5 = this;

      window.setTimeout(function () {
        _this5.preventClickOutside = false;
      }, 100);
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imageSrc: 'static/default.jpg',
      customRoles: [],
      form: {
        fields: {
          avatar: null,
          name: '',
          cargo: '',
          celular: '',
          email: '',
          password: '',
          conf_password: '',
          custom_role_id: null,
          bloqueado: false
        }
      }
    };
  },
  mounted: function mounted() {
    this.loadCustomRoles();
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    loadCustomRoles: function loadCustomRoles() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/roles').then(function (response) {
        _this2.customRoles = response.data.data;
      });
    },
    onFileChange: function onFileChange(event) {
      var _this3 = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this3.imageSrc = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
        this.form.fields.avatar = input.files[0];
      }
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var formData = new FormData();

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.form.fields).forEach(function (key) {
            if (key !== 'avatar' && _this4.form.fields[key] !== null) {
              formData.append(key, _this4.form.fields[key]);
            }
          });

          if (_this4.form.fields.avatar !== null) {
            __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__["a" /* default */].resize(_this4.form.fields['avatar'], {
              width: 300,
              height: 300
            }, function (blob, didItResize) {
              formData.append('avatar', blob);

              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios', formData).then(function (response) {
                _this4.$store.dispatch('utils/showSnackbar', {
                  persistent: true,
                  type: 'success',
                  text: 'O usu\xE1rio ' + response.data.data.name + ' foi criado com sucesso!'
                });
                _this4.$store.dispatch('utils/hideLoading');
                _this4.$router.push({ name: 'UsuariosLista' });
              }, function (error) {
                var errorText = '';
                if (error.response.status === 422) {
                  errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
                } else {
                  errorText = 'Servidor indisponível. Tente novamente mais tarde.';
                }
                _this4.$store.dispatch('utils/showSnackbar', {
                  text: errorText
                });
                _this4.$store.dispatch('utils/hideLoading');
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios', formData).then(function (response) {
              _this4.$store.dispatch('utils/showSnackbar', {
                persistent: true,
                type: 'success',
                text: 'O usu\xE1rio ' + response.data.data.name + ' foi criado com sucesso!'
              });
              _this4.$store.dispatch('utils/hideLoading');
              _this4.$router.push({ name: 'UsuariosLista' });
            }, function (error) {
              var errorText = '';
              if (error.response.status === 422) {
                errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
              } else {
                errorText = 'Servidor indisponível. Tente novamente mais tarde.';
              }
              _this4.$store.dispatch('utils/showSnackbar', {
                text: errorText
              });
              _this4.$store.dispatch('utils/hideLoading');
            });
          }
        } else {
          _this4.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this4.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imageSrc: 'static/default.jpg',
      niveis: ['Administrador', 'Patrimônio', 'Operacional'],
      visualizacoes: [{ text: 'Lista', value: 'lista' }, { text: 'Mapa', value: 'mapa' }],
      form: {
        fields: {
          visualizacao: '',
          avatar: null,
          name: '',
          cargo: '',
          celular: '',
          email: '',
          password: '',
          conf_password: ''
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('utils/showLoading');
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/my/profile').then(function (response) {
      var data = response.data.data;

      _this.imageSrc = data.avatar;
      _this.form.fields.visualizacao = data.visualizacao;
      _this.form.fields.name = data.name;
      _this.form.fields.cargo = data.cargo;
      _this.form.fields.celular = data.celular;
      _this.form.fields.email = data.email;

      _this.$store.dispatch('utils/hideLoading');
    }, function () {
      _this.$store.dispatch('utils/showSnackbar', {
        text: 'Servidor indisponível. Tente novamente mais tarde.',
        persistent: true
      });
      _this.$store.dispatch('utils/hideLoading');
    });
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this2.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    onFileChange: function onFileChange(event) {
      var _this3 = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this3.imageSrc = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
        this.form.fields.avatar = input.files[0];
      }
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var formData = new FormData();

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.form.fields).forEach(function (key) {
            if (key !== 'avatar') {
              formData.append(key, _this4.form.fields[key]);
            }
          });

          if (_this4.form.fields.avatar !== null) {
            __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__["a" /* default */].resize(_this4.form.fields['avatar'], {
              width: 300,
              height: 300
            }, function (blob, didItResize) {
              formData.append('avatar', blob);

              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/my/profile', formData).then(function (response) {
                _this4.$auth.fetch();
                _this4.$store.dispatch('utils/showSnackbar', {
                  persistent: true,
                  type: 'success',
                  text: 'Suas configurações foram alteradas com sucesso!'
                });
                _this4.$store.dispatch('utils/hideLoading');
                _this4.$router.push('/');
              }, function (error) {
                var errorText = '';
                if (error.response.status === 422) {
                  errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
                } else {
                  errorText = 'Servidor indisponível. Tente novamente mais tarde.';
                }
                _this4.$store.dispatch('utils/showSnackbar', {
                  text: errorText
                });
                _this4.$store.dispatch('utils/hideLoading');
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/my/profile', formData).then(function (response) {
              _this4.$auth.fetch();
              _this4.$store.dispatch('utils/showSnackbar', {
                persistent: true,
                type: 'success',
                text: 'Suas configurações foram alteradas com sucesso!'
              });
              _this4.$store.dispatch('utils/hideLoading');
              _this4.$router.push('/');
            }, function (error) {
              var errorText = '';
              if (error.response.status === 422) {
                errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
              } else {
                errorText = 'Servidor indisponível. Tente novamente mais tarde.';
              }
              _this4.$store.dispatch('utils/showSnackbar', {
                text: errorText
              });
              _this4.$store.dispatch('utils/hideLoading');
            });
          }
        } else {
          _this4.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this4.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialogApagar: false,
      imageSrc: 'static/default.jpg',
      customRoles: [],
      form: {
        fields: {
          avatar: null,
          name: '',
          cargo: '',
          celular: '',
          email: '',
          password: '',
          conf_password: '',
          custom_role_id: null,
          bloqueado: false
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$auth.user().id === this.$route.params.id) {
      this.$router.push({ name: 'UsuariosConfiguracoes' });
    } else {
      this.$store.dispatch('utils/showLoading');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;

        _this.imageSrc = data.avatar;
        _this.form.fields.name = data.name;
        _this.form.fields.cargo = data.cargo;
        _this.form.fields.celular = data.celular;
        _this.form.fields.email = data.email;
        _this.form.fields.custom_role_id = data.custom_role_id;
        _this.form.fields.bloqueado = data.bloqueado;

        if (!_this.$auth.check('Administrador') && data.roles[0] !== 'Operacional') {
          _this.$router.push({ name: 'UsuariosLista' });
        }

        _this.loadCustomRoles();
        _this.$store.dispatch('utils/hideLoading');
      }, function () {
        _this.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        });
        _this.$store.dispatch('utils/hideLoading');
      });
    }
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this2.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  methods: {
    loadCustomRoles: function loadCustomRoles() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/roles').then(function (response) {
        _this3.customRoles = response.data.data;
      });
    },
    openDialogApagar: function openDialogApagar() {
      this.dialogApagar = true;
    },
    onFileChange: function onFileChange(event) {
      var _this4 = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this4.imageSrc = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
        this.form.fields.avatar = input.files[0];
      }
    },
    apagarUsuario: function apagarUsuario() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios/' + this.$route.params.id).then(function (response) {
        _this5.$store.dispatch('utils/showSnackbar', {
          persistent: true,
          type: 'success',
          text: 'Usuário apagado com sucesso.'
        });
        _this5.$store.dispatch('utils/hideLoading');
        _this5.$router.push({ name: 'UsuariosLista' });
      }, function () {
        _this5.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.'
        });
        _this5.$store.dispatch('utils/hideLoading');
      });
    },
    onSubmit: function onSubmit() {
      var _this6 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var formData = new FormData();

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.form.fields).forEach(function (key) {
            if (key !== 'avatar' && _this6.form.fields[key] !== null) {
              formData.append(key, _this6.form.fields[key]);
            }
          });

          if (_this6.form.fields.avatar !== null) {
            __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__["a" /* default */].resize(_this6.form.fields['avatar'], {
              width: 300,
              height: 300
            }, function (blob, didItResize) {
              formData.append('avatar', blob);

              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios/' + _this6.$route.params.id, formData).then(function (response) {
                _this6.$store.dispatch('utils/showSnackbar', {
                  persistent: true,
                  type: 'success',
                  text: 'O usu\xE1rio ' + response.data.data.name + ' foi alterado com sucesso!'
                });
                _this6.$store.dispatch('utils/hideLoading');
                _this6.$router.push({ name: 'UsuariosLista' });
              }, function (error) {
                var errorText = '';
                if (error.response.status === 422) {
                  errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
                } else {
                  errorText = 'Servidor indisponível. Tente novamente mais tarde.';
                }
                _this6.$store.dispatch('utils/showSnackbar', {
                  text: errorText
                });
                _this6.$store.dispatch('utils/hideLoading');
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/usuarios/' + _this6.$route.params.id, formData).then(function (response) {
              _this6.$store.dispatch('utils/showSnackbar', {
                persistent: true,
                type: 'success',
                text: 'O usu\xE1rio ' + response.data.data.name + ' foi alterado com sucesso!'
              });
              _this6.$store.dispatch('utils/hideLoading');
              _this6.$router.push({ name: 'UsuariosLista' });
            }, function (error) {
              var errorText = '';
              if (error.response.status === 422) {
                errorText = 'E-mail já cadastrado. Por favor, escolha outro.';
              } else {
                errorText = 'Servidor indisponível. Tente novamente mais tarde.';
              }
              _this6.$store.dispatch('utils/showSnackbar', {
                text: errorText
              });
              _this6.$store.dispatch('utils/hideLoading');
            });
          }
        } else {
          _this6.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this6.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$store.dispatch('users/loadUsers');
  },

  computed: {
    users: function users() {
      var users = this.$store.getters['users/users'];

      if (this.$auth.check('Patrimônio')) {
        users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(users, { roles: ['Operacional'] });
      }

      return users;
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-bottom-sheet',

  props: {
    inset: Boolean,
    value: null
  },

  render: function render(h) {
    var activator = h('template', {
      slot: 'activator'
    }, this.$slots.activator);

    var contentClass = ['bottom-sheet', this.inset ? 'bottom-sheet--inset' : ''].join(' ');

    return h('v-dialog', {
      attrs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$attrs),
      on: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$listeners),
      props: {
        contentClass: contentClass,
        transition: 'slide-y-reverse-transition',
        value: this.value
      }
    }, [activator, this.$slots.default]);
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['filename', 'large'],
  data: function data() {
    return {
      icon: ''
    };
  },
  mounted: function mounted() {
    switch (this.filename.split('.').pop().toLowerCase()) {
      case 'txt':
      case 'rtf':
        this.icon = 'file-document';
        break;
      case 'xls':
      case 'xlsx':
      case 'csv':
        this.icon = 'file-excel';
        break;
      case 'bmp':
      case 'jpg':
      case 'gif':
      case 'jpeg':
      case 'png':
        this.icon = 'file-image';
        break;
      case 'pdf':
        this.icon = 'file-pdf';
        break;
      case 'pptx':
      case 'ppt':
      case 'pptm':
      case 'pps':
      case 'ppsx':
        this.icon = 'file-powerpoint';
        break;
      case 'doc':
      case 'docx':
        this.icon = 'file-word';
        break;
      default:
        this.icon = 'file';
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BottomSheet__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BottomSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BottomSheet__);




var FormData = __webpack_require__(770);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: [Array, String]
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'choose_file'
    },
    icon: {
      type: String,
      default: 'attach_file'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BottomSheet: __WEBPACK_IMPORTED_MODULE_1__BottomSheet___default.a
  },
  data: function data() {
    return {
      filename: '',
      sheet: false
    };
  },

  watch: {
    value: function value(v) {
      this.filename = v;
    }
  },
  mounted: function mounted() {
    this.filename = this.value;
  },


  methods: {
    getFormData: function getFormData(file) {
      var form = new FormData();
      form.append('data', file, file.name);
      return form;
    },
    onFocus: function onFocus() {
      var _this = this;

      if (!this.disabled) {
        if (this.accept === 'image/*' && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.device && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.device.platform && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.device.platform === 'Android') {
          setTimeout(function () {
            _this.sheet = true;
          }, 100);
        } else {
          this.$refs.fileInput.click();
        }
      }
    },
    onFileChange: function onFileChange($event) {
      var file = $event.target.files[0];
      this.filename = file.name;
      this.$emit('input', this.filename);
      this.$emit('formData', file);
    },
    processAndroidPicture: function processAndroidPicture(imageData) {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');
      window.resolveLocalFileSystemURL(imageData, function (fileEntry) {
        fileEntry.file(function (file) {
          _this2.filename = file.name;

          _this2.$emit('input', _this2.filename);
          _this2.$emit('formData', file);

          _this2.$store.dispatch('utils/hideLoading');
        });
      });
    },
    androidCamera: function androidCamera() {
      var _this3 = this;

      this.sheet = false;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.getPicture(function (imageData) {
        _this3.processAndroidPicture(imageData);
      }, function () {
        console.log('Erro');
      }, {
        quality: 80,
        sourceType: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.PictureSourceType.CAMERA,
        destinationType: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.DestinationType.FILE_URI,
        correctOrientation: true,
        saveToPhotoAlbum: true
      });
    },
    androidLibrary: function androidLibrary() {
      var _this4 = this;

      this.sheet = false;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.getPicture(function (imageData) {
        _this4.processAndroidPicture(imageData);
      }, function () {
        console.log('Erro');
      }, {
        quality: 80,
        sourceType: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.PictureSourceType.PHOTOLIBRARY,
        destinationType: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.camera.DestinationType.FILE_URI,
        correctOrientation: true,
        saveToPhotoAlbum: true
      });
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollHeight: document.body.scrollHeight,
      windowHeight: document.body.clientHeight
    };
  },

  methods: {
    irParaOTopo: function irParaOTopo() {
      var cosParameter = window.scrollY / 2;
      var scrollCount = 0;
      var oldTimestamp = performance.now();

      function step(newTimestamp) {
        scrollCount += Math.PI / (1000 / (newTimestamp - oldTimestamp));
        if (scrollCount >= Math.PI) window.scrollTo(0, 0);
        if (window.scrollY === 0) return;
        window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    isLoading: function isLoading() {
      return this.$store.getters['utils/isLoading'].status;
    },
    transparent: function transparent() {
      if (this.$store.getters['utils/isLoading'].transparent) {
        return 'transparent';
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      type: null,
      text: null,
      timeout: 5000
    };
  },
  mounted: function mounted() {
    this.text = this.snackbar[0].text;
    this.type = 'type' in this.snackbar[0] ? this.snackbar[0].type : this.type;
    this.timeout = 'timeout' in this.snackbar[0] ? this.snackbar[0].timeout : this.timeout;
    this.show = true;
  },

  watch: {
    show: function show(value) {
      var _this = this;

      if (value === false) {
        setTimeout(function () {
          _this.removeFromStore();
        }, 500);
      }
    }
  },
  computed: {
    snackbar: function snackbar() {
      return this.$store.getters['utils/snackbar'];
    }
  },
  methods: {
    removeFromStore: function removeFromStore() {
      this.$store.dispatch('utils/hideSnackbar');
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_4__Imoveis_Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      imovelId: this.$route.params.id,
      dialogUsuarios: false,
      dialogRecorrencia: false,
      menuData: false,
      datasPermitidas: function datasPermitidas(date) {
        var today = new Date();
        return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
      },
      form: {
        fields: {
          data: '',
          data_formatada: '',
          recorrencia: false,
          recorrencia_cada: 1,
          recorrencia_periodo: 'mensal',
          recorrencia_formatada: '',
          user_id: '',
          user_name: '',
          observacoes: ''
        },
        recorrenciaCada: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        recorrenciaPeriodos: [{ value: 'semanal', text: 'Semanal' }, { value: 'mensal', text: 'Mensal' }, { value: 'anual', text: 'Anual' }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$primeUserRestrictions().then(function () {
      if (_this.isLimitadoTarefas) {
        _this.$store.dispatch('utils/showSnackbar', {
          text: 'Usuários limitados por tarefas/vistorias não podem adicionar vistoria.'
        });
        _this.$router.replace({ name: 'ImoveisDetalhesResumo', params: { id: _this.imovelId } });
        return;
      }

      _this.$store.dispatch('users/loadAssignableUsers');
    });
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    isLimitadoTarefas: function isLimitadoTarefas() {
      return this.$hasUserRestrictionFlag('limitado_tarefas');
    },
    users: function users() {
      return this.$store.getters['users/users'];
    },
    recorrenciaToString: function recorrenciaToString() {
      if (this.form.fields.recorrencia) {
        return 'Repete';
      } else {
        return 'Não repete';
      }
    },
    isFormInvalid: function isFormInvalid() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this2.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  watch: {
    'form.fields.user_id': function formFieldsUser_id(value) {
      this.form.fields.user_name = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.users, { id: value }).name;
    },
    'form.fields.recorrencia': function formFieldsRecorrencia() {
      this.formatarRecorrencia();
    },
    'form.fields.recorrencia_cada': function formFieldsRecorrencia_cada() {
      this.formatarRecorrencia();
    },
    'form.fields.recorrencia_periodo': function formFieldsRecorrencia_periodo() {
      this.formatarRecorrencia();
    }
  },
  methods: {
    selectUser: function selectUser(userId) {
      this.form.fields.user_id = userId;
      this.dialogUsuarios = false;
    },
    formatarRecorrencia: function formatarRecorrencia() {
      if (this.form.fields.recorrencia) {
        var periodoFormatadoSingular = '';
        var periodoFormatadoPlural = '';
        var periodoFormatado = '';

        switch (this.form.fields.recorrencia_periodo) {
          case 'semanal':
            periodoFormatadoSingular = 'semana';
            periodoFormatadoPlural = 'semanas';
            break;
          case 'mensal':
            periodoFormatadoSingular = 'mês';
            periodoFormatadoPlural = 'meses';
            break;
          case 'anual':
            periodoFormatadoSingular = 'ano';
            periodoFormatadoPlural = 'anos';
            break;
        }

        periodoFormatado = this.form.fields.recorrencia_cada > 1 ? periodoFormatadoPlural : periodoFormatadoSingular;
        var recorrenciaFormatada = 'A cada ' + this.form.fields.recorrencia_cada + ' ' + periodoFormatado;
        this.form.fields.recorrencia_formatada = recorrenciaFormatada;
      } else {
        this.form.fields.recorrencia_formatada = '';
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (this.isLimitadoTarefas) {
        return;
      }

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/vistoria/' + _this3.imovelId, _this3.form.fields).then(function (response) {
            _this3.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: _this3.imovelId } });
            _this3.$store.dispatch('utils/hideLoading');
          }, function () {
            _this3.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this3.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this3.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this3.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeadersDetalhesResumo: __WEBPACK_IMPORTED_MODULE_5__Imoveis_Headers_HeadersDetalhesResumo___default.a
  },
  data: function data() {
    return {
      imovelId: this.$route.params.id,
      dialogUsuarios: false,
      dialogRecorrencia: false,
      menuData: false,
      datasPermitidas: function datasPermitidas(date) {
        var today = new Date();
        return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
      },
      form: {
        fields: {
          data: '',
          data_formatada: '',
          recorrencia: false,
          recorrencia_cada: 1,
          recorrencia_periodo: 'mensal',
          recorrencia_formatada: '',
          user_id: '',
          user_name: '',
          observacoes: ''
        },
        recorrenciaCada: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        recorrenciaPeriodos: [{ value: 'semanal', text: 'Semanal' }, { value: 'mensal', text: 'Mensal' }, { value: 'anual', text: 'Anual' }]
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('users/loadAssignableUsers');
  },

  computed: {
    imovel: function imovel() {
      return this.$store.getters['imoveis/detalhes'];
    },
    users: function users() {
      return this.$store.getters['users/users'];
    },
    vistoria: function vistoria() {
      return this.$store.getters['imoveis/vistoria'];
    },
    recorrenciaToString: function recorrenciaToString() {
      if (this.form.fields.recorrencia) {
        return 'Repete';
      } else {
        return 'Não repete';
      }
    },
    isFormInvalid: function isFormInvalid() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).some(function (key) {
        return _this.fields[key].invalid;
      }) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omitBy(this.form.fields, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty));
    }
  },
  watch: {
    vistoria: function vistoria() {
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.vistoria)) {
        this.form.fields.data = this.vistoria.data;
        this.form.fields.data_formatada = this.vistoria.data_formatada;
        this.form.fields.user_id = this.vistoriaUserId();
        this.form.fields.user_name = this.vistoriaUserName();
        this.form.fields.observacoes = this.vistoria.observacoes;

        if (this.vistoria.recorrencia) {
          this.form.fields.recorrencia = this.vistoria.recorrencia;
          this.form.fields.recorrencia_cada = this.vistoria.recorrencia_cada;
          this.form.fields.recorrencia_periodo = this.vistoria.recorrencia_periodo;
          this.form.fields.recorrencia_formatada = this.vistoria.recorrencia_formatada;
        }
      }
    },
    'form.fields.user_id': function formFieldsUser_id(value) {
      var user = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.users, { id: value });
      this.form.fields.user_name = user ? user.name : this.form.fields.user_name;
    },
    'form.fields.recorrencia': function formFieldsRecorrencia() {
      this.formatarRecorrencia();
    },
    'form.fields.recorrencia_cada': function formFieldsRecorrencia_cada() {
      this.formatarRecorrencia();
    },
    'form.fields.recorrencia_periodo': function formFieldsRecorrencia_periodo() {
      this.formatarRecorrencia();
    }
  },
  methods: {
    vistoriaUserId: function vistoriaUserId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__["a" /* getAssignedUserId */])(this.vistoria);
    },
    vistoriaUserName: function vistoriaUserName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_assignedUser__["b" /* getAssignedUserName */])(this.vistoria);
    },
    selectUser: function selectUser(userId) {
      this.form.fields.user_id = userId;
      this.dialogUsuarios = false;
    },
    formatarRecorrencia: function formatarRecorrencia() {
      if (this.form.fields.recorrencia) {
        var periodoFormatadoSingular = '';
        var periodoFormatadoPlural = '';
        var periodoFormatado = '';

        switch (this.form.fields.recorrencia_periodo) {
          case 'semanal':
            periodoFormatadoSingular = 'semana';
            periodoFormatadoPlural = 'semanas';
            break;
          case 'mensal':
            periodoFormatadoSingular = 'mês';
            periodoFormatadoPlural = 'meses';
            break;
          case 'anual':
            periodoFormatadoSingular = 'ano';
            periodoFormatadoPlural = 'anos';
            break;
        }

        periodoFormatado = this.form.fields.recorrencia_cada > 1 ? periodoFormatadoPlural : periodoFormatadoSingular;
        var recorrenciaFormatada = 'A cada ' + this.form.fields.recorrencia_cada + ' ' + periodoFormatado;
        this.form.fields.recorrencia_formatada = recorrenciaFormatada;
      } else {
        this.form.fields.recorrencia_formatada = '';
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/vistoria/' + _this2.imovelId, _this2.form.fields).then(function (response) {
            _this2.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: _this2.imovelId } });
            _this2.$store.dispatch('utils/hideLoading');
          }, function () {
            _this2.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this2.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this2.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this2.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_FileInput__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_FileInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Utils_FileInput__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['vistoriaId', 'imovelId'],
  components: {
    FileInput: __WEBPACK_IMPORTED_MODULE_2__Utils_FileInput___default.a
  },
  data: function data() {
    return {
      dialog: false,
      inputKey: Math.random(),
      form: {
        fields: {
          tipo: 'geral',
          legenda: '',
          foto: null,
          fotoFilename: ''
        }
      }
    };
  },

  methods: {
    onFilePicked: function onFilePicked(event) {
      this.form.fields.foto = event;
    },
    descartar: function descartar() {
      this.dialog = false;
      this.form.fields.legenda = '';
      this.form.fields.foto = null;
      this.form.fields.fotoFilename = '';
      this.inputKey = Math.random();
      this.errors.clear();
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$store.dispatch('utils/showLoading');

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var fieldsFormatados = {
            id: _this.imovelId,
            tipo: _this.form.fields.tipo,
            legenda: _this.form.fields.legenda.length > 1 ? _this.form.fields.legenda : 'Vistoria realizada',
            foto: _this.form.fields.foto,
            fotoFilename: _this.form.fields.fotoFilename
          };

          _this.$store.dispatch('fotos/adicionarFoto', { fields: fieldsFormatados }).then(function (response) {
            if (response !== false) {
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/vistoria/realizar/' + _this.vistoriaId).then(function () {
                _this.$store.dispatch('imoveis/loadImovel', { id: _this.imovelId });
                _this.descartar();
              }).catch(function (error) {
                console.error('Erro ao finalizar vistoria', error);
                _this.$store.dispatch('utils/showSnackbar', {
                  text: 'Servidor indisponível. Tente novamente mais tarde.'
                });
              }).then(function () {
                _this.$store.dispatch('utils/hideLoading');
              });
            }
          }, function () {
            _this.$store.dispatch('utils/showSnackbar', {
              text: 'Servidor indisponível. Tente novamente mais tarde.'
            });
            _this.$store.dispatch('utils/hideLoading');
          });
        } else {
          _this.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: 'Preencha os campos corretamente'
          });
          _this.$store.dispatch('utils/hideLoading');
        }
      });
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['situacao'],
  computed: {
    situacaoClass: function situacaoClass() {
      switch (this.situacao) {
        case 'realizada':
          return 'primary';
        case 'atrasada':
          return 'vermelho';
        case 'próxima':
          return 'amarelo';
        case 'em dia':
          return 'verde';
      }
    }
  }
});

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(919);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Pie */],
  props: ['chartdata'],
  mounted: function mounted() {
    this.renderChart(this.chartdata, {
      responsive: false,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      animation: false,
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var label = data.labels[tooltipItem.index];
            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
              return previousValue + currentValue;
            });

            var currentValue = dataset.data[tooltipItem.index];
            var percentage = Math.floor(currentValue / total * 100 + 0.5);

            return ' ' + label + ': ' + currentValue + ' (' + percentage + '%)';
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var legendHtml = [];
        legendHtml.push('<ul class="chart-legend">');

        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;

        if (datasets.length) {
          for (var i = 0; i < datasets[0].data.length; i++) {
            legendHtml.push('<li><span class="legend-circle" style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
            if (labels[i]) {
              var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                return previousValue + currentValue;
              });
              var currentValue = datasets[0].data[i];
              var percentage = Math.floor(currentValue / total * 100 + 0.5);
              legendHtml.push(' <span class="legend-label">' + labels[i] + '</span> <div class="legend-data"><span class="legend-total">' + datasets[0].data[i] + '</span> <span class="legend-percentage">' + percentage + '%</span></div>');
            }
            legendHtml.push('</li>');
          }
        }

        legendHtml.push('</ul>');

        return legendHtml.join('');
      }
    });

    var HTML = this.$data._chart.generateLegend();
    this.$emit('generated', HTML);
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cordova__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cordova___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cordova__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate_dist_locale_pt_BR__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_img__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_access__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_roleRestrictions__ = __webpack_require__(406);


















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_cordova___default.a);
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  cordovaScript.setAttribute('src', 'cordova.js');
  document.body.appendChild(cordovaScript);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_img__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default.a);

__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].addLocale(__WEBPACK_IMPORTED_MODULE_9_vee_validate_dist_locale_pt_BR___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* default */], {
  locale: 'pt_BR'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBeoZfZPWSQP49sEuM5SdjrJ3ne5qInXxY',
    libraries: 'places, geometry'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    $hasGeneralAccess: function $hasGeneralAccess(permissionKey) {
      var user = this.$auth.user();
      if (!user) return false;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["a" /* shouldUseCustomPermissions */])(user)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["b" /* hasGeneralAccess */])(user, permissionKey);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["c" /* hasCustomPermissionsPayload */])(user)) return false;

      if (permissionKey === 'administracao_usuarios') {
        return this.$auth.check(['Administrador', 'Patrimônio']);
      }

      if (permissionKey === 'administracao_niveis_acesso') {
        return this.$auth.check(['Administrador']);
      }

      if (permissionKey === 'visualizar_relatorios') {
        return this.$auth.check(['Administrador']);
      }

      return false;
    },
    $hasGranularPermission: function $hasGranularPermission(category, action) {
      var user = this.$auth.user();
      if (!user) return false;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["a" /* shouldUseCustomPermissions */])(user)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["d" /* hasGranularPermission */])(user, category, action);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_access__["c" /* hasCustomPermissionsPayload */])(user)) return false;

      if (this.$auth.check(['Administrador', 'Diretoria', 'Patrimônio'])) {
        return true;
      }

      if (this.$auth.check('Operacional')) {
        if (category === 'valor') return false;
        if (action === 'view') return true;
        return false;
      }

      console.warn('Granular Permission Denied (No Role Match):', category, action, user);
      return false;
    },
    $hasUserRestrictionFlag: function $hasUserRestrictionFlag(flag) {
      var user = this.$auth.user();
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_roleRestrictions__["a" /* getUserRestrictionFlag */])(user, flag);
    },
    $primeUserRestrictions: function $primeUserRestrictions() {
      var user = this.$auth.user();
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_roleRestrictions__["b" /* primeUserRestrictions */])(user);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */],
  template: '<div id="app"><router-view></router-view></div>'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.on('deviceready', function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova.geolocation.watchPosition(function (position) {
    var coordsAtuais = __WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */].getters['utils/coords'];

    if (position.coords.latitude !== coordsAtuais.latitude || position.coords.longitude !== coordsAtuais.longitude) {
      __WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */].dispatch('utils/setCoords', position);
    }
  }, function () {}, {
    enableHighAccuracy: true
  });

  var iosSettings = {
    kOSSettingsKeyAutoPrompt: true
  };
  window.plugins.OneSignal.startInit('987a10c1-e7c3-4081-8c17-dadfa9705f2b').iOSSettings(iosSettings).inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification).endInit();
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeImovelFilterValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeSearchText;
/* harmony export (immutable) */ __webpack_exports__["b"] = includesNormalizedText;
/* harmony export (immutable) */ __webpack_exports__["d"] = buildRelatorioPagamentosPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



function normalizeImovelFilterValue(value) {
  if (value === null || value === undefined || value === '' || value === 'all') {
    return null;
  }

  return String(value);
}

function normalizeSearchText(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

function includesNormalizedText(text, query) {
  var normalizedText = normalizeSearchText(text);
  var normalizedQuery = normalizeSearchText(query);

  return normalizedText.indexOf(normalizedQuery) > -1;
}

function buildRelatorioPagamentosPayload() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$periodo = _ref.periodo,
      periodo = _ref$periodo === undefined ? 'mes' : _ref$periodo,
      _ref$filtros = _ref.filtros,
      filtros = _ref$filtros === undefined ? {} : _ref$filtros,
      _ref$dataInicial = _ref.dataInicial,
      dataInicial = _ref$dataInicial === undefined ? null : _ref$dataInicial,
      _ref$dataFinal = _ref.dataFinal,
      dataFinal = _ref$dataFinal === undefined ? null : _ref$dataFinal,
      _ref$status = _ref.status,
      status = _ref$status === undefined ? [] : _ref$status,
      _ref$imovelId = _ref.imovelId,
      imovelId = _ref$imovelId === undefined ? null : _ref$imovelId;

  var payload = {
    periodo: periodo
  };

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(filtros)) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, filtros);
  }

  if (periodo === 'custom') {
    payload.data_inicial = dataInicial;
    payload.data_final = dataFinal;
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(status) && status.length > 0) {
    payload.status = status;
  }

  var normalizedImovelId = normalizeImovelFilterValue(imovelId);
  if (normalizedImovelId) {
    payload.imovel_id = normalizedImovelId;
  }

  return payload;
}

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);



var anexos = {
  namespaced: true,
  actions: {
    downloadAnexo: function downloadAnexo(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      dispatch('utils/showLoading', {}, { root: true });

      var config = {
        params: {
          url: payload.path
        },
        responseType: 'arraybuffer'
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/anexos/download', config).then(function (response) {
        dispatch('utils/hideLoading', {}, { root: true });

        var filename = payload.name;
        var headers = response.headers;
        var blob = new Blob([response.data], { type: headers['content-type'] });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }, function () {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (anexos);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var constants = {
  namespaced: true,
  state: {
    endereco_uf: [],
    endereco_tipo: [],
    imovel_tipo: [],
    taxa_situacao: [],
    tarefa_tipo: []
  },
  mutations: {
    SET_CONSTANTS: function SET_CONSTANTS(state, payload) {
      for (var key in state) {
        state[key] = payload[key];
      }
    }
  },
  actions: {
    loadConstants: function loadConstants(_ref, payload) {
      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* apiURL */] + '/constants').then(function (response) {
        commit('SET_CONSTANTS', response.data);
      }, function (error) {
        if (error.response.status === 401) {
          dispatch('utils/showSnackbar', {
            text: 'Realize o login novamente.'
          }, { root: true });
        } else {
          dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.',
            persistent: true
          }, { root: true });
        }
      });
    }
  },
  getters: {
    enderecoUF: function enderecoUF(state) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(state.endereco_uf, function (key, value) {
        return { text: key['titulo'], value: key['uf'] };
      });
    },
    enderecoTipo: function enderecoTipo(state) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(state.endereco_tipo, function (key) {
        return { text: key, value: key };
      });
    },
    imovelTipo: function imovelTipo(state) {
      return state.imovel_tipo;
    },
    taxaSituacao: function taxaSituacao(state) {
      return state.taxa_situacao;
    },
    tarefaTipo: function tarefaTipo(state) {
      return state.tarefa_tipo;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__ = __webpack_require__(77);






var fotos = {
  namespaced: true,
  actions: {
    adicionarFoto: function adicionarFoto(_ref, payload) {
      var dispatch = _ref.dispatch;

      if (payload.fields.foto === null) {
        dispatch('utils/showSnackbar', {
          text: 'O campo foto é obrigatório.',
          type: 'error'
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      var filename = payload.fields['fotoFilename'];

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__components_Utils_resizeBeforeUpload__["a" /* default */].resize(payload.fields['foto'], {
          width: 1024,
          height: 1024
        }, function (blob) {
          var formData = new FormData();

          formData.append('foto', blob, filename);
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload.fields).forEach(function (key) {
            if (key !== 'foto' && key !== 'id') {
              formData.append(key, payload.fields[key]);
            }
          });

          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiURL */] + '/fotos/' + payload.fields.id, formData).then(function (response) {
            resolve(response.data.data);
          }).catch(reject);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (fotos);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_savoynet__ = __webpack_require__(80);












function normalizeImovelSavoyNet(imovel) {
  if (!imovel || (typeof imovel === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(imovel)) !== 'object') {
    return imovel;
  }

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, imovel, {
    savoynet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_savoynet__["a" /* parseSavoyNetFromApi */])(imovel.savoynet)
  });
}

var imoveis = {
  namespaced: true,
  state: {
    lista: {
      data: [],
      paginacao: {}
    },
    listaFiltros: {
      proprietario: [],
      tipo: [],
      uf: [],
      loteamento: []
    },
    listaDownload: [],
    filtros: {},
    proprietarios: [],
    detalhes: {}
  },
  mutations: {
    INSERT_LISTA: function INSERT_LISTA(state, payload) {
      var normalizedPayload = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(payload, normalizeImovelSavoyNet);
      state.lista.data = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(state.lista.data, normalizedPayload), 'id');
    },
    SET_LISTA_PAGINACAO: function SET_LISTA_PAGINACAO(state, payload) {
      state.lista.paginacao = payload;
    },
    SET_LISTA_DOWNLOAD: function SET_LISTA_DOWNLOAD(state, payload) {
      state.listaDownload = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(payload, normalizeImovelSavoyNet);
    },
    SET_DETALHES: function SET_DETALHES(state, payload) {
      state.detalhes = normalizeImovelSavoyNet(payload);
    },
    SET_PROPRIETARIOS: function SET_PROPRIETARIOS(state, payload) {
      state.proprietarios = payload;
    },
    SET_LISTA_FILTROS: function SET_LISTA_FILTROS(state, payload) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.listaFiltros).forEach(function (key) {
        state.listaFiltros[key] = payload[key];
      });
    },
    SET_FILTROS: function SET_FILTROS(state, payload) {
      state.filtros = payload;
    },
    CLEAR_FILTROS: function CLEAR_FILTROS() {},
    CLEAR_LISTA: function CLEAR_LISTA(state) {
      state.lista.data.length = 0;
      state.lista.paginacao = {};
    },
    CLEAR_DETALHES: function CLEAR_DETALHES(state) {
      state.detalhes = {};
    },
    INSERT_OBSERVACAO: function INSERT_OBSERVACAO(state, payload) {
      state.detalhes.observacoes.data.unshift(payload);
    },
    UPDATE_OBSERVACAO: function UPDATE_OBSERVACAO(state, payload) {
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.detalhes.observacoes.data, payload.item).conteudo = payload.conteudo;
    },
    DELETE_OBSERVACAO: function DELETE_OBSERVACAO(state, payload) {
      state.detalhes.observacoes.data.splice(state.detalhes.observacoes.data.indexOf(payload), 1);
    },
    INSERT_ANEXO: function INSERT_ANEXO(state, payload) {
      state.detalhes.anexos.data.unshift(payload);
    },
    UPDATE_ANEXO: function UPDATE_ANEXO(state, payload) {
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.detalhes.anexos.data, payload.item).legenda = payload.legenda;
    },
    DELETE_ANEXO: function DELETE_ANEXO(state, payload) {
      state.detalhes.anexos.data.splice(state.detalhes.anexos.data.indexOf(payload), 1);
    },
    INSERT_FOTO: function INSERT_FOTO(state, payload) {
      state.detalhes.fotos.data.unshift(payload);
    },
    UPDATE_FOTO: function UPDATE_FOTO(state, payload) {
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.detalhes.fotos.data, payload.item).legenda = payload.legenda;
    },
    DELETE_FOTO: function DELETE_FOTO(state, payload) {
      state.detalhes.fotos.data.splice(state.detalhes.fotos.data.indexOf(payload), 1);
    },
    DELETE_TAREFA: function DELETE_TAREFA(state, payload) {
      state.detalhes.tarefas.data.splice(state.detalhes.tarefas.data.indexOf(payload), 1);
    },
    REALIZAR_TAREFA: function REALIZAR_TAREFA(state, payload) {
      var tarefa = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.detalhes.tarefas.data, { id: payload.id });
      if (!tarefa) {
        return;
      }
      tarefa.realizada = true;
    },
    INSERT_TAXA: function INSERT_TAXA(state, payload) {
      state.detalhes.taxas.data.unshift(payload);
    },
    UPDATE_TAXA: function UPDATE_TAXA(state, payload) {
      var taxa = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(state.detalhes.taxas.data, payload.item);
      taxa.numero = payload.data.numero;
      taxa.situacao = payload.data.situacao;
      taxa.ajuizado_cliente = payload.data.ajuizado_cliente;
      taxa.ajuizado_processo = payload.data.ajuizado_processo;
    },
    DELETE_TAXA: function DELETE_TAXA(state, payload) {
      state.detalhes.taxas.data.splice(state.detalhes.taxas.data.indexOf(payload), 1);
    }
  },
  actions: {
    loadLista: function loadLista(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      if (payload.loading !== false) {
        dispatch('utils/showLoading', { transparent: true }, { root: true });
      }
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/imoveis', { params: payload }).then(function (response) {
        commit('INSERT_LISTA', response.data.data);
        commit('SET_LISTA_PAGINACAO', response.data.meta.pagination);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function () {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/');
      });
    },
    loadListaFiltros: function loadListaFiltros(_ref2, payload) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      dispatch('utils/showLoading', { transparent: true }, { root: true });
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/filtros', { params: payload }).then(function (response) {
        commit('SET_LISTA_FILTROS', response.data);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function () {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/');
      });
    },
    setFiltros: function setFiltros(_ref3, payload) {
      var commit = _ref3.commit;

      commit('SET_FILTROS', payload);
    },
    clearFiltros: function clearFiltros(_ref4) {
      var commit = _ref4.commit;

      commit('CLEAR_FILTROS');
    },
    loadListaDownload: function loadListaDownload(_ref5, payload) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      payload.download = true;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/imoveis', { params: payload }).then(function (response) {
          commit('SET_LISTA_DOWNLOAD', response.data.data);
          resolve();
        }, function () {
          dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.',
            persistent: true
          }, { root: true });
          reject();
          __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/');
        });
      });
    },
    loadListaSelect: function loadListaSelect(_ref6) {
      var dispatch = _ref6.dispatch;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var baseParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, payload, {
        fields: 'id,apelido',
        download: true
      });

      var mapItems = function mapItems(response) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(response.data.data || [], function (item) {
          return {
            id: item.id,
            apelido: item.apelido || 'Im\xF3vel #' + item.id
          };
        });
      };

      var loadPage = function loadPage(page) {
        return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/imoveis', {
          params: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, baseParams, { page: page })
        });
      };

      var appendUniqueItems = function appendUniqueItems(allItems, newItems) {
        var existingIds = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(allItems.map(function (item) {
          return String(item.id);
        }));
        var added = 0;

        newItems.forEach(function (item) {
          var id = String(item.id);
          if (existingIds.has(id)) return;
          existingIds.add(id);
          allItems.push(item);
          added++;
        });

        return added;
      };

      var extractTotalPages = function extractTotalPages(response) {
        var pagination = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.pagination', {});
        var total = parseInt(pagination.total || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.total') || 0);
        var perPage = parseInt(pagination.per_page || pagination.page_size || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.per_page') || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.page_size') || 0);
        var calculatedTotalPages = perPage > 0 && total > 0 ? Math.ceil(total / perPage) : 0;
        var totalPages = parseInt(pagination.total_pages || pagination.last_page || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.total_pages') || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(response, 'data.meta.last_page') || calculatedTotalPages || 0);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(totalPages) ? totalPages : 0;
      };

      var loadRemainingPagesSequentially = function loadRemainingPagesSequentially(_ref7) {
        var totalPages = _ref7.totalPages,
            allItems = _ref7.allItems,
            page = _ref7.page;

        if (totalPages > 0 && page > totalPages) {
          return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(allItems, 'id');
        }

        if (page > 100) {
          return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(allItems, 'id');
        }

        return loadPage(page).then(function (response) {
          var pageItems = mapItems(response);
          if (pageItems.length < 1) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(allItems, 'id');
          }

          var added = appendUniqueItems(allItems, pageItems);
          if (added < 1) {
            return allItems;
          }

          return loadRemainingPagesSequentially({
            totalPages: totalPages,
            allItems: allItems,
            page: page + 1
          });
        }, function () {
          return allItems;
        });
      };

      return loadPage(1).then(function (response) {
        var firstPageItems = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniqBy(mapItems(response), 'id');
        var totalPages = extractTotalPages(response);

        if (firstPageItems.length < 1) {
          return [];
        }

        if (totalPages <= 1) {
          return loadRemainingPagesSequentially({
            totalPages: 0,
            allItems: firstPageItems.slice(),
            page: 2
          });
        }

        return loadRemainingPagesSequentially({
          totalPages: totalPages,
          allItems: firstPageItems.slice(),
          page: 2
        });
      }).catch(function () {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error('loadListaSelect_failed'));
      });
    },
    loadImovel: function loadImovel(_ref8, payload) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      dispatch('utils/showLoading', {}, { root: true });
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/imoveis/' + payload.id).then(function (response) {
        commit('SET_DETALHES', response.data.data);
        dispatch('utils/hideLoading', {}, { root: true });
        return response.data.data;
      }, function (error) {
        var status = error && error.response ? error.response.status : null;
        var text = status === 403 ? 'Sem permissão para acessar este imóvel.' : 'Servidor indisponível. Tente novamente mais tarde.';

        dispatch('utils/showSnackbar', {
          text: text,
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        if (status === 403) {
          __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({ name: 'ImoveisLista' });
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
        }
        __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/');
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    loadProprietarios: function loadProprietarios(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      dispatch('utils/showLoading', {}, { root: true });
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* apiURL */] + '/proprietarios').then(function (response) {
        commit('SET_PROPRIETARIOS', response.data);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function () {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/');
      });
    },
    clearLista: function clearLista(_ref10) {
      var commit = _ref10.commit;

      commit('CLEAR_LISTA');
    },
    clearImovel: function clearImovel(_ref11) {
      var commit = _ref11.commit;

      commit('CLEAR_DETALHES');
    },
    insertObservacao: function insertObservacao(_ref12, payload) {
      var commit = _ref12.commit;

      commit('INSERT_OBSERVACAO', payload);
    },
    updateObservacao: function updateObservacao(_ref13, payload) {
      var commit = _ref13.commit;

      commit('UPDATE_OBSERVACAO', payload);
    },
    deleteObservacao: function deleteObservacao(_ref14, payload) {
      var commit = _ref14.commit;

      commit('DELETE_OBSERVACAO', payload);
    },
    insertAnexo: function insertAnexo(_ref15, payload) {
      var commit = _ref15.commit;

      commit('INSERT_ANEXO', payload);
    },
    updateAnexo: function updateAnexo(_ref16, payload) {
      var commit = _ref16.commit;

      commit('UPDATE_ANEXO', payload);
    },
    deleteAnexo: function deleteAnexo(_ref17, payload) {
      var commit = _ref17.commit;

      commit('DELETE_ANEXO', payload);
    },
    insertFoto: function insertFoto(_ref18, payload) {
      var commit = _ref18.commit;

      commit('INSERT_FOTO', payload);
    },
    updateFoto: function updateFoto(_ref19, payload) {
      var commit = _ref19.commit;

      commit('UPDATE_FOTO', payload);
    },
    deleteFoto: function deleteFoto(_ref20, payload) {
      var commit = _ref20.commit;

      commit('DELETE_FOTO', payload);
    },
    deleteTarefa: function deleteTarefa(_ref21, payload) {
      var commit = _ref21.commit;

      commit('DELETE_TAREFA', payload);
    },
    realizarTarefa: function realizarTarefa(_ref22, payload) {
      var commit = _ref22.commit;

      commit('REALIZAR_TAREFA', payload);
    },
    insertTaxa: function insertTaxa(_ref23, payload) {
      var commit = _ref23.commit;

      commit('INSERT_TAXA', payload);
    },
    updateTaxa: function updateTaxa(_ref24, payload) {
      var commit = _ref24.commit;

      commit('UPDATE_TAXA', payload);
    },
    deleteTaxa: function deleteTaxa(_ref25, payload) {
      var commit = _ref25.commit;

      commit('DELETE_TAXA', payload);
    }
  },
  getters: {
    lista: function lista(state) {
      return state.lista.data;
    },
    listaPaginacao: function listaPaginacao(state) {
      return state.lista.paginacao;
    },
    listaDownload: function listaDownload(state) {
      return state.listaDownload;
    },
    proprietarios: function proprietarios(state) {
      return state.proprietarios;
    },
    listaFiltros: function listaFiltros(state) {
      return state.listaFiltros;
    },
    filtros: function filtros(state) {
      return state.filtros;
    },
    detalhes: function detalhes(state) {
      return state.detalhes;
    },

    observacoes: function observacoes(state) {
      return function (tipo) {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'observacoes.data')) {
          return [];
        }
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.detalhes.observacoes.data, { tipo: tipo });
      };
    },
    anexos: function anexos(state) {
      return function (tipo) {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'anexos.data')) {
          return [];
        }
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.detalhes.anexos.data, { tipo: tipo });
      };
    },
    fotos: function fotos(state) {
      return function (tipo) {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'fotos.data')) {
          return [];
        }
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.detalhes.fotos.data, { tipo: tipo });
      };
    },
    tarefas: function tarefas(state) {
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'tarefas.data')) {
        return [];
      }
      return state.detalhes.tarefas.data;
    },
    tarefasPendentes: function tarefasPendentes(state) {
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'tarefas.data')) {
        return [];
      }
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.detalhes.tarefas.data, { realizada: false });
    },

    tarefaById: function tarefaById(state) {
      return function (tarefaId) {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'tarefas.data')) {
          return {};
        }
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.detalhes.tarefas.data, { id: tarefaId }));
      };
    },
    vistoria: function vistoria(state) {
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'vistoria.data')) {
        return {};
      }
      return state.detalhes.vistoria.data;
    },
    taxas: function taxas(state) {
      if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(state.detalhes, 'taxas.data')) {
        return [];
      }
      return state.detalhes.taxas.data;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (imoveis);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(76);





var pagamentosRequestId = 0;

var relatorios = {
  namespaced: true,
  state: {
    historico: {
      data: [],
      paginacao: {}
    },
    comparativo: {
      data: {}
    },
    pagamentos: {
      periodo_aplicado: {},
      resumo: {
        total: 0,
        valor_total: 0,
        por_status: {}
      },
      por_status: {},
      itens: []
    }
  },
  mutations: {
    INSERT_HISTORICO: function INSERT_HISTORICO(state, payload) {
      if (state.historico.data.length < 1) {
        state.historico.data = payload;
      } else {
        state.historico.data = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mergeWith(state.historico.data, payload, function (a, b) {
          if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(a)) {
            return a.concat(b);
          }
        });
      }
    },
    CLEAR_HISTORICO: function CLEAR_HISTORICO(state) {
      state.historico.data = [];
      state.historico.paginacao = {};
    },
    SET_LISTA_PAGINACAO: function SET_LISTA_PAGINACAO(state, payload) {
      state.historico.paginacao = payload;
    },
    INSERT_COMPARATIVO: function INSERT_COMPARATIVO(state, payload) {
      state.comparativo.data = payload;
    },
    CLEAR_COMPARATIVO: function CLEAR_COMPARATIVO(state) {
      state.comparativo.data = {};
    },
    SET_RELATORIO_PAGAMENTOS: function SET_RELATORIO_PAGAMENTOS(state, payload) {
      state.pagamentos.periodo_aplicado = payload.periodo_aplicado || {};
      state.pagamentos.resumo = payload.resumo || {
        total: 0,
        valor_total: 0,
        por_status: {}
      };
      state.pagamentos.por_status = payload.por_status || {};
      state.pagamentos.itens = payload.itens || [];
    },
    CLEAR_RELATORIO_PAGAMENTOS: function CLEAR_RELATORIO_PAGAMENTOS(state) {
      state.pagamentos.periodo_aplicado = {};
      state.pagamentos.resumo = {
        total: 0,
        valor_total: 0,
        por_status: {}
      };
      state.pagamentos.por_status = {};
      state.pagamentos.itens = [];
    }
  },
  actions: {
    loadHistorico: function loadHistorico(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      dispatch('utils/showLoading', {}, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + '/historico', { params: payload }).then(function (response) {
        commit('INSERT_HISTORICO', response.data.data);
        commit('SET_LISTA_PAGINACAO', response.data.meta.pagination);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        if (isForbidden) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
        }
      });
    },
    clearHistorico: function clearHistorico(_ref2) {
      var commit = _ref2.commit;

      commit('CLEAR_HISTORICO');
    },
    loadComparativo: function loadComparativo(_ref3, payload) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      dispatch('utils/showLoading', {}, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + '/relatorio/atual', { params: payload }).then(function (response) {
        commit('INSERT_COMPARATIVO', response.data);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        if (isForbidden) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
        }
      });
    },
    clearComparativo: function clearComparativo(_ref4) {
      var commit = _ref4.commit;

      commit('CLEAR_COMPARATIVO');
    },
    loadPagamentos: function loadPagamentos(_ref5, payload) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      var requestId = ++pagamentosRequestId;
      dispatch('utils/showLoading', {}, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + '/relatorio/pagamentos', { params: payload }).then(function (response) {
        if (requestId !== pagamentosRequestId) return;
        commit('SET_RELATORIO_PAGAMENTOS', response.data);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function (error) {
        if (requestId !== pagamentosRequestId) return;
        var isForbidden = error && error.response && error.response.status === 403;
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar relatórios.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        if (isForbidden) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
        }
      });
    },
    clearPagamentos: function clearPagamentos(_ref6) {
      var commit = _ref6.commit;

      commit('CLEAR_RELATORIO_PAGAMENTOS');
    }
  },
  getters: {
    historico: function historico(state) {
      return state.historico.data;
    },
    historicoPaginacao: function historicoPaginacao(state) {
      return state.historico.paginacao;
    },
    comparativo: function comparativo(state) {
      return state.comparativo.data;
    },
    pagamentos: function pagamentos(state) {
      return state.pagamentos;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (relatorios);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(76);





var isBlockedUser = function isBlockedUser(user) {
  if (!user) return true;
  var blocked = user.bloqueado;
  return blocked === true || blocked === 1 || blocked === '1';
};

var normalizeUsers = function normalizeUsers(users) {
  if (!Array.isArray(users)) return [];

  return users.filter(function (user) {
    return !isBlockedUser(user);
  }).sort(function (a, b) {
    var nameA = String(a && a.name || '');
    var nameB = String(b && b.name || '');
    return nameA.localeCompare(nameB, 'pt-BR');
  });
};

var extractResponseData = function extractResponseData(response) {
  return response && response.data ? response.data.data : [];
};

var requestUsersWithFallback = function requestUsersWithFallback(endpoints) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (index >= endpoints.length) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('users_not_available'));
  }

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + endpoints[index]).then(extractResponseData).catch(function (error) {
    var status = error && error.response ? error.response.status : null;
    var canFallback = index < endpoints.length - 1 && (status === 404 || status === 405);

    if (canFallback) {
      return requestUsersWithFallback(endpoints, index + 1);
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var users = {
  namespaced: true,
  state: {
    users: []
  },
  mutations: {
    SET_USERS: function SET_USERS(state, payload) {
      state.users = payload;
    }
  },
  actions: {
    loadUsers: function loadUsers(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      dispatch('utils/showLoading', {}, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiURL */] + '/users').then(function (response) {
        commit('SET_USERS', response.data.data);
        dispatch('utils/hideLoading', {}, { root: true });
      }, function (error) {
        var isForbidden = error && error.response && error.response.status === 403;
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar usuários.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
        if (isForbidden) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
        }
      });
    },
    loadAssignableUsers: function loadAssignableUsers(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      dispatch('utils/showLoading', {}, { root: true });

      requestUsersWithFallback(['/pagamentos/aprovadores', '/users', '/usuarios']).then(function (users) {
        commit('SET_USERS', normalizeUsers(users));
        dispatch('utils/hideLoading', {}, { root: true });
      }).catch(function (error) {
        commit('SET_USERS', []);
        var status = error && error.response ? error.response.status : null;

        dispatch('utils/showSnackbar', {
          type: 'error',
          text: status === 403 ? 'Sem permissão para carregar usuários responsáveis.' : 'Não foi possível carregar a lista de usuários.'
        }, { root: true });
        dispatch('utils/hideLoading', {}, { root: true });
      });
    }
  },
  getters: {
    users: function users(state) {
      return state.users;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (users);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {
  namespaced: true,
  state: {
    isLoading: {
      status: false,
      transparent: false
    },
    snackbar: [],
    coords: {
      latitude: -23.5647577,
      longitude: -46.651849500000026
    },
    isRetrievingCoords: false
  },
  mutations: {
    SET_IS_LOADING: function SET_IS_LOADING(state, payload) {
      state.isLoading.status = payload.status;
      state.isLoading.transparent = payload.transparent ? payload.transparent : false;
    },
    SHOW_SNACKBAR: function SHOW_SNACKBAR(state, payload) {
      state.snackbar.push(payload);
    },
    REMOVE_SNACKBAR: function REMOVE_SNACKBAR(state) {
      state.snackbar.shift();
    },
    EMPTY_SNACKBAR: function EMPTY_SNACKBAR(state) {
      state.snackbar = state.snackbar.filter(function (snackbar) {
        return snackbar.persistent === true;
      });
    },
    SET_COORDS: function SET_COORDS(state, payload) {
      state.coords.latitude = payload.coords.latitude;
      state.coords.longitude = payload.coords.longitude;
    },
    SET_RETRIEVING_COORDS: function SET_RETRIEVING_COORDS(state, payload) {
      state.isRetrievingCoords = payload;
    }
  },
  actions: {
    showLoading: function showLoading(_ref, payload) {
      var commit = _ref.commit;

      if (payload !== undefined) {
        commit('SET_IS_LOADING', { status: true, transparent: payload.transparent });
      } else {
        commit('SET_IS_LOADING', { status: true });
      }
    },
    hideLoading: function hideLoading(_ref2, payload) {
      var commit = _ref2.commit;

      commit('SET_IS_LOADING', { status: false });
    },
    showSnackbar: function showSnackbar(_ref3, payload) {
      var commit = _ref3.commit;

      commit('SHOW_SNACKBAR', payload);
    },
    hideSnackbar: function hideSnackbar(_ref4) {
      var commit = _ref4.commit;

      commit('REMOVE_SNACKBAR');
    },
    emptySnackbar: function emptySnackbar(_ref5) {
      var commit = _ref5.commit;

      commit('EMPTY_SNACKBAR');
    },
    setRetrievingCoords: function setRetrievingCoords(_ref6, payload) {
      var commit = _ref6.commit;

      commit('SET_RETRIEVING_COORDS', payload);
    },
    setCoords: function setCoords(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      if (payload === false) {
        var coordsDefault = {
          coords: {
            latitude: -23.5647577,
            longitude: -46.651849500000026
          }
        };
        commit('SET_COORDS', coordsDefault);
      } else {
        commit('SET_COORDS', payload);
      }
    },
    getCoords: function getCoords(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      var coordsDefault = {
        coords: {
          latitude: -23.5647577,
          longitude: -46.651849500000026
        }
      };
      if (navigator.geolocation) {
        commit('SET_RETRIEVING_COORDS', true);
        dispatch('utils/showLoading', {}, { root: true });
        navigator.geolocation.getCurrentPosition(function (position) {
          var payload = {
            coords: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
          };
          commit('SET_COORDS', payload);
          dispatch('utils/hideLoading', {}, { root: true });
          commit('SET_RETRIEVING_COORDS', false);
        }, function () {
          commit('SET_COORDS', coordsDefault);
          dispatch('utils/hideLoading', {}, { root: true });
          commit('SET_RETRIEVING_COORDS', false);
        });
      } else {
        commit('SET_COORDS', coordsDefault);
      }
    }
  },
  getters: {
    isLoading: function isLoading(state) {
      return state.isLoading;
    },
    snackbar: function snackbar(state) {
      return state.snackbar;
    },
    coords: function coords(state) {
      return state.coords;
    },
    isRetrievingCoords: function isRetrievingCoords(state) {
      return state.isRetrievingCoords;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, exports) {

module.exports = {"AED":{"code":"AED","symbol":"د.إ.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AFN":{"code":"AFN","symbol":"؋","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ALL":{"code":"ALL","symbol":"Lek","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AMD":{"code":"AMD","symbol":"֏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ANG":{"code":"ANG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AOA":{"code":"AOA","symbol":"Kz","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ARS":{"code":"ARS","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AUD":{"code":"AUD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AWG":{"code":"AWG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AZN":{"code":"AZN","symbol":"₼","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BAM":{"code":"BAM","symbol":"КМ","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BBD":{"code":"BBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BDT":{"code":"BDT","symbol":"৳","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"BGN":{"code":"BGN","symbol":"лв.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BHD":{"code":"BHD","symbol":"د.ب.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"BIF":{"code":"BIF","symbol":"FBu","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BMD":{"code":"BMD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BND":{"code":"BND","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BOB":{"code":"BOB","symbol":"Bs","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BRL":{"code":"BRL","symbol":"R$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BSD":{"code":"BSD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTC":{"code":"BTC","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTN":{"code":"BTN","symbol":"Nu.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"BWP":{"code":"BWP","symbol":"P","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BYR":{"code":"BYR","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BZD":{"code":"BZD","symbol":"BZ$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CAD":{"code":"CAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CDF":{"code":"CDF","symbol":"FC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CHF":{"code":"CHF","symbol":"CHF","thousandsSeparator":"'","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CLP":{"code":"CLP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CNY":{"code":"CNY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"COP":{"code":"COP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CRC":{"code":"CRC","symbol":"₡","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUC":{"code":"CUC","symbol":"CUC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUP":{"code":"CUP","symbol":"$MN","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CVE":{"code":"CVE","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CZK":{"code":"CZK","symbol":"Kč","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DJF":{"code":"DJF","symbol":"Fdj","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"DKK":{"code":"DKK","symbol":"kr.","thousandsSeparator":"","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DOP":{"code":"DOP","symbol":"RD$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"DZD":{"code":"DZD","symbol":"د.ج.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"EGP":{"code":"EGP","symbol":"ج.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ERN":{"code":"ERN","symbol":"Nfk","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ETB":{"code":"ETB","symbol":"ETB","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"EUR":{"code":"EUR","symbol":"€","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"FJD":{"code":"FJD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"FKP":{"code":"FKP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GBP":{"code":"GBP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GEL":{"code":"GEL","symbol":"Lari","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"GHS":{"code":"GHS","symbol":"₵","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GIP":{"code":"GIP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GMD":{"code":"GMD","symbol":"D","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GNF":{"code":"GNF","symbol":"FG","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"GTQ":{"code":"GTQ","symbol":"Q","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GYD":{"code":"GYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HKD":{"code":"HKD","symbol":"HK$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HNL":{"code":"HNL","symbol":"L.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HRK":{"code":"HRK","symbol":"kn","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HTG":{"code":"HTG","symbol":"G","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HUF":{"code":"HUF","symbol":"Ft","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IDR":{"code":"IDR","symbol":"Rp","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"ILS":{"code":"ILS","symbol":"₪","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"INR":{"code":"INR","symbol":"₹","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"IQD":{"code":"IQD","symbol":"د.ع.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IRR":{"code":"IRR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":"/","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ISK":{"code":"ISK","symbol":"kr.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"JMD":{"code":"JMD","symbol":"J$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"JOD":{"code":"JOD","symbol":"د.ا.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"JPY":{"code":"JPY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KES":{"code":"KES","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KGS":{"code":"KGS","symbol":"сом","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"KHR":{"code":"KHR","symbol":"៛","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KMF":{"code":"KMF","symbol":"CF","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KPW":{"code":"KPW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KRW":{"code":"KRW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KWD":{"code":"KWD","symbol":"د.ك.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"KYD":{"code":"KYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KZT":{"code":"KZT","symbol":"₸","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LAK":{"code":"LAK","symbol":"₭","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"LBP":{"code":"LBP","symbol":"ل.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"LKR":{"code":"LKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"LRD":{"code":"LRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LSL":{"code":"LSL","symbol":"M","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LYD":{"code":"LYD","symbol":"د.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":3},"MAD":{"code":"MAD","symbol":"د.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MDL":{"code":"MDL","symbol":"lei","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MGA":{"code":"MGA","symbol":"Ar","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"MKD":{"code":"MKD","symbol":"ден.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MMK":{"code":"MMK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MNT":{"code":"MNT","symbol":"₮","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MOP":{"code":"MOP","symbol":"MOP$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MRO":{"code":"MRO","symbol":"UM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MTL":{"code":"MTL","symbol":"₤","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MUR":{"code":"MUR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MVR":{"code":"MVR","symbol":"MVR","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"MWK":{"code":"MWK","symbol":"MK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MXN":{"code":"MXN","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MYR":{"code":"MYR","symbol":"RM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MZN":{"code":"MZN","symbol":"MT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"NAD":{"code":"NAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NGN":{"code":"NGN","symbol":"₦","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NIO":{"code":"NIO","symbol":"C$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NOK":{"code":"NOK","symbol":"kr","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NPR":{"code":"NPR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NZD":{"code":"NZD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"OMR":{"code":"OMR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"PAB":{"code":"PAB","symbol":"B/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PEN":{"code":"PEN","symbol":"S/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PGK":{"code":"PGK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PHP":{"code":"PHP","symbol":"₱","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PKR":{"code":"PKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PLN":{"code":"PLN","symbol":"zł","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PYG":{"code":"PYG","symbol":"₲","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"QAR":{"code":"QAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RON":{"code":"RON","symbol":"lei","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RSD":{"code":"RSD","symbol":"Дин.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RUB":{"code":"RUB","symbol":"₽","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RWF":{"code":"RWF","symbol":"RWF","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SAR":{"code":"SAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SBD":{"code":"SBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SCR":{"code":"SCR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDD":{"code":"SDD","symbol":"LSd","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDG":{"code":"SDG","symbol":"£‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SEK":{"code":"SEK","symbol":"kr","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SGD":{"code":"SGD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SHP":{"code":"SHP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SLL":{"code":"SLL","symbol":"Le","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SOS":{"code":"SOS","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SRD":{"code":"SRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"STD":{"code":"STD","symbol":"Db","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SVC":{"code":"SVC","symbol":"₡","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SYP":{"code":"SYP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SZL":{"code":"SZL","symbol":"E","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"THB":{"code":"THB","symbol":"฿","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TJS":{"code":"TJS","symbol":"TJS","thousandsSeparator":" ","decimalSeparator":";","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TMT":{"code":"TMT","symbol":"m","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"TND":{"code":"TND","symbol":"د.ت.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"TOP":{"code":"TOP","symbol":"T$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TRY":{"code":"TRY","symbol":"TL","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TTD":{"code":"TTD","symbol":"TT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TVD":{"code":"TVD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TWD":{"code":"TWD","symbol":"NT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TZS":{"code":"TZS","symbol":"TSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UAH":{"code":"UAH","symbol":"₴","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UGX":{"code":"UGX","symbol":"USh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"USD":{"code":"USD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UYU":{"code":"UYU","symbol":"$U","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"UZS":{"code":"UZS","symbol":"сўм","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VEB":{"code":"VEB","symbol":"Bs.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"VEF":{"code":"VEF","symbol":"Bs. F.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VND":{"code":"VND","symbol":"₫","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"VUV":{"code":"VUV","symbol":"VT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"WST":{"code":"WST","symbol":"WS$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XAF":{"code":"XAF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XCD":{"code":"XCD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XOF":{"code":"XOF","symbol":"F","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XPF":{"code":"XPF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"YER":{"code":"YER","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ZAR":{"code":"ZAR","symbol":"R","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ZMW":{"code":"ZMW","symbol":"ZK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"WON":{"code":"WON","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2}}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"de-AT":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"el-GR":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"en-IE":{"symbolOnLeft":true,"thousandsSeparator":",","decimalSeparator":".","spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"es-ES":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"it-IT":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl-NL":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl-BE":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2}}

/***/ }),
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 274,
	"./af.js": 274,
	"./ar": 281,
	"./ar-dz": 275,
	"./ar-dz.js": 275,
	"./ar-kw": 276,
	"./ar-kw.js": 276,
	"./ar-ly": 277,
	"./ar-ly.js": 277,
	"./ar-ma": 278,
	"./ar-ma.js": 278,
	"./ar-sa": 279,
	"./ar-sa.js": 279,
	"./ar-tn": 280,
	"./ar-tn.js": 280,
	"./ar.js": 281,
	"./az": 282,
	"./az.js": 282,
	"./be": 283,
	"./be.js": 283,
	"./bg": 284,
	"./bg.js": 284,
	"./bm": 285,
	"./bm.js": 285,
	"./bn": 286,
	"./bn.js": 286,
	"./bo": 287,
	"./bo.js": 287,
	"./br": 288,
	"./br.js": 288,
	"./bs": 289,
	"./bs.js": 289,
	"./ca": 290,
	"./ca.js": 290,
	"./cs": 291,
	"./cs.js": 291,
	"./cv": 292,
	"./cv.js": 292,
	"./cy": 293,
	"./cy.js": 293,
	"./da": 294,
	"./da.js": 294,
	"./de": 297,
	"./de-at": 295,
	"./de-at.js": 295,
	"./de-ch": 296,
	"./de-ch.js": 296,
	"./de.js": 297,
	"./dv": 298,
	"./dv.js": 298,
	"./el": 299,
	"./el.js": 299,
	"./en-au": 300,
	"./en-au.js": 300,
	"./en-ca": 301,
	"./en-ca.js": 301,
	"./en-gb": 302,
	"./en-gb.js": 302,
	"./en-ie": 303,
	"./en-ie.js": 303,
	"./en-il": 304,
	"./en-il.js": 304,
	"./en-nz": 305,
	"./en-nz.js": 305,
	"./eo": 306,
	"./eo.js": 306,
	"./es": 309,
	"./es-do": 307,
	"./es-do.js": 307,
	"./es-us": 308,
	"./es-us.js": 308,
	"./es.js": 309,
	"./et": 310,
	"./et.js": 310,
	"./eu": 311,
	"./eu.js": 311,
	"./fa": 312,
	"./fa.js": 312,
	"./fi": 313,
	"./fi.js": 313,
	"./fo": 314,
	"./fo.js": 314,
	"./fr": 317,
	"./fr-ca": 315,
	"./fr-ca.js": 315,
	"./fr-ch": 316,
	"./fr-ch.js": 316,
	"./fr.js": 317,
	"./fy": 318,
	"./fy.js": 318,
	"./gd": 319,
	"./gd.js": 319,
	"./gl": 320,
	"./gl.js": 320,
	"./gom-latn": 321,
	"./gom-latn.js": 321,
	"./gu": 322,
	"./gu.js": 322,
	"./he": 323,
	"./he.js": 323,
	"./hi": 324,
	"./hi.js": 324,
	"./hr": 325,
	"./hr.js": 325,
	"./hu": 326,
	"./hu.js": 326,
	"./hy-am": 327,
	"./hy-am.js": 327,
	"./id": 328,
	"./id.js": 328,
	"./is": 329,
	"./is.js": 329,
	"./it": 330,
	"./it.js": 330,
	"./ja": 331,
	"./ja.js": 331,
	"./jv": 332,
	"./jv.js": 332,
	"./ka": 333,
	"./ka.js": 333,
	"./kk": 334,
	"./kk.js": 334,
	"./km": 335,
	"./km.js": 335,
	"./kn": 336,
	"./kn.js": 336,
	"./ko": 337,
	"./ko.js": 337,
	"./ky": 338,
	"./ky.js": 338,
	"./lb": 339,
	"./lb.js": 339,
	"./lo": 340,
	"./lo.js": 340,
	"./lt": 341,
	"./lt.js": 341,
	"./lv": 342,
	"./lv.js": 342,
	"./me": 343,
	"./me.js": 343,
	"./mi": 344,
	"./mi.js": 344,
	"./mk": 345,
	"./mk.js": 345,
	"./ml": 346,
	"./ml.js": 346,
	"./mn": 347,
	"./mn.js": 347,
	"./mr": 348,
	"./mr.js": 348,
	"./ms": 350,
	"./ms-my": 349,
	"./ms-my.js": 349,
	"./ms.js": 350,
	"./mt": 351,
	"./mt.js": 351,
	"./my": 352,
	"./my.js": 352,
	"./nb": 353,
	"./nb.js": 353,
	"./ne": 354,
	"./ne.js": 354,
	"./nl": 356,
	"./nl-be": 355,
	"./nl-be.js": 355,
	"./nl.js": 356,
	"./nn": 357,
	"./nn.js": 357,
	"./pa-in": 358,
	"./pa-in.js": 358,
	"./pl": 359,
	"./pl.js": 359,
	"./pt": 361,
	"./pt-br": 360,
	"./pt-br.js": 360,
	"./pt.js": 361,
	"./ro": 362,
	"./ro.js": 362,
	"./ru": 363,
	"./ru.js": 363,
	"./sd": 364,
	"./sd.js": 364,
	"./se": 365,
	"./se.js": 365,
	"./si": 366,
	"./si.js": 366,
	"./sk": 367,
	"./sk.js": 367,
	"./sl": 368,
	"./sl.js": 368,
	"./sq": 369,
	"./sq.js": 369,
	"./sr": 371,
	"./sr-cyrl": 370,
	"./sr-cyrl.js": 370,
	"./sr.js": 371,
	"./ss": 372,
	"./ss.js": 372,
	"./sv": 373,
	"./sv.js": 373,
	"./sw": 374,
	"./sw.js": 374,
	"./ta": 375,
	"./ta.js": 375,
	"./te": 376,
	"./te.js": 376,
	"./tet": 377,
	"./tet.js": 377,
	"./tg": 378,
	"./tg.js": 378,
	"./th": 379,
	"./th.js": 379,
	"./tl-ph": 380,
	"./tl-ph.js": 380,
	"./tlh": 381,
	"./tlh.js": 381,
	"./tr": 382,
	"./tr.js": 382,
	"./tzl": 383,
	"./tzl.js": 383,
	"./tzm": 385,
	"./tzm-latn": 384,
	"./tzm-latn.js": 384,
	"./tzm.js": 385,
	"./ug-cn": 386,
	"./ug-cn.js": 386,
	"./uk": 387,
	"./uk.js": 387,
	"./ur": 388,
	"./ur.js": 388,
	"./uz": 390,
	"./uz-latn": 389,
	"./uz-latn.js": 389,
	"./uz.js": 390,
	"./vi": 391,
	"./vi.js": 391,
	"./x-pseudo": 392,
	"./x-pseudo.js": 392,
	"./yo": 393,
	"./yo.js": 393,
	"./zh-cn": 394,
	"./zh-cn.js": 394,
	"./zh-hk": 395,
	"./zh-hk.js": 395,
	"./zh-tw": 396,
	"./zh-tw.js": 396
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;

/***/ }),
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(753)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(745)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  "data-v-7466dabb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-07f65040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  "data-v-7c3cc488",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-4993cea5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)
__webpack_require__(767)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  "data-v-fa49ac24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)
__webpack_require__(740)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-257abbde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  "data-v-89a2f89e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-20a83356",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(736)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  "data-v-222ec434",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  "data-v-fe406a08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-16753550",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-0ebe5680",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  "data-v-89363196",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(749)
__webpack_require__(750)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-476309f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(743)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  "data-v-34552b44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  "data-v-24afe10f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  "data-v-09740e0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  "data-v-15f5b579",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-224963d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  "data-v-6ec343ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(752)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-638681ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)
__webpack_require__(757)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-7018e04a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-005a106c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(746)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-3f7df45e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(742)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-32565b6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  "data-v-3fe9c59d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  "data-v-dd9e8dee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Configurações")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 configuracoes-form-start",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "border-color": "#F37021",
      "width": "150px",
      "height": "150px",
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "subheading secondary--text mt-2 mb-4",
    staticStyle: {
      "text-transform": "uppercase",
      "width": "100%",
      "float": "left",
      "cursor": "pointer"
    }
  }, [_vm._v("\n                Trocar foto\n                "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.visualizacoes,
      "label": "Modo de visualização padrão",
      "name": "visualizacao",
      "data-vv-as": "visualização padrão",
      "error-messages": _vm.errors.has('visualizacao') ? _vm.errors.first('visualizacao') : []
    },
    model: {
      value: (_vm.form.fields.visualizacao),
      callback: function($$v) {
        _vm.form.fields.visualizacao = $$v
      },
      expression: "form.fields.visualizacao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cargo"
    },
    model: {
      value: (_vm.form.fields.cargo),
      callback: function($$v) {
        _vm.form.fields.cargo = $$v
      },
      expression: "form.fields.cargo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }],
    attrs: {
      "label": "Celular"
    },
    model: {
      value: (_vm.form.fields.celular),
      callback: function($$v) {
        _vm.form.fields.celular = $$v
      },
      expression: "form.fields.celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Login")]), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "email",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = $$v
      },
      expression: "form.fields.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6'),
      expression: "'min:6'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Senha (opcional)",
      "name": "password",
      "data-vv-as": "senha",
      "error-messages": _vm.errors.has('password') ? _vm.errors.first('password') : []
    },
    model: {
      value: (_vm.form.fields.password),
      callback: function($$v) {
        _vm.form.fields.password = $$v
      },
      expression: "form.fields.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6|confirmed:password'),
      expression: "'min:6|confirmed:password'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Confirmar senha",
      "name": "conf_password",
      "data-vv-as": "confirmação de senha",
      "error-messages": _vm.errors.has('conf_password') ? _vm.errors.first('conf_password') : []
    },
    model: {
      value: (_vm.form.fields.conf_password),
      callback: function($$v) {
        _vm.form.fields.conf_password = $$v
      },
      expression: "form.fields.conf_password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text ma-0",
    attrs: {
      "type": "submit",
      "outline": "",
      "block": "",
      "large": "",
      "disabled": _vm.isFormInvalid
    }
  }, [_vm._v("\n                Salvar\n              ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "pt-0",
    staticStyle: {
      "margin-top": "-12px"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.$hasGranularPermission('observacoes', 'view')) ? _c('v-flex', {
    staticClass: "btn-coluna",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "block": "",
      "to": ({
        name: 'ImoveisDetalhesObservacoes',
        params: {
          tipo: _vm.$route.meta.tipo,
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Observações")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? _c('v-flex', {
    staticClass: "btn-coluna",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "block": "",
      "to": ({
        name: 'ImoveisDetalhesAnexos',
        params: {
          tipo: _vm.$route.meta.tipo,
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Anexos")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-speed-dial', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Pagamentos'
      }),
      expression: "{ html: 'Pagamentos' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesPagamentos',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("account_balance_wallet")])], 1) : _vm._e(), _vm._v(" "), (_vm.showVistoriaButton) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Vistoria'
      }),
      expression: "{ html: 'Vistoria' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.substituirVistoria()
      }
    }
  }, [_c('v-icon', [_vm._v("schedule")])], 1) : _vm._e(), _vm._v(" "), (_vm.showTarefasButton) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Tarefas'
      }),
      expression: "{ html: 'Tarefas' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'TarefasLista',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("event_available")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Info'
      }),
      expression: "{ html: 'Info' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesInfo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("info_outline")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Fotos de apresentação'
      }),
      expression: "{ html: 'Fotos de apresentação' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'ilustrativa',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("photo_library")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Endereço'
      }),
      expression: "{ html: 'Endereço' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesEndereco',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("room")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('registro', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Registros / documentos'
      }),
      expression: "{ html: 'Registros / documentos' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesRegistro',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("description")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Área'
      }),
      expression: "{ html: 'Área' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesArea',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("filter_hdr")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'IPTU / impostos / taxas'
      }),
      expression: "{ html: 'IPTU / impostos / taxas' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesTaxas',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("location_city")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Valor'
      }),
      expression: "{ html: 'Valor' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesValor',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("local_atm")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Status'
      }),
      expression: "{ html: 'Status' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesStatus',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Baixar PDF'
      }),
      expression: "{ html: 'Baixar PDF' }",
      arg: "left"
    }],
    staticClass: "secondary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$parent.download()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-file-pdf")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fab),
      expression: "fab"
    }],
    staticClass: "fab-background"
  })]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "620"
    },
    model: {
      value: (_vm.dialogSubstituirVistoria),
      callback: function($$v) {
        _vm.dialogSubstituirVistoria = $$v
      },
      expression: "dialogSubstituirVistoria"
    }
  }, [_c('v-card', {
    staticClass: "botoes_com_padding_menor"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Substituir ou editar vistoria?")]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" A vistoria atual será removida caso você escolha a opção substituir.")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "primary--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogSubstituirVistoria = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "to": ({
        name: 'VistoriaEditar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Editar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "to": ({
        name: 'VistoriaAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Substituir")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Níveis de acesso")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'RolesLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Adicionar nível de acesso")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acessos Gerais")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de usuários")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_usuarios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_usuarios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_usuarios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de níveis de acesso")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_niveis_acesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Visualizar relatórios")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.visualizar_relatorios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.visualizar_relatorios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.visualizar_relatorios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acesso a Imóveis")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis com tarefas/vistorias atribuídas ao usuário (ex: fiscal)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_tarefas),
      callback: function($$v) {
        _vm.form.fields.limitado_tarefas = $$v
      },
      expression: "form.fields.limitado_tarefas"
    }
  })], 1), _vm._v(" "), (!_vm.form.fields.limitado_tarefas) ? _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis de proprietários específicos")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario = $$v
      },
      expression: "form.fields.limitado_proprietario"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.fields.limitado_proprietario) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "items": _vm.proprietarios,
      "label": "Limitado aos imóveis do(s) proprietário(s) selecionado(s)"
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario_lista),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario_lista = $$v
      },
      expression: "form.fields.limitado_proprietario_lista"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "permissions-table-wrap"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Categoria")]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
    return _c('td', {
      key: action.id,
      staticClass: "text-xs-center"
    }, [_vm._v("\n                        " + _vm._s(action.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllAction(action.id)
        }
      }
    }, [_vm._v("Marcar todos")])])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categories), function(category) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v("\n                        " + _vm._s(category.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllCategory(category.id)
        }
      }
    }, [_vm._v("Marcar todos")])])]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
      return _c('td', {
        key: action.id
      }, [_c('v-checkbox', {
        staticClass: "status_checkbox",
        attrs: {
          "color": "secondary",
          "hide-details": ""
        },
        model: {
          value: (_vm.form.fields.permissions[category.id][action.id]),
          callback: function($$v) {
            _vm.$set(_vm.form.fields.permissions[category.id], action.id, $$v)
          },
          expression: "form.fields.permissions[category.id][action.id]"
        }
      })], 1)
    })], 2)
  }))])])])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "860",
      "width": "860",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [(_vm.pagamento) ? _c('v-card', {
    staticClass: "pa-0 dialog-card"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        REGISTRAR PAGAMENTO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5 dialog-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4 mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline verde--text font-weight-medium"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.pagamento.valor)))]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.descricao))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "detalhes-box pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_vencimento)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2 detalhe-direita",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.status ? _vm.pagamento.status.toUpperCase() : '---'))])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "label": "Data do Pagamento",
      "type": "date",
      "required": "",
      "hint": _vm.data_pagamento ? ("Data selecionada: " + (_vm.formatDate(_vm.data_pagamento))) : 'Formato de exibição: dd/mm/aaaa',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.data_pagamento),
      callback: function($$v) {
        _vm.data_pagamento = $$v
      },
      expression: "data_pagamento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "upload-zone text-xs-center pa-4 mt-3",
    class: {
      'has-file': _vm.file
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*,application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (!_vm.file) ? [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "grey lighten-1"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-2"
  }, [_vm._v("Anexar Comprovante")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text lighten-1"
  }, [_vm._v("* Obrigatório (PDF ou Imagem)")])] : [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticClass: "subheading green--text text--darken-1 mt-2 text-truncate",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.fileName) + "\n                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "small": "",
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetFile($event)
      }
    }
  }, [_vm._v("Trocar arquivo")])]], 2)])], 1)], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-cancelar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "verde px-4 font-weight-bold btn-acao-principal btn-registrar",
    attrs: {
      "dark": "",
      "large": "",
      "loading": _vm.loading,
      "disabled": !_vm.file || !_vm.data_pagamento || _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("payment")]), _vm._v(" Registrar\n      ")], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('Loading'), _vm._v(" "), _c('v-toolbar', {
    staticClass: "menu_toolbar white",
    attrs: {
      "fixed": ""
    }
  }, [(!_vm.isMobile) ? [_c('v-toolbar-items', {
    staticClass: "menu_desktop ma-0"
  }, [_c('div', {
    staticClass: "menu_brand text-xs-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('img', {
    staticClass: "menu_brand_logo",
    attrs: {
      "src": "static/logo_menor.png",
      "width": "131",
      "height": "54"
    }
  })])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('v-btn', {
    staticClass: "menu_first_btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("home")]), _vm._v(" Imóveis\n          ")], 1)], 1), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_usuarios')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'UsuariosLista'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("people")]), _vm._v(" Usuários\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_niveis_acesso')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'RolesLista'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Níveis de acesso\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('visualizar_relatorios')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'RelatoriosHistoricoData'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("insert_chart")]), _vm._v(" Relatórios\n          ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UsuariosConfiguracoes'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("settings")]), _vm._v(" Configurações\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "menu_desktop"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$auth.user().avatar
    }
  }), _vm._v(" "), _c('div', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$auth.user().name))])]), _vm._v(" "), (_vm.$auth.user().cargo) ? _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$auth.user().cargo))]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Logout'
      },
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")]), _vm._v(" Sair\n          ")], 1)], 1)], 1)] : [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleLeftNav($event)
      }
    }
  }, [_c('v-icon', [_vm._v("tune")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-brand"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo_menor.png",
      "width": "102",
      "height": "42"
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "mobile-header-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "mobile-user",
    attrs: {
      "ripple": false
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$auth.user().avatar
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$auth.user().name))]), _vm._v(" "), (_vm.$auth.user().cargo) ? _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$auth.user().cargo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Imóveis")])], 1), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_usuarios')) ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'UsuariosLista'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("people")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Usuários")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('administracao_niveis_acesso')) ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'RolesLista'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Níveis de acesso")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGeneralAccess('visualizar_relatorios')) ? _c('v-list-tile', {
    staticClass: "mobile-hide-relatorios",
    attrs: {
      "to": {
        name: 'RelatoriosHistoricoData'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("insert_chart")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Relatórios")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'UsuariosConfiguracoes'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Configurações")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'Logout'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1)], 1)]], 2), _vm._v(" "), _c('TemplateLeftNav', {
    attrs: {
      "mobile": _vm.isMobile,
      "drawer": _vm.leftNavOpen
    },
    on: {
      "update:drawer": _vm.onLeftNavUpdate
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('main', [_c('router-view')], 1)]), _vm._v(" "), _vm._l((_vm.snackbar), function(item, i) {
    return _c('Snackbar', {
      key: i
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'RolesLista'
      })
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Níveis de acesso")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'RolesLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Editar nível de acesso")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acessos Gerais")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de usuários")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_usuarios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_usuarios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_usuarios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administração de níveis de acesso")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.administracao_niveis_acesso = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.administracao_niveis_acesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Visualizar relatórios")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.permissions.acessos_gerais.visualizar_relatorios),
      callback: function($$v) {
        _vm.form.fields.permissions.acessos_gerais.visualizar_relatorios = $$v
      },
      expression: "form.fields.permissions.acessos_gerais.visualizar_relatorios"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h6', [_vm._v("Acesso a Imóveis")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis com tarefas/vistorias atribuídas ao usuário (ex: fiscal)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_tarefas),
      callback: function($$v) {
        _vm.form.fields.limitado_tarefas = $$v
      },
      expression: "form.fields.limitado_tarefas"
    }
  })], 1), _vm._v(" "), (!_vm.form.fields.limitado_tarefas) ? _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Acessar apenas imóveis de proprietários específicos")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario = $$v
      },
      expression: "form.fields.limitado_proprietario"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.fields.limitado_proprietario) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "items": _vm.proprietarios,
      "label": "Limitado aos imóveis do(s) proprietário(s) selecionado(s)"
    },
    model: {
      value: (_vm.form.fields.limitado_proprietario_lista),
      callback: function($$v) {
        _vm.form.fields.limitado_proprietario_lista = $$v
      },
      expression: "form.fields.limitado_proprietario_lista"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "permissions-table-wrap"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Categoria")]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
    return _c('td', {
      key: action.id,
      staticClass: "text-xs-center"
    }, [_vm._v("\n                        " + _vm._s(action.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllAction(action.id)
        }
      }
    }, [_vm._v("Marcar todos")])])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categories), function(category) {
    return _c('tr', {
      key: category.id
    }, [_c('td', [_vm._v("\n                        " + _vm._s(category.name)), _c('br'), _vm._v(" "), _c('small', [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggleAllCategory(category.id)
        }
      }
    }, [_vm._v("Marcar todos")])])]), _vm._v(" "), _vm._l((_vm.actions), function(action) {
      return _c('td', {
        key: action.id
      }, [_c('v-checkbox', {
        staticClass: "status_checkbox",
        attrs: {
          "color": "secondary",
          "hide-details": ""
        },
        model: {
          value: (_vm.form.fields.permissions[category.id][action.id]),
          callback: function($$v) {
            _vm.$set(_vm.form.fields.permissions[category.id], action.id, $$v)
          },
          expression: "form.fields.permissions[category.id][action.id]"
        }
      })], 1)
    })], 2)
  }))])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4 mb-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ma-0",
    attrs: {
      "outline": "",
      "block": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogApagar($event)
      }
    }
  }, [_vm._v("\n                Apagar\n              ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "560"
    },
    model: {
      value: (_vm.dialogApagar),
      callback: function($$v) {
        _vm.dialogApagar = $$v
      },
      expression: "dialogApagar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Apagar nível de acesso?")]), _vm._v(" "), _c('v-card-text', [_vm._v("Usuários vinculados a este nível perderão suas permissões granulares.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogApagar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.apagarRole($event)
      }
    }
  }, [_vm._v("Apagar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Pagamentos")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canViewPagamentos) ? _c('v-flex', {
    staticClass: "pagamentos-content py-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('PagamentosLista', {
    attrs: {
      "imovelId": _vm.$route.params.id
    }
  })], 1) : _c('v-flex', {
    staticClass: "pagamentos-content py-5 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "42",
      "color": "grey lighten-1"
    }
  }, [_vm._v("lock")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-3"
  }, [_vm._v("Você não possui permissão para visualizar pagamentos.")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    ref: "info-window"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.imovel.id
        }
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pb-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "subheading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.infoWindowContentApelido))])]), _vm._v(" "), (_vm.infoWindowContentProprietario.length > 0) ? _c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.infoWindowContentProprietario))]) : _vm._e()]), _vm._v(" "), (_vm.infoWindowContentFoto.length > 0) ? _c('v-card-media', {
    staticClass: "mb-3",
    attrs: {
      "src": _vm.infoWindowContentFoto,
      "height": "170px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0 pb-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v(_vm._s(_vm.infoWindowContentEndereco))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "info-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.infoWindowContentVistoria) ? _c('ListaVistoriaSituacao', {
    attrs: {
      "situacao": _vm.infoWindowContentVistoria
    }
  }) : _c('v-btn', {
    staticClass: "secondary secondary--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [_vm._v("Sem vistoria")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "info-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey grey--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [(_vm.infoWindowContentTarefasPendentes === 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v("1  ")]), _vm._v("tarefa")] : (_vm.infoWindowContentTarefasPendentes > 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.infoWindowContentTarefasPendentes) + "  ")]), _vm._v("tarefas")] : [_vm._v("Sem tarefas")]], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Usuários")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'UsuariosLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Adicionar usuário")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "border-color": "#F37021",
      "width": "150px",
      "height": "150px",
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "subheading secondary--text mt-2 mb-4",
    staticStyle: {
      "text-transform": "uppercase",
      "width": "100%",
      "float": "left",
      "cursor": "pointer"
    }
  }, [_vm._v("\n                Adicionar foto\n                "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cargo"
    },
    model: {
      value: (_vm.form.fields.cargo),
      callback: function($$v) {
        _vm.form.fields.cargo = $$v
      },
      expression: "form.fields.cargo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }],
    attrs: {
      "label": "Celular"
    },
    model: {
      value: (_vm.form.fields.celular),
      callback: function($$v) {
        _vm.form.fields.celular = $$v
      },
      expression: "form.fields.celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Login")]), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "email",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = $$v
      },
      expression: "form.fields.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Senha",
      "name": "password",
      "data-vv-as": "senha",
      "error-messages": _vm.errors.has('password') ? _vm.errors.first('password') : []
    },
    model: {
      value: (_vm.form.fields.password),
      callback: function($$v) {
        _vm.form.fields.password = $$v
      },
      expression: "form.fields.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6|confirmed:password'),
      expression: "'min:6|confirmed:password'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Confirmar senha",
      "name": "conf_password",
      "data-vv-as": "confirmação de senha",
      "error-messages": _vm.errors.has('conf_password') ? _vm.errors.first('conf_password') : []
    },
    model: {
      value: (_vm.form.fields.conf_password),
      callback: function($$v) {
        _vm.form.fields.conf_password = $$v
      },
      expression: "form.fields.conf_password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.customRoles,
      "item-text": "name",
      "item-value": "id",
      "label": "Nível de acesso",
      "clearable": ""
    },
    model: {
      value: (_vm.form.fields.custom_role_id),
      callback: function($$v) {
        _vm.form.fields.custom_role_id = $$v
      },
      expression: "form.fields.custom_role_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Usuário "), (_vm.form.fields.bloqueado) ? _c('span', [_vm._v("bloqueado")]) : _c('span', [_vm._v("desbloqueado")])]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.bloqueado),
      callback: function($$v) {
        _vm.form.fields.bloqueado = $$v
      },
      expression: "form.fields.bloqueado"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "960",
      "width": "960",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [_c('v-card', {
    staticClass: "pa-0 dialog-card"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        NOVA SOLICITAÇÃO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5 dialog-body"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "form-grid",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-4 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline primary--text font-weight-medium"
  }, [_vm._v("Solicitar Pagamento")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text text--darken-1 mt-1"
  }, [_vm._v("Preencha os dados e anexe o boleto.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resumo-box"
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    staticClass: "subheading mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.form.descricao || 'Sem descrição'))])]), _vm._v(" "), _c('div', {
    staticClass: "title secondary--text mt-1"
  }, [_vm._v(_vm._s(_vm.valorPreview))]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text text--darken-1 mt-1"
  }, [_vm._v("\n                  Vencimento: " + _vm._s(_vm.form.data_vencimento ? _vm.formatDate(_vm.form.data_vencimento) : '--') + "\n                ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "label": "Descrição",
      "placeholder": "Ex: Manutenção Elétrica",
      "name": "descricao",
      "data-vv-as": "descrição",
      "error-messages": _vm.errors.has('descricao') ? _vm.errors.first('descricao') : []
    },
    model: {
      value: (_vm.form.descricao),
      callback: function($$v) {
        _vm.form.descricao = $$v
      },
      expression: "form.descricao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "name": "valor",
      "data-vv-as": "valor",
      "placeholder": "Ex.: 1.250,90",
      "single-line": "",
      "hint": "Formato: 1.250,90",
      "persistent-hint": false,
      "error-messages": _vm.errors.has('valor') ? _vm.errors.first('valor') : []
    },
    on: {
      "input": _vm.onValorInput
    },
    model: {
      value: (_vm.form.valor),
      callback: function($$v) {
        _vm.form.valor = $$v
      },
      expression: "form.valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "name": "data_vencimento",
      "data-vv-as": "vencimento",
      "single-line": "",
      "hint": _vm.form.data_vencimento ? ("Data selecionada: " + (_vm.formatDate(_vm.form.data_vencimento))) : 'Formato de exibição: dd/mm/aaaa',
      "persistent-hint": false,
      "error-messages": _vm.errors.has('data_vencimento') ? _vm.errors.first('data_vencimento') : []
    },
    model: {
      value: (_vm.form.data_vencimento),
      callback: function($$v) {
        _vm.form.data_vencimento = $$v
      },
      expression: "form.data_vencimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "premium-input",
    attrs: {
      "items": _vm.users,
      "item-text": "name",
      "item-value": "id",
      "label": "Aprovador Responsável",
      "name": "aprovador",
      "data-vv-as": "aprovador",
      "error-messages": _vm.errors.has('aprovador') ? _vm.errors.first('aprovador') : []
    },
    model: {
      value: (_vm.form.aprovador_id),
      callback: function($$v) {
        _vm.form.aprovador_id = $$v
      },
      expression: "form.aprovador_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "upload-zone text-xs-center pa-4 mt-2",
    class: {
      'has-file': _vm.file
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*,application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (!_vm.file) ? [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "grey lighten-1"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-2"
  }, [_vm._v("Anexar Boleto")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text lighten-1"
  }, [_vm._v("PDF ou Imagem (Máx 5MB)")])] : [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticClass: "subheading green--text text--darken-1 mt-2 text-truncate",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.fileName) + "\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "small": "",
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetFile($event)
      }
    }
  }, [_vm._v("Trocar arquivo")])]], 2)])], 1)], 1)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-cancelar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4 font-weight-bold btn-confirmar",
    attrs: {
      "depressed": "",
      "large": "",
      "color": "secondary",
      "disabled": _vm.isFormInvalid,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Solicitar Aprovação\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    class: _vm.transparent,
    attrs: {
      "id": "loading"
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('Loading'), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "sm8": "",
      "lg4": "",
      "offset-sm2": "",
      "offset-lg4": ""
    }
  }, [_c('div', {
    staticClass: "mb-5"
  }, [_c('img', {
    staticStyle: {
      "max-width": "40%"
    },
    attrs: {
      "src": "static/logo.png"
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "mt-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "e-mail",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "form.fields.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    attrs: {
      "label": "Senha",
      "name": "password",
      "type": "password",
      "data-vv-as": "senha",
      "error-messages": _vm.errors.has('password') ? _vm.errors.first('password') : []
    },
    model: {
      value: (_vm.form.fields.password),
      callback: function($$v) {
        _vm.form.fields.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "form.fields.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text ma-0",
    attrs: {
      "type": "submit",
      "outline": "",
      "block": "",
      "large": "",
      "disabled": _vm.isFormInvalid
    }
  }, [_vm._v("\n                Entrar\n              ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.dialogRecuperarSenha),
      callback: function($$v) {
        _vm.dialogRecuperarSenha = $$v
      },
      expression: "dialogRecuperarSenha"
    }
  }, [_c('p', {
    staticClass: "primary--text",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Esqueci a senha")]), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRecuperarSenha = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Esqueci a senha")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-4 px-4 text-xs-center"
  }, [_c('p', {
    staticClass: "secondary--text mb-4"
  }, [_vm._v("Uma mensagem será enviada para o e-mail cadastrado.")]), _vm._v(" "), _c('form', {
    staticClass: "mt-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitRecuperarSenha($event)
      }
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "e-mail",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = $$v
      },
      expression: "form.fields.email"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "type": "submit",
      "outline": "",
      "large": ""
    }
  }, [_vm._v("\n                      Recuperar senha\n                    ")])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.snackbar), function(item, i) {
    return _c('Snackbar', {
      key: i
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "760",
      "width": "760",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [(_vm.pagamento) ? _c('v-card', {
    staticClass: "pa-0"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        AVALIAR PAGAMENTO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4 mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline primary--text font-weight-medium"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.pagamento.valor)))]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.descricao))])]), _vm._v(" "), _c('span', {
    staticClass: "status-tag mt-2",
    style: ({
      'background-color': _vm.getStatusColor(_vm.pagamento.status)
    })
  }, [_vm._v("\n            " + _vm._s(_vm.formatStatus(_vm.pagamento.status)) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "detalhes-box pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_vencimento)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2 detalhe-direita",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Solicitado por")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.solicitante ? _vm.pagamento.solicitante.name : '---'))])])]), _vm._v(" "), (_vm.pagamento.data_pagamento) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Pago em")]), _vm._v(" "), _c('div', {
    staticClass: "body-2 verde--text text--darken-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_pagamento)))])])]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-rejeitar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "red",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.confirmar('rejeitar')
      }
    }
  }, [_vm._v("\n        Rejeitar\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-5 font-weight-bold btn-acao-principal btn-autorizar",
    attrs: {
      "dark": "",
      "large": "",
      "color": "secondary",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.confirmar('autorizar')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" Autorizar\n      ")], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Agendar tarefa")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogTarefasTipos),
      callback: function($$v) {
        _vm.dialogTarefasTipos = $$v
      },
      expression: "dialogTarefasTipos"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogTarefasTipos),
      expression: "!dialogTarefasTipos"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Tipo de tarefa",
      "name": "tipo",
      "data-vv-as": "tipo",
      "error-messages": _vm.errors.has('tipo') ? _vm.errors.first('tipo') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "event_available",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTarefasTipos = false
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Tarefa")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTarefasTipos = false
      }
    }
  }, [_vm._v("Concluir")])], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.tarefaTipo), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectTarefa(item)
        }
      }
    }, [_c('v-list-tile-action', [(index === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item))])], 1), _vm._v(" "), (_vm.form.fields.tipo === item) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [(_vm.tarefaTipo.length === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-text-field', {
    staticClass: "tarefa_personalizada",
    attrs: {
      "label": "Personalizada",
      "single-line": "",
      "full-width": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tipoTarefaPersonalizada),
      callback: function($$v) {
        _vm.tipoTarefaPersonalizada = $$v
      },
      expression: "tipoTarefaPersonalizada"
    }
  })], 1), _vm._v(" "), (_vm.tipoTarefaPersonalizada.length > 0 && _vm.tipoTarefaPersonalizada === _vm.form.fields.tipo) ? _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("done")])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px",
      "nudge-top": 140
    },
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_c('v-text-field', {
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Adicionar data",
      "name": "data",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.data_formatada),
      callback: function($$v) {
        _vm.form.fields.data_formatada = $$v
      },
      expression: "form.fields.data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "allowed-dates": _vm.datasPermitidas,
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.data),
      callback: function($$v) {
        _vm.form.fields.data = $$v
      },
      expression: "form.fields.data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogUsuarios),
      callback: function($$v) {
        _vm.dialogUsuarios = $$v
      },
      expression: "dialogUsuarios"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar usuário",
      "name": "usuario",
      "data-vv-as": "usuário",
      "error-messages": _vm.errors.has('usuario') ? _vm.errors.first('usuario') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "person",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.user_name),
      callback: function($$v) {
        _vm.form.fields.user_name = $$v
      },
      expression: "form.fields.user_name"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogUsuarios = false
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Usuário")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.users), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(item.id)
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1), _vm._v(" "), (item.id === _vm.form.fields.user_id) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-pagamentos-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "px-5 pb-5 pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Filtros")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.periodoItems,
      "item-text": "text",
      "item-value": "value",
      "label": "Período",
      "single-line": ""
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1), _vm._v(" "), (_vm.periodo === 'custom') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "offset-y": "",
      "close-on-content-click": false,
      "bottom": ""
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "value": ("De " + (_vm.formatDate(_vm.dataInicial)) + " até " + (_vm.formatDate(_vm.dataFinal))),
      "label": "Período customizado",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "label": "Data inicial"
    },
    on: {
      "input": _vm.onCustomDateInput
    },
    model: {
      value: (_vm.dataInicial),
      callback: function($$v) {
        _vm.dataInicial = $$v
      },
      expression: "dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "label": "Data final"
    },
    on: {
      "input": _vm.onCustomDateInput
    },
    model: {
      value: (_vm.dataFinal),
      callback: function($$v) {
        _vm.dataFinal = $$v
      },
      expression: "dataFinal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "grey darken-1"
    },
    on: {
      "click": function($event) {
        _vm.dateMenu = false
      }
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "disabled": !_vm.isCustomDateRangeValid
    },
    on: {
      "click": _vm.applyCustomDateRange
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    staticClass: "filtro-imovel",
    attrs: {
      "items": _vm.imovelItems,
      "item-text": "text",
      "item-value": "value",
      "label": "Imóvel",
      "autocomplete": "",
      "no-data-text": "Nenhum imóvel encontrado",
      "filter": _vm.imovelFilter,
      "clearable": "",
      "loading": _vm.imoveisLoading
    },
    on: {
      "input": _vm.onImovelInput,
      "change": _vm.onImovelInput
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "filtro-imovel-selecao-title"
        }, [_vm._v(_vm._s(data.item.text))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-content', {
          staticClass: "filtro-imovel-opcao-wrap"
        }, [_c('v-list-tile-title', {
          staticClass: "filtro-imovel-opcao-title"
        }, [_vm._v("\n                      " + _vm._s(data.item.text) + "\n                    ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.selectedImovelId),
      callback: function($$v) {
        _vm.selectedImovelId = $$v
      },
      expression: "selectedImovelId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": "Status",
      "multiple": "",
      "chips": "",
      "clearable": ""
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "dark": "",
      "disabled": _vm.itens.length < 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.download('pdf')
      }
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "dark": "",
      "disabled": _vm.itens.length < 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.download('excel')
      }
    }
  }, [_vm._v("Excel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Período aplicado")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.periodoTitulo))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Total de despesas")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.resumo.total || 0))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Valor total")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.resumo.valor_total || 0)))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "subheading mb-3"
  }, [_c('strong', [_vm._v("Resumo por status")])]), _vm._v(" "), (_vm.statusRows.length < 1) ? _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Sem dados para o período selecionado.")]) : _c('table', {
    staticClass: "resumo-status-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusRows), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(item.valor_total)))])])
  }))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "subheading mb-3"
  }, [_c('strong', [_vm._v("Itens")])]), _vm._v(" "), (_vm.itens.length < 1) ? _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Nenhum pagamento encontrado para os filtros aplicados.")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "itens-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Data ref.")]), _vm._v(" "), _c('th', [_vm._v("Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Pagamento")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Imóvel")]), _vm._v(" "), _c('th', [_vm._v("Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Aprovador")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_referencia)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_pagamento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatStatus(item.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descricao || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.imovel ? item.imovel.apelido : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitante ? item.solicitante.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aprovador ? item.aprovador.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(item.valor)))])])
  }))])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension imoveis-toolbar",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo titulo-imoveis"
  }, [_vm._v("Imóveis")]), _vm._v(" "), _c('div', {
    staticClass: "opcoes_lista_mapa opcoes_lista_mapa_mobile"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisLista'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("list")]), _vm._v(" Lista\n        ")], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisMapa'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("room")]), _vm._v(" Mapa\n        ")], 1)], 1)], 1)]), _vm._v(" "), _c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 142px)"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.currentZoom,
      "options": {
        clickableIcons: false,
        streetViewControl: false,
        fullscreenControl: false,
        minZoom: 7,
        maxZoom: 17,
        zoomControlOptions: {
          position: _vm.zoomPosition
        }
      }
    },
    on: {
      "bounds_changed": function($event) {
        _vm.updateBounds($event)
      },
      "zoom_changed": function($event) {
        _vm.updateZoom($event)
      },
      "idle": _vm.idleLoadImoveis
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.coords.latitude,
        lng: _vm.coords.longitude
      },
      "clickable": false,
      "icon": _vm.currentLocationIcon
    }
  }), _vm._v(" "), _vm._l((_vm.imoveis), function(item, index) {
    return (item.endereco !== undefined) ? _c('gmap-marker', {
      key: item.id,
      ref: 'marker' + item.id,
      refInFor: true,
      attrs: {
        "position": {
          lat: item.endereco.data.latitude,
          lng: item.endereco.data.longitude
        },
        "icon": _vm.getIcon(item),
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.clickMarker(item)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.infoWindowOpened) ? _c('mapa-info-window', {
    key: _vm.infoWindowImovel.id,
    attrs: {
      "marker": _vm.infoWindowMarker,
      "imovel": _vm.infoWindowImovel,
      "is-open": _vm.infoWindowOpened
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "mapa_botoes",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "scale-transition"
    }
  }, [(_vm.legenda) ? _c('v-flex', {
    staticClass: "mb-2 legenda-card-col",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "subheading secondary--text uppercase text-xs-center mb-4"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right legenda_cores"
  }, [_c('div', [_vm._v("Sem status "), _c('span', {
    staticClass: "legenda_cor",
    style: ({
      'background-color': _vm.colors.undefined
    })
  })]), _vm._v(" "), _vm._l((_vm.colors), function(item, index) {
    return (index !== 'undefined') ? _c('div', {
      key: index,
      staticClass: "my-3"
    }, [_vm._v(_vm._s(index) + " "), _c('span', {
      staticClass: "legenda_cor",
      style: ({
        'background-color': item
      })
    })]) : _vm._e()
  })], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "legenda-btn-col",
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white secondary--text legenda-btn",
    attrs: {
      "large": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.legenda = !_vm.legenda
      }
    }
  }, [_vm._v("Legenda")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'UsuariosLista'
      })
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Níveis de acesso")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.roles), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "to": {
          name: 'RolesEditar',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [(item.limitado_tarefas) ? _c('span', [_vm._v("Limitado por tarefas")]) : _vm._e(), _vm._v(" "), (item.limitado_proprietario) ? _c('span', [_vm._v(" | Limitado por proprietário")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'RolesAdicionar'
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension imoveis-toolbar",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo titulo-imoveis"
  }, [_vm._v("Imóveis")]), _vm._v(" "), _c('div', {
    staticClass: "opcoes_lista_mapa opcoes_lista_mapa_mobile"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisLista'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("list")]), _vm._v(" Lista\n        ")], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisMapa'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("room")]), _vm._v(" Mapa\n        ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": ""
    },
    on: {
      "input": _vm.changeTab
    }
  }, [_c('v-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, [_c('v-tabs-slider', {
    staticClass: "secondary"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "href": '#' + tab.id
      }
    }, [_vm._v(_vm._s(tab.title))])
  })], 2), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return _c('v-tabs-content', {
      key: i,
      attrs: {
        "lazy": "",
        "id": tab.id
      }
    }, [(Object.keys(_vm.filtros).length > 0) ? _c('div', {
      staticClass: "pt-2"
    }, [_c('v-subheader', {
      staticClass: "text-xs-left",
      staticStyle: {
        "margin": "0",
        "margin-top": "9px"
      }
    }, [(!_vm.filtros.hasOwnProperty('locado_indice')) ? [(_vm.paginacao.total === 0) ? [_vm._v("\n              Nenhum resultado encontrado\n            ")] : (_vm.paginacao.total === 1) ? [_vm._v("\n              1 resultado\n            ")] : [_vm._v("\n              " + _vm._s(_vm.paginacao.total) + " resultados\n            ")]] : [_vm._v("\n            " + _vm._s(_vm.imoveis.length) + " resultado(s)\n          ")]], 2)], 1) : (Object.keys(_vm.filtros).length === 0 && _vm.paginacao.total > 0) ? _c('div', {
      staticClass: "text-xs-center grey--text text--darken-1 pt-2 mt-3"
    }, [(_vm.paginacao.total === 1) ? [_vm._v("\n          1 imóvel\n        ")] : [_vm._v("\n          " + _vm._s(String(_vm.paginacao.total).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')) + " imóveis\n        ")]], 2) : _vm._e(), _vm._v(" "), (tab.id === _vm.tabAtiva) ? _vm._l((_vm.imoveis), function(item, index) {
      return _c('ListaImovel', {
        key: index,
        attrs: {
          "flat": index === 0,
          "imovel": item,
          "exibirStatus": true
        }
      })
    }) : _vm._e()], 2)
  })], 2), _vm._v(" "), (_vm.imoveis.length > 0 && _vm.$auth.check(['Administrador', 'Patrimônio'])) ? _c('v-speed-dial', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    model: {
      value: (_vm.fabSave),
      callback: function($$v) {
        _vm.fabSave = $$v
      },
      expression: "fabSave"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fabSave),
      callback: function($$v) {
        _vm.fabSave = $$v
      },
      expression: "fabSave"
    }
  }, [_c('v-icon', [_vm._v("save")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'PDF'
      }),
      expression: "{ html: 'PDF' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadLista('pdf')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-file-pdf")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Excel'
      }),
      expression: "{ html: 'Excel' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadLista('excel')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-file-excel")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.paginacao !== undefined && _vm.paginacao.current_page < _vm.paginacao.total_pages) ? _c('div', {
    staticClass: "secondary--text text-xs-center subheading my-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.loadImoveis(_vm.paginacao.current_page + 1)
      }
    }
  }, [_vm._v("CARREGAR MAIS")])]) : _vm._e(), _vm._v(" "), (_vm.paginacao.total === 0 && !_vm.filtros.hasOwnProperty('locado_indice')) ? _c('div', {
    staticClass: "subheading text-xs-center pt-5 pb-5 px-4"
  }, [_vm._v("Sua busca não gerou nenhum resultado, tente uma nova busca.")]) : (_vm.imoveis.length === 0 && _vm.filtros.hasOwnProperty('locado_indice')) ? _c('div', {
    staticClass: "subheading text-xs-center pt-5 pb-5 px-4"
  }, [_vm._v("Sua busca não gerou nenhum resultado, tente uma nova busca.")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Sem permissão")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("Você não tem acesso a esta área.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_vm._v("Voltar para Imóveis")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Agendar vistoria")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$hasGranularPermission('vistoria', 'add')) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px",
      "nudge-top": 80
    },
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Adicionar data",
      "name": "data",
      "data-vv-as": "data",
      "error-messages": _vm.errors.has('data') ? _vm.errors.first('data') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.data_formatada),
      callback: function($$v) {
        _vm.form.fields.data_formatada = $$v
      },
      expression: "form.fields.data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "allowed-dates": _vm.datasPermitidas,
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.data),
      callback: function($$v) {
        _vm.form.fields.data = $$v
      },
      expression: "form.fields.data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogRecorrencia),
      callback: function($$v) {
        _vm.dialogRecorrencia = $$v
      },
      expression: "dialogRecorrencia"
    }
  }, [_c('v-text-field', {
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar recorrência",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "loop",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.recorrencia_formatada),
      callback: function($$v) {
        _vm.form.fields.recorrencia_formatada = $$v
      },
      expression: "form.fields.recorrencia_formatada"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Selecionar recorrência")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": "",
      "label": _vm.recorrenciaToString
    },
    model: {
      value: (_vm.form.fields.recorrencia),
      callback: function($$v) {
        _vm.form.fields.recorrencia = $$v
      },
      expression: "form.fields.recorrencia"
    }
  })], 1), _vm._v(" "), (_vm.form.fields.recorrencia) ? _c('div', {
    staticClass: "mt-4",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.recorrencia,
          min_value: 1
        }
      }),
      expression: "{ rules: { required: form.fields.recorrencia, min_value: 1 } }"
    }],
    attrs: {
      "auto": "",
      "label": "Repetir a cada",
      "name": "recorrencia_cada",
      "data-vv-as": "repetir a cada",
      "error-messages": _vm.errors.has('recorrencia_cada') ? _vm.errors.first('recorrencia_cada') : [],
      "items": _vm.form.recorrenciaCada
    },
    model: {
      value: (_vm.form.fields.recorrencia_cada),
      callback: function($$v) {
        _vm.form.fields.recorrencia_cada = $$v
      },
      expression: "form.fields.recorrencia_cada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.recorrencia
        }
      }),
      expression: "{ rules: { required: form.fields.recorrencia } }"
    }],
    attrs: {
      "auto": "",
      "items": _vm.form.recorrenciaPeriodos,
      "label": "Período",
      "data-vv-as": "período",
      "name": "recorrencia_periodo",
      "error-messages": _vm.errors.has('recorrencia_periodo') ? _vm.errors.first('recorrencia_periodo') : []
    },
    model: {
      value: (_vm.form.fields.recorrencia_periodo),
      callback: function($$v) {
        _vm.form.fields.recorrencia_periodo = $$v
      },
      expression: "form.fields.recorrencia_periodo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRecorrencia = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogUsuarios),
      callback: function($$v) {
        _vm.dialogUsuarios = $$v
      },
      expression: "dialogUsuarios"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar usuário",
      "name": "usuario",
      "data-vv-as": "usuário",
      "error-messages": _vm.errors.has('usuario') ? _vm.errors.first('usuario') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "person",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.user_name),
      callback: function($$v) {
        _vm.form.fields.user_name = $$v
      },
      expression: "form.fields.user_name"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Usuário")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.users), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(item.id)
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1), _vm._v(" "), (item.id === _vm.form.fields.user_id) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Observações",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "assignment"
    },
    model: {
      value: (_vm.form.fields.observacoes),
      callback: function($$v) {
        _vm.form.fields.observacoes = $$v
      },
      expression: "form.fields.observacoes"
    }
  }), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-historico-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "equal-heights pa-5 historico-layout",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.por === 'data') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('ul', {
    staticClass: "opcoes"
  }, [_c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'recentes'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('recentes')
      }
    }
  }, [_c('strong', [_vm._v("mais recentes")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'dia'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('dia')
      }
    }
  }, [_c('strong', [_vm._v("dia")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'semana'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('semana')
      }
    }
  }, [_c('strong', [_vm._v("semana")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'mes'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('mes')
      }
    }
  }, [_c('strong', [_vm._v("mês")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'semestre'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('semestre')
      }
    }
  }, [_c('strong', [_vm._v("semestre")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'ano'
    },
    on: {
      "click": function($event) {
        _vm.changePeriodo('ano')
      }
    }
  }, [_c('strong', [_vm._v("ano")])]), _vm._v(" "), _c('li', {
    class: {
      'ativo': _vm.periodoSelecionado === 'custom'
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "offset-y": "",
      "close-on-content-click": false,
      "bottom": ""
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("por período")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('DateRange', {
    attrs: {
      "options": _vm.dateRangeOptions,
      "no-presets": ""
    },
    on: {
      "input": _vm.onDateRangeChange
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePeriodoCustom($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)])]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('ul', {
    staticClass: "opcoes"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      class: {
        'ativo': _vm.userSelecionado === user.id
      },
      on: {
        "click": function($event) {
          _vm.changeUserSelecionado(user.id)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(user.name))])])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-3 px-4 py-3 historico-card",
    staticStyle: {
      "min-height": "70vh"
    }
  }, [(_vm.paginacao.total > 0) ? _c('v-card-text', [_vm._l((_vm.historico), function(dia, index) {
    return _c('div', {
      staticClass: "alteracao"
    }, [_c('p', {
      staticClass: "data alteracao-data"
    }, [_vm._v(_vm._s(_vm.formatData(index)))]), _vm._v(" "), _vm._l((dia), function(alteracoes) {
      return _c('div', {
        staticClass: "alteracao-imovel"
      }, [_c('div', {
        staticClass: "alteracao-imovel-apelido"
      }, [(alteracoes[0]['apelido']) ? _c('strong', [_vm._v(_vm._s(alteracoes[0]['apelido']))]) : _vm._e(), _vm._v(" "), (alteracoes[0]['endereco']) ? [_vm._v("\n                       " + _vm._s(_vm.formatEndereco(alteracoes[0]['endereco'])) + "\n                  ")] : _vm._e()], 2), _vm._v(" "), _vm._l((alteracoes), function(alteracao) {
        return _c('div', {
          staticClass: "alteracao-tipo"
        }, [(alteracao['event'] === 'created') ? [(_vm.formatType(alteracao['auditable_type']) === 'Imóvel') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Imóvel criado às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])])] : [_c('span', {
          staticClass: "data"
        }, [_vm._v("Criação de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['new_values']), function(new_value, new_value_index) {
          return (new_value !== '' && new_value !== null) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.formatColunaName(new_value_index)) + ":\n                        "), _c('strong', {
            staticClass: "valor-novo"
          }, [_vm._v(_vm._s(_vm.formatValue(alteracao['new_values'][new_value_index], new_value_index)))])]) : _vm._e()
        })]] : _vm._e(), _vm._v(" "), (alteracao['event'] === 'deleted') ? [(_vm.formatType(alteracao['auditable_type']) === 'Imóvel') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Imóvel removido às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])])] : [_c('span', {
          staticClass: "data"
        }, [_vm._v("Remoção de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['old_values']), function(old_value, old_value_index) {
          return _c('div', [_vm._v("\n                        " + _vm._s(_vm.formatColunaName(old_value_index)) + ":\n                        "), _c('strong', {
            staticClass: "valor-antigo"
          }, [_vm._v(_vm._s(_vm.formatValue(old_value, old_value_index)))])])
        })]] : (alteracao['event'] === 'updated') ? [_c('span', {
          staticClass: "data"
        }, [_vm._v("Alteração de " + _vm._s(_vm.formatType(alteracao['auditable_type'])) + " às " + _vm._s(_vm.formatHora(alteracao['created_at'])) + " por "), _c('em', [_vm._v(_vm._s(alteracao['user']['name']))])]), _vm._v(" "), _vm._l((alteracao['old_values']), function(old_value, old_value_index) {
          return _c('div', [_vm._v("\n                      " + _vm._s(_vm.formatColunaName(old_value_index)) + ":\n                      "), _c('strong', {
            staticClass: "valor-novo"
          }, [_vm._v(_vm._s(_vm.formatValue(alteracao['new_values'][old_value_index], old_value_index)))]), _vm._v(" "), (alteracao['new_values'][old_value_index] !== '' && alteracao['new_values'][old_value_index] !== null && old_value !== '' && old_value !== null) ? _c('span', [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('strong', {
            staticClass: "valor-antigo"
          }, [_vm._v(_vm._s(_vm.formatValue(old_value, old_value_index)))])])
        })] : _vm._e()], 2)
      })], 2)
    })], 2)
  }), _vm._v(" "), (_vm.paginacao !== undefined && _vm.paginacao.current_page < _vm.paginacao.total_pages) ? _c('div', {
    staticClass: "secondary--text text-xs-center subheading my-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.loadHistorico(_vm.paginacao.current_page + 1)
      }
    }
  }, [_vm._v("CARREGAR MAIS")])]) : _vm._e()], 2) : _c('v-card-text', [_c('div', {
    staticClass: "subheading text-xs-center pt-5"
  }, [_vm._v("Nenhum resultado encontrado. Experimente remover os filtros de imóveis.")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "readonly": "",
      "prepend-icon": _vm.icon,
      "single-line": "",
      "label": _vm.label,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-list', [_c('v-subheader', [_vm._v("Escolher uma ação")]), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.androidCamera
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("photo_camera")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Câmera")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.androidLibrary
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("photo_library")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Biblioteca de Fotos")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-icon', {
    attrs: {
      "large": _vm.large
    }
  }, [_vm._v("mdi-" + _vm._s(_vm.icon))])
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Adicionar imóvel")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autofocus": "",
      "autocomplete": "off",
      "label": "Nome do imóvel",
      "name": "apelido",
      "data-vv-as": "nome do imóvel",
      "error-messages": _vm.errors.has('apelido') ? _vm.errors.first('apelido') : []
    },
    model: {
      value: (_vm.form.fields.apelido),
      callback: function($$v) {
        _vm.form.fields.apelido = $$v
      },
      expression: "form.fields.apelido"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.proprietarios,
      "label": "Dono do imóvel"
    },
    model: {
      value: (_vm.form.fields.proprietarioSelect),
      callback: function($$v) {
        _vm.form.fields.proprietarioSelect = $$v
      },
      expression: "form.fields.proprietarioSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.proprietarioSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Nome do proprietário"
    },
    model: {
      value: (_vm.form.fields.proprietario),
      callback: function($$v) {
        _vm.form.fields.proprietario = $$v
      },
      expression: "form.fields.proprietario"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tipos,
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipoSelect),
      callback: function($$v) {
        _vm.form.fields.tipoSelect = $$v
      },
      expression: "form.fields.tipoSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.tipoSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.form.fields.savoynet.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, _vm._l((_vm.form.fields.savoynet), function(item, index) {
    return _c('v-chip', {
      key: ("savoynet-" + item + "-" + index),
      staticClass: "mr-2 mb-2",
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          _vm.removeSavoyNet(index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "SavoyNet",
      "hint": "Use Enter, vírgula, ponto e vírgula ou nova linha.",
      "persistent-hint": ""
    },
    on: {
      "keydown": _vm.onSavoyNetKeydown,
      "input": _vm.onSavoyNetInput,
      "blur": _vm.commitSavoyNetInput,
      "paste": _vm.onSavoyNetPaste
    },
    model: {
      value: (_vm.savoynetInput),
      callback: function($$v) {
        _vm.savoynetInput = $$v
      },
      expression: "savoynetInput"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text ma-0",
    attrs: {
      "type": "submit",
      "outline": "",
      "block": "",
      "large": "",
      "disabled": _vm.isFormInvalid
    }
  }, [_vm._v("\n                Criar\n              ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Usuários")])]), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.users), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "to": {
          name: 'UsuariosEditar',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda usuario-avatar"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'UsuariosAdicionar'
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Agendar vistoria")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$hasGranularPermission('vistoria', 'edit')) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px",
      "nudge-top": 80
    },
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Adicionar data",
      "name": "data",
      "data-vv-as": "data",
      "error-messages": _vm.errors.has('data') ? _vm.errors.first('data') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.data_formatada),
      callback: function($$v) {
        _vm.form.fields.data_formatada = $$v
      },
      expression: "form.fields.data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "allowed-dates": _vm.datasPermitidas,
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.data),
      callback: function($$v) {
        _vm.form.fields.data = $$v
      },
      expression: "form.fields.data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogRecorrencia),
      callback: function($$v) {
        _vm.dialogRecorrencia = $$v
      },
      expression: "dialogRecorrencia"
    }
  }, [_c('v-text-field', {
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar recorrência",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "loop",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.recorrencia_formatada),
      callback: function($$v) {
        _vm.form.fields.recorrencia_formatada = $$v
      },
      expression: "form.fields.recorrencia_formatada"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Selecionar recorrência")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": "",
      "label": _vm.recorrenciaToString
    },
    model: {
      value: (_vm.form.fields.recorrencia),
      callback: function($$v) {
        _vm.form.fields.recorrencia = $$v
      },
      expression: "form.fields.recorrencia"
    }
  })], 1), _vm._v(" "), (_vm.form.fields.recorrencia) ? _c('div', {
    staticClass: "mt-4",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.recorrencia,
          min_value: 1
        }
      }),
      expression: "{ rules: { required: form.fields.recorrencia, min_value: 1 } }"
    }],
    attrs: {
      "auto": "",
      "label": "Repetir a cada",
      "name": "recorrencia_cada",
      "data-vv-as": "repetir a cada",
      "error-messages": _vm.errors.has('recorrencia_cada') ? _vm.errors.first('recorrencia_cada') : [],
      "items": _vm.form.recorrenciaCada
    },
    model: {
      value: (_vm.form.fields.recorrencia_cada),
      callback: function($$v) {
        _vm.form.fields.recorrencia_cada = $$v
      },
      expression: "form.fields.recorrencia_cada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.recorrencia
        }
      }),
      expression: "{ rules: { required: form.fields.recorrencia } }"
    }],
    attrs: {
      "auto": "",
      "items": _vm.form.recorrenciaPeriodos,
      "label": "Período",
      "data-vv-as": "período",
      "name": "recorrencia_periodo",
      "error-messages": _vm.errors.has('recorrencia_periodo') ? _vm.errors.first('recorrencia_periodo') : []
    },
    model: {
      value: (_vm.form.fields.recorrencia_periodo),
      callback: function($$v) {
        _vm.form.fields.recorrencia_periodo = $$v
      },
      expression: "form.fields.recorrencia_periodo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRecorrencia = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogUsuarios),
      callback: function($$v) {
        _vm.dialogUsuarios = $$v
      },
      expression: "dialogUsuarios"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar usuário",
      "name": "usuario",
      "data-vv-as": "usuário",
      "error-messages": _vm.errors.has('usuario') ? _vm.errors.first('usuario') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "person",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.user_name),
      callback: function($$v) {
        _vm.form.fields.user_name = $$v
      },
      expression: "form.fields.user_name"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Usuário")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.users), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(item.id)
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1), _vm._v(" "), (item.id === _vm.form.fields.user_id) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Observações",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "assignment"
    },
    model: {
      value: (_vm.form.fields.observacoes),
      callback: function($$v) {
        _vm.form.fields.observacoes = $$v
      },
      expression: "form.fields.observacoes"
    }
  }), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fundo-cinza"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Relatórios")])]), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": ""
    }
  }, [_c('v-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, [_c('v-tabs-slider', {
    staticClass: "secondary"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "to": tab.to
      }
    }, [_vm._v(_vm._s(tab.title))])
  })], 2)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setLeftNav($event)
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Controle de Imóveis")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setRightNav($event)
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text mx-0",
    attrs: {
      "slot": "activator",
      "outline": "",
      "large": ""
    },
    slot: "activator"
  }, [_vm._t("default", [_vm._v("Marcar como realizada")])], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Marcar vistoria como realizada?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Para marcar uma vistoria como realizada você precisa anexar uma foto referente a vistoria.")])]), _vm._v(" "), _c('v-card-text', [_c('file-input', {
    key: _vm.inputKey,
    attrs: {
      "accept": "image/*",
      "icon": "add_a_photo",
      "label": "Selecionar foto"
    },
    on: {
      "formData": _vm.onFilePicked
    },
    model: {
      value: (_vm.form.fields.fotoFilename),
      callback: function($$v) {
        _vm.form.fields.fotoFilename = $$v
      },
      expression: "form.fields.fotoFilename"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Legenda"
    },
    model: {
      value: (_vm.form.fields.legenda),
      callback: function($$v) {
        _vm.form.fields.legenda = $$v
      },
      expression: "form.fields.legenda"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Ainda não")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-comparativos-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 pt-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printStatus"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Status")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.status)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.status
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'status')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printStatus', 'Status')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printSubstatus"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Sub-status")]), _vm._v(" "), (_vm.dataLoaded) ? _c('ul', {
    staticClass: "opcoes"
  }, _vm._l((Object.keys(_vm.dataChart.substatus)), function(substatus) {
    return _c('li', {
      class: {
        'ativo': _vm.substatusSelecionado === substatus
      },
      on: {
        "click": function($event) {
          _vm.changeSubstatusSelecionado(substatus)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(substatus))])])
  })) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Sub-status")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _vm._l((Object.keys(_vm.dataChart.substatus)), function(substatus) {
    return (_vm.dataLoaded) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.substatusSelecionado === substatus),
        expression: "substatusSelecionado === substatus"
      }]
    }, [_c('div', {
      staticClass: "graph-legend"
    }, [_c('div', {
      staticClass: "legend",
      domProps: {
        "innerHTML": _vm._s(_vm.legendChart[substatus.toLowerCase()])
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "graph-container"
    }, [_c('PieChart', {
      attrs: {
        "chartdata": _vm.dataChart.substatus[substatus]
      },
      on: {
        "generated": function($event) {
          _vm.setLegend($event, substatus.toLowerCase())
        }
      }
    })], 1)]) : _vm._e()
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printSubstatus', 'Sub-status (' + _vm.substatusSelecionado + ')')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printProprietario"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4",
    staticStyle: {
      "min-height": "542px"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Proprietário")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Proprietário")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.proprietario)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.proprietario
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'proprietario')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printProprietario', 'Proprietário')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printVistoria"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Vistoria")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Vistoria")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.vistoria)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.vistoria
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'vistoria')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printVistoria', 'Vistoria')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printTipo"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Tipo")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Tipo")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.tipo)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.tipo
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'tipo')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printTipo', 'Tipo')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printTarefas"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Tarefas")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Tarefas")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.tarefas)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.tarefas
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'tarefas')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printTarefas', 'Tarefas')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printIptu"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4",
    staticStyle: {
      "min-height": "542px"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("IPTU")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("IPTU")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.iptu)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.iptu
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'iptu')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printIptu', 'IPTU')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printCidade"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Cidade")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Cidade")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('table', _vm._l((this.comparativo.cidade), function(total, cidade) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(cidade))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(total))]), _vm._v("   " + _vm._s(Math.floor(((total / _vm.totalCidades) * 100) + 0.5)) + "%")])])
  }))]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printCidade', 'Cidade')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Área")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditArea) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditArea
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área do terreno",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_terreno),
      callback: function($$v) {
        _vm.form.fields.area_terreno = $$v
      },
      expression: "form.fields.area_terreno"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área construída",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_construida),
      callback: function($$v) {
        _vm.form.fields.area_construida = $$v
      },
      expression: "form.fields.area_construida"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área útil",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_util),
      callback: function($$v) {
        _vm.form.fields.area_util = $$v
      },
      expression: "form.fields.area_util"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.calcada) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" calçada")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.calcada),
      callback: function($$v) {
        _vm.form.fields.calcada = $$v
      },
      expression: "form.fields.calcada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.muro) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" muro")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.muro),
      callback: function($$v) {
        _vm.form.fields.muro = $$v
      },
      expression: "form.fields.muro"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditArea
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [(this.map.center.lat !== null && this.map.center.lng !== null) ? _c('gmap-map', {
    ref: "map",
    staticClass: "map-container",
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "margin-bottom": "30px"
    },
    attrs: {
      "center": _vm.map.center,
      "zoom": 19,
      "options": {
        clickableIcons: false,
        disableDoubleClickZoom: true,
        streetViewControl: false
      }
    },
    on: {
      "idle": _vm.calculateArea
    }
  }, [(_vm.polygon.paths.length > 0) ? _c('gmap-polygon', {
    ref: "polygon",
    attrs: {
      "options": _vm.polygonOptions,
      "paths": _vm.polygon.paths,
      "editable": _vm.canEditArea
    },
    on: {
      "paths_changed": function($event) {
        _vm.updateEdited($event)
      },
      "dblclick": _vm.handleClickForDelete
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.polygon.edited && _vm.polygon.area > 0) ? _c('v-container', {
    staticClass: "py-0 mt-2 mb-4 text-xs-center",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Cálculo aproximado da área desenhada: "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(_vm._s(Math.round(_vm.polygon.area)) + " m²")])])])], 1) : _vm._e(), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Informações do imóvel")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditInfo) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditInfo
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome do imóvel",
      "name": "apelido",
      "data-vv-as": "nome do imóvel",
      "error-messages": _vm.errors.has('apelido') ? _vm.errors.first('apelido') : []
    },
    model: {
      value: (_vm.form.fields.apelido),
      callback: function($$v) {
        _vm.form.fields.apelido = $$v
      },
      expression: "form.fields.apelido"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.proprietarios,
      "label": "Dono do imóvel"
    },
    model: {
      value: (_vm.form.fields.proprietarioSelect),
      callback: function($$v) {
        _vm.form.fields.proprietarioSelect = $$v
      },
      expression: "form.fields.proprietarioSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.proprietarioSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Nome do proprietário"
    },
    model: {
      value: (_vm.form.fields.proprietario),
      callback: function($$v) {
        _vm.form.fields.proprietario = $$v
      },
      expression: "form.fields.proprietario"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tipos,
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipoSelect),
      callback: function($$v) {
        _vm.form.fields.tipoSelect = $$v
      },
      expression: "form.fields.tipoSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.tipoSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.form.fields.savoynet.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, _vm._l((_vm.form.fields.savoynet), function(item, index) {
    return _c('v-chip', {
      key: ("savoynet-" + item + "-" + index),
      staticClass: "mr-2 mb-2",
      attrs: {
        "close": _vm.canEditInfo
      },
      on: {
        "input": function($event) {
          _vm.removeSavoyNet(index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "SavoyNet",
      "hint": "Use Enter, vírgula, ponto e vírgula ou nova linha.",
      "persistent-hint": ""
    },
    on: {
      "keydown": _vm.onSavoyNetKeydown,
      "input": _vm.onSavoyNetInput,
      "blur": _vm.commitSavoyNetInput,
      "paste": _vm.onSavoyNetPaste
    },
    model: {
      value: (_vm.savoynetInput),
      callback: function($$v) {
        _vm.savoynetInput = $$v
      },
      expression: "savoynetInput"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "acao-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.canDeleteInfo) ? _c('v-btn', {
    staticClass: "red red--text ma-0",
    attrs: {
      "outline": "",
      "block": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogExcluir($event)
      }
    }
  }, [_vm._v("\n                Excluir\n              ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "520"
    },
    model: {
      value: (_vm.dialogExcluir),
      callback: function($$v) {
        _vm.dialogExcluir = $$v
      },
      expression: "dialogExcluir"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Excluir imóvel?")]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" O imóvel não poderá ser recuperado após a exclusão.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogExcluir = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluirImovel($event)
      }
    }
  }, [_vm._v("Excluir")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.canEditInfo) ? _c('v-flex', {
    staticClass: "acao-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text ma-0",
    attrs: {
      "type": "submit",
      "outline": "",
      "block": "",
      "large": "",
      "disabled": _vm.isFormInvalid
    }
  }, [_vm._v("\n                Salvar\n              ")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.canViewFotos) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'ilustrativa',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("photo_library")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "success": _vm.type === 'success',
      "info": _vm.type === 'info',
      "warning": _vm.type === 'warning',
      "error": _vm.type === 'error',
      "primary": _vm.type === 'primary',
      "secondary": _vm.type === 'secondary',
      "bottom": "",
      "multi-line": ""
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Tarefas")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.tarefas.length > 0) ? [_vm._l((_vm.tarefas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "tarefas-meta-coluna",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-icon', [_vm._v("event_available")]), _vm._v(" "), _c('TarefasSituacao', {
      key: item.data,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    }, [_vm._v(_vm._s(item.data_formatada))])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "tarefas-meta-coluna tarefas-meta-coluna-direita",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('TarefasSituacao', {
      key: item.data,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-2",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(item.tipo) + "\n              ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.taskUserName(item)))])])], 1)], 1), _vm._v(" "), (_vm.canCompleteTask(item)) ? _c('TarefasRealizar', {
      attrs: {
        "tarefaId": item.id,
        "imovelId": _vm.$route.params.id
      }
    }) : _vm._e(), _vm._v(" "), (_vm.canEditTask(item)) ? _c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "flat": "",
        "to": ({
          name: 'TarefasEditar',
          params: {
            id: _vm.$route.params.id,
            tarefa: item.id
          }
        })
      }
    }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma tarefa cadastrada.")]), _vm._v(" "), (_vm.canAddTask) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'TarefasAdicionar',
        params: {
          id: _vm.imovelId
        }
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Endereço")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditEndereco) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditEndereco
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#####-###'),
      expression: "'#####-###'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          regex: /^[0-9]{5}-[0-9]{3}$/
        }
      }),
      expression: "{ rules: { regex: /^[0-9]{5}-[0-9]{3}$/} }"
    }],
    attrs: {
      "autocomplete": "off",
      "placeholder": "00000-000",
      "data-vv-as": "CEP",
      "data-vv-delay": "1000",
      "name": "cep",
      "error-messages": _vm.errors.has('cep') ? _vm.errors.first('cep') : [],
      "label": "CEP"
    },
    on: {
      "focusout": _vm.buscarCEP
    },
    model: {
      value: (_vm.form.fields.cep),
      callback: function($$v) {
        _vm.form.fields.cep = $$v
      },
      expression: "form.fields.cep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: _vm.form.fields.logradouro.length > 0
        }
      }),
      expression: "{ rules: { required: form.fields.logradouro.length > 0 } }",
      modifiers: {
        "initial": true
      }
    }],
    attrs: {
      "items": _vm.enderecoTipo,
      "name": "tipo",
      "data-vv-as": "tipo",
      "error-messages": _vm.errors.has('tipo') ? _vm.errors.first('tipo') : [],
      "label": "Tipo"
    },
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: _vm.form.fields.tipo.length > 0
        }
      }),
      expression: "{ rules: { required: form.fields.tipo.length > 0 } }",
      modifiers: {
        "initial": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "logradouro",
      "data-vv-as": "logradouro",
      "error-messages": _vm.errors.has('logradouro') ? _vm.errors.first('logradouro') : [],
      "label": "Logradouro"
    },
    model: {
      value: (_vm.form.fields.logradouro),
      callback: function($$v) {
        _vm.form.fields.logradouro = $$v
      },
      expression: "form.fields.logradouro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Número",
      "type": "number"
    },
    model: {
      value: (_vm.form.fields.numero),
      callback: function($$v) {
        _vm.form.fields.numero = _vm._n($$v)
      },
      expression: "form.fields.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Complemento"
    },
    model: {
      value: (_vm.form.fields.complemento),
      callback: function($$v) {
        _vm.form.fields.complemento = $$v
      },
      expression: "form.fields.complemento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Bairro"
    },
    model: {
      value: (_vm.form.fields.bairro),
      callback: function($$v) {
        _vm.form.fields.bairro = $$v
      },
      expression: "form.fields.bairro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Cidade"
    },
    model: {
      value: (_vm.form.fields.cidade),
      callback: function($$v) {
        _vm.form.fields.cidade = $$v
      },
      expression: "form.fields.cidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "auto": "",
      "items": _vm.enderecoUF,
      "label": "Estado"
    },
    model: {
      value: (_vm.form.fields.uf),
      callback: function($$v) {
        _vm.form.fields.uf = $$v
      },
      expression: "form.fields.uf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Coordenadas manualmente")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.coordenadas_manual),
      callback: function($$v) {
        _vm.form.fields.coordenadas_manual = $$v
      },
      expression: "form.fields.coordenadas_manual"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.coordenadas_manual) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    staticClass: "mb-3 mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body"
  }, [_vm._v("Preencha as coordenadas ou mova o marcador pelo mapa abaixo. Caso você preencha os campos manualmente, o mapa só será atualizado após salvar as alterações.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.coordenadas_manual
        }
      }),
      expression: "{ rules: { required: form.fields.coordenadas_manual } }"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "latitude_manual",
      "data-vv-as": "latitude",
      "error-messages": _vm.errors.has('latitude_manual') ? _vm.errors.first('latitude_manual') : [],
      "label": "Latitude",
      "type": "number"
    },
    model: {
      value: (_vm.form.fields.latitude_manual),
      callback: function($$v) {
        _vm.form.fields.latitude_manual = $$v
      },
      expression: "form.fields.latitude_manual"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.coordenadas_manual
        }
      }),
      expression: "{ rules: { required: form.fields.coordenadas_manual } }"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "longitude_manual",
      "data-vv-as": "longitude",
      "error-messages": _vm.errors.has('longitude_manual') ? _vm.errors.first('longitude_manual') : [],
      "label": "Longitude",
      "type": "number"
    },
    model: {
      value: (_vm.form.fields.longitude_manual),
      callback: function($$v) {
        _vm.form.fields.longitude_manual = $$v
      },
      expression: "form.fields.longitude_manual"
    }
  })], 1), _vm._v(" "), (_vm.coords.lat !== null && _vm.coords.lng !== null) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "margin-bottom": "20px"
    },
    attrs: {
      "center": _vm.coords,
      "zoom": 15,
      "options": {
        clickableIcons: false,
        disableDoubleClickZoom: true,
        streetViewControl: false,
        mapTypeControl: true
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.coords,
      "clickable": false,
      "draggable": true
    },
    on: {
      "drag": _vm.updateManualCoords
    }
  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Loteamento")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.loteamento),
      callback: function($$v) {
        _vm.form.fields.loteamento = $$v
      },
      expression: "form.fields.loteamento"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.loteamento) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.form.fields.loteamento
        }
      }),
      expression: "{ rules: { required: form.fields.loteamento } }"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "loteamento_nome",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('loteamento_nome') ? _vm.errors.first('loteamento_nome') : [],
      "label": "Nome"
    },
    model: {
      value: (_vm.form.fields.loteamento_nome),
      callback: function($$v) {
        _vm.form.fields.loteamento_nome = $$v
      },
      expression: "form.fields.loteamento_nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Lote"
    },
    model: {
      value: (_vm.form.fields.loteamento_lote),
      callback: function($$v) {
        _vm.form.fields.loteamento_lote = $$v
      },
      expression: "form.fields.loteamento_lote"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Quadra"
    },
    model: {
      value: (_vm.form.fields.loteamento_quadra),
      callback: function($$v) {
        _vm.form.fields.loteamento_quadra = $$v
      },
      expression: "form.fields.loteamento_quadra"
    }
  })], 1)], 1) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Valor")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditValor) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditValor
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Estimativa do valor do imóvel",
      "name": "estimativa_valor",
      "data-vv-as": "estimativa do valor do imóvel",
      "error-messages": _vm.errors.has('estimativa_valor') ? _vm.errors.first('estimativa_valor') : []
    },
    model: {
      value: (_vm.form.fields.estimativa_valor),
      callback: function($$v) {
        _vm.form.fields.estimativa_valor = $$v
      },
      expression: "form.fields.estimativa_valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.dataMenu),
      callback: function($$v) {
        _vm.dataMenu = $$v
      },
      expression: "dataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da estimativa",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.estimativa_data_formatada),
      callback: function($$v) {
        _vm.form.fields.estimativa_data_formatada = $$v
      },
      expression: "form.fields.estimativa_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.estimativa_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.estimativa_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.estimativa_data),
      callback: function($$v) {
        _vm.form.fields.estimativa_data = $$v
      },
      expression: "form.fields.estimativa_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Valor do m² da região",
      "name": "regiao_valor"
    },
    model: {
      value: (_vm.form.fields.regiao_valor),
      callback: function($$v) {
        _vm.form.fields.regiao_valor = $$v
      },
      expression: "form.fields.regiao_valor"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Agendar tarefa")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogTarefasTipos),
      callback: function($$v) {
        _vm.dialogTarefasTipos = $$v
      },
      expression: "dialogTarefasTipos"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogTarefasTipos),
      expression: "!dialogTarefasTipos"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Tipo de tarefa",
      "name": "tipo",
      "data-vv-as": "tipo",
      "error-messages": _vm.errors.has('tipo') ? _vm.errors.first('tipo') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "event_available",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Tarefa")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTarefasTipos = false
      }
    }
  }, [_vm._v("Concluir")])], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.tarefaTipo), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectTarefa(item)
        }
      }
    }, [_c('v-list-tile-action', [(index === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item))])], 1), _vm._v(" "), (_vm.form.fields.tipo === item) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [(_vm.tarefaTipo.length === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-text-field', {
    staticClass: "tarefa_personalizada",
    attrs: {
      "label": "Personalizada",
      "single-line": "",
      "full-width": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tipoTarefaPersonalizada),
      callback: function($$v) {
        _vm.tipoTarefaPersonalizada = $$v
      },
      expression: "tipoTarefaPersonalizada"
    }
  })], 1), _vm._v(" "), (_vm.tipoTarefaPersonalizada.length > 0 && _vm.tipoTarefaPersonalizada === _vm.form.fields.tipo) ? _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("done")])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px",
      "nudge-top": 140
    },
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_c('v-text-field', {
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Adicionar data",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.data_formatada),
      callback: function($$v) {
        _vm.form.fields.data_formatada = $$v
      },
      expression: "form.fields.data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "allowed-dates": _vm.datasPermitidas,
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.data),
      callback: function($$v) {
        _vm.form.fields.data = $$v
      },
      expression: "form.fields.data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogUsuarios),
      callback: function($$v) {
        _vm.dialogUsuarios = $$v
      },
      expression: "dialogUsuarios"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar usuário",
      "name": "usuario",
      "data-vv-as": "usuário",
      "error-messages": _vm.errors.has('usuario') ? _vm.errors.first('usuario') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "person",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.user_name),
      callback: function($$v) {
        _vm.form.fields.user_name = $$v
      },
      expression: "form.fields.user_name"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Usuário")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.users), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(item.id)
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1), _vm._v(" "), (item.id === _vm.form.fields.user_id) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', {
    class: [(_vm.situacaoClass + "--text"), 'upperCase']
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.situacao))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "elevation-5",
    attrs: {
      "value": _vm.drawerState,
      "permanent": !_vm.mobile,
      "temporary": _vm.mobile,
      "width": "300"
    },
    on: {
      "input": _vm.onDrawerInput
    }
  }, [_c('div', {
    staticClass: "left_nav"
  }, [(_vm.preventClickOutside) ? _c('div', {
    staticClass: "prevent_click_outside"
  }) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'add')) ? _c('div', {
    staticClass: "text-xs-center pt-4 pb-2",
    staticStyle: {
      "background": "#FAFAFA"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisAdicionar'
      }
    }
  }, [_c('v-btn', {
    staticClass: "secondary"
  }, [_vm._v("Cadastrar Imóvel")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "background": "#FAFAFA"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "borda_laranja",
    attrs: {
      "placeholder": "Busca",
      "hide-details": "",
      "append-icon": "search",
      "append-icon-cb": _vm.setFiltros
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.texto),
      callback: function($$v) {
        _vm.form.texto = $$v
      },
      expression: "form.texto"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "remover_padding mx-0 grey",
    class: {
      'secondary--text': _vm.countFiltros > 0, 'grey--text': _vm.countFiltros === 0
    },
    attrs: {
      "flat": "",
      "disabled": _vm.countFiltros === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.limparFiltros($event)
      }
    }
  }, [_vm._v("Limpar filtros")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.filtroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.setFiltros($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [(_vm.canShowProprietarioFilter) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Proprietário",
      "items": _vm.proprietarioItems,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.proprietario),
      callback: function($$v) {
        _vm.form.proprietario = $$v
      },
      expression: "form.proprietario"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canShowProprietarioFilter) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Tipo",
      "items": _vm.lista.tipo,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.tipo),
      callback: function($$v) {
        _vm.form.tipo = $$v
      },
      expression: "form.tipo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Estado",
      "items": Object.keys(_vm.lista.uf),
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.uf),
      callback: function($$v) {
        _vm.form.uf = $$v
      },
      expression: "form.uf"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.uf.length > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Cidade",
      "items": Object.keys(_vm.lista.cidade).sort(),
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.cidade),
      callback: function($$v) {
        _vm.form.cidade = $$v
      },
      expression: "form.cidade"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.uf.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.cidade.length > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Bairro",
      "items": _vm.lista.bairro,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.bairro),
      callback: function($$v) {
        _vm.form.bairro = $$v
      },
      expression: "form.bairro"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.cidade.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Em loteamento",
      "items": _vm.lista.com_loteamento,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_loteamento),
      callback: function($$v) {
        _vm.form.com_loteamento = $$v
      },
      expression: "form.com_loteamento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Selecionar loteamento",
      "items": _vm.lista.loteamento,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.loteamento),
      callback: function($$v) {
        _vm.form.loteamento = $$v
      },
      expression: "form.loteamento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.lote),
      callback: function($$v) {
        _vm.opcoes.lote = $$v
      },
      expression: "opcoes.lote"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Lote e quadra")]), _vm._v(" "), (!_vm.opcoes.lote && (_vm.form.lote.length > 0 || _vm.form.quadra.length > 0)) ? _c('div', {
    staticClass: "selecionados"
  }, [(_vm.form.lote.length > 0) ? [_vm._v("Lote " + _vm._s(_vm.form.lote))] : _vm._e(), _vm._v(" "), (_vm.form.lote.length > 0 && _vm.form.quadra.length > 0) ? [_vm._v(" - ")] : _vm._e(), _vm._v(" "), (_vm.form.quadra.length > 0) ? [_vm._v("Quadra " + _vm._s(_vm.form.quadra))] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Lote")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "lote",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.lote),
      callback: function($$v) {
        _vm.form.lote = $$v
      },
      expression: "form.lote"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Quadra")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "quadra",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.quadra),
      callback: function($$v) {
        _vm.form.quadra = $$v
      },
      expression: "form.quadra"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.status),
      callback: function($$v) {
        _vm.opcoes.status = $$v
      },
      expression: "opcoes.status"
    }
  }, [(_vm.$hasGranularPermission('status', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Status")]), _vm._v(" "), (!_vm.opcoes.status && _vm.form.status.length > 0) ? _c('div', {
    staticClass: "selecionados"
  }, [_vm._v("\n              " + _vm._s(_vm.form.status.join(', ')) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Vago",
      "color": "secondary",
      "value": "Vago",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Com placa",
      "items": _vm.lista.vago_com_placa,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.vago_com_placa),
      callback: function($$v) {
        _vm.form.vago_com_placa = $$v
      },
      expression: "form.vago_com_placa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-2 py-2"
  }, [_vm._v("Nível de segurança")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Seguro",
      "color": "secondary",
      "value": "Seguro",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Média segurança",
      "color": "secondary",
      "value": "Média segurança",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inseguro",
      "color": "secondary",
      "value": "Inseguro",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Compromissado",
      "color": "secondary",
      "value": "Compromissado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Em dia",
      "color": "secondary",
      "value": "Em dia",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Quitado sem escritura",
      "color": "secondary",
      "value": "Quitado sem escritura",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Com escritura definitiva",
      "color": "secondary",
      "value": "Com escritura definitiva",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente",
      "color": "secondary",
      "value": "Inadimplente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente ajuizado",
      "color": "secondary",
      "value": "Inadimplente ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Locado",
      "color": "secondary",
      "value": "Locado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), (_vm.$auth.check('Administrador')) ? _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Em dia",
      "color": "secondary",
      "value": "Em dia",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente",
      "color": "secondary",
      "value": "Inadimplente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente ajuizado",
      "color": "secondary",
      "value": "Inadimplente ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com ação renovatória",
      "items": _vm.lista.locado_acao_renovatoria,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.locado_acao_renovatoria),
      callback: function($$v) {
        _vm.form.locado_acao_renovatoria = $$v
      },
      expression: "form.locado_acao_renovatoria"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Índice",
      "items": _vm.lista.locado_indice,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.locado_indice),
      callback: function($$v) {
        _vm.form.locado_indice = $$v
      },
      expression: "form.locado_indice"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Valor do aluguel (R$)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "locado_valor_minimo",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_valor_minimo),
      callback: function($$v) {
        _vm.form.locado_valor_minimo = $$v
      },
      expression: "form.locado_valor_minimo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "locado_valor_maximo",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_valor_maximo),
      callback: function($$v) {
        _vm.form.locado_valor_maximo = $$v
      },
      expression: "form.locado_valor_maximo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Comodato",
      "color": "secondary",
      "value": "Comodato",
      "hide-details": ""
    },
    on: {
      "change": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Invadido",
      "color": "secondary",
      "value": "Invadido",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ocupado irregularmente",
      "color": "secondary",
      "value": "Ocupado irregularmente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.invadido_condicao),
      callback: function($$v) {
        _vm.form.invadido_condicao = $$v
      },
      expression: "form.invadido_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Ocupado ajuizado",
      "color": "secondary",
      "value": "Ocupado ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.invadido_condicao),
      callback: function($$v) {
        _vm.form.invadido_condicao = $$v
      },
      expression: "form.invadido_condicao"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.area),
      callback: function($$v) {
        _vm.opcoes.area = $$v
      },
      expression: "opcoes.area"
    }
  }, [(_vm.$hasGranularPermission('area', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Área")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Área do terreno (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_terreno_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_terreno_minima),
      callback: function($$v) {
        _vm.form.area_terreno_minima = $$v
      },
      expression: "form.area_terreno_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_terreno_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_terreno_maxima),
      callback: function($$v) {
        _vm.form.area_terreno_maxima = $$v
      },
      expression: "form.area_terreno_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Área construída (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_construida_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_construida_minima),
      callback: function($$v) {
        _vm.form.area_construida_minima = $$v
      },
      expression: "form.area_construida_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_construida_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_construida_maxima),
      callback: function($$v) {
        _vm.form.area_construida_maxima = $$v
      },
      expression: "form.area_construida_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Área útil (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_util_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_util_minima),
      callback: function($$v) {
        _vm.form.area_util_minima = $$v
      },
      expression: "form.area_util_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_util_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_util_maxima),
      callback: function($$v) {
        _vm.form.area_util_maxima = $$v
      },
      expression: "form.area_util_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com calçada",
      "items": _vm.lista.com_calcada,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_calcada),
      callback: function($$v) {
        _vm.form.com_calcada = $$v
      },
      expression: "form.com_calcada"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com muro",
      "items": _vm.lista.com_muro,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_muro),
      callback: function($$v) {
        _vm.form.com_muro = $$v
      },
      expression: "form.com_muro"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "IPTU",
      "items": _vm.lista.iptu_condicao,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.iptu_condicao),
      callback: function($$v) {
        _vm.form.iptu_condicao = $$v
      },
      expression: "form.iptu_condicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.valor),
      callback: function($$v) {
        _vm.opcoes.valor = $$v
      },
      expression: "opcoes.valor"
    }
  }, [(_vm.$hasGranularPermission('valor', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Valor")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Estimativa do valor (R$)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "estimativa_valor_minimo",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.estimativa_valor_minimo),
      callback: function($$v) {
        _vm.form.estimativa_valor_minimo = $$v
      },
      expression: "form.estimativa_valor_minimo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "estimativa_valor_maximo",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.estimativa_valor_maximo),
      callback: function($$v) {
        _vm.form.estimativa_valor_maximo = $$v
      },
      expression: "form.estimativa_valor_maximo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Vistoria",
      "items": _vm.lista.vistoria,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.vistoria),
      callback: function($$v) {
        _vm.form.vistoria = $$v
      },
      expression: "form.vistoria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Com tarefas pendentes",
      "items": _vm.lista.tarefas_pendentes,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.tarefas_pendentes),
      callback: function($$v) {
        _vm.form.tarefas_pendentes = $$v
      },
      expression: "form.tarefas_pendentes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-divider') : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%",
      "align-self": "flex-end"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "remover_padding mx-0 grey",
    class: {
      'secondary--text': _vm.countFiltros > 0, 'grey--text': _vm.countFiltros === 0
    },
    attrs: {
      "flat": "",
      "disabled": _vm.countFiltros === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.limparFiltros($event)
      }
    }
  }, [_vm._v("Limpar filtros")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.filtroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.setFiltros($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Anexos")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.anexos.length > 0) ? [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.anexos), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id
    }, [_c('v-list-tile-content', {
      staticClass: "pl-5"
    }, [_c('v-list-tile-sub-title', [_vm._v(_vm._s(item.data) + " às " + _vm._s(item.horario))]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.legenda))])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "pr-5"
    }, [_c('v-menu', [_c('v-icon', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      attrs: {
        "href": item.path,
        "target": "_blank",
        "download": ""
      }
    }, [_c('v-list-tile-title', [_vm._v("Visualizar")])], 1), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "640"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Editar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.itemEditar.titulo))])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
      attrs: {
        "label": "Legenda"
      },
      model: {
        value: (_vm.formEditar.fields.legenda),
        callback: function($$v) {
          _vm.formEditar.fields.legenda = $$v
        },
        expression: "formEditar.fields.legenda"
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Apagar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.anexos.length) ? _c('v-divider', {
      key: item.id
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhum anexo cadastrado.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "720"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('anexos', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('file-input', {
    key: _vm.inputKey,
    attrs: {
      "label": "Selecionar arquivo"
    },
    on: {
      "formData": _vm.onFilePicked
    },
    model: {
      value: (_vm.form.fields.anexoFilename),
      callback: function($$v) {
        _vm.form.fields.anexoFilename = $$v
      },
      expression: "form.fields.anexoFilename"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Legenda"
    },
    model: {
      value: (_vm.form.fields.legenda),
      callback: function($$v) {
        _vm.form.fields.legenda = $$v
      },
      expression: "form.fields.legenda"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$router.back()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Adicionar imóvel")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Fotos")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.fotos.length > 0) ? [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.fotos), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id
    }, [_c('v-list-tile-content', {
      staticClass: "pl-5"
    }, [_c('v-list-tile-sub-title', [_vm._v(_vm._s(item.data) + " às " + _vm._s(item.horario))]), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }]
    }, [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.legenda))])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "pr-5"
    }, [_c('v-menu', [_c('v-icon', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }]
    }, [_c('v-list-tile-title', [_vm._v("Visualizar")])], 1), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "640"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Editar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.itemEditar.titulo))])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
      attrs: {
        "label": "Legenda"
      },
      model: {
        value: (_vm.formEditar.fields.legenda),
        callback: function($$v) {
          _vm.formEditar.fields.legenda = $$v
        },
        expression: "formEditar.fields.legenda"
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-title', [_vm._v("Apagar")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.fotos.length) ? _c('v-divider', {
      key: item.id
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma foto cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "720"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('fotos', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('file-input', {
    key: _vm.inputKey,
    attrs: {
      "accept": "image/*",
      "icon": "add_a_photo",
      "label": "Selecionar foto"
    },
    on: {
      "formData": _vm.onFilePicked
    },
    model: {
      value: (_vm.form.fields.fotoFilename),
      callback: function($$v) {
        _vm.form.fields.fotoFilename = $$v
      },
      expression: "form.fields.fotoFilename"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Legenda"
    },
    model: {
      value: (_vm.form.fields.legenda),
      callback: function($$v) {
        _vm.form.fields.legenda = $$v
      },
      expression: "form.fields.legenda"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Registros / documentos")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditRegistro) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditRegistro
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Matrícula"
    },
    model: {
      value: (_vm.form.fields.matricula),
      callback: function($$v) {
        _vm.form.fields.matricula = $$v
      },
      expression: "form.fields.matricula"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Transcrição"
    },
    model: {
      value: (_vm.form.fields.transcricao),
      callback: function($$v) {
        _vm.form.fields.transcricao = $$v
      },
      expression: "form.fields.transcricao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cartório"
    },
    model: {
      value: (_vm.form.fields.cartorio),
      callback: function($$v) {
        _vm.form.fields.cartorio = $$v
      },
      expression: "form.fields.cartorio"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.apelido))]), _vm._v(" "), (_vm.proprietario || _vm.tipo || _vm.savoyNetItems.length > 0) ? _c('div', {
    staticClass: "detalhes-toolbar-extension",
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [(_vm.tipo) ? _c('span', {
    staticStyle: {
      "margin": "0 18px"
    }
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("Tipo")]), _vm._v(" " + _vm._s(_vm.tipo))]) : _vm._e(), _vm._v(" "), (_vm.proprietario) ? _c('span', [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("Proprietário")]), _vm._v(" " + _vm._s(_vm.proprietario))]) : _vm._e(), _vm._v(" "), (_vm.savoyNetItems.length === 1) ? _c('span', {
    staticStyle: {
      "margin-left": "18px"
    }
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("SavoyNet")]), _vm._v(" "), _c('a', {
    staticClass: "white--text",
    attrs: {
      "href": _vm.savoyNetItems[0].url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savoyNetItems[0].numero) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.savoyNetItems.length > 1) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 savoynet-ativador",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "caption secondary--text",
    staticStyle: {
      "font-weight": "500 !important"
    }
  }, [_vm._v("SavoyNet")]), _vm._v(" "), _c('span', {
    staticClass: "white--text",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_vm._v("(" + _vm._s(_vm.savoyNetItems.length) + ")")])]), _vm._v(" "), _c('v-card', [_c('v-list', _vm._l((_vm.savoyNetItems), function(item) {
    return _c('v-list-tile', {
      key: item.numero,
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.numero))])], 1)
  }))], 1)], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "slot": "activator",
      "outline": "",
      "large": ""
    },
    slot: "activator"
  }, [_vm._t("default", [_vm._v("Marcar como realizada")])], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Marcar tarefa como realizada?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Para marcar uma tarefa como realizada você precisa preencher uma observação referente a tarefa.")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Observação",
      "multi-line": "",
      "name": "observacao",
      "data-vv-as": "observação",
      "error-messages": _vm.errors.has('observacao') ? _vm.errors.first('observacao') : []
    },
    model: {
      value: (_vm.form.fields.conteudo),
      callback: function($$v) {
        _vm.form.fields.conteudo = $$v
      },
      expression: "form.fields.conteudo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Ainda não")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "public-payment-app",
    attrs: {
      "light": ""
    }
  }, [_c('main', {
    staticClass: "public-payment-shell"
  }, [_c('div', {
    staticClass: "public-payment-background"
  }), _vm._v(" "), _c('v-container', {
    staticClass: "public-payment-container",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "public-payment-card"
  }, [_c('div', {
    staticClass: "public-payment-brand"
  }, [_c('img', {
    staticClass: "public-payment-logo",
    attrs: {
      "src": "static/logo.png",
      "alt": "Savoy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "public-payment-brand-copy"
  }, [_c('span', {
    staticClass: "public-payment-eyebrow"
  }, [_vm._v("Savoy Controle")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.pageHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pageSubheading))])])]), _vm._v(" "), (_vm.status === 'loading') ? _c('div', {
    staticClass: "public-payment-state"
  }, [_c('div', {
    staticClass: "public-payment-icon public-payment-icon-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 68,
      "width": 5,
      "color": "secondary"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.loadingTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadingMessage))])]) : (_vm.status === 'success') ? _c('div', {
    staticClass: "public-payment-state"
  }, [_c('div', {
    staticClass: "public-payment-icon public-payment-icon-success"
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "white"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.responseTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.responseMessage))]), _vm._v(" "), (_vm.hasPagamentoDetails) ? _c('div', {
    staticClass: "public-payment-details"
  }, [_c('div', {
    staticClass: "public-payment-detail"
  }, [_c('span', [_vm._v("Pagamento")]), _vm._v(" "), _c('strong', [_vm._v("#" + _vm._s(_vm.pagamento.id))])]), _vm._v(" "), _c('div', {
    staticClass: "public-payment-detail"
  }, [_c('span', [_vm._v("Status")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.pagamento.status || '---'))])]), _vm._v(" "), (_vm.pagamento.descricao) ? _c('div', {
    staticClass: "public-payment-detail"
  }, [_c('span', [_vm._v("Descrição")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.pagamento.descricao))])]) : _vm._e(), _vm._v(" "), (_vm.pagamento.imovel) ? _c('div', {
    staticClass: "public-payment-detail"
  }, [_c('span', [_vm._v("Imóvel")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.pagamento.imovel))])]) : _vm._e(), _vm._v(" "), (_vm.pagamento.solicitante) ? _c('div', {
    staticClass: "public-payment-detail"
  }, [_c('span', [_vm._v("Solicitante")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.pagamento.solicitante))])]) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "public-payment-state"
  }, [_c('div', {
    staticClass: "public-payment-icon public-payment-icon-error"
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "white"
    }
  }, [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.responseTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.responseMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "public-payment-footer"
  }, [_c('span', [_vm._v("Ação: " + _vm._s(_vm.actionLabel))]), _vm._v(" "), (_vm.token) ? _c('span', [_vm._v("Token " + _vm._s(_vm.maskedToken))]) : _vm._e()])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "lista-imovel-card",
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.imovel.id
        }
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4 pb-4 lista_imoveis"
  }, [_c('v-layout', {
    staticStyle: {
      "min-height": "50px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "xl8": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [(_vm.exibirStatus) ? _c('span', {
    staticClass: "status_circulo",
    style: ({
      'background-color': _vm.statusColor
    })
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.imovel.apelido || _vm.fallbackTitulo))])]), _vm._v(" "), (_vm.formattedEndereco) ? _c('div', {
    staticClass: "grey--text text--darken-1 mt-1"
  }, [_vm._v("\n            " + _vm._s(_vm.formattedEndereco) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.imovel.tipo || _vm.imovel.proprietario) ? _c('div', {
    staticClass: "grey--text text--darken-1 mt-2"
  }, [(_vm.imovel.tipo) ? _c('span', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "caption secondary--text"
  }, [_c('strong', [_vm._v("Tipo")])]), _vm._v(" " + _vm._s(_vm.imovel.tipo))]) : _vm._e(), _vm._v(" "), (_vm.imovel.proprietario) ? _c('span', [_c('span', {
    staticClass: "caption secondary--text"
  }, [_c('strong', [_vm._v("Proprietário")])]), _vm._v(" " + _vm._s(_vm.imovel.proprietario))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view') || _vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "status-coluna",
    attrs: {
      "xs12": "",
      "md6": "",
      "xl4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.vistoriaSituacao) ? _c('ListaVistoriaSituacao', {
    attrs: {
      "situacao": _vm.vistoriaSituacao
    }
  }) : _c('v-btn', {
    staticClass: "secondary secondary--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [_vm._v("Sem vistoria")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "tarefas-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey grey--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [(_vm.tarefasPendentesCount === 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v("1  ")]), _vm._v("tarefa")] : (_vm.tarefasPendentesCount > 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.tarefasPendentesCount) + "  ")]), _vm._v("tarefas")] : [_vm._v("Sem tarefas")]], 2)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    class: [("" + _vm.situacaoClass), 'white--text', 'ma-0', 'caption'],
    attrs: {
      "block": ""
    }
  }, [_vm._t("default", [_vm._v("Vistoria " + _vm._s(_vm.situacao))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Status")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditStatus) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditStatus
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.listaStatus,
      "name": "status",
      "data-vv-as": "status",
      "error-messages": _vm.errors.has('status') ? _vm.errors.first('status') : [],
      "label": "Selecione um status"
    },
    model: {
      value: (_vm.form.fields.status),
      callback: function($$v) {
        _vm.form.fields.status = $$v
      },
      expression: "form.fields.status"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Vago') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    staticClass: "switch-fix mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.vago_com_placa) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" placa")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.vago_com_placa),
      callback: function($$v) {
        _vm.form.fields.vago_com_placa = $$v
      },
      expression: "form.fields.vago_com_placa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaSeguranca,
      "name": "vago_seguranca",
      "label": "Nível de segurança"
    },
    model: {
      value: (_vm.form.fields.vago_seguranca),
      callback: function($$v) {
        _vm.form.fields.vago_seguranca = $$v
      },
      expression: "form.fields.vago_seguranca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Observações de segurança",
      "name": "vago_seguranca_observacoes"
    },
    model: {
      value: (_vm.form.fields.vago_seguranca_observacoes),
      callback: function($$v) {
        _vm.form.fields.vago_seguranca_observacoes = $$v
      },
      expression: "form.fields.vago_seguranca_observacoes"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Compromissado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "compromissado_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.compromissado_condicao),
      callback: function($$v) {
        _vm.form.fields.compromissado_condicao = $$v
      },
      expression: "form.fields.compromissado_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.compromissado_condicao === 'Inadimplente') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.compromissadoInadimplenteDataMenu),
      callback: function($$v) {
        _vm.compromissadoInadimplenteDataMenu = $$v
      },
      expression: "compromissadoInadimplenteDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da inadimplência",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.compromissado_inadimplente_data_formatada),
      callback: function($$v) {
        _vm.form.fields.compromissado_inadimplente_data_formatada = $$v
      },
      expression: "form.fields.compromissado_inadimplente_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.compromissado_inadimplente_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.compromissado_inadimplente_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.compromissado_inadimplente_data),
      callback: function($$v) {
        _vm.form.fields.compromissado_inadimplente_data = $$v
      },
      expression: "form.fields.compromissado_inadimplente_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.compromissado_condicao === 'Inadimplente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.compromissado_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.compromissado_ajuizado_cliente = $$v
      },
      expression: "form.fields.compromissado_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.compromissado_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.compromissado_ajuizado_processo = $$v
      },
      expression: "form.fields.compromissado_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do comprador",
      "name": "compromissado_comprador"
    },
    model: {
      value: (_vm.form.fields.compromissado_comprador),
      callback: function($$v) {
        _vm.form.fields.compromissado_comprador = $$v
      },
      expression: "form.fields.compromissado_comprador"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.compromissadoDataMenu),
      callback: function($$v) {
        _vm.compromissadoDataMenu = $$v
      },
      expression: "compromissadoDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do compromisso",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.compromissado_data_formatada),
      callback: function($$v) {
        _vm.form.fields.compromissado_data_formatada = $$v
      },
      expression: "form.fields.compromissado_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.compromissado_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.compromissado_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.compromissado_data),
      callback: function($$v) {
        _vm.form.fields.compromissado_data = $$v
      },
      expression: "form.fields.compromissado_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Locado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "locado_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.locado_condicao),
      callback: function($$v) {
        _vm.form.fields.locado_condicao = $$v
      },
      expression: "form.fields.locado_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_condicao === 'Inadimplente') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoInadimplenteDataMenu),
      callback: function($$v) {
        _vm.locadoInadimplenteDataMenu = $$v
      },
      expression: "locadoInadimplenteDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da inadimplência",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_inadimplente_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_inadimplente_data_formatada = $$v
      },
      expression: "form.fields.locado_inadimplente_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_inadimplente_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_inadimplente_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_inadimplente_data),
      callback: function($$v) {
        _vm.form.fields.locado_inadimplente_data = $$v
      },
      expression: "form.fields.locado_inadimplente_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_condicao === 'Inadimplente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.locado_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.locado_ajuizado_cliente = $$v
      },
      expression: "form.fields.locado_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.locado_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.locado_ajuizado_processo = $$v
      },
      expression: "form.fields.locado_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do locador"
    },
    model: {
      value: (_vm.form.fields.locado_locador),
      callback: function($$v) {
        _vm.form.fields.locado_locador = $$v
      },
      expression: "form.fields.locado_locador"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do locatário"
    },
    model: {
      value: (_vm.form.fields.locado_locatario),
      callback: function($$v) {
        _vm.form.fields.locado_locatario = $$v
      },
      expression: "form.fields.locado_locatario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Valor do aluguel",
      "name": "locado_valor"
    },
    model: {
      value: (_vm.form.fields.locado_valor),
      callback: function($$v) {
        _vm.form.fields.locado_valor = $$v
      },
      expression: "form.fields.locado_valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoValorDataMenu),
      callback: function($$v) {
        _vm.locadoValorDataMenu = $$v
      },
      expression: "locadoValorDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do valor do aluguel",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_valor_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_valor_data_formatada = $$v
      },
      expression: "form.fields.locado_valor_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_valor_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_valor_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_valor_data),
      callback: function($$v) {
        _vm.form.fields.locado_valor_data = $$v
      },
      expression: "form.fields.locado_valor_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoInicioDataMenu),
      callback: function($$v) {
        _vm.locadoInicioDataMenu = $$v
      },
      expression: "locadoInicioDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do início do contrato",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_inicio_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_inicio_data_formatada = $$v
      },
      expression: "form.fields.locado_inicio_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_inicio_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_inicio_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_inicio_data),
      callback: function($$v) {
        _vm.form.fields.locado_inicio_data = $$v
      },
      expression: "form.fields.locado_inicio_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoFimDataMenu),
      callback: function($$v) {
        _vm.locadoFimDataMenu = $$v
      },
      expression: "locadoFimDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do fim do contrato",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_fim_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_fim_data_formatada = $$v
      },
      expression: "form.fields.locado_fim_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_fim_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_fim_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_fim_data),
      callback: function($$v) {
        _vm.form.fields.locado_fim_data = $$v
      },
      expression: "form.fields.locado_fim_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Ação renovatória")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria = $$v
      },
      expression: "form.fields.locado_acao_renovatoria"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_acao_renovatoria) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº da ação renovatória"
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria_numero),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria_numero = $$v
      },
      expression: "form.fields.locado_acao_renovatoria_numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria_cliente),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria_cliente = $$v
      },
      expression: "form.fields.locado_acao_renovatoria_cliente"
    }
  })], 1)], 1) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Comodato') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "name": "comodato_nome"
    },
    model: {
      value: (_vm.form.fields.comodato_nome),
      callback: function($$v) {
        _vm.form.fields.comodato_nome = $$v
      },
      expression: "form.fields.comodato_nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "name": "comodato_rg"
    },
    model: {
      value: (_vm.form.fields.comodato_rg),
      callback: function($$v) {
        _vm.form.fields.comodato_rg = $$v
      },
      expression: "form.fields.comodato_rg"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/
      }),
      expression: "{ regex: /[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}/ }"
    }],
    attrs: {
      "label": "CPF",
      "name": "comodato_cpf",
      "data-vv-delay": "300",
      "data-vv-as": "CPF",
      "error-messages": _vm.errors.has('comodato_cpf') ? _vm.errors.first('comodato_cpf') : []
    },
    model: {
      value: (_vm.form.fields.comodato_cpf),
      callback: function($$v) {
        _vm.form.fields.comodato_cpf = $$v
      },
      expression: "form.fields.comodato_cpf"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.fields.comodato_telefone), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (['(##) ####-####', '(##) #####-####']),
        expression: "['(##) ####-####', '(##) #####-####']"
      }],
      attrs: {
        "prepend-icon": "phone",
        "append-icon": _vm.appendIcon(index),
        "append-icon-cb": _vm.adicionarRemoverTelefone.bind(this, index, _vm.form.fields.comodato_telefone),
        "label": "Telefone",
        "name": "comodato_telefone"
      },
      model: {
        value: (_vm.form.fields.comodato_telefone[index].numero),
        callback: function($$v) {
          _vm.form.fields.comodato_telefone[index].numero = $$v
        },
        expression: "form.fields.comodato_telefone[index].numero"
      }
    })], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Invadido') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "name": "invadido_nome"
    },
    model: {
      value: (_vm.form.fields.invadido_nome),
      callback: function($$v) {
        _vm.form.fields.invadido_nome = $$v
      },
      expression: "form.fields.invadido_nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "name": "invadido_rg"
    },
    model: {
      value: (_vm.form.fields.invadido_rg),
      callback: function($$v) {
        _vm.form.fields.invadido_rg = $$v
      },
      expression: "form.fields.invadido_rg"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/
      }),
      expression: "{ regex: /[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}/ }"
    }],
    attrs: {
      "label": "CPF",
      "name": "invadido_cpf",
      "data-vv-delay": "300",
      "data-vv-as": "CPF",
      "error-messages": _vm.errors.has('invadido_cpf') ? _vm.errors.first('invadido_cpf') : []
    },
    model: {
      value: (_vm.form.fields.invadido_cpf),
      callback: function($$v) {
        _vm.form.fields.invadido_cpf = $$v
      },
      expression: "form.fields.invadido_cpf"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.fields.invadido_telefone), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (['(##) ####-####', '(##) #####-####']),
        expression: "['(##) ####-####', '(##) #####-####']"
      }],
      attrs: {
        "prepend-icon": "phone",
        "append-icon": _vm.appendIcon(index),
        "append-icon-cb": _vm.adicionarRemoverTelefone.bind(this, index, _vm.form.fields.invadido_telefone),
        "label": "Telefone",
        "name": "invadido_telefone"
      },
      model: {
        value: (_vm.form.fields.invadido_telefone[index].numero),
        callback: function($$v) {
          _vm.form.fields.invadido_telefone[index].numero = $$v
        },
        expression: "form.fields.invadido_telefone[index].numero"
      }
    })], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.invadidoDataMenu),
      callback: function($$v) {
        _vm.invadidoDataMenu = $$v
      },
      expression: "invadidoDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data estimada da invasão",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.invadido_data_formatada),
      callback: function($$v) {
        _vm.form.fields.invadido_data_formatada = $$v
      },
      expression: "form.fields.invadido_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.invadido_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.invadido_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.invadido_data),
      callback: function($$v) {
        _vm.form.fields.invadido_data = $$v
      },
      expression: "form.fields.invadido_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "invadido_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.invadido_condicao),
      callback: function($$v) {
        _vm.form.fields.invadido_condicao = $$v
      },
      expression: "form.fields.invadido_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.invadido_condicao === 'Ocupado ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.invadido_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.invadido_ajuizado_cliente = $$v
      },
      expression: "form.fields.invadido_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.invadido_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.invadido_ajuizado_processo = $$v
      },
      expression: "form.fields.invadido_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()])], 2) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("IPTU / impostos / taxas")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.taxas.length > 0) ? _vm._l((_vm.taxas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v(_vm._s(item.taxa) + ":")]), _vm._v(" " + _vm._s(item.numero))]), _vm._v(" "), (item.situacao) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Situação:")]), _vm._v(" " + _vm._s(item.situacao))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Cliente/caso:")]), _vm._v(" " + _vm._s(item.ajuizado_cliente))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_processo) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Processo/execução:")]), _vm._v(" " + _vm._s(item.ajuizado_processo))]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', {
      staticClass: "text-xs-right"
    }, [(_vm.$hasGranularPermission('taxas', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "760"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Editar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.taxa))])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": "Número da taxa/imposto",
        "name": "adicionar.numero",
        "data-vv-as": "número",
        "error-messages": _vm.errors.has('adicionar.numero') ? _vm.errors.first('adicionar.numero') : []
      },
      model: {
        value: (_vm.formEditar.fields.numero),
        callback: function($$v) {
          _vm.formEditar.fields.numero = $$v
        },
        expression: "formEditar.fields.numero"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "auto": "",
        "items": _vm.taxaSituacao,
        "label": "Situação"
      },
      model: {
        value: (_vm.formEditar.fields.situacao),
        callback: function($$v) {
          _vm.formEditar.fields.situacao = $$v
        },
        expression: "formEditar.fields.situacao"
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "slide-x-transition"
      }
    }, [(_vm.formEditar.fields.situacao === 'Pendente ajuizado') ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Nº do cliente/caso"
      },
      model: {
        value: (_vm.formEditar.fields.ajuizado_cliente),
        callback: function($$v) {
          _vm.formEditar.fields.ajuizado_cliente = $$v
        },
        expression: "formEditar.fields.ajuizado_cliente"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Nº do processo/execução"
      },
      model: {
        value: (_vm.formEditar.fields.ajuizado_processo),
        callback: function($$v) {
          _vm.formEditar.fields.ajuizado_processo = $$v
        },
        expression: "formEditar.fields.ajuizado_processo"
      }
    })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }) : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma taxa cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "760"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('taxas', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "IPTU",
      "value": "IPTU"
    },
    model: {
      value: (_vm.form.fields.selecionarTaxa),
      callback: function($$v) {
        _vm.form.fields.selecionarTaxa = $$v
      },
      expression: "form.fields.selecionarTaxa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Outra taxa",
      "value": "Outra taxa"
    },
    model: {
      value: (_vm.form.fields.selecionarTaxa),
      callback: function($$v) {
        _vm.form.fields.selecionarTaxa = $$v
      },
      expression: "form.fields.selecionarTaxa"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.fields.selecionarTaxa !== 'IPTU') ? _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Nome da taxa/imposto",
      "name": "adicionar.taxa",
      "data-vv-as": "taxa",
      "error-messages": _vm.errors.has('adicionar.taxa') ? _vm.errors.first('adicionar.taxa') : []
    },
    model: {
      value: (_vm.form.fields.taxa),
      callback: function($$v) {
        _vm.form.fields.taxa = $$v
      },
      expression: "form.fields.taxa"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Número da taxa/imposto",
      "name": "adicionar.numero",
      "data-vv-as": "número",
      "error-messages": _vm.errors.has('adicionar.numero') ? _vm.errors.first('adicionar.numero') : []
    },
    model: {
      value: (_vm.form.fields.numero),
      callback: function($$v) {
        _vm.form.fields.numero = $$v
      },
      expression: "form.fields.numero"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "auto": "",
      "items": _vm.taxaSituacao,
      "label": "Situação"
    },
    model: {
      value: (_vm.form.fields.situacao),
      callback: function($$v) {
        _vm.form.fields.situacao = $$v
      },
      expression: "form.fields.situacao"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.situacao === 'Pendente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.ajuizado_cliente = $$v
      },
      expression: "form.fields.ajuizado_cliente"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.ajuizado_processo = $$v
      },
      expression: "form.fields.ajuizado_processo"
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos', {
    staticClass: "mt-3"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v(_vm._s(_vm.componentTituloPlural))])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.observacoes.length > 0) ? [_vm._l((_vm.observacoes), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(item.data) + " às " + _vm._s(item.horario))]), _c('br'), _vm._v("\n            " + _vm._s(item.conteudo) + "\n          ")]), _vm._v(" "), _c('v-card-actions', {
      staticClass: "text-xs-right"
    }, [(_vm.$hasGranularPermission('observacoes', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "680"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Editar")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": _vm.componentTitulo,
        "multi-line": "",
        "name": "editar.observacao",
        "data-vv-as": "observação",
        "error-messages": _vm.errors.has('editar.observacao') ? _vm.errors.first('editar.observacao') : []
      },
      model: {
        value: (_vm.formEditar.fields.conteudo),
        callback: function($$v) {
          _vm.formEditar.fields.conteudo = $$v
        },
        expression: "formEditar.fields.conteudo"
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma " + _vm._s(_vm.componentTitulo.toLowerCase()) + " cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "720"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('observacoes', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": _vm.componentTitulo,
      "multi-line": "",
      "name": "adicionar.observacao",
      "data-vv-as": "observação",
      "error-messages": _vm.errors.has('adicionar.observacao') ? _vm.errors.first('adicionar.observacao') : []
    },
    model: {
      value: (_vm.form.fields.conteudo),
      callback: function($$v) {
        _vm.form.fields.conteudo = $$v
      },
      expression: "form.fields.conteudo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', {
    class: [(_vm.situacaoClass + "--text"), 'upperCase']
  }, [_vm._t("default", [_vm._v("Vistoria " + _vm._s(_vm.situacao))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Usuários")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'UsuariosLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Editar usuário")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "border-color": "#F37021",
      "width": "150px",
      "height": "150px",
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "subheading secondary--text mt-2 mb-4",
    staticStyle: {
      "text-transform": "uppercase",
      "width": "100%",
      "float": "left"
    }
  }, [_vm._v("\n                Trocar foto\n                "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cargo"
    },
    model: {
      value: (_vm.form.fields.cargo),
      callback: function($$v) {
        _vm.form.fields.cargo = $$v
      },
      expression: "form.fields.cargo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }],
    attrs: {
      "label": "Celular"
    },
    model: {
      value: (_vm.form.fields.celular),
      callback: function($$v) {
        _vm.form.fields.celular = $$v
      },
      expression: "form.fields.celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Login")]), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "email",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = $$v
      },
      expression: "form.fields.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6'),
      expression: "'min:6'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Senha (opcional)",
      "name": "password",
      "data-vv-as": "senha",
      "error-messages": _vm.errors.has('password') ? _vm.errors.first('password') : []
    },
    model: {
      value: (_vm.form.fields.password),
      callback: function($$v) {
        _vm.form.fields.password = $$v
      },
      expression: "form.fields.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6|confirmed:password'),
      expression: "'min:6|confirmed:password'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Confirmar senha",
      "name": "conf_password",
      "data-vv-as": "confirmação de senha",
      "error-messages": _vm.errors.has('conf_password') ? _vm.errors.first('conf_password') : []
    },
    model: {
      value: (_vm.form.fields.conf_password),
      callback: function($$v) {
        _vm.form.fields.conf_password = $$v
      },
      expression: "form.fields.conf_password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Usuário "), (_vm.form.fields.bloqueado) ? _c('span', [_vm._v("bloqueado")]) : _c('span', [_vm._v("desbloqueado")])]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.bloqueado),
      callback: function($$v) {
        _vm.form.fields.bloqueado = $$v
      },
      expression: "form.fields.bloqueado"
    }
  })], 1), _vm._v(" "), (_vm.$auth.check('Administrador')) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.customRoles,
      "item-text": "name",
      "item-value": "id",
      "label": "Nível de acesso",
      "clearable": ""
    },
    model: {
      value: (_vm.form.fields.custom_role_id),
      callback: function($$v) {
        _vm.form.fields.custom_role_id = $$v
      },
      expression: "form.fields.custom_role_id"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "acao-coluna",
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ma-0",
    attrs: {
      "outline": "",
      "block": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogApagar($event)
      }
    }
  }, [_vm._v("\n                Apagar\n              ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "560"
    },
    model: {
      value: (_vm.dialogApagar),
      callback: function($$v) {
        _vm.dialogApagar = $$v
      },
      expression: "dialogApagar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Apagar usuário?")]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" Todas as tarefas e vistorias atribuídas a esse usuário serão apagadas. O usuário não poderá ser recuperado após a remoção.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogApagar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.apagarUsuario($event)
      }
    }
  }, [_vm._v("Apagar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ( false) ? _c('div', [_c('div', {
    staticClass: "text-xs-center grey--text text--darken-1 my-4",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.irParaOTopo($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text-xs-center grey--text text--darken-1 cursor_pointer"
  }, [_vm._v("arrow_upwards")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "cursor_pointer"
  }, [_vm._v("Ir para o topo")])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "save-as-pdf"
    }
  }, [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), (_vm.ilustrativas.length > 0) ? _c('slick', {
    ref: "slick",
    staticClass: "hide-pdf",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.ilustrativas), function(item, index) {
    return _c('img', {
      attrs: {
        "src": item.foto,
        "height": "350"
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.showVistoriaColumn || _vm.$hasGranularPermission('tarefas', 'view')) ? [_c('v-subheader', [_vm._v("Vistoria e Tarefas")]), _vm._v(" "), _c('v-layout', {
    staticClass: "vistoria-tarefas-layout",
    attrs: {
      "row": ""
    }
  }, [(_vm.showVistoriaColumn) ? _c('v-flex', {
    staticClass: "px-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.showVistoriaEmptyState) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("schedule")]), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("Sem vistoria agendada")])], 1), _vm._v(" "), (_vm.canAddVistoria) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'VistoriaAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Agendar vistoria")])], 1) : _vm._e()], 1) : (_vm.canShowVistoriaCard) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', [_c('span', [_c('v-icon', [_vm._v("schedule")]), _vm._v(" "), (_vm.vistoria.data_formatada) ? _c('VistoriaSituacao', {
    key: _vm.vistoria.data,
    staticClass: "mr-5",
    attrs: {
      "situacao": _vm.vistoria.situacao
    }
  }, [_vm._v(_vm._s(_vm.vistoria.data_formatada))]) : _vm._e()], 1), _vm._v(" "), _c('span', [_c('VistoriaSituacao', {
    key: _vm.vistoria.data,
    attrs: {
      "situacao": _vm.vistoria.situacao
    }
  })], 1), _vm._v(" "), (_vm.vistoria.recorrencia) ? _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n              " + _vm._s(_vm.vistoria.recorrencia_formatada) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.vistoriaUserName()))])]), _vm._v(" "), (_vm.vistoria.observacoes) ? _c('div', {
    staticClass: "mt-3 mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.vistoria.observacoes) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.canCompleteVistoria) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('VistoriaRealizar', {
    attrs: {
      "vistoriaId": _vm.vistoria.id,
      "imovelId": _vm.$route.params.id
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showVistoriaColumn && _vm.$hasGranularPermission('tarefas', 'view')) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "px-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.tarefas.length < 1) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("event_available")]), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("Sem tarefas agendadas")])], 1)])], 1), _vm._v(" "), (_vm.canAddTask) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'TarefasAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Agendar tarefa")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tarefas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c('div', [_c('span', [_c('v-icon', [_vm._v("event_available")]), _vm._v(" "), (item.data_formatada) ? _c('TarefasSituacao', {
      key: index,
      staticClass: "mr-5",
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    }, [_vm._v(_vm._s(item.data_formatada))]) : _vm._e()], 1), _vm._v(" "), _c('span', [_c('TarefasSituacao', {
      key: index,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_vm._v("\n              " + _vm._s(item.tipo) + "\n            ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.taskUserName(item)))])])])]), _vm._v(" "), (_vm.isTaskAssignedToCurrentUser(item)) ? _c('v-card-text', {
      staticClass: "pt-0 pb-3"
    }, [_c('TarefasRealizar', {
      attrs: {
        "tarefaId": item.id,
        "imovelId": _vm.$route.params.id
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.tarefas.length > index + 1) ? _c('v-divider') : _vm._e()], 1)
  })], 2) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Cadastro")]), _vm._v(" "), (_vm.coords.lat !== null && _vm.coords.lng !== null && _vm.$hasGranularPermission('endereco', 'view')) ? _c('v-card', {
    staticClass: "hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [(_vm.coords.lat !== null && _vm.coords.lng !== null) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "460px",
      "margin-bottom": "10px"
    },
    attrs: {
      "center": _vm.coords,
      "zoom": 15,
      "options": {
        clickableIcons: false,
        disableDoubleClickZoom: true,
        streetViewControl: false,
        mapTypeControl: true,
        zoomControl: false,
        fullscreenControl: false
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.coords,
      "icon": _vm.getIcon(),
      "clickable": false
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("room")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('endereco')) ? [_c('strong', [_vm._v("Endereço")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Endereço")])]), _vm._v(" "), _vm._l((this.endereco), function(item, index) {
    return (index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))]) : _vm._e()
  }), _vm._v(" "), (this.loteamento) ? _c('div', [_c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Loteamento")])]), _vm._v(" "), _vm._l((this.loteamento), function(item) {
    return _c('p', {
      key: item.id
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e()], 2), _vm._v(" "), (this.endereco.observacoes.length > 0 || this.endereco.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.endereco.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.endereco.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.endereco.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.endereco.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('registro', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("description")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('registro')) ? [_c('strong', [_vm._v("Registros / documentos")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Registros / documentos")])]), _vm._v(" "), _vm._l((this.registro), function(item, index) {
    return (index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: index
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item))]) : _vm._e()
  })], 2), _vm._v(" "), (this.registro.observacoes.length > 0 || this.registro.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.registro.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.registro.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.registro.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.registro.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("filter_hdr")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('area')) ? [_c('strong', [_vm._v("Área")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Área")])]), _vm._v(" "), _vm._l((this.area), function(item, index) {
    return (item.length > 0 && index !== 'Calçada' && index !== 'Muro' && index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: item.id
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item) + "\n            ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((this.area), function(item, index) {
    return (index === 'Calçada' || index === 'Muro') ? _c('p', {
      key: item.id
    }, [_vm._v("\n              " + _vm._s(item) + " " + _vm._s(index.toLowerCase()) + "\n            ")]) : _vm._e()
  })], 2), _vm._v(" "), (this.area.observacoes.length > 0 || this.area.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.area.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.area.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.area.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.area.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("location_city")])], 1), _vm._v(" "), (_vm.taxas.lista.length < 1) ? [_c('strong', [_vm._v("IPTU / impostos / taxas")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("IPTU / impostos / taxas")])]), _vm._v(" "), _vm._l((_vm.taxas.lista), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(item.taxa) + ":")]), _vm._v(" " + _vm._s(item.numero))]), _vm._v(" "), (item.situacao) ? _c('p', [_c('strong', [_vm._v("Situação:")]), _vm._v(" " + _vm._s(item.situacao))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente) ? _c('p', [_c('strong', [_vm._v("Cliente/caso:")]), _vm._v(" " + _vm._s(item.ajuizado_cliente))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_processo) ? _c('p', [_c('strong', [_vm._v("Processo/execução:")]), _vm._v(" " + _vm._s(item.ajuizado_processo))]) : _vm._e(), _vm._v(" "), (index + 1 < _vm.taxas.lista.length) ? _c('v-divider', {
      key: item.id,
      staticClass: "mb-3"
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), (this.taxas.observacoes.length > 0 || this.taxas.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.taxas.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.taxas.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.taxas.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.taxas.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("local_atm")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('valor')) ? [_c('strong', [_vm._v("Valor")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Valor")])]), _vm._v(" "), _vm._l((this.valor), function(item, index) {
    return (item.length > 0 && index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: item.id
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item))]) : _vm._e()
  })], 2), _vm._v(" "), (this.valor.observacoes.length > 0 || this.valor.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.valor.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.valor.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.valor.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.valor.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('status')) ? [_c('strong', [_vm._v("Status")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(this.status.status))])]), _vm._v(" "), _vm._l((this.status), function(item, index) {
    return (item && index !== 'status' && index !== 'observacoes' && index !== 'anexos') ? [(/^divider.*/.test(index) === false && index !== 'Telefone') ? _c('p', {
      key: index
    }, [(index !== 'Placa' && index !== 'Condição' && index !== 'Índice') ? [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item) + "\n                ")] : (index === 'Índice') ? [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" "), (typeof item === 'number') ? _c('span', {
      class: {
        'red--text': item < 1
      }
    }, [_vm._v(_vm._s(item) + "%")]) : _c('span', [_vm._v(_vm._s(item))])] : _c('strong', [_vm._v(_vm._s(item))])], 2) : (index === 'Telefone') ? _vm._l((item), function(telefone) {
      return _c('p', {
        key: item.id
      }, [_c('strong', {
        key: telefone.id
      }, [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(telefone.numero) + "\n                ")])
    }) : _c('v-divider', {
      key: index,
      staticClass: "mt-1 mb-3"
    })] : _vm._e()
  })], 2), _vm._v(" "), (this.status.observacoes.length > 0 || this.status.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.status.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.status.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.status.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.status.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'view')) ? [_c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Anotações")]), _vm._v(" "), (_vm.anotacoes.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, _vm._l((_vm.anotacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })) : _vm._e()])], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'view')) ? _c('div', {
    staticClass: "pt-0 pb-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesObservacoes',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir anotações")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? [_c('v-card', {
    staticClass: "px-5 hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Anexos")]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mt-2 mb-1",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? _c('div', {
    staticClass: "py-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesAnexos',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir arquivos")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? [_c('v-card', {
    staticClass: "px-5 hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Fotos")]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fotos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mt-2 mb-1",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('FileIcon', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }],
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])], 1)
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? _c('div', {
    staticClass: "py-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir fotos")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), _c('IrParaOTopo'), _vm._v(" "), _c('DetalhesFAB', {
    attrs: {
      "status": _vm.status
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagamentos-lista"
  }, [(_vm.pagamentos.length < 1) ? _c('v-card', {
    staticClass: "text-xs-center pt-5 pb-5 px-4 empty-state-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "42",
      "color": "grey lighten-1"
    }
  }, [_vm._v("account_balance_wallet")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-3"
  }, [_vm._v("Nenhum pagamento registrado para este imóvel.")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text mt-1"
  }, [_vm._v("Solicite o primeiro pagamento para iniciar o histórico.")]), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'add')) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text mx-0",
    attrs: {
      "outline": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogAdicionar($event)
      }
    }
  }, [_vm._v("Solicitar Pagamento")])], 1) : _vm._e()], 1) : [_c('v-card', {
    staticClass: "mb-3 resumo-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "py-3 px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Solicitações")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamentos.length))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Total solicitado")]), _vm._v(" "), _c('div', {
    staticClass: "subheading secondary--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalSolicitado)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Total pago")]), _vm._v(" "), _c('div', {
    staticClass: "subheading verde--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalPago)))])])])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.pagamentos), function(item, index) {
    return _c('v-card', {
      key: item.id,
      staticClass: "mb-2 pagamento-card",
      class: ("status-" + (item.status)),
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "py-4 px-4 lista_pagamentos"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "mb-3 mb-sm-0 dados-coluna",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md7": ""
      }
    }, [_c('div', {
      staticClass: "subheading pagamento-titulo"
    }, [_c('span', {
      staticClass: "status_circulo",
      style: ({
        'background-color': _vm.getStatusColor(item.status)
      })
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(item.descricao))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('span', {
      staticClass: "status_tag",
      style: ({
        'background-color': _vm.getStatusColor(item.status)
      })
    }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(item.status)) + "\n              ")]), _vm._v(" "), (item.status === 'rejeitado' && item.observacao) ? _c('span', {
      staticClass: "caption grey--text text--darken-1 ml-2"
    }, [_vm._v("\n                " + _vm._s(item.observacao) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
      staticClass: "mt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Solicitado por:")]), _vm._v(" " + _vm._s(item.solicitante ? item.solicitante.name : '---') + "\n              ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Aprovador:")]), _vm._v(" " + _vm._s(item.aprovador ? item.aprovador.name : '---') + "\n              ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Vencimento:")]), _vm._v(" " + _vm._s(_vm.formatDate(item.data_vencimento)) + "\n              ")]), _vm._v(" "), (item.data_pagamento) ? _c('v-flex', {
      staticClass: "caption verde--text text--darken-2 meta-item",
      attrs: {
        "xs12": ""
      }
    }, [_c('strong', [_vm._v("Pago em:")]), _vm._v(" " + _vm._s(_vm.formatDate(item.data_pagamento)) + "\n              ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mb-3 mb-sm-0 valor-coluna",
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "caption grey--text text--darken-1"
    }, [_c('strong', [_vm._v("Valor")])]), _vm._v(" "), _c('div', {
      staticClass: "headline secondary--text valor-principal"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.valor)))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "acoes-coluna",
      attrs: {
        "xs12": "",
        "sm2": "",
        "md2": ""
      }
    }, [_c('v-layout', {
      staticClass: "acoes-layout",
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [(item.documento_url) ? _c('v-btn', {
      staticClass: "mr-1",
      attrs: {
        "icon": "",
        "outline": "",
        "color": "grey",
        "href": item.documento_url,
        "target": "_blank",
        "title": "Boleto"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "19"
      }
    }, [_vm._v("description")])], 1) : _vm._e(), _vm._v(" "), (item.comprovante_url) ? _c('v-btn', {
      staticClass: "mr-1",
      attrs: {
        "icon": "",
        "outline": "",
        "color": "grey",
        "href": item.comprovante_url,
        "target": "_blank",
        "title": "Comprovante"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "19"
      }
    }, [_vm._v("receipt")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasMenuActions(item)) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      staticClass: "botao_lapis secondary ma-0",
      attrs: {
        "slot": "activator",
        "dark": "",
        "fab": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [(item.status === 'pendente' && _vm.canApproveAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.openDialogAprovar(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Avaliar")])], 1) : _vm._e(), _vm._v(" "), (_vm.canRegisterPaymentAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.openDialogPagar(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("payment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Registrar Pagamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.canDeleteAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.excluirPagamento(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticClass: "red--text font-weight-bold"
    }, [_vm._v("Apagar")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.pagamentos.length) ? _c('v-divider') : _vm._e()], 1)
  }), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'add')) ? _c('div', {
    staticClass: "text-xs-center mt-4 mb-4"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogAdicionar($event)
      }
    }
  }, [_vm._v("Solicitar Novo Pagamento")])], 1) : _vm._e()], _vm._v(" "), _c('PagamentosAdicionar', {
    attrs: {
      "visible": _vm.dialogAdicionar,
      "imovelId": _vm.imovelId
    },
    on: {
      "close": function($event) {
        _vm.dialogAdicionar = false
      },
      "saved": _vm.loadPagamentos
    }
  }), _vm._v(" "), _c('PagamentosAprovar', {
    attrs: {
      "visible": _vm.dialogAprovar,
      "pagamento": _vm.selectedPagamento
    },
    on: {
      "close": function($event) {
        _vm.dialogAprovar = false
      },
      "saved": _vm.loadPagamentos
    }
  }), _vm._v(" "), _c('PagamentosPagar', {
    attrs: {
      "visible": _vm.dialogPagar,
      "pagamento": _vm.selectedPagamento
    },
    on: {
      "close": function($event) {
        _vm.dialogPagar = false
      },
      "saved": _vm.loadPagamentos
    }
  })], 2)
},staticRenderFns: []}

/***/ })
],[508]);


// WEBPACK FOOTER //
// static/js/app.fa524094b3e09af990cc.js